(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as FS, getPartnerDevApiHeaders as IS, WidgetContextProvider as ES, makeExecuteQuery as TS, makeUseLazyQuery as $S, makeUseQuery as DS, makeUseMutation as OS, validateApiHostName as pb, useTracking as kn, useWidgetContext as mn, hasDownstreamApiForbiddenError as Nm, hasDownstreamApiAuthorizationError as jm, DisplayErrors as In, useCopyWithDelay as er, defaultDateFormat as dt, displayAttributeValue as fb, OAuthSettings as Mi, useData as wm, isDownstreamApiNotFoundError as RS, isDownstreamApiAuthorizationError as hb, KlaviyoSubscribeSetting as PS, isDownstreamApiPermissionError as AS, capitalizeFirstCharacter as Es, hasDownstreamApiTooManyRequestsError as LS, hasDownstreamApiPermissionError as yb, hasDownstreamApiNotFoundError as no, getCountryNameFromCountryCode as VS, IntegrationModal as gb, useInboundOAuthContext as zS } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import Se, { useMemo as qn, useState as se, useEffect as qe, useRef as ui, useCallback as tt, useReducer as US, useLayoutEffect as MS, useContext as Cm, createContext as vb, isValidElement as BS, createElement as qS, Fragment as HS } from "react";
import { Text as A, FlexBox as b, Spinner as cn, Icon as ue, Tooltip as Ke, List as We, Badge as Un, Button as Kn, IconButton as Yt, Tag as Pn, NavigationButton as St, Select as _r, CollapseCard as ar, Box as Qn, Modal as Nt, ModalHead as jt, ModalBody as wt, FormGrid as Ut, FormField as tn, FieldWrapper as Ln, ModalFoot as It, InputText as kr, Textarea as Bu, TagsInput as Ts, Image as Bi, Banner as $s, Divider as Fm, InputSelectionList as Yr, SelectionList as ot, FieldText as or, FieldTextarea as WS, CopyToClipboardButton as KS, getSelectionListContext as GS, Avatar as Im, Timestamp as YS, Attachment as JS, Switch as qu, FieldLabel as QS, EmptyState as ss, Table as Xn, Checkbox as qp, TextWithHighlight as XS, ErrorBoundaryContext as kb, FieldSwitch as bb } from "@dixa/lib-shared-habla";
import { ApolloLink as Em, Observable as _b, ApolloClient as ZS, InMemoryCache as e0, createHttpLink as n0, ApolloProvider as t0, useApolloClient as r0, ApolloConsumer as i0, NetworkStatus as Gt, isApolloError as xb, ApolloError as a0, gql as Zr, useQuery as o0, useMutation as Hp } from "@apollo/client";
import s0 from "cross-fetch";
import { config as Qa } from "lib-shared-backend-config";
import ut from "classnames";
import An from "moment";
import { __rest as l0, __assign as Zs } from "tslib";
import "moment-timezone";
import { useLocation as c0 } from "react-router-dom";
function Tm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ho = { exports: {} }, Zi = {};
var Wp;
function d0() {
  if (Wp) return Zi;
  Wp = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Zi.Fragment = r, Zi.jsx = s, Zi.jsxs = s, Zi;
}
var ea = {};
var Kp;
function u0() {
  return Kp || (Kp = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c, P));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    ea.Fragment = i, ea.jsx = On, ea.jsxs = Bn;
  })()), ea;
}
var Gp;
function m0() {
  return Gp || (Gp = 1, process.env.NODE_ENV === "production" ? ho.exports = d0() : ho.exports = u0()), ho.exports;
}
var Ue = m0();
function Sb(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: p0 } = Object.prototype, { getPrototypeOf: $m } = Object, { iterator: Ds, toStringTag: Nb } = Symbol, Os = /* @__PURE__ */ ((e) => (n) => {
  const r = p0.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), xr = (e) => (e = e.toLowerCase(), (n) => Os(n) === e), Rs = (e) => (n) => typeof n === e, { isArray: qi } = Array, Li = Rs("undefined");
function to(e) {
  return e !== null && !Li(e) && e.constructor !== null && !Li(e.constructor) && Ht(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const jb = xr("ArrayBuffer");
function f0(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && jb(e.buffer), n;
}
const h0 = Rs("string"), Ht = Rs("function"), wb = Rs("number"), ro = (e) => e !== null && typeof e == "object", y0 = (e) => e === !0 || e === !1, Ho = (e) => {
  if (Os(e) !== "object")
    return !1;
  const n = $m(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Nb in e) && !(Ds in e);
}, g0 = (e) => {
  if (!ro(e) || to(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, v0 = xr("Date"), k0 = xr("File"), b0 = xr("Blob"), _0 = xr("FileList"), x0 = (e) => ro(e) && Ht(e.pipe), S0 = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || Ht(e.append) && ((n = Os(e)) === "formdata" || // detect form-data instance
  n === "object" && Ht(e.toString) && e.toString() === "[object FormData]"));
}, N0 = xr("URLSearchParams"), [j0, w0, C0, F0] = ["ReadableStream", "Request", "Response", "Headers"].map(xr), I0 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function io(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), qi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (to(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function Cb(e, n) {
  if (to(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const si = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Fb = (e) => !Li(e) && e !== si;
function Hu() {
  const { caseless: e, skipUndefined: n } = Fb(this) && this || {}, r = {}, i = (a, o) => {
    const s = e && Cb(r, o) || o;
    Ho(r[s]) && Ho(a) ? r[s] = Hu(r[s], a) : Ho(a) ? r[s] = Hu({}, a) : qi(a) ? r[s] = a.slice() : (!n || !Li(a)) && (r[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && io(arguments[a], i);
  return r;
}
const E0 = (e, n, r, { allOwnKeys: i } = {}) => (io(n, (a, o) => {
  r && Ht(a) ? e[o] = Sb(a, r) : e[o] = a;
}, { allOwnKeys: i }), e), T0 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), $0 = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, D0 = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && $m(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, O0 = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, R0 = (e) => {
  if (!e) return null;
  if (qi(e)) return e;
  let n = e.length;
  if (!wb(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, P0 = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && $m(Uint8Array)), A0 = (e, n) => {
  const i = (e && e[Ds]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, L0 = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, V0 = xr("HTMLFormElement"), z0 = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, i, a) {
    return i.toUpperCase() + a;
  }
), Yp = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), U0 = xr("RegExp"), Ib = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  io(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, M0 = (e) => {
  Ib(e, (n, r) => {
    if (Ht(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = e[r];
    if (Ht(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, B0 = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return qi(e) ? i(e) : i(String(e).split(n)), r;
}, q0 = () => {
}, H0 = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function W0(e) {
  return !!(e && Ht(e.append) && e[Nb] === "FormData" && e[Ds]);
}
const K0 = (e) => {
  const n = new Array(10), r = (i, a) => {
    if (ro(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (to(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = qi(i) ? [] : {};
        return io(i, (s, l) => {
          const d = r(s, a + 1);
          !Li(d) && (o[l] = d);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return r(e, 0);
}, G0 = xr("AsyncFunction"), Y0 = (e) => e && (ro(e) || Ht(e)) && Ht(e.then) && Ht(e.catch), Eb = ((e, n) => e ? setImmediate : n ? ((r, i) => (si.addEventListener("message", ({ source: a, data: o }) => {
  a === si && o === r && i.length && i.shift()();
}, !1), (a) => {
  i.push(a), si.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  Ht(si.postMessage)
), J0 = typeof queueMicrotask < "u" ? queueMicrotask.bind(si) : typeof process < "u" && process.nextTick || Eb, Q0 = (e) => e != null && Ht(e[Ds]), ve = {
  isArray: qi,
  isArrayBuffer: jb,
  isBuffer: to,
  isFormData: S0,
  isArrayBufferView: f0,
  isString: h0,
  isNumber: wb,
  isBoolean: y0,
  isObject: ro,
  isPlainObject: Ho,
  isEmptyObject: g0,
  isReadableStream: j0,
  isRequest: w0,
  isResponse: C0,
  isHeaders: F0,
  isUndefined: Li,
  isDate: v0,
  isFile: k0,
  isBlob: b0,
  isRegExp: U0,
  isFunction: Ht,
  isStream: x0,
  isURLSearchParams: N0,
  isTypedArray: P0,
  isFileList: _0,
  forEach: io,
  merge: Hu,
  extend: E0,
  trim: I0,
  stripBOM: T0,
  inherits: $0,
  toFlatObject: D0,
  kindOf: Os,
  kindOfTest: xr,
  endsWith: O0,
  toArray: R0,
  forEachEntry: A0,
  matchAll: L0,
  isHTMLForm: V0,
  hasOwnProperty: Yp,
  hasOwnProp: Yp,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ib,
  freezeMethods: M0,
  toObjectSet: B0,
  toCamelCase: z0,
  noop: q0,
  toFiniteNumber: H0,
  findKey: Cb,
  global: si,
  isContextDefined: Fb,
  isSpecCompliantForm: W0,
  toJSONObject: K0,
  isAsyncFn: G0,
  isThenable: Y0,
  setImmediate: Eb,
  asap: J0,
  isIterable: Q0
};
function Fn(e, n, r, i, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), r && (this.config = r), i && (this.request = i), a && (this.response = a, this.status = a.status ? a.status : null);
}
ve.inherits(Fn, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ve.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Tb = Fn.prototype, $b = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  $b[e] = { value: e };
});
Object.defineProperties(Fn, $b);
Object.defineProperty(Tb, "isAxiosError", { value: !0 });
Fn.from = (e, n, r, i, a, o) => {
  const s = Object.create(Tb);
  ve.toFlatObject(e, s, function(u) {
    return u !== Error.prototype;
  }, (m) => m !== "isAxiosError");
  const l = e && e.message ? e.message : "Error", d = n == null && e ? e.code : n;
  return Fn.call(s, l, d, r, i, a), e && s.cause == null && Object.defineProperty(s, "cause", { value: e, configurable: !0 }), s.name = e && e.name || "Error", o && Object.assign(s, o), s;
};
const X0 = null;
function Wu(e) {
  return ve.isPlainObject(e) || ve.isArray(e);
}
function Db(e) {
  return ve.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Jp(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = Db(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function Z0(e) {
  return ve.isArray(e) && !e.some(Wu);
}
const eN = ve.toFlatObject(ve, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Ps(e, n, r) {
  if (!ve.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ve.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(w, C) {
    return !ve.isUndefined(C[w]);
  });
  const i = r.metaTokens, a = r.visitor || u, o = r.dots, s = r.indexes, d = (r.Blob || typeof Blob < "u" && Blob) && ve.isSpecCompliantForm(n);
  if (!ve.isFunction(a))
    throw new TypeError("visitor must be a function");
  function m(N) {
    if (N === null) return "";
    if (ve.isDate(N))
      return N.toISOString();
    if (ve.isBoolean(N))
      return N.toString();
    if (!d && ve.isBlob(N))
      throw new Fn("Blob is not supported. Use a Buffer instead.");
    return ve.isArrayBuffer(N) || ve.isTypedArray(N) ? d && typeof Blob == "function" ? new Blob([N]) : Buffer.from(N) : N;
  }
  function u(N, w, C) {
    let F = N;
    if (N && !C && typeof N == "object") {
      if (ve.endsWith(w, "{}"))
        w = i ? w : w.slice(0, -2), N = JSON.stringify(N);
      else if (ve.isArray(N) && Z0(N) || (ve.isFileList(N) || ve.endsWith(w, "[]")) && (F = ve.toArray(N)))
        return w = Db(w), F.forEach(function(H, $) {
          !(ve.isUndefined(H) || H === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Jp([w], $, o) : s === null ? w : w + "[]",
            m(H)
          );
        }), !1;
    }
    return Wu(N) ? !0 : (n.append(Jp(C, w, o), m(N)), !1);
  }
  const f = [], h = Object.assign(eN, {
    defaultVisitor: u,
    convertValue: m,
    isVisitable: Wu
  });
  function v(N, w) {
    if (!ve.isUndefined(N)) {
      if (f.indexOf(N) !== -1)
        throw Error("Circular reference detected in " + w.join("."));
      f.push(N), ve.forEach(N, function(F, y) {
        (!(ve.isUndefined(F) || F === null) && a.call(
          n,
          F,
          ve.isString(y) ? y.trim() : y,
          w,
          h
        )) === !0 && v(F, w ? w.concat(y) : [y]);
      }), f.pop();
    }
  }
  if (!ve.isObject(e))
    throw new TypeError("data must be an object");
  return v(e), n;
}
function Qp(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(i) {
    return n[i];
  });
}
function Dm(e, n) {
  this._pairs = [], e && Ps(e, this, n);
}
const Ob = Dm.prototype;
Ob.append = function(n, r) {
  this._pairs.push([n, r]);
};
Ob.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, Qp);
  } : Qp;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function nN(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Rb(e, n, r) {
  if (!n)
    return e;
  const i = r && r.encode || nN;
  ve.isFunction(r) && (r = {
    serialize: r
  });
  const a = r && r.serialize;
  let o;
  if (a ? o = a(n, r) : o = ve.isURLSearchParams(n) ? n.toString() : new Dm(n, r).toString(i), o) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class Xp {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ve.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Pb = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, tN = typeof URLSearchParams < "u" ? URLSearchParams : Dm, rN = typeof FormData < "u" ? FormData : null, iN = typeof Blob < "u" ? Blob : null, aN = {
  isBrowser: !0,
  classes: {
    URLSearchParams: tN,
    FormData: rN,
    Blob: iN
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Om = typeof window < "u" && typeof document < "u", Ku = typeof navigator == "object" && navigator || void 0, oN = Om && (!Ku || ["ReactNative", "NativeScript", "NS"].indexOf(Ku.product) < 0), sN = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", lN = Om && window.location.href || "http://localhost", cN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Om,
  hasStandardBrowserEnv: oN,
  hasStandardBrowserWebWorkerEnv: sN,
  navigator: Ku,
  origin: lN
}, Symbol.toStringTag, { value: "Module" })), Ct = {
  ...cN,
  ...aN
};
function dN(e, n) {
  return Ps(e, new Ct.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Ct.isNode && ve.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function uN(e) {
  return ve.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function mN(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function Ab(e) {
  function n(r, i, a, o) {
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && ve.isArray(a) ? a.length : s, d ? (ve.hasOwnProp(a, s) ? a[s] = [a[s], i] : a[s] = i, !l) : ((!a[s] || !ve.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ve.isArray(a[s]) && (a[s] = mN(a[s])), !l);
  }
  if (ve.isFormData(e) && ve.isFunction(e.entries)) {
    const r = {};
    return ve.forEachEntry(e, (i, a) => {
      n(uN(i), a, r, 0);
    }), r;
  }
  return null;
}
function pN(e, n, r) {
  if (ve.isString(e))
    try {
      return (n || JSON.parse)(e), ve.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const ao = {
  transitional: Pb,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(n, r) {
    const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ve.isObject(n);
    if (o && ve.isHTMLForm(n) && (n = new FormData(n)), ve.isFormData(n))
      return a ? JSON.stringify(Ab(n)) : n;
    if (ve.isArrayBuffer(n) || ve.isBuffer(n) || ve.isStream(n) || ve.isFile(n) || ve.isBlob(n) || ve.isReadableStream(n))
      return n;
    if (ve.isArrayBufferView(n))
      return n.buffer;
    if (ve.isURLSearchParams(n))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let l;
    if (o) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return dN(n, this.formSerializer).toString();
      if ((l = ve.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return Ps(
          l ? { "files[]": n } : n,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return o || a ? (r.setContentType("application/json", !1), pN(n)) : n;
  }],
  transformResponse: [function(n) {
    const r = this.transitional || ao.transitional, i = r && r.forcedJSONParsing, a = this.responseType === "json";
    if (ve.isResponse(n) || ve.isReadableStream(n))
      return n;
    if (n && ve.isString(n) && (i && !this.responseType || a)) {
      const s = !(r && r.silentJSONParsing) && a;
      try {
        return JSON.parse(n, this.parseReviver);
      } catch (l) {
        if (s)
          throw l.name === "SyntaxError" ? Fn.from(l, Fn.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ct.classes.FormData,
    Blob: Ct.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ve.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  ao.headers[e] = {};
});
const fN = ve.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), hN = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && fN[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
}, Zp = Symbol("internals");
function na(e) {
  return e && String(e).trim().toLowerCase();
}
function Wo(e) {
  return e === !1 || e == null ? e : ve.isArray(e) ? e.map(Wo) : String(e);
}
function yN(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const gN = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function el(e, n, r, i, a) {
  if (ve.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ve.isString(n)) {
    if (ve.isString(i))
      return n.indexOf(i) !== -1;
    if (ve.isRegExp(i))
      return i.test(n);
  }
}
function vN(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function kN(e, n) {
  const r = ve.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Wt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = na(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = ve.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = Wo(l));
    }
    const s = (l, d) => ve.forEach(l, (m, u) => o(m, u, d));
    if (ve.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ve.isString(n) && (n = n.trim()) && !gN(n))
      s(hN(n), r);
    else if (ve.isObject(n) && ve.isIterable(n)) {
      let l = {}, d, m;
      for (const u of n) {
        if (!ve.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = u[0]] = (d = l[m]) ? ve.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = na(n), n) {
      const i = ve.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return yN(a);
        if (ve.isFunction(r))
          return r.call(this, a, i);
        if (ve.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = na(n), n) {
      const i = ve.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || el(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = na(s), s) {
        const l = ve.findKey(i, s);
        l && (!r || el(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ve.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || el(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ve.forEach(this, (a, o) => {
      const s = ve.findKey(i, o);
      if (s) {
        r[s] = Wo(a), delete r[o];
        return;
      }
      const l = n ? vN(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Wo(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ve.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ve.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[Zp] = this[Zp] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = na(s);
      i[l] || (kN(a, s), i[l] = !0);
    }
    return ve.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Wt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ve.reduceDescriptors(Wt.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ve.freezeMethods(Wt);
function nl(e, n) {
  const r = this || ao, i = n || r, a = Wt.from(i.headers);
  let o = i.data;
  return ve.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function Lb(e) {
  return !!(e && e.__CANCEL__);
}
function Hi(e, n, r) {
  Fn.call(this, e ?? "canceled", Fn.ERR_CANCELED, n, r), this.name = "CanceledError";
}
ve.inherits(Hi, Fn, {
  __CANCEL__: !0
});
function Vb(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new Fn(
    "Request failed with status code " + r.status,
    [Fn.ERR_BAD_REQUEST, Fn.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function bN(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function _N(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const v = u && m - u;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function xN(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const ls = (e, n, r = 3) => {
  let i = 0;
  const a = _N(50, 250);
  return xN((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = s - i, m = a(d), u = s <= l;
    i = s;
    const f = {
      loaded: s,
      total: l,
      progress: l ? s / l : void 0,
      bytes: d,
      rate: m || void 0,
      estimated: m && l && u ? (l - s) / m : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, ef = (e, n) => {
  const r = e != null;
  return [(i) => n[0]({
    lengthComputable: r,
    total: e,
    loaded: i
  }), n[1]];
}, nf = (e) => (...n) => ve.asap(() => e(...n)), SN = Ct.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Ct.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Ct.origin),
  Ct.navigator && /(msie|trident)/i.test(Ct.navigator.userAgent)
) : () => !0, NN = Ct.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o) {
      const s = [e + "=" + encodeURIComponent(n)];
      ve.isNumber(r) && s.push("expires=" + new Date(r).toGMTString()), ve.isString(i) && s.push("path=" + i), ve.isString(a) && s.push("domain=" + a), o === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function jN(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function wN(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function zb(e, n, r) {
  let i = !jN(n);
  return e && (i || r == !1) ? wN(e, n) : n;
}
const tf = (e) => e instanceof Wt ? { ...e } : e;
function yi(e, n) {
  n = n || {};
  const r = {};
  function i(m, u, f, h) {
    return ve.isPlainObject(m) && ve.isPlainObject(u) ? ve.merge.call({ caseless: h }, m, u) : ve.isPlainObject(u) ? ve.merge({}, u) : ve.isArray(u) ? u.slice() : u;
  }
  function a(m, u, f, h) {
    if (ve.isUndefined(u)) {
      if (!ve.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, u, f, h);
  }
  function o(m, u) {
    if (!ve.isUndefined(u))
      return i(void 0, u);
  }
  function s(m, u) {
    if (ve.isUndefined(u)) {
      if (!ve.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, u);
  }
  function l(m, u, f) {
    if (f in n)
      return i(m, u);
    if (f in e)
      return i(void 0, m);
  }
  const d = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, u, f) => a(tf(m), tf(u), f, !0)
  };
  return ve.forEach(Object.keys({ ...e, ...n }), function(u) {
    const f = d[u] || a, h = f(e[u], n[u], u);
    ve.isUndefined(h) && f !== l || (r[u] = h);
  }), r;
}
const Ub = (e) => {
  const n = yi({}, e);
  let { data: r, withXSRFToken: i, xsrfHeaderName: a, xsrfCookieName: o, headers: s, auth: l } = n;
  if (n.headers = s = Wt.from(s), n.url = Rb(zb(n.baseURL, n.url, n.allowAbsoluteUrls), e.params, e.paramsSerializer), l && s.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  ), ve.isFormData(r)) {
    if (Ct.hasStandardBrowserEnv || Ct.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if (ve.isFunction(r.getHeaders)) {
      const d = r.getHeaders(), m = ["content-type", "content-length"];
      Object.entries(d).forEach(([u, f]) => {
        m.includes(u.toLowerCase()) && s.set(u, f);
      });
    }
  }
  if (Ct.hasStandardBrowserEnv && (i && ve.isFunction(i) && (i = i(n)), i || i !== !1 && SN(n.url))) {
    const d = a && o && NN.read(o);
    d && s.set(a, d);
  }
  return n;
}, CN = typeof XMLHttpRequest < "u", FN = CN && function(e) {
  return new Promise(function(r, i) {
    const a = Ub(e);
    let o = a.data;
    const s = Wt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, v, N;
    function w() {
      v && v(), N && N(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let C = new XMLHttpRequest();
    C.open(a.method.toUpperCase(), a.url, !0), C.timeout = a.timeout;
    function F() {
      if (!C)
        return;
      const H = Wt.from(
        "getAllResponseHeaders" in C && C.getAllResponseHeaders()
      ), E = {
        data: !l || l === "text" || l === "json" ? C.responseText : C.response,
        status: C.status,
        statusText: C.statusText,
        headers: H,
        config: e,
        request: C
      };
      Vb(function(U) {
        r(U), w();
      }, function(U) {
        i(U), w();
      }, E), C = null;
    }
    "onloadend" in C ? C.onloadend = F : C.onreadystatechange = function() {
      !C || C.readyState !== 4 || C.status === 0 && !(C.responseURL && C.responseURL.indexOf("file:") === 0) || setTimeout(F);
    }, C.onabort = function() {
      C && (i(new Fn("Request aborted", Fn.ECONNABORTED, e, C)), C = null);
    }, C.onerror = function($) {
      const E = $ && $.message ? $.message : "Network Error", D = new Fn(E, Fn.ERR_NETWORK, e, C);
      D.event = $ || null, i(D), C = null;
    }, C.ontimeout = function() {
      let $ = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const E = a.transitional || Pb;
      a.timeoutErrorMessage && ($ = a.timeoutErrorMessage), i(new Fn(
        $,
        E.clarifyTimeoutError ? Fn.ETIMEDOUT : Fn.ECONNABORTED,
        e,
        C
      )), C = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in C && ve.forEach(s.toJSON(), function($, E) {
      C.setRequestHeader(E, $);
    }), ve.isUndefined(a.withCredentials) || (C.withCredentials = !!a.withCredentials), l && l !== "json" && (C.responseType = a.responseType), m && ([h, N] = ls(m, !0), C.addEventListener("progress", h)), d && C.upload && ([f, v] = ls(d), C.upload.addEventListener("progress", f), C.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (u = (H) => {
      C && (i(!H || H.type ? new Hi(null, e, C) : H), C.abort(), C = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const y = bN(a.url);
    if (y && Ct.protocols.indexOf(y) === -1) {
      i(new Fn("Unsupported protocol " + y + ":", Fn.ERR_BAD_REQUEST, e));
      return;
    }
    C.send(o || null);
  });
}, IN = (e, n) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (n || r) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const u = m instanceof Error ? m : this.reason;
        i.abort(u instanceof Fn ? u : new Hi(u instanceof Error ? u.message : u));
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new Fn(`timeout ${n} of ms exceeded`, Fn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: d } = i;
    return d.unsubscribe = () => ve.asap(l), d;
  }
}, EN = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, TN = async function* (e, n) {
  for await (const r of $N(e))
    yield* EN(r, n);
}, $N = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, rf = (e, n, r, i) => {
  const a = TN(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream({
    async pull(d) {
      try {
        const { done: m, value: u } = await a.next();
        if (m) {
          l(), d.close();
          return;
        }
        let f = u.byteLength;
        if (r) {
          let h = o += f;
          r(h);
        }
        d.enqueue(new Uint8Array(u));
      } catch (m) {
        throw l(m), m;
      }
    },
    cancel(d) {
      return l(d), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, af = 64 * 1024, { isFunction: yo } = ve, DN = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ve.global), {
  ReadableStream: of,
  TextEncoder: sf
} = ve.global, lf = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, ON = (e) => {
  e = ve.merge.call({
    skipUndefined: !0
  }, DN, e);
  const { fetch: n, Request: r, Response: i } = e, a = n ? yo(n) : typeof fetch == "function", o = yo(r), s = yo(i);
  if (!a)
    return !1;
  const l = a && yo(of), d = a && (typeof sf == "function" ? /* @__PURE__ */ ((N) => (w) => N.encode(w))(new sf()) : async (N) => new Uint8Array(await new r(N).arrayBuffer())), m = o && l && lf(() => {
    let N = !1;
    const w = new r(Ct.origin, {
      body: new of(),
      method: "POST",
      get duplex() {
        return N = !0, "half";
      }
    }).headers.has("Content-Type");
    return N && !w;
  }), u = s && l && lf(() => ve.isReadableStream(new i("").body)), f = {
    stream: u && ((N) => N.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((N) => {
    !f[N] && (f[N] = (w, C) => {
      let F = w && w[N];
      if (F)
        return F.call(w);
      throw new Fn(`Response type '${N}' is not supported`, Fn.ERR_NOT_SUPPORT, C);
    });
  });
  const h = async (N) => {
    if (N == null)
      return 0;
    if (ve.isBlob(N))
      return N.size;
    if (ve.isSpecCompliantForm(N))
      return (await new r(Ct.origin, {
        method: "POST",
        body: N
      }).arrayBuffer()).byteLength;
    if (ve.isArrayBufferView(N) || ve.isArrayBuffer(N))
      return N.byteLength;
    if (ve.isURLSearchParams(N) && (N = N + ""), ve.isString(N))
      return (await d(N)).byteLength;
  }, v = async (N, w) => {
    const C = ve.toFiniteNumber(N.getContentLength());
    return C ?? h(w);
  };
  return async (N) => {
    let {
      url: w,
      method: C,
      data: F,
      signal: y,
      cancelToken: H,
      timeout: $,
      onDownloadProgress: E,
      onUploadProgress: D,
      responseType: U,
      headers: Z,
      withCredentials: Q = "same-origin",
      fetchOptions: ie
    } = Ub(N), Y = n || fetch;
    U = U ? (U + "").toLowerCase() : "text";
    let M = IN([y, H && H.toAbortSignal()], $), R = null;
    const q = M && M.unsubscribe && (() => {
      M.unsubscribe();
    });
    let ee;
    try {
      if (D && m && C !== "get" && C !== "head" && (ee = await v(Z, F)) !== 0) {
        let ke = new r(w, {
          method: "POST",
          body: F,
          duplex: "half"
        }), Ce;
        if (ve.isFormData(F) && (Ce = ke.headers.get("content-type")) && Z.setContentType(Ce), ke.body) {
          const [K, Be] = ef(
            ee,
            ls(nf(D))
          );
          F = rf(ke.body, af, K, Be);
        }
      }
      ve.isString(Q) || (Q = Q ? "include" : "omit");
      const ge = o && "credentials" in r.prototype, de = {
        ...ie,
        signal: M,
        method: C.toUpperCase(),
        headers: Z.normalize().toJSON(),
        body: F,
        duplex: "half",
        credentials: ge ? Q : void 0
      };
      R = o && new r(w, de);
      let le = await (o ? Y(R, ie) : Y(w, de));
      const pe = u && (U === "stream" || U === "response");
      if (u && (E || pe && q)) {
        const ke = {};
        ["status", "statusText", "headers"].forEach((Me) => {
          ke[Me] = le[Me];
        });
        const Ce = ve.toFiniteNumber(le.headers.get("content-length")), [K, Be] = E && ef(
          Ce,
          ls(nf(E), !0)
        ) || [];
        le = new i(
          rf(le.body, af, K, () => {
            Be && Be(), q && q();
          }),
          ke
        );
      }
      U = U || "text";
      let W = await f[ve.findKey(f, U) || "text"](le, N);
      return !pe && q && q(), await new Promise((ke, Ce) => {
        Vb(ke, Ce, {
          data: W,
          headers: Wt.from(le.headers),
          status: le.status,
          statusText: le.statusText,
          config: N,
          request: R
        });
      });
    } catch (ge) {
      throw q && q(), ge && ge.name === "TypeError" && /Load failed|fetch/i.test(ge.message) ? Object.assign(
        new Fn("Network Error", Fn.ERR_NETWORK, N, R),
        {
          cause: ge.cause || ge
        }
      ) : Fn.from(ge, ge && ge.code, N, R);
    }
  };
}, RN = /* @__PURE__ */ new Map(), Mb = (e) => {
  let n = e ? e.env : {};
  const { fetch: r, Request: i, Response: a } = n, o = [
    i,
    a,
    r
  ];
  let s = o.length, l = s, d, m, u = RN;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : ON(n)), u = m;
  return m;
};
Mb();
const Gu = {
  http: X0,
  xhr: FN,
  fetch: {
    get: Mb
  }
};
ve.forEach(Gu, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const cf = (e) => `- ${e}`, PN = (e) => ve.isFunction(e) || e === null || e === !1, Bb = {
  getAdapter: (e, n) => {
    e = ve.isArray(e) ? e : [e];
    const { length: r } = e;
    let i, a;
    const o = {};
    for (let s = 0; s < r; s++) {
      i = e[s];
      let l;
      if (a = i, !PN(i) && (a = Gu[(l = String(i)).toLowerCase()], a === void 0))
        throw new Fn(`Unknown adapter '${l}'`);
      if (a && (ve.isFunction(a) || (a = a.get(n))))
        break;
      o[l || "#" + s] = a;
    }
    if (!a) {
      const s = Object.entries(o).map(
        ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = r ? s.length > 1 ? `since :
` + s.map(cf).join(`
`) : " " + cf(s[0]) : "as no adapter specified";
      throw new Fn(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return a;
  },
  adapters: Gu
};
function tl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Hi(null, e);
}
function df(e) {
  return tl(e), e.headers = Wt.from(e.headers), e.data = nl.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Bb.getAdapter(e.adapter || ao.adapter, e)(e).then(function(i) {
    return tl(e), i.data = nl.call(
      e,
      e.transformResponse,
      i
    ), i.headers = Wt.from(i.headers), i;
  }, function(i) {
    return Lb(i) || (tl(e), i && i.response && (i.response.data = nl.call(
      e,
      e.transformResponse,
      i.response
    ), i.response.headers = Wt.from(i.response.headers))), Promise.reject(i);
  });
}
const qb = "1.12.2", As = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  As[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const uf = {};
As.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + qb + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new Fn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        Fn.ERR_DEPRECATED
      );
    return r && !uf[s] && (uf[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
As.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function AN(e, n, r) {
  if (typeof e != "object")
    throw new Fn("options must be an object", Fn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = n[o];
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new Fn("option " + o + " must be " + d, Fn.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new Fn("Unknown option " + o, Fn.ERR_BAD_OPTION);
  }
}
const Ko = {
  assertOptions: AN,
  validators: As
}, Sr = Ko.validators;
let mi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new Xp(),
      response: new Xp()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          i.stack ? o && !String(i.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (i.stack += `
` + o) : i.stack = o;
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = yi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Ko.assertOptions(i, {
      silentJSONParsing: Sr.transitional(Sr.boolean),
      forcedJSONParsing: Sr.transitional(Sr.boolean),
      clarifyTimeoutError: Sr.transitional(Sr.boolean)
    }, !1), a != null && (ve.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Ko.assertOptions(a, {
      encode: Sr.function,
      serialize: Sr.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Ko.assertOptions(r, {
      baseUrl: Sr.spelling("baseURL"),
      withXsrfToken: Sr.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ve.merge(
      o.common,
      o[r.method]
    );
    o && ve.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (N) => {
        delete o[N];
      }
    ), r.headers = Wt.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(w) {
      typeof w.runWhen == "function" && w.runWhen(r) === !1 || (d = d && w.synchronous, l.unshift(w.fulfilled, w.rejected));
    });
    const m = [];
    this.interceptors.response.forEach(function(w) {
      m.push(w.fulfilled, w.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const N = [df.bind(this), void 0];
      for (N.unshift(...l), N.push(...m), h = N.length, u = Promise.resolve(r); f < h; )
        u = u.then(N[f++], N[f++]);
      return u;
    }
    h = l.length;
    let v = r;
    for (; f < h; ) {
      const N = l[f++], w = l[f++];
      try {
        v = N(v);
      } catch (C) {
        w.call(this, C);
        break;
      }
    }
    try {
      u = df.call(this, v);
    } catch (N) {
      return Promise.reject(N);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = yi(this.defaults, n);
    const r = zb(n.baseURL, n.url, n.allowAbsoluteUrls);
    return Rb(r, n.params, n.paramsSerializer);
  }
};
ve.forEach(["delete", "get", "head", "options"], function(n) {
  mi.prototype[n] = function(r, i) {
    return this.request(yi(i || {}, {
      method: n,
      url: r,
      data: (i || {}).data
    }));
  };
});
ve.forEach(["post", "put", "patch"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(yi(l || {}, {
        method: n,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: s
      }));
    };
  }
  mi.prototype[n] = r(), mi.prototype[n + "Form"] = r(!0);
});
let LN = class Hb {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new Hi(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new Hb(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function VN(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function zN(e) {
  return ve.isObject(e) && e.isAxiosError === !0;
}
const Yu = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Yu).forEach(([e, n]) => {
  Yu[n] = e;
});
function Wb(e) {
  const n = new mi(e), r = Sb(mi.prototype.request, n);
  return ve.extend(r, mi.prototype, n, { allOwnKeys: !0 }), ve.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return Wb(yi(e, a));
  }, r;
}
const mt = Wb(ao);
mt.Axios = mi;
mt.CanceledError = Hi;
mt.CancelToken = LN;
mt.isCancel = Lb;
mt.VERSION = qb;
mt.toFormData = Ps;
mt.AxiosError = Fn;
mt.Cancel = mt.CanceledError;
mt.all = function(n) {
  return Promise.all(n);
};
mt.spread = VN;
mt.isAxiosError = zN;
mt.mergeConfig = yi;
mt.AxiosHeaders = Wt;
mt.formToJSON = (e) => Ab(ve.isHTMLForm(e) ? new FormData(e) : e);
mt.getAdapter = Bb.getAdapter;
mt.HttpStatusCode = Yu;
mt.default = mt;
const {
  Axios: v4,
  AxiosError: k4,
  CanceledError: b4,
  isCancel: _4,
  CancelToken: x4,
  VERSION: S4,
  all: N4,
  Cancel: j4,
  isAxiosError: UN,
  spread: w4,
  toFormData: C4,
  AxiosHeaders: F4,
  HttpStatusCode: I4,
  formToJSON: E4,
  getAdapter: T4,
  mergeConfig: $4
} = mt;
class MN {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const mf = new MN();
function BN(e, n) {
  return pf(e), pf(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function pf(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const qN = Object.prototype.toString;
function HN(e, n) {
  return qN.call(e) === `[object ${n}]`;
}
function WN(e) {
  return HN(e, "Object");
}
function KN(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const za = "8.36.0", qr = globalThis;
function Rm(e, n, r) {
  const i = r || qr, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[za] = a[za] || {};
  return o[e] || (o[e] = n());
}
const Kb = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, GN = "Sentry Logger ", ff = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], hf = {};
function Gb(e) {
  if (!("console" in qr))
    return e();
  const n = qr.console, r = {}, i = Object.keys(hf);
  i.forEach((a) => {
    const o = hf[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function YN() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Kb ? ff.forEach((r) => {
    n[r] = (...i) => {
      e && Gb(() => {
        qr.console[r](`${GN}[${r}]:`, ...i);
      });
    };
  }) : ff.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Go = Rm("logger", YN);
function JN(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Kb && Go.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const Yb = 1e3;
function Pm() {
  return Date.now() / Yb;
}
function QN() {
  const { performance: e } = qr;
  if (!e || !e.now)
    return Pm;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / Yb;
}
const XN = QN();
(() => {
  const { performance: e } = qr;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function Di() {
  const e = qr, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function yf() {
  return {
    traceId: Di(),
    spanId: Di().substring(16)
  };
}
function Am() {
  return Lm(qr), qr;
}
function Lm(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || za, n[za] = n[za] || {};
}
function ZN(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || XN(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : Di()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Ju = "_sentrySpan";
function gf(e, n) {
  n ? JN(e, Ju, n) : delete e[Ju];
}
function vf(e) {
  return e[Ju];
}
const ej = 100;
class Vm {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = yf();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Vm();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, gf(n, vf(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && ZN(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof Vi ? [r.getScopeData(), r.getRequestSession()] : WN(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, gf(this, void 0), this._attachments = [], this._propagationContext = yf(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : ej;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Pm(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: vf(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : Di();
    if (!this._client)
      return Go.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : Di();
    if (!this._client)
      return Go.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : Di();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Go.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Vi = Vm;
function nj() {
  return Rm("defaultCurrentScope", () => new Vi());
}
function tj() {
  return Rm("defaultIsolationScope", () => new Vi());
}
class rj {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Vi();
    let a;
    r ? a = r : a = new Vi(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return KN(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function zi() {
  const e = Am(), n = Lm(e);
  return n.stack = n.stack || new rj(nj(), tj());
}
function ij(e) {
  return zi().withScope(e);
}
function aj(e, n) {
  const r = zi();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function kf(e) {
  return zi().withScope(() => e(zi().getIsolationScope()));
}
function oj() {
  return {
    withIsolationScope: kf,
    withScope: ij,
    withSetScope: aj,
    withSetIsolationScope: (e, n) => kf(n),
    getCurrentScope: () => zi().getScope(),
    getIsolationScope: () => zi().getIsolationScope()
  };
}
function Jb(e) {
  const n = Lm(e);
  return n.acs ? n.acs : oj();
}
function zm() {
  const e = Am();
  return Jb(e).getCurrentScope();
}
function Qb() {
  const e = Am();
  return Jb(e).getIsolationScope();
}
function sj() {
  return zm().getClient();
}
function lj(e) {
  if (e)
    return cj(e) ? { captureContext: e } : uj(e) ? {
      captureContext: e
    } : e;
}
function cj(e) {
  return e instanceof Vi || typeof e == "function";
}
const dj = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function uj(e) {
  return Object.keys(e).some((n) => dj.includes(n));
}
function bf(e, n) {
  return zm().captureException(e, lj(n));
}
function mj(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return zm().captureMessage(e, r, i);
}
function pj(e, n) {
  Qb().setContext(e, n);
}
const fj = 100;
function ii(e, n) {
  const r = sj(), i = Qb();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = fj } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Pm(), ...e }, d = a ? Gb(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var Xa;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Xa || (Xa = {}));
function Oi(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const hj = Qa.backendDomain ? {
  "backend-domain": Qa.backendDomain
} : void 0;
function Yo() {
  const e = new URLSearchParams({
    noToken: "true",
    ...hj
  }).toString();
  document.location.href = `${Qa.url.logIn}?${e}`;
}
const rl = "authData", il = 30, yj = 600, al = 5;
class gj {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= al || this.clientServerTimeDiff <= -al ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + yj, a = Oi(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > al) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(rl, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(rl), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(rl);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - il;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = Oi(n), i = r.exp - il;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - il - this.estimatedServerTime()) * 1e3;
  }
}
const vt = new gj();
async function vj(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? Oi(o).exp : "None", l = await Ls.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? Oi(m).exp : "None", h = u ? Oi(u).exp : "None", v = typeof s == "number" ? d - s : "Unknown", N = typeof f == "number" ? d - f : "Unknown", w = typeof h == "number" ? d - h : "Unknown", C = e.response.headers["x-dixa-rid"];
      pj("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: v,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: N,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: w,
        xDixaRid: C,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    mj("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Xa.Platform,
        domain: n
      }
    });
  }
}
const ol = /* @__PURE__ */ new Map(), kj = 3;
function bj(e) {
  e.interceptors.response.use((n) => (ol.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case Qu.Unauthorized:
          if (!Ls.isRefreshTokenExpired() && n.config) {
            ii({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = ol.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= kj)
              return ol.set(n.config.url, i + 1), e(n.config);
          }
          vj(n), console.error("401 unauthorized interceptor"), Yo();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const Xb = mt.create();
bj(Xb);
const Ar = console.log;
async function _f(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class _j extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function xj(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const Sj = 5;
class Nj {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      vt.setAuthData(r);
    else {
      const i = vt.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new _j("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = vt.getAccessToken();
    if (!n)
      return {};
    const r = Oi(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return vt.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = vt.getAuthData();
    return r ? vt.isAccessTokenExpired() ? (ii({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && vt.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return vt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return vt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return vt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = vt.getAuthData();
    return n ? vt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!mf.isElectron())
      return !0;
    const n = await mf.getVersion();
    return BN(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = Sj) {
    try {
      return await Xb.post(`${Qa.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Ar("AUTH", "Network connection offline - waiting..."), ii({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await _f(5);
    n && (Ar("AUTH", "Network connection restored"), ii({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = xj(this.retryCount);
    return Ar("AUTH", `Retrying in ${i} seconds`), await _f(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (vt.isRefreshTokenExpired(r))
      return Ar("AUTH", "Refresh token expired"), ii({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), vt.removeAuthData(), Yo(), null;
    if (UN(n)) {
      if (n.message === "timeout exceeded")
        return Ar("AUTH", "Timeout exceeded"), ii({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Ar("AUTH", "Network error"), ii({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Ar("AUTH", "Refresh token invalid (401)"), vt.removeAuthData(), Yo(), null;
      bf(n, {
        level: "error",
        tags: {
          team: Xa.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Ar("AUTH", "Retries exhausted, logging out"), bf(n, {
      level: "error",
      tags: {
        team: Xa.Platform,
        errorSource: "authManager.refresh"
      }
    }), vt.removeAuthData(), Yo(), null) : (Ar("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return vt.accessTokenExpiresInMs();
  }
}
const Ls = new Nj();
var Qu;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Qu || (Qu = {}));
const jj = new Em((e, n) => new _b((r) => {
  Ls.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), wj = new Em(
  (e, n) => new _b((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Ls.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...FS(Qa.url.partnerIntegrations) && d?.access_token && IS(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), Cj = new AbortController(), Zb = (e) => new ZS({
  queryDeduplication: !1,
  cache: new e0(),
  link: Em.from([
    jj,
    wj,
    n0({
      uri: `${e}/graphql`,
      fetch: s0,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: Cj.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), Fj = ({
  configuration: e,
  children: n
}) => {
  const r = qn(
    () => Zb(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Ue.jsx(t0, { client: r, children: n });
};
function Ij() {
  try {
    return r0(), !0;
  } catch {
    return !1;
  }
}
const Ej = ({
  configuration: e,
  children: n
}) => Ij() ? n : /* @__PURE__ */ Ue.jsx(Fj, { configuration: e, children: n }), Tj = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Ue.jsx(i0, { children: (o) => /* @__PURE__ */ Ue.jsx(
  ES,
  {
    value: {
      useMutation: OS(e, n),
      useQuery: DS(e, n),
      useLazyQuery: $S(e, n),
      executeQuery: TS(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), e_ = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Ue.jsx(Ej, { configuration: r, children: s ? /* @__PURE__ */ Ue.jsx(
    Tj,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var sl = { exports: {} }, ta = {}, xf;
function $j() {
  if (xf) return ta;
  xf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ta.Fragment = r, ta.jsx = s, ta.jsxs = s, ta;
}
var go = {}, Sf;
function Dj() {
  return Sf || (Sf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    go.Fragment = i, go.jsx = On, go.jsxs = Bn;
  })()), go;
}
var Nf;
function Oj() {
  return Nf || (Nf = 1, process.env.NODE_ENV === "production" ? sl.exports = $j() : sl.exports = Dj()), sl.exports;
}
var ae = Oj();
const Rj = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, Pj = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, Aj = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": Rj,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": Pj
};
function n_(e) {
  return Aj[e] ?? {};
}
const Lj = n_(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), Vj = n_(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), zj = "_copyIcon_1wjfs_48", Uj = "_list_1wjfs_53", Mj = "_listItem_1wjfs_63", Bj = "_collapsible_1wjfs_72", qj = "_collapsibleIsOpen_1wjfs_80", Hj = "_collapsibleHeader_1wjfs_83", Wj = "_collapsibleIconTrue_1wjfs_86", Kj = "_collapsibleIconFalse_1wjfs_89", Rn = {
  copyIcon: zj,
  list: Uj,
  listItem: Mj,
  collapsible: Bj,
  collapsibleIsOpen: qj,
  collapsibleHeader: Hj,
  collapsibleIconTrue: Wj,
  collapsibleIconFalse: Kj
}, Gj = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: ut(Rn.collapsible, {
        [Rn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Rn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ ae.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(We, { className: Rn.list, children: [
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: An(d).format(dt) })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: An(m).format(dt) })
          ] }) })
        ] })
      ]
    }
  );
}, Yj = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ ae.jsx(Un, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx(Gj, { app: r, openByDefault: i === 0 }, i))
  ] });
}, Jj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ ae.jsx(We, { className: Rn.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ ae.jsx(
      We.Text,
      {
        variant: "dense",
        className: Rn.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: i }),
          fb(a)
        ] })
      },
      o
    )) })
  ] }) });
}, Qj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ ae.jsx(We, { className: Rn.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      We.Text,
      {
        variant: "dense",
        className: Rn.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            Ke,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${An(a?.first).format(
                  dt
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${An(a?.last).format(
                  dt
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, cs = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ ae.jsx(Ke, { content: n ? null : l(), children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(ue, { size: 14, name: o(), color: s() }) }) });
}, Xj = "_wrapper_1xucg_1", Zj = "_externalLink_1xucg_7", ll = {
  wrapper: Xj,
  externalLink: Zj
}, ew = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = er(), { isCopied: i, copy: a } = er(), { isCopied: o, copy: s } = er(), { isCopied: l, copy: d } = er(), { isCopied: m, copy: u } = er();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: v,
    last_name: N,
    home_city: w,
    country: C,
    email: F,
    phone: y,
    dob: H,
    created_at: $,
    email_subscribe: E,
    push_subscribe: D
  } = e, U = 14, Z = `${v || ""} ${N || ""}`.trim() || "A customer has no name", Q = `${w ? `${w} /` : ""} ${C || ""}`.trim(), ie = H ? An(H).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { className: ll.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: ll.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-2", children: Z }),
          ie && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    $ && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: An($).format(dt) })
    ] }),
    Q && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "map-pin" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: Q })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy location", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: o ? "done" : "copy",
          onClick: () => s(Q),
          className: Rn.copyIcon
        }
      ) }) })
    ] }),
    F && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "mail" }),
        /* @__PURE__ */ ae.jsx("span", { className: ll.externalLink, children: F })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy email", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: n ? "done" : "copy",
          onClick: () => r(F),
          className: Rn.copyIcon
        }
      ) }) })
    ] }),
    y && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "phone" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: y })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: i ? "done" : "copy",
          onClick: () => a(y),
          className: Rn.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "user" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ ae.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy Braze ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: Rn.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "tag" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ ae.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy External ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: Rn.copyIcon
        }
      ) }) })
    ] }),
    E && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "sync" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(cs, { state: E })
    ] }),
    D && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "bell" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(cs, { isPush: !0, state: D })
    ] })
  ] }) });
}, nw = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: ut(Rn.collapsible, {
        [Rn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Rn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ ae.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(We, { className: Rn.list, children: [
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ ae.jsx(
              ue,
              {
                size: a,
                className: ut({
                  [Rn.collapsibleIconTrue]: d,
                  [Rn.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ke, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Ke, { content: "For iOS", children: /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, tw = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ ae.jsx(Un, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx(nw, { device: r, openByDefault: i === 0 }, i))
  ] });
}, ra = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, vo = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = kn(), { useMutation: a } = mn(), [o, s] = se(!1), [l] = a(
    Vj,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: ra[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ ae.jsx(Ke, { content: ra[n].tooltipContent, children: /* @__PURE__ */ ae.jsx(
    Kn,
    {
      variant: "secondary",
      color: ra[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ ae.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(
          cs,
          {
            noTooltip: !0,
            state: ra[n].parameter
          }
        ),
        ra[n].label
      ] })
    }
  ) });
}, rw = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ ae.jsx(We, { className: Rn.list, children: /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: 14, name: "sync" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(cs, { state: a })
    ] }) }) }),
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
        /* @__PURE__ */ ae.jsx(
          vo,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ ae.jsx(
          vo,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ ae.jsx(
        vo,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ ae.jsx(
        vo,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, iw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ ae.jsx(We, { className: Rn.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      We.Text,
      {
        variant: "dense",
        className: Rn.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            Ke,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${An(a?.first).format(
                  dt
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${An(a?.last).format(
                  dt
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, aw = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = kn(), { useMutation: i } = mn(), [a, o] = se(), [s, l] = se(!1), [d, m] = se(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, N = n.displayCustomAttributes ?? !1, w = n.displayCustomEvents ?? !1, C = n.displayPuchases ?? !1, F = n.displayDevices ?? !1, y = n.displayApps ?? !1, H = !h && !v && !N && !w && !C, [$, { error: E }] = i(
    Lj,
    {
      onError: () => {
      },
      onCompleted: (U) => {
        const Z = U?.Braze?.exportUserDetails?.users?.[0];
        Z ? (o(Z), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), D = async () => {
    u || f ? await $({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (qe(() => {
    async function U() {
      m(!0), await D();
    }
    U().finally(() => m(!1));
  }, [u, f]), E) {
    const U = E.graphQLErrors;
    return Nm({ errors: U }) ? /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : jm({ errors: U }) ? /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ae.jsx(In, { error: E });
  }
  return d ? /* @__PURE__ */ ae.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ae.jsx(cn, {}) }) : H ? /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ ae.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ae.jsx(ew, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ ae.jsx(
          rw,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await D()
          }
        ),
        N && !!a && /* @__PURE__ */ ae.jsx(Jj, { customerDetails: a }),
        w && !!a && /* @__PURE__ */ ae.jsx(Qj, { customerDetails: a }),
        C && !!a && /* @__PURE__ */ ae.jsx(iw, { customerDetails: a }),
        F && !!a && /* @__PURE__ */ ae.jsx(tw, { devices: a?.devices }),
        y && !!a && /* @__PURE__ */ ae.jsx(Yj, { apps: a?.apps })
      ]
    }
  );
}, ow = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => pb(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function sw() {
  var e = ui(!1), n = tt(function() {
    return e.current;
  }, []);
  return qe(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var lw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = tt(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, cw = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, jf = function(e) {
  return US(cw, e);
}, cl, wf;
function dw() {
  return wf || (wf = 1, cl = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), cl;
}
var dl, Cf;
function uw() {
  if (Cf) return dl;
  Cf = 1;
  var e = dw(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(w) {
        if (w.stopPropagation(), s.format)
          if (w.preventDefault(), typeof w.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var C = n[s.format] || n.default;
            window.clipboardData.setData(C, o);
          } else
            w.clipboardData.clearData(), w.clipboardData.setData(s.format, o);
        s.onCopy && (w.preventDefault(), s.onCopy(w.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var N = document.execCommand("copy");
      if (!N)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (w) {
      l && console.error("unable to copy using execCommand: ", w), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (C) {
        l && console.error("unable to copy using clipboardData: ", C), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return v;
  }
  return dl = a, dl;
}
var mw = uw();
const pw = /* @__PURE__ */ Tm(mw);
var t_ = function() {
  var e = sw(), n = lw({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = tt(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = pw(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function fw(e, n) {
  n === void 0 && (n = 0);
  var r = ui(!1), i = ui(), a = ui(e), o = tt(function() {
    return r.current;
  }, []), s = tt(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = tt(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return qe(function() {
    a.current = e;
  }, [e]), qe(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function gi(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = fw(e, n), a = i[0], o = i[1], s = i[2];
  return qe(s, r), [a, o];
}
var hw = function(e) {
  qe(e, []);
}, yw = function(e, n) {
  var r = ui(function() {
  });
  qe(function() {
    r.current = e;
  }), qe(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, gw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = qn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return Zs(Zs({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = l0(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = Zs({ get: tt(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, vw = function(e) {
  var n = ui(e);
  n.current = e, hw(function() {
    return function() {
      return n.current();
    };
  });
}, oo = (e) => e.type === "checkbox", li = (e) => e instanceof Date, Rt = (e) => e == null;
const r_ = (e) => typeof e == "object";
var st = (e) => !Rt(e) && !Array.isArray(e) && r_(e) && !li(e), i_ = (e) => st(e) && e.target ? oo(e.target) ? e.target.checked : e.target.value : e, kw = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, a_ = (e, n) => e.has(kw(n)), bw = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return st(n) && n.hasOwnProperty("isPrototypeOf");
}, Um = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function bt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Um && (e instanceof Blob || i)) && (r || st(e)))
    if (n = r ? [] : {}, !r && !bw(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = bt(e[a]));
  else
    return e;
  return n;
}
var Vs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], rt = (e) => e === void 0, Ge = (e, n, r) => {
  if (!n || !st(e))
    return r;
  const i = Vs(n.split(/[,[\].]+?/)).reduce((a, o) => Rt(a) ? a : a[o], e);
  return rt(i) || i === e ? rt(e[n]) ? r : e[n] : i;
}, Qt = (e) => typeof e == "boolean", Mm = (e) => /^\w*$/.test(e), o_ = (e) => Vs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Gn = (e, n, r) => {
  let i = -1;
  const a = Mm(n) ? [n] : o_(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = st(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const ds = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, pr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Lr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, s_ = Se.createContext(null), Rr = () => Se.useContext(s_), Bm = (e) => {
  const { children: n, ...r } = e;
  return Se.createElement(s_.Provider, { value: r }, n);
};
var l_ = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== pr.all && (n._proxyFormState[s] = !i || pr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function _w(e) {
  const n = Rr(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => l_(s, r, d.current, !1), [s, r]);
}
var Er = (e) => typeof e == "string", c_ = (e, n, r, i, a) => Er(e) ? (i && n.watch.add(e), Ge(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ge(r, o))) : (i && (n.watchAll = !0), r);
function Jo(e) {
  const n = Rr(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(c_(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function qm(e) {
  const n = Rr(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = a_(a._names.array, r), l = Jo({
    control: a,
    name: r,
    defaultValue: Ge(a._formValues, r, Ge(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = _w({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Qt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ge(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ge(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ge(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ge(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Ge(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((C) => u.current.onChange({
    target: {
      value: i_(C),
      name: r
    },
    type: ds.CHANGE
  }), [r]), v = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Ge(a._formValues, r),
      name: r
    },
    type: ds.BLUR
  }), [r, a._formValues]), N = Se.useCallback((C) => {
    const F = Ge(a._fields, r);
    F && C && (F._f.ref = {
      focus: () => C.focus(),
      select: () => C.select(),
      setCustomValidity: (y) => C.setCustomValidity(y),
      reportValidity: () => C.reportValidity()
    });
  }, [a._fields, r]), w = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Qt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: N
  }), [r, i, d.disabled, h, v, N, l]);
  return Se.useEffect(() => {
    const C = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Qt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const F = (y, H) => {
      const $ = Ge(a._fields, y);
      $ && $._f && ($._f.mount = H);
    };
    if (F(r, !0), C) {
      const y = bt(Ge(a._options.defaultValues, r));
      Gn(a._defaultValues, r, y), rt(Ge(a._formValues, r)) && Gn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? C && !a._state.action : C) ? a.unregister(r) : F(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: w,
    formState: d,
    fieldState: f
  }), [w, d, f]);
}
const Lt = (e) => e.render(qm(e));
var xw = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ua = (e) => Array.isArray(e) ? e : [e], Ff = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Xu = (e) => Rt(e) || !r_(e);
function Jr(e, n) {
  if (Xu(e) || Xu(n))
    return e === n;
  if (li(e) && li(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (li(o) && li(s) || st(o) && st(s) || Array.isArray(o) && Array.isArray(s) ? !Jr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var $t = (e) => st(e) && !Object.keys(e).length, Hm = (e) => e.type === "file", fr = (e) => typeof e == "function", us = (e) => {
  if (!Um)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, d_ = (e) => e.type === "select-multiple", Wm = (e) => e.type === "radio", Sw = (e) => Wm(e) || oo(e), ul = (e) => us(e) && e.isConnected;
function Nw(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = rt(e) ? i++ : e[n[i++]];
  return e;
}
function jw(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !rt(e[n]))
      return !1;
  return !0;
}
function ft(e, n) {
  const r = Array.isArray(n) ? n : Mm(n) ? [n] : o_(n), i = r.length === 1 ? e : Nw(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (st(i) && $t(i) || Array.isArray(i) && jw(i)) && ft(e, r.slice(0, -1)), e;
}
var u_ = (e) => {
  for (const n in e)
    if (fr(e[n]))
      return !0;
  return !1;
};
function ms(e, n = {}) {
  const r = Array.isArray(e);
  if (st(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || st(e[i]) && !u_(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, ms(e[i], n[i])) : Rt(e[i]) || (n[i] = !0);
  return n;
}
function m_(e, n, r) {
  const i = Array.isArray(e);
  if (st(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || st(e[a]) && !u_(e[a]) ? rt(n) || Xu(r[a]) ? r[a] = Array.isArray(e[a]) ? ms(e[a], []) : { ...ms(e[a]) } : m_(e[a], Rt(n) ? {} : n[a], r[a]) : r[a] = !Jr(e[a], n[a]);
  return r;
}
var ia = (e, n) => m_(e, n, ms(n));
const If = {
  value: !1,
  isValid: !1
}, Ef = { value: !0, isValid: !0 };
var p_ = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !rt(e[0].attributes.value) ? rt(e[0].value) || e[0].value === "" ? Ef : { value: e[0].value, isValid: !0 } : Ef
    ) : If;
  }
  return If;
}, f_ = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => rt(e) ? e : n ? e === "" ? NaN : e && +e : r && Er(e) ? new Date(e) : i ? i(e) : e;
const Tf = {
  isValid: !1,
  value: null
};
var h_ = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Tf) : Tf;
function $f(e) {
  const n = e.ref;
  return Hm(n) ? n.files : Wm(n) ? h_(e.refs).value : d_(n) ? [...n.selectedOptions].map(({ value: r }) => r) : oo(n) ? p_(e.refs).value : f_(rt(n.value) ? e.ref.value : n.value, e);
}
var ww = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Ge(n, o);
    s && Gn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, ps = (e) => e instanceof RegExp, aa = (e) => rt(e) ? e : ps(e) ? e.source : st(e) ? ps(e.value) ? e.value.source : e.value : e, Df = (e) => ({
  isOnSubmit: !e || e === pr.onSubmit,
  isOnBlur: e === pr.onBlur,
  isOnChange: e === pr.onChange,
  isOnAll: e === pr.all,
  isOnTouch: e === pr.onTouched
});
const Of = "AsyncFunction";
var Cw = (e) => !!e && !!e.validate && !!(fr(e.validate) && e.validate.constructor.name === Of || st(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Of)), Fw = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Rf = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ma = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Ge(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ma(l, n))
          break;
      } else if (st(l) && Ma(l, n))
        break;
    }
  }
};
function Pf(e, n, r) {
  const i = Ge(e, r);
  if (i || Mm(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ge(n, o), l = Ge(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var Iw = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return $t(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || pr.all));
}, Ew = (e, n, r) => !e || !n || e === n || Ua(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), Tw = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, $w = (e, n) => !Vs(Ge(e, n)).length && ft(e, n), Dw = (e, n, r) => {
  const i = Ua(Ge(e, r));
  return Gn(i, "root", n[r]), Gn(e, r, i), e;
}, Qo = (e) => Er(e);
function Af(e, n, r = "validate") {
  if (Qo(e) || Array.isArray(e) && e.every(Qo) || Qt(e) && !e)
    return {
      type: r,
      message: Qo(e) ? e : "",
      ref: n
    };
}
var xi = (e) => st(e) && !ps(e) ? e : {
  value: e,
  message: ""
}, Lf = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: N, name: w, valueAsNumber: C, mount: F } = e._f, y = Ge(r, w);
  if (!F || n.has(w))
    return {};
  const H = l ? l[0] : s, $ = (M) => {
    a && H.reportValidity && (H.setCustomValidity(Qt(M) ? "" : M || ""), H.reportValidity());
  }, E = {}, D = Wm(s), U = oo(s), Z = D || U, Q = (C || Hm(s)) && rt(s.value) && rt(y) || us(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ie = xw.bind(null, w, i, E), Y = (M, R, q, ee = Lr.maxLength, ge = Lr.minLength) => {
    const de = M ? R : q;
    E[w] = {
      type: M ? ee : ge,
      message: de,
      ref: s,
      ...ie(M ? ee : ge, de)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Z && (Q || Rt(y)) || Qt(y) && !y || U && !p_(l).isValid || D && !h_(l).isValid)) {
    const { value: M, message: R } = Qo(d) ? { value: !!d, message: d } : xi(d);
    if (M && (E[w] = {
      type: Lr.required,
      message: R,
      ref: H,
      ...ie(Lr.required, R)
    }, !i))
      return $(R), E;
  }
  if (!Q && (!Rt(f) || !Rt(h))) {
    let M, R;
    const q = xi(h), ee = xi(f);
    if (!Rt(y) && !isNaN(y)) {
      const ge = s.valueAsNumber || y && +y;
      Rt(q.value) || (M = ge > q.value), Rt(ee.value) || (R = ge < ee.value);
    } else {
      const ge = s.valueAsDate || new Date(y), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", pe = s.type == "week";
      Er(q.value) && y && (M = le ? de(y) > de(q.value) : pe ? y > q.value : ge > new Date(q.value)), Er(ee.value) && y && (R = le ? de(y) < de(ee.value) : pe ? y < ee.value : ge < new Date(ee.value));
    }
    if ((M || R) && (Y(!!M, q.message, ee.message, Lr.max, Lr.min), !i))
      return $(E[w].message), E;
  }
  if ((m || u) && !Q && (Er(y) || o && Array.isArray(y))) {
    const M = xi(m), R = xi(u), q = !Rt(M.value) && y.length > +M.value, ee = !Rt(R.value) && y.length < +R.value;
    if ((q || ee) && (Y(q, M.message, R.message), !i))
      return $(E[w].message), E;
  }
  if (v && !Q && Er(y)) {
    const { value: M, message: R } = xi(v);
    if (ps(M) && !y.match(M) && (E[w] = {
      type: Lr.pattern,
      message: R,
      ref: s,
      ...ie(Lr.pattern, R)
    }, !i))
      return $(R), E;
  }
  if (N) {
    if (fr(N)) {
      const M = await N(y, r), R = Af(M, H);
      if (R && (E[w] = {
        ...R,
        ...ie(Lr.validate, R.message)
      }, !i))
        return $(R.message), E;
    } else if (st(N)) {
      let M = {};
      for (const R in N) {
        if (!$t(M) && !i)
          break;
        const q = Af(await N[R](y, r), H, R);
        q && (M = {
          ...q,
          ...ie(R, q.message)
        }, $(q.message), i && (E[w] = M));
      }
      if (!$t(M) && (E[w] = {
        ref: H,
        ...M
      }, !i))
        return E;
    }
  }
  return $(!0), E;
};
const Ow = {
  mode: pr.onSubmit,
  reValidateMode: pr.onChange,
  shouldFocusError: !0
};
function Rw(e = {}) {
  let n = {
    ...Ow,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: fr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = st(n.defaultValues) || st(n.values) ? bt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : bt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Ff(),
    state: Ff()
  }, v = Df(n.mode), N = Df(n.reValidateMode), w = n.criteriaMode === pr.all, C = (_) => (T) => {
    clearTimeout(m), m = setTimeout(_, T);
  }, F = async (_) => {
    if (!n.disabled && (u.isValid || f.isValid || _)) {
      const T = n.resolver ? $t((await Q()).errors) : await Y(i, !0);
      T !== r.isValid && h.state.next({
        isValid: T
      });
    }
  }, y = (_, T) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((_ || Array.from(l.mount)).forEach((G) => {
      G && (T ? Gn(r.validatingFields, G, T) : ft(r.validatingFields, G));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !$t(r.validatingFields)
    }));
  }, H = (_, T = [], G, J, O = !0, z = !0) => {
    if (J && G && !n.disabled) {
      if (s.action = !0, z && Array.isArray(Ge(i, _))) {
        const re = G(Ge(i, _), J.argA, J.argB);
        O && Gn(i, _, re);
      }
      if (z && Array.isArray(Ge(r.errors, _))) {
        const re = G(Ge(r.errors, _), J.argA, J.argB);
        O && Gn(r.errors, _, re), $w(r.errors, _);
      }
      if ((u.touchedFields || f.touchedFields) && z && Array.isArray(Ge(r.touchedFields, _))) {
        const re = G(Ge(r.touchedFields, _), J.argA, J.argB);
        O && Gn(r.touchedFields, _, re);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = ia(a, o)), h.state.next({
        name: _,
        isDirty: R(_, T),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Gn(o, _, T);
  }, $ = (_, T) => {
    Gn(r.errors, _, T), h.state.next({
      errors: r.errors
    });
  }, E = (_) => {
    r.errors = _, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (_, T, G, J) => {
    const O = Ge(i, _);
    if (O) {
      const z = Ge(o, _, rt(G) ? Ge(a, _) : G);
      rt(z) || J && J.defaultChecked || T ? Gn(o, _, T ? z : $f(O._f)) : ge(_, z), s.mount && F();
    }
  }, U = (_, T, G, J, O) => {
    let z = !1, re = !1;
    const fe = {
      name: _
    };
    if (!n.disabled) {
      if (!G || J) {
        (u.isDirty || f.isDirty) && (re = r.isDirty, r.isDirty = fe.isDirty = R(), z = re !== fe.isDirty);
        const be = Jr(Ge(a, _), T);
        re = !!Ge(r.dirtyFields, _), be ? ft(r.dirtyFields, _) : Gn(r.dirtyFields, _, !0), fe.dirtyFields = r.dirtyFields, z = z || (u.dirtyFields || f.dirtyFields) && re !== !be;
      }
      if (G) {
        const be = Ge(r.touchedFields, _);
        be || (Gn(r.touchedFields, _, G), fe.touchedFields = r.touchedFields, z = z || (u.touchedFields || f.touchedFields) && be !== G);
      }
      z && O && h.state.next(fe);
    }
    return z ? fe : {};
  }, Z = (_, T, G, J) => {
    const O = Ge(r.errors, _), z = (u.isValid || f.isValid) && Qt(T) && r.isValid !== T;
    if (n.delayError && G ? (d = C(() => $(_, G)), d(n.delayError)) : (clearTimeout(m), d = null, G ? Gn(r.errors, _, G) : ft(r.errors, _)), (G ? !Jr(O, G) : O) || !$t(J) || z) {
      const re = {
        ...J,
        ...z && Qt(T) ? { isValid: T } : {},
        errors: r.errors,
        name: _
      };
      r = {
        ...r,
        ...re
      }, h.state.next(re);
    }
  }, Q = async (_) => {
    y(_, !0);
    const T = await n.resolver(o, n.context, ww(_ || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(_), T;
  }, ie = async (_) => {
    const { errors: T } = await Q(_);
    if (_)
      for (const G of _) {
        const J = Ge(T, G);
        J ? Gn(r.errors, G, J) : ft(r.errors, G);
      }
    else
      r.errors = T;
    return T;
  }, Y = async (_, T, G = {
    valid: !0
  }) => {
    for (const J in _) {
      const O = _[J];
      if (O) {
        const { _f: z, ...re } = O;
        if (z) {
          const fe = l.array.has(z.name), be = O._f && Cw(O._f);
          be && u.validatingFields && y([J], !0);
          const Ze = await Lf(O, l.disabled, o, w, n.shouldUseNativeValidation && !T, fe);
          if (be && u.validatingFields && y([J]), Ze[z.name] && (G.valid = !1, T))
            break;
          !T && (Ge(Ze, z.name) ? fe ? Dw(r.errors, Ze, z.name) : Gn(r.errors, z.name, Ze[z.name]) : ft(r.errors, z.name));
        }
        !$t(re) && await Y(re, T, G);
      }
    }
    return G.valid;
  }, M = () => {
    for (const _ of l.unMount) {
      const T = Ge(i, _);
      T && (T._f.refs ? T._f.refs.every((G) => !ul(G)) : !ul(T._f.ref)) && Ae(_);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (_, T) => !n.disabled && (_ && T && Gn(o, _, T), !Jr(Ce(), a)), q = (_, T, G) => c_(_, l, {
    ...s.mount ? o : rt(T) ? a : Er(_) ? { [_]: T } : T
  }, G, T), ee = (_) => Vs(Ge(s.mount ? o : a, _, n.shouldUnregister ? Ge(a, _, []) : [])), ge = (_, T, G = {}) => {
    const J = Ge(i, _);
    let O = T;
    if (J) {
      const z = J._f;
      z && (!z.disabled && Gn(o, _, f_(T, z)), O = us(z.ref) && Rt(T) ? "" : T, d_(z.ref) ? [...z.ref.options].forEach((re) => re.selected = O.includes(re.value)) : z.refs ? oo(z.ref) ? z.refs.length > 1 ? z.refs.forEach((re) => (!re.defaultChecked || !re.disabled) && (re.checked = Array.isArray(O) ? !!O.find((fe) => fe === re.value) : O === re.value)) : z.refs[0] && (z.refs[0].checked = !!O) : z.refs.forEach((re) => re.checked = re.value === O) : Hm(z.ref) ? z.ref.value = "" : (z.ref.value = O, z.ref.type || h.state.next({
        name: _,
        values: bt(o)
      })));
    }
    (G.shouldDirty || G.shouldTouch) && U(_, O, G.shouldTouch, G.shouldDirty, !0), G.shouldValidate && ke(_);
  }, de = (_, T, G) => {
    for (const J in T) {
      const O = T[J], z = `${_}.${J}`, re = Ge(i, z);
      (l.array.has(_) || st(O) || re && !re._f) && !li(O) ? de(z, O, G) : ge(z, O, G);
    }
  }, le = (_, T, G = {}) => {
    const J = Ge(i, _), O = l.array.has(_), z = bt(T);
    Gn(o, _, z), O ? (h.array.next({
      name: _,
      values: bt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && G.shouldDirty && h.state.next({
      name: _,
      dirtyFields: ia(a, o),
      isDirty: R(_, z)
    })) : J && !J._f && !Rt(z) ? de(_, z, G) : ge(_, z, G), Rf(_, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? _ : void 0,
      values: bt(o)
    });
  }, pe = async (_) => {
    s.mount = !0;
    const T = _.target;
    let G = T.name, J = !0;
    const O = Ge(i, G), z = (re) => {
      J = Number.isNaN(re) || li(re) && isNaN(re.getTime()) || Jr(re, Ge(o, G, re));
    };
    if (O) {
      let re, fe;
      const be = T.type ? $f(O._f) : i_(_), Ze = _.type === ds.BLUR || _.type === ds.FOCUS_OUT, un = !Fw(O._f) && !n.resolver && !Ge(r.errors, G) && !O._f.deps || Tw(Ze, Ge(r.touchedFields, G), r.isSubmitted, N, v), rn = Rf(G, l, Ze);
      Gn(o, G, be), Ze ? (O._f.onBlur && O._f.onBlur(_), d && d(0)) : O._f.onChange && O._f.onChange(_);
      const dn = U(G, be, Ze), pn = !$t(dn) || rn;
      if (!Ze && h.state.next({
        name: G,
        type: _.type,
        values: bt(o)
      }), un)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Ze && F() : Ze || F()), pn && h.state.next({ name: G, ...rn ? {} : dn });
      if (!Ze && rn && h.state.next({ ...r }), n.resolver) {
        const { errors: ln } = await Q([G]);
        if (z(be), J) {
          const vn = Pf(r.errors, i, G), Qe = Pf(ln, i, vn.name || G);
          re = Qe.error, G = Qe.name, fe = $t(ln);
        }
      } else
        y([G], !0), re = (await Lf(O, l.disabled, o, w, n.shouldUseNativeValidation))[G], y([G]), z(be), J && (re ? fe = !1 : (u.isValid || f.isValid) && (fe = await Y(i, !0)));
      J && (O._f.deps && ke(O._f.deps), Z(G, fe, re, dn));
    }
  }, W = (_, T) => {
    if (Ge(r.errors, T) && _.focus)
      return _.focus(), 1;
  }, ke = async (_, T = {}) => {
    let G, J;
    const O = Ua(_);
    if (n.resolver) {
      const z = await ie(rt(_) ? _ : O);
      G = $t(z), J = _ ? !O.some((re) => Ge(z, re)) : G;
    } else _ ? (J = (await Promise.all(O.map(async (z) => {
      const re = Ge(i, z);
      return await Y(re && re._f ? { [z]: re } : re);
    }))).every(Boolean), !(!J && !r.isValid) && F()) : J = G = await Y(i);
    return h.state.next({
      ...!Er(_) || (u.isValid || f.isValid) && G !== r.isValid ? {} : { name: _ },
      ...n.resolver || !_ ? { isValid: G } : {},
      errors: r.errors
    }), T.shouldFocus && !J && Ma(i, W, _ ? O : l.mount), J;
  }, Ce = (_) => {
    const T = {
      ...s.mount ? o : a
    };
    return rt(_) ? T : Er(_) ? Ge(T, _) : _.map((G) => Ge(T, G));
  }, K = (_, T) => ({
    invalid: !!Ge((T || r).errors, _),
    isDirty: !!Ge((T || r).dirtyFields, _),
    error: Ge((T || r).errors, _),
    isValidating: !!Ge(r.validatingFields, _),
    isTouched: !!Ge((T || r).touchedFields, _)
  }), Be = (_) => {
    _ && Ua(_).forEach((T) => ft(r.errors, T)), h.state.next({
      errors: _ ? r.errors : {}
    });
  }, Me = (_, T, G) => {
    const J = (Ge(i, _, { _f: {} })._f || {}).ref, O = Ge(r.errors, _) || {}, { ref: z, message: re, type: fe, ...be } = O;
    Gn(r.errors, _, {
      ...be,
      ...T,
      ref: J
    }), h.state.next({
      name: _,
      errors: r.errors,
      isValid: !1
    }), G && G.shouldFocus && J && J.focus && J.focus();
  }, Pe = (_, T) => fr(_) ? h.state.subscribe({
    next: (G) => _(q(void 0, T), G)
  }) : q(_, T, !0), ze = (_) => h.state.subscribe({
    next: (T) => {
      Ew(_.name, T.name, _.exact) && Iw(T, _.formState || u, Oe, _.reRenderRoot) && _.callback({
        values: { ...o },
        ...r,
        ...T
      });
    }
  }).unsubscribe, je = (_) => (s.mount = !0, f = {
    ...f,
    ..._.formState
  }, ze({
    ..._,
    formState: f
  })), Ae = (_, T = {}) => {
    for (const G of _ ? Ua(_) : l.mount)
      l.mount.delete(G), l.array.delete(G), T.keepValue || (ft(i, G), ft(o, G)), !T.keepError && ft(r.errors, G), !T.keepDirty && ft(r.dirtyFields, G), !T.keepTouched && ft(r.touchedFields, G), !T.keepIsValidating && ft(r.validatingFields, G), !n.shouldUnregister && !T.keepDefaultValue && ft(a, G);
    h.state.next({
      values: bt(o)
    }), h.state.next({
      ...r,
      ...T.keepDirty ? { isDirty: R() } : {}
    }), !T.keepIsValid && F();
  }, $e = ({ disabled: _, name: T }) => {
    (Qt(_) && s.mount || _ || l.disabled.has(T)) && (_ ? l.disabled.add(T) : l.disabled.delete(T));
  }, nn = (_, T = {}) => {
    let G = Ge(i, _);
    const J = Qt(T.disabled) || Qt(n.disabled);
    return Gn(i, _, {
      ...G || {},
      _f: {
        ...G && G._f ? G._f : { ref: { name: _ } },
        name: _,
        mount: !0,
        ...T
      }
    }), l.mount.add(_), G ? $e({
      disabled: Qt(T.disabled) ? T.disabled : n.disabled,
      name: _
    }) : D(_, !0, T.value), {
      ...J ? { disabled: T.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!T.required,
        min: aa(T.min),
        max: aa(T.max),
        minLength: aa(T.minLength),
        maxLength: aa(T.maxLength),
        pattern: aa(T.pattern)
      } : {},
      name: _,
      onChange: pe,
      onBlur: pe,
      ref: (O) => {
        if (O) {
          nn(_, T), G = Ge(i, _);
          const z = rt(O.value) && O.querySelectorAll && O.querySelectorAll("input,select,textarea")[0] || O, re = Sw(z), fe = G._f.refs || [];
          if (re ? fe.find((be) => be === z) : z === G._f.ref)
            return;
          Gn(i, _, {
            _f: {
              ...G._f,
              ...re ? {
                refs: [
                  ...fe.filter(ul),
                  z,
                  ...Array.isArray(Ge(a, _)) ? [{}] : []
                ],
                ref: { type: z.type, name: _ }
              } : { ref: z }
            }
          }), D(_, !1, void 0, z);
        } else
          G = Ge(i, _, {}), G._f && (G._f.mount = !1), (n.shouldUnregister || T.shouldUnregister) && !(a_(l.array, _) && s.action) && l.unMount.add(_);
      }
    };
  }, we = () => n.shouldFocusError && Ma(i, W, l.mount), He = (_) => {
    Qt(_) && (h.state.next({ disabled: _ }), Ma(i, (T, G) => {
      const J = Ge(i, G);
      J && (T.disabled = J._f.disabled || _, Array.isArray(J._f.refs) && J._f.refs.forEach((O) => {
        O.disabled = J._f.disabled || _;
      }));
    }, 0, !1));
  }, Xe = (_, T) => async (G) => {
    let J;
    G && (G.preventDefault && G.preventDefault(), G.persist && G.persist());
    let O = bt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: z, values: re } = await Q();
      r.errors = z, O = re;
    } else
      await Y(i);
    if (l.disabled.size)
      for (const z of l.disabled)
        Gn(O, z, void 0);
    if (ft(r.errors, "root"), $t(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await _(O, G);
      } catch (z) {
        J = z;
      }
    } else
      T && await T({ ...r.errors }, G), we(), setTimeout(we);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: $t(r.errors) && !J,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), J)
      throw J;
  }, me = (_, T = {}) => {
    Ge(i, _) && (rt(T.defaultValue) ? le(_, bt(Ge(a, _))) : (le(_, T.defaultValue), Gn(a, _, bt(T.defaultValue))), T.keepTouched || ft(r.touchedFields, _), T.keepDirty || (ft(r.dirtyFields, _), r.isDirty = T.defaultValue ? R(_, bt(Ge(a, _))) : R()), T.keepError || (ft(r.errors, _), u.isValid && F()), h.state.next({ ...r }));
  }, he = (_, T = {}) => {
    const G = _ ? bt(_) : a, J = bt(G), O = $t(_), z = O ? a : J;
    if (T.keepDefaultValues || (a = G), !T.keepValues) {
      if (T.keepDirtyValues) {
        const re = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(ia(a, o))
        ]);
        for (const fe of Array.from(re))
          Ge(r.dirtyFields, fe) ? Gn(z, fe, Ge(o, fe)) : le(fe, Ge(z, fe));
      } else {
        if (Um && rt(_))
          for (const re of l.mount) {
            const fe = Ge(i, re);
            if (fe && fe._f) {
              const be = Array.isArray(fe._f.refs) ? fe._f.refs[0] : fe._f.ref;
              if (us(be)) {
                const Ze = be.closest("form");
                if (Ze) {
                  Ze.reset();
                  break;
                }
              }
            }
          }
        for (const re of l.mount)
          le(re, Ge(z, re));
      }
      o = bt(z), h.array.next({
        values: { ...z }
      }), h.state.next({
        values: { ...z }
      });
    }
    l = {
      mount: T.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!T.keepIsValid || !!T.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: T.keepSubmitCount ? r.submitCount : 0,
      isDirty: O ? !1 : T.keepDirty ? r.isDirty : !!(T.keepDefaultValues && !Jr(_, a)),
      isSubmitted: T.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: O ? {} : T.keepDirtyValues ? T.keepDefaultValues && o ? ia(a, o) : r.dirtyFields : T.keepDefaultValues && _ ? ia(a, _) : T.keepDirty ? r.dirtyFields : {},
      touchedFields: T.keepTouched ? r.touchedFields : {},
      errors: T.keepErrors ? r.errors : {},
      isSubmitSuccessful: T.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ie = (_, T) => he(fr(_) ? _(o) : _, T), Le = (_, T = {}) => {
    const G = Ge(i, _), J = G && G._f;
    if (J) {
      const O = J.refs ? J.refs[0] : J.ref;
      O.focus && (O.focus(), T.shouldSelect && fr(O.select) && O.select());
    }
  }, Oe = (_) => {
    r = {
      ...r,
      ..._
    };
  }, j = {
    control: {
      register: nn,
      unregister: Ae,
      getFieldState: K,
      handleSubmit: Xe,
      setError: Me,
      _subscribe: ze,
      _runSchema: Q,
      _getWatch: q,
      _getDirty: R,
      _setValid: F,
      _setFieldArray: H,
      _setDisabledField: $e,
      _setErrors: E,
      _getFieldArray: ee,
      _reset: he,
      _resetDefaultValues: () => fr(n.defaultValues) && n.defaultValues().then((_) => {
        Ie(_, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: M,
      _disableForm: He,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(_) {
        s = _;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(_) {
        l = _;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(_) {
        n = {
          ...n,
          ..._
        };
      }
    },
    subscribe: je,
    trigger: ke,
    register: nn,
    handleSubmit: Xe,
    watch: Pe,
    setValue: le,
    getValues: Ce,
    reset: Ie,
    resetField: me,
    clearErrors: Be,
    unregister: Ae,
    setError: Me,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...j,
    formControl: j
  };
}
function lr(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: fr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: fr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : Rw(e),
    formState: i
  }, e.formControl && e.defaultValues && !fr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Jr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !$t(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = l_(i, o), n.current;
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ml = { exports: {} }, oa = {}, Vf;
function Pw() {
  if (Vf) return oa;
  Vf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return oa.Fragment = r, oa.jsx = s, oa.jsxs = s, oa;
}
var ko = {}, zf;
function Aw() {
  return zf || (zf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    ko.Fragment = i, ko.jsx = On, ko.jsxs = Bn;
  })()), ko;
}
var Uf;
function Lw() {
  return Uf || (Uf = 1, process.env.NODE_ENV === "production" ? ml.exports = Pw() : ml.exports = Aw()), ml.exports;
}
var _e = Lw();
const Vw = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, zw = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, Uw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, Mw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, Bw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, qw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, Hw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, Ww = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, Kw = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": Uw,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": Mw,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": Bw,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": Vw,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": zw,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": qw,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": Hw,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": Ww
};
function Wi(e) {
  return Kw[e] ?? {};
}
const Gw = Wi(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), Yw = Wi(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Jw = Wi(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Mf = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, rr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, Qw = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), Bf = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, Zu = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ _e.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ _e.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ _e.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ _e.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ _e.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ _e.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function Xw({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = se(
    []
  ), [o, s] = se([]), [l, d] = se([]), [m, u] = se([]), [f, h] = se(), { showNotification: v, showModal: N, executeQuery: w } = mn(), { track: C } = kn(), {
    loading: F,
    data: y,
    error: H,
    store: $
  } = wm(e ?? null), E = y?.github?.issues || [], D = y?.github?.pullRequests || [], [U, Z] = se(!1), [Q, ie] = se();
  qe(
    () => h(H || Q || void 0),
    [H, Q]
  ), qe(
    () => {
      !F && (E?.length || D?.length) ? (a(E), s(D), M(E, D)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  );
  const Y = async (pe, W) => {
    await $(pe).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: W.success.title,
        text: W.success.text
      });
    }).catch((ke) => {
      v({
        title: W.error.title,
        text: `${W.error.text} ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, M = (pe, W) => {
    if (!pe?.length && !W?.length) {
      d([]), u([]);
      return;
    }
    const ke = (pe || []).map(
      (Be) => w(Yw, {
        owner: Be.owner,
        repositoryName: Be.repository,
        issueNumber: Be.number
      })
    ), Ce = (W || []).map(
      (Be) => w(Jw, {
        owner: Be.owner,
        repositoryName: Be.repository,
        prNumber: Be.number
      })
    ), K = [...ke, ...Ce];
    Z(!0), Promise.all(K).then((Be) => {
      const Me = [], Pe = [];
      Be.forEach((ze) => {
        const je = ze?.data?.GitHub;
        if (!je) {
          d([]), u([]);
          return;
        }
        Object.keys(je).forEach((Ae) => {
          if (Ae.startsWith("repository")) {
            const $e = je[Ae];
            Object.keys($e).forEach((nn) => {
              const we = $e[nn], He = {
                number: we?.number,
                owner: we?.repository?.owner?.login,
                repository: we?.repository?.name
              };
              nn.startsWith("issue") && Me.push({
                ...we,
                type: "ISSUE",
                key: He
              }), nn.startsWith("pullRequest") && Pe.push({
                ...we,
                type: "PR",
                key: He
              });
            });
          }
        });
      }), d(Me), u(Pe);
    }).catch(ie).finally(() => {
      Z(!1);
    });
  }, R = ({ key: pe, type: W }) => {
    C("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = y && (E.length || D.length) ? y : r, Ce = W === "ISSUE" ? "issues" : "pullRequests";
    ke.github[Ce] = Array.from(
      new Set(ke.github[Ce]).add(pe)
    ), Y(ke, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${rr(
          pe
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${rr(pe)} failed. Please try again.`
      }
    });
  }, q = async ({ key: pe, type: W }) => {
    C("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = y && (E.length || D.length) ? y : r, Ce = W === "ISSUE" ? "issues" : "pullRequests";
    ke.github[Ce] = Array.from(
      new Set(ke.github[Ce]).add(pe)
    ), await $(ke).catch((K) => {
      v({
        title: "Linking failed",
        text: `Linking ${pe} failed. Please try again. ${K.message && " (" + K.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ee = ({ key: pe, type: W }) => {
    C("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const ke = W === "ISSUE" ? "issue" : "pull request";
    N({
      headline: `Unlink ${ke} ${rr(pe)}?`,
      text: `You are about to unlink the ${ke} ${rr(
        pe
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${ke}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Ce = W === "ISSUE" ? "issues" : "pullRequests";
        if (!y)
          return;
        const K = {
          ...y,
          github: {
            ...y?.github,
            [Ce]: y?.github?.[Ce].filter(
              (Be) => Be.number !== pe.number || Be.owner !== pe.owner || Be.repository !== pe.repository
            )
          }
        };
        C("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), Y(K, {
          success: {
            title: `GitHub ${ke} unlinked`,
            text: `You unlinked the GitHub ${ke} ${rr(
              pe
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${rr(pe)} failed.`
          }
        });
      },
      onCancel: () => {
        C("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ge = () => {
    C("github:unlink:all:clicked", {
      githubOrganization: n
    }), N({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        C("github:unlink:all:confirmed", {
          githubOrganization: n
        }), Y(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        C("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, de = E.filter(
    (pe) => !i?.includes(pe)
  ) || [], le = D.filter(
    (pe) => !o?.includes(pe)
  ) || [];
  return {
    linkGithubItem: R,
    linkGithubItemQuietly: q,
    unlinkGithubItem: ee,
    loadGithubItems: M,
    removeDanglingGithubItemLinks: () => {
      const pe = {
        ...y,
        github: {
          ...y?.github,
          issues: E.filter(
            (W) => !de.includes(W)
          ) || [],
          pullRequests: D.filter(
            (W) => !le.includes(W)
          ) || []
        }
      };
      $(pe);
    },
    unlinkAllGithubItems: ge,
    isLoadingGithubItemLinks: F,
    danglingIssueLinks: de,
    danglingPullRequestLinks: le,
    isLoadingGithubItems: U,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const Zw = "_contentWrapper_1vx3c_1", eC = "_contentWrapperHeadline_1vx3c_4", nC = "_contentWrapperBody_1vx3c_11", tC = "_contentWrapperAssigneeIcon_1vx3c_15", rC = "_contentWrapperStatusTag_1vx3c_20", Vr = {
  contentWrapper: Zw,
  contentWrapperHeadline: eC,
  contentWrapperBody: nC,
  contentWrapperAssigneeIcon: tC,
  contentWrapperStatusTag: rC
}, y_ = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
  e && /* @__PURE__ */ _e.jsxs(Qn, { className: Vr.contentWrapper, children: [
    /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ _e.jsxs(Qn, { className: Vr.contentWrapper, children: [
    /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ _e.jsxs(Qn, { margin: "100 0", children: [
        /* @__PURE__ */ _e.jsx(
          "img",
          {
            className: Vr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ _e.jsx(
      Pn,
      {
        className: Vr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), iC = "_collapse_1bdjy_1", aC = "_collapseHeader_1bdjy_10", oC = "_collapseHeaderKey_1bdjy_31", sC = "_collapseHeaderKeyIcon_1bdjy_36", lC = "_collapseHeaderKeyLink_1bdjy_41", cC = "_collapseHeaderIcon_1bdjy_44", dC = "_collapseHeaderTitle_1bdjy_49", uC = "_collapseContent_1bdjy_57", mC = "_collapseContentButtonSpacer_1bdjy_60", pC = "_collapseContentButtonLink_1bdjy_63", Nr = {
  collapse: iC,
  collapseHeader: aC,
  collapseHeaderKey: oC,
  collapseHeaderKeyIcon: sC,
  collapseHeaderKeyLink: lC,
  collapseHeaderIcon: cC,
  collapseHeaderTitle: dC,
  collapseContent: uC,
  collapseContentButtonSpacer: mC,
  collapseContentButtonLink: pC
}, fC = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = se(i), { track: s } = kn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ _e.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: v,
      repository: N,
      type: w,
      state: C,
      assignees: F,
      labels: y
    } = d, H = a[m];
    return /* @__PURE__ */ _e.jsxs(
      ar,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: H,
        className: Nr.collapse,
        children: [
          /* @__PURE__ */ _e.jsx(ar.Header, { className: Nr.collapseHeader, children: /* @__PURE__ */ _e.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ _e.jsx(Qn, { children: /* @__PURE__ */ _e.jsxs(Qn, { as: "span", className: Nr.collapseHeaderKey, children: [
                  Zu(
                    w,
                    C,
                    Nr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ _e.jsxs(
                    "a",
                    {
                      href: Mf(f),
                      className: Nr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: ($) => {
                        $.stopPropagation();
                      },
                      children: [
                        rr(f),
                        /* @__PURE__ */ _e.jsx(
                          ue,
                          {
                            className: Nr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ _e.jsx(Qn, { className: Nr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ _e.jsx(ar.Content, { className: Nr.collapseContent, children: /* @__PURE__ */ _e.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ _e.jsx(
              y_,
              {
                description: v,
                assignees: F,
                labels: y
              }
            ),
            /* @__PURE__ */ _e.jsxs(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Nr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: N?.owner.login,
                    repository: d.repository.name
                  },
                  type: w
                }),
                children: [
                  "Unlink ",
                  Bf(w)
                ]
              }
            ),
            /* @__PURE__ */ _e.jsxs(
              St,
              {
                slotEnd: /* @__PURE__ */ _e.jsx(ue, { name: "external-link" }),
                variant: "tertiary",
                className: Nr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(Mf(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  Bf(w),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ _e.jsx(_e.Fragment, {}) });
}, hC = "_result_1uaom_1", yC = "_resultName_1uaom_21", gC = "_resultItemIcon_1uaom_29", vC = "_resultDescription_1uaom_34", kC = "_resultLinkIcon_1uaom_46", bC = "_tooltip_1uaom_55", _C = "_tooltipName_1uaom_61", xC = "_tooltipTag_1uaom_71", zr = {
  result: hC,
  resultName: yC,
  resultItemIcon: gC,
  resultDescription: vC,
  resultLinkIcon: kC,
  tooltip: bC,
  tooltipName: _C,
  tooltipTag: xC
}, SC = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = se(!1);
  return /* @__PURE__ */ _e.jsx(
    Ke,
    {
      className: zr.tooltip,
      content: /* @__PURE__ */ _e.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ _e.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ _e.jsxs(Qn, { as: "span", className: zr.tooltipName, children: [
                Zu(a, o, zr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ _e.jsx(Pn, { className: zr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ _e.jsx(
          y_,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ _e.jsxs(
        "button",
        {
          className: zr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ _e.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ _e.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ _e.jsxs(Qn, { as: "span", className: zr.resultName, children: [
                    Zu(a, o, zr.resultItemIcon),
                    rr(r)
                  ] }) }),
                  /* @__PURE__ */ _e.jsx(Qn, { className: zr.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ _e.jsx(
              ue,
              {
                className: zr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, NC = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ _e.jsx(
  St,
  {
    slotEnd: /* @__PURE__ */ _e.jsx(ue, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), fs = "[a-zA-z0-9_.-]+", g_ = "[0-9]+", jC = new RegExp(
  `(${fs})/(${fs})/(?:issues|pull)/(${g_})`,
  "i"
), qf = new RegExp(`^${jC.source}$`), Hf = new RegExp(
  `https://github.com/(${fs})/(${fs})/(?:issues|pull)/(${g_})`,
  "i"
), wC = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = qn(() => r?.map((D) => D.id) || [], [r]), o = qn(() => i?.map((D) => D.id) || [], [i]), [s, l] = se([]), { useLazyQuery: d } = mn(), [m, u] = se(), [f, { loading: h, error: v, data: N, networkStatus: w }] = d(Gw, {
    notifyOnNetworkStatusChange: !0
  });
  gi(
    () => {
      !h && m && w === Gt.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), qe(() => {
    let D = N?.GitHub?.issues?.nodes || [], U = N?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (D = D.filter((Z) => !a.includes(Z.id))), o.length > 0 && (U = U.filter(
      (Z) => !o.includes(Z.id)
    )), l([
      ...D.map((Z) => ({
        ...Z,
        type: "ISSUE",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      })),
      ...U.map((Z) => ({
        ...Z,
        type: "PR",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      }))
    ]);
  }, [N, a, o]);
  function C(D) {
    const U = D?.trim();
    if (qf.test(U)) {
      const [Z, Q, ie, Y] = U.match(qf) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ie,
        number: parseInt(Y)
      };
    }
    if (Hf.test(U)) {
      const [Z, Q, ie, Y] = U.match(Hf) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ie,
        number: parseInt(Y)
      };
    }
  }
  const F = (D) => {
    e({
      key: Qw(D),
      type: D.type
    }), u(void 0);
  }, y = (D) => {
    const U = C(D);
    u(
      U ? `org:${U.owner} repo:${U.repository} ${U.number}` : `org:${n} ${D}`
    );
  }, H = () => {
    u(void 0);
  }, $ = ({ className: D, searched: U }) => /* @__PURE__ */ _e.jsx(
    NC,
    {
      className: D,
      searched: U,
      githubOrganization: n
    }
  ), E = ({ item: D, onSelect: U }) => /* @__PURE__ */ _e.jsx(SC, { item: D, onSelect: U });
  return !h && v ? /* @__PURE__ */ _e.jsx(In, { error: v }) : /* @__PURE__ */ _e.jsx(
    _r,
    {
      items: s?.map((D) => ({ name: D.title, ...D })),
      loading: h,
      onSearch: y,
      onSelect: F,
      onClear: H,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: $,
      itemComponent: E,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, CC = "_itemButton_3sxfy_1", FC = "_result_3sxfy_6", IC = "_resultName_3sxfy_30", EC = "_resultCheckIcon_3sxfy_38", TC = "_resultAssigneeIcon_3sxfy_41", sa = {
  itemButton: CC,
  result: FC,
  resultName: IC,
  resultCheckIcon: EC,
  resultAssigneeIcon: TC
}, v_ = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ _e.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ _e.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: sa.itemButton,
        children: /* @__PURE__ */ _e.jsxs(b, { className: sa.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ _e.jsx(Qn, { margin: "100 0", children: /* @__PURE__ */ _e.jsx(
            "img",
            {
              className: sa.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ _e.jsx(Qn, { className: sa.resultName, children: e.name }),
          n && /* @__PURE__ */ _e.jsx(Qn, { className: sa.resultCheckIcon, children: /* @__PURE__ */ _e.jsx(ue, { name: "done" }) })
        ] })
      }
    )
  }
), $C = Wi(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), DC = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(""), m = 2, [u, { loading: f, error: h, data: v, networkStatus: N }] = a(
    $C,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return gi(
    () => {
      !f && l && l.length >= m && N === Gt.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const w = v?.GitHub?.organization?.teams || { edges: [] }, C = [];
    w?.edges?.forEach((F) => {
      const y = F?.node?.members?.edges;
      (y?.length || 0) > 0 && y?.forEach((H) => {
        const $ = H?.node;
        $ && ($?.id && C.find((E) => E.id === $.id) || C.push($));
      });
    }), s(
      C.sort((F, y) => {
        const H = F.name?.toLowerCase() || F.login?.toLowerCase(), $ = y.name?.toLowerCase() || y.login?.toLowerCase();
        return H.localeCompare($, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ _e.jsx(In, { error: h }) : /* @__PURE__ */ _e.jsx(
    _r,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: w, name: C, login: F, avatarUrl: y }) => ({
        id: w,
        name: C || F,
        iconUrl: y
      })) || [],
      loading: f,
      onSearch: (w) => d(w),
      onChange: (w, C) => {
        const F = w.id;
        i ? (C && !n.find(
          (y) => y.id === F
        ) && n.push(w), C || (n = n.filter(
          (y) => y.id !== F
        ))) : n = C ? [w] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: w, onSelect: C, checked: F }) => /* @__PURE__ */ _e.jsx(
        v_,
        {
          item: w,
          checked: F,
          onSelectItem: C
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, OC = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ _e.jsx(kr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ _e.jsx(
        _r,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ _e.jsx(
        Ts,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ _e.jsx(kr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ _e.jsx(
        _r,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ _e.jsx(kr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ _e.jsx(Bu, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ _e.jsx(
        DC,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ _e.jsx(_e.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, RC = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ _e.jsx(_e.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ _e.jsx(
  Lt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ _e.jsx(
      Ln,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: OC({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), PC = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ _e.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ _e.jsxs(A.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ _e.jsxs(A.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ _e.jsx(ue, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ _e.jsx(Ln, { label: "GitHub issue link", children: /* @__PURE__ */ _e.jsx(
          kr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, AC = "_modalBody_1hk1o_1", LC = "_modalBodyFormFields_1hk1o_4", pl = {
  modalBody: AC,
  modalBodyFormFields: LC
}, VC = Wi(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), zC = Wi(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), UC = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], MC = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = mn(), { track: d } = kn(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = lr(), [N, w] = se(""), [C, F] = se([]), [y, H] = se(), [$, E] = se(!1), [D, U] = se(!1), [Z, Q] = t_(), [
    ie,
    {
      loading: Y,
      error: M,
      networkStatus: R
    }
  ] = s(VC, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Ce) => {
      F(
        Ce.GitHub.search?.edges?.map((K) => K?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), F([]);
    }
  });
  gi(
    () => {
      !Y && N && R === Gt.ready ? ie({
        variables: {
          query: N,
          maxResults: 10
        }
      }) : F([]);
    },
    500,
    [N]
  );
  const [q, { error: ee }] = l(
    zC,
    {
      onError: (Ce) => {
        E(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Ce);
      },
      onCompleted: (Ce) => {
        E(!1);
        const K = Ce.GitHub.createIssue?.issue;
        H(K), o({
          title: "Success",
          text: `GitHub issue '${K.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: K.repository.name,
          number: K.number
        });
      }
    }
  ), ge = (Ce) => {
    w(`org:${a} ${Ce}`);
  }, de = (Ce, K) => {
    K(Ce), w("");
  }, le = () => {
    w("");
  }, pe = (Ce) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), E(!0), q({
      variables: {
        input: {
          repositoryId: Ce.repository.id,
          title: Ce.title,
          body: Ce.body,
          assigneeIds: Ce.assignees?.length > 0 ? Ce.assignees.map((K) => K.id) : void 0
        }
      }
    });
  };
  qe(() => {
    const Ce = D ? window.setTimeout(() => U(!1), 2e3) : void 0;
    return () => window.clearTimeout(Ce);
  }, [D]);
  const W = () => {
    w(""), F([]), H(void 0), E(!1), U(!1);
  }, ke = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), W(), h(), n();
  };
  return /* @__PURE__ */ _e.jsxs(
    Nt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: ke,
      children: [
        /* @__PURE__ */ _e.jsx(
          jt,
          {
            title: y ? "Issue creation successful" : "Create new GitHub issue",
            onClose: ke
          }
        ),
        /* @__PURE__ */ _e.jsxs(wt, { className: pl.modalBody, children: [
          !Y && M && /* @__PURE__ */ _e.jsx(In, { error: M }),
          !$ && ee && /* @__PURE__ */ _e.jsx(In, { error: ee }),
          y ? /* @__PURE__ */ _e.jsx(
            PC,
            {
              createdIssue: y,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: D,
              setIssueLinkCopied: U,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ _e.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(pe),
              children: /* @__PURE__ */ _e.jsxs(Ut, { children: [
                /* @__PURE__ */ _e.jsx(tn, { children: /* @__PURE__ */ _e.jsx(Ln, { label: "Repository", required: !0, children: /* @__PURE__ */ _e.jsx(
                  Lt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Ce, value: K } }) => /* @__PURE__ */ _e.jsx(
                      _r,
                      {
                        className: pl.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: Y,
                        onSearch: ge,
                        onSelect: (Be) => de(Be, Ce),
                        onClear: le,
                        selectedItems: [K],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: M ? "No repositories found" : "No repositories available",
                        items: C || [],
                        itemComponent: ({ item: Be, onSelect: Me, checked: Pe }) => /* @__PURE__ */ _e.jsx(
                          v_,
                          {
                            item: Be,
                            checked: Pe,
                            onSelectItem: Me
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ _e.jsx(tn, { className: pl.modalBodyFormFields, children: /* @__PURE__ */ _e.jsx(
                  RC,
                  {
                    control: m,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: UC
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ _e.jsx(
          It,
          {
            confirmOnClick: y ? ke : u(pe),
            confirmProps: {
              isLoading: $,
              loadingIndicator: /* @__PURE__ */ _e.jsx(cn, { size: 16 })
            },
            confirmName: y ? "Close" : "Save",
            cancelOnClick: y ? void 0 : ke
          }
        )
      ]
    }
  );
}, BC = "_wrapper_19v8w_1", qC = "_inputWrapper_19v8w_6", HC = "_buttonLink_19v8w_19", WC = "_noItemsFound_19v8w_23", KC = "_createIssueButton_19v8w_28", Si = {
  wrapper: BC,
  inputWrapper: qC,
  buttonLink: HC,
  noItemsFound: WC,
  createIssueButton: KC
}, GC = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se(!1), { track: a } = kn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: N,
    danglingPullRequestLinks: w,
    isLoadingGithubItems: C,
    issues: F,
    pullRequests: y,
    error: H
  } = Xw({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), $ = (Q) => d({ key: Q, type: "ISSUE" }), E = !(!!F?.length).valueOf() && !(!!y?.length).valueOf() && !(!!N?.length).valueOf() && !(!!w?.length).valueOf(), D = !v && !C && !!N?.length && !!w?.length && !!n?.showDanglingLinks, U = n?.enableCreateIssue, Z = !!F?.length || !!y?.length;
  return !C && H ? /* @__PURE__ */ _e.jsx(In, { error: H, retry: () => u() }) : /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
    /* @__PURE__ */ _e.jsxs(b, { className: Si.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ _e.jsxs(b, { className: Si.inputWrapper, flexDirection: "column", children: [
        U && /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
          /* @__PURE__ */ _e.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Si.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ _e.jsx("div", { className: Si.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ _e.jsx(
          wC,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: F,
            linkedPullRequests: y
          }
        )
      ] }),
      C ? /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ _e.jsx(cn, { "data-testid": "github-widget-item-spinner" }) }) : Z ? /* @__PURE__ */ _e.jsx(
        fC,
        {
          items: [...F, ...y],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ _e.jsx(A.Paragraph, { align: "center", className: Si.noItemsFound, children: "No linked items found." }),
      D && /* @__PURE__ */ _e.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ _e.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ _e.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              N.map((Q) => /* @__PURE__ */ _e.jsx(
                Pn,
                {
                  onDelete: () => m({
                    key: Q,
                    type: "ISSUE"
                  }),
                  children: rr(Q)
                },
                rr(Q)
              )),
              w.map((Q) => /* @__PURE__ */ _e.jsx(
                Pn,
                {
                  onDelete: () => m({ key: Q, type: "PR" }),
                  children: rr(Q)
                },
                rr(Q)
              ))
            ] }),
            /* @__PURE__ */ _e.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Z && /* @__PURE__ */ _e.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: E,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ _e.jsx(
        St,
        {
          slotEnd: /* @__PURE__ */ _e.jsx(ue, { name: "external-link" }),
          variant: "tertiary",
          className: Si.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ _e.jsx(
      MC,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: $,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, YC = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Mi
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var fl = { exports: {} }, la = {}, Wf;
function JC() {
  if (Wf) return la;
  Wf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return la.Fragment = r, la.jsx = s, la.jsxs = s, la;
}
var bo = {}, Kf;
function QC() {
  return Kf || (Kf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    bo.Fragment = i, bo.jsx = On, bo.jsxs = Bn;
  })()), bo;
}
var Gf;
function XC() {
  return Gf || (Gf = 1, process.env.NODE_ENV === "production" ? fl.exports = JC() : fl.exports = QC()), fl.exports;
}
var Ee = XC(), Aa = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Aa || {}), ai = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(ai || {}), Mt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Mt || {});
const ZC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, e1 = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": ZC
};
function n1(e) {
  return e1[e] ?? {};
}
const t1 = n1(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Yf = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, k_ = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, r1 = "_listItem_16pij_4", i1 = "_clickableIcon_16pij_15", hs = {
  listItem: r1,
  clickableIcon: i1
}, b_ = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = se(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ Ee.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ Ee.jsx(ue, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ Ee.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Ee.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: hs.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ Ee.jsx(
              ue,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ Ee.jsx(We, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: v } = l, N = l.currency ?? r;
      return /* @__PURE__ */ Ee.jsx(
        We.Item,
        {
          contentLeft: /* @__PURE__ */ Ee.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { children: u }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ Ee.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: k_(f / 100, N) })
          ] }),
          contentRight: h && /* @__PURE__ */ Ee.jsx(Bi, { src: h, alt: m ?? "Product image" }),
          className: hs.listItem
        },
        `item-${d}-${v}`
      );
    }) })
  ] }) });
}, a1 = "_boxWrapper_89s7l_1", o1 = "_trackButton_89s7l_10", Jf = {
  boxWrapper: a1,
  trackButton: o1
}, s1 = {
  [Mt.StepUnknown]: "Unknown",
  [Mt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Mt.StepPreparedByMerchant]: "Prepared by merchant",
  [Mt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Mt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Mt.StepOnRoute]: "On route",
  [Mt.StepDeliveredToPickupPoint]: "At pickup point",
  [Mt.StepDeliveredToConsumer]: "Delivered to customer",
  [Mt.StepDeliveredToMerchant]: "Returned to merchant",
  [Mt.StepReturnRequested]: "Return requested",
  [Mt.StepSentBack]: "Sent back",
  [Mt.StepTerminated]: "Terminated",
  [Mt.StepAwaitingSupplier]: "Awaiting supplier"
}, l1 = {
  [ai.Delivery]: "Home delivery",
  [ai.Pickup]: "Pickup point",
  [ai.Instore]: "In-store pickup",
  [ai.Mailbox]: "Mailbox",
  [ai.Inwarehouse]: "Warehouse",
  [ai.Unknown]: "Unknown"
}, c1 = {
  [Aa.Outbound]: "From merchant to customer",
  [Aa.Return]: "Return from customer to merchant",
  [Aa.Unspecified]: "Unspecified",
  [Aa.UnknownDirectionType]: "Unknown"
}, d1 = (e) => e ? s1[e] ?? e : "", u1 = (e) => e ? l1[e] ?? e : "", m1 = (e) => e ? c1[e] ?? e : "", p1 = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, f1 = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = er();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, v = m || l || i, N = a?.filter(($) => $?.time !== ""), w = d1(N?.[0]?.step), C = u1(u), F = m1(f), y = p1(e.location?.address), H = 14;
  return /* @__PURE__ */ Ee.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Jf.boxWrapper,
      children: [
        /* @__PURE__ */ Ee.jsx(A.Heading, { variant: "heading-4", children: v }),
        /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ee.jsx(
              ue,
              {
                size: H,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ Ee.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Ee.jsx(Ke, { content: "Copy tracking ID", children: /* @__PURE__ */ Ee.jsx(
            ue,
            {
              size: H,
              name: n ? "done" : "copy",
              className: hs.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        w && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: H, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: w })
          ] })
        ] }),
        F && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: H, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: F })
          ] })
        ] }),
        h && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: H, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ Ee.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
              Yf(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Yf(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: H, name: "info", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: C })
          ] })
        ] }),
        y && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: H, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: y })
          ] })
        ] }),
        /* @__PURE__ */ Ee.jsx(b_, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ Ee.jsxs(
          St,
          {
            variant: "secondary",
            className: Jf.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ Ee.jsx(ue, { name: "external-link" }),
            children: [
              "Track on ",
              v ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, h1 = "_order_135ze_1", y1 = "_orderIsOpen_135ze_9", g1 = "_orderHeader_135ze_12", hl = {
  order: h1,
  orderIsOpen: y1,
  orderHeader: g1
}, v1 = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { isCopied: a, copy: o } = er();
  if (!e)
    return null;
  const {
    cart: s,
    parcels: l,
    external_id: d,
    sender_name: m,
    tos_id: u
  } = e, f = s?.currency || "", h = s?.prices?.total?.price ?? 0, v = k_(h / 100, f), N = 14, w = m && m.trim() !== "" ? m : "unknown sender";
  return /* @__PURE__ */ Ee.jsxs(
    b,
    {
      className: ut(hl.order, {
        [hl.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ee.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: hl.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ee.jsxs(A.Paragraph, { variant: "4", children: [
                  "From ",
                  w
                ] }),
                /* @__PURE__ */ Ee.jsxs(A.Paragraph, { variant: "3", children: [
                  "#",
                  d
                ] })
              ] }),
              /* @__PURE__ */ Ee.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ Ee.jsx(
                ue,
                {
                  size: N,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !u && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  u && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: u })
                ] })
              ] })
            ] }),
            u && /* @__PURE__ */ Ee.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Ee.jsx(Ke, { content: "Copy tracking ID", children: /* @__PURE__ */ Ee.jsx(
              ue,
              {
                size: N,
                name: a ? "done" : "copy",
                className: hs.clickableIcon,
                onClick: () => o(u)
              }
            ) }) })
          ] }),
          m && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ee.jsx(ue, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", children: m })
            ] })
          ] }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ee.jsx(ue, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", children: v })
            ] })
          ] }),
          /* @__PURE__ */ Ee.jsx(
            b_,
            {
              openByDefault: !0,
              title: "Order items",
              items: s?.items?.map((C) => C),
              currency: s?.currency
            }
          ),
          l && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ Ee.jsx(A.Heading, { variant: "heading-4", children: "Parcels" }),
              l.length > 0 && /* @__PURE__ */ Ee.jsx(Un, { variant: "success", size: "small", children: l.length })
            ] }),
            l.length === 0 && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            l.map((C, F) => /* @__PURE__ */ Ee.jsx(
              f1,
              {
                parcel: C
              },
              `parcel-${F}-${C?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, k1 = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, b1 = ({
  customerEmail: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se([]), a = !e, { data: o, loading: s, error: l } = n(t1, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? RS({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? hb({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return qe(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(k1(f.orders));
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ee.jsx(cn, {}) }) : m || !d && !l ? /* @__PURE__ */ Ee.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ Ee.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ Ee.jsx(In, { error: l }) : /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ Ee.jsx(Un, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ Ee.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Ee.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ Ee.jsx(
      v1,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, _1 = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ Ee.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ Ee.jsx(b1, { customerEmail: n })
    }
  );
}, x1 = [
  {
    key: "ingridUseStagingEnvironment",
    label: "Use Ingrid staging environment",
    required: !0,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    placeholder: "Site ID from Ingrid",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "ingridApiToken",
    label: "API token",
    placeholder: "API token from Ingrid",
    required: !0,
    secret: !0,
    type: "input"
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var yl = { exports: {} }, ca = {}, Qf;
function S1() {
  if (Qf) return ca;
  Qf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ca.Fragment = r, ca.jsx = s, ca.jsxs = s, ca;
}
var _o = {}, Xf;
function N1() {
  return Xf || (Xf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    _o.Fragment = i, _o.jsx = On, _o.jsxs = Bn;
  })()), _o;
}
var Zf;
function j1() {
  return Zf || (Zf = 1, process.env.NODE_ENV === "production" ? yl.exports = S1() : yl.exports = N1()), yl.exports;
}
var ye = j1();
const Km = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Km(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, w1 = "_jiraCode_h30p6_1", C1 = "_jiraCodeInline_h30p6_8", gl = {
  jiraCode: w1,
  jiraCodeInline: C1
}, __ = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ ye.jsx(ye.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ ye.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ ye.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ ye.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ ye.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ ye.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ ye.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ ye.jsx("pre", { children: /* @__PURE__ */ ye.jsx("code", { className: gl.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ ye.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ ye.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ ye.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ ye.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ ye.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ ye.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ ye.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ ye.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ ye.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ ye.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ ye.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ ye.jsx("code", { className: ut(gl.jiraCode, gl.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, ys = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = se(!1);
  return !e || i ? /* @__PURE__ */ ye.jsx(ue, { size: r, name: "question", className: n }) : /* @__PURE__ */ ye.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, F1 = "_collapse_m2gjh_1", I1 = "_collapseHeader_m2gjh_10", E1 = "_collapseHeaderLink_m2gjh_31", T1 = "_collapseHeaderStatus_m2gjh_40", $1 = "_collapseHeaderTitle_m2gjh_51", D1 = "_collapseContent_m2gjh_59", O1 = "_collapseContentHeadline_m2gjh_62", R1 = "_collapseContentButtonSpacer_m2gjh_68", P1 = "_collapseContentButtonLink_m2gjh_71", A1 = "_collapseContentStatusTag_m2gjh_74", L1 = "_collapseContentDescription_m2gjh_77", ur = {
  collapse: F1,
  collapseHeader: I1,
  collapseHeaderLink: E1,
  collapseHeaderStatus: T1,
  collapseHeaderTitle: $1,
  collapseContent: D1,
  collapseContentHeadline: O1,
  collapseContentButtonSpacer: R1,
  collapseContentButtonLink: P1,
  collapseContentStatusTag: A1,
  collapseContentDescription: L1
}, x_ = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, V1 = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = se(i), { track: s } = kn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ ye.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, v = x_({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), N = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ ye.jsxs(
      ar,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: N,
        className: ur.collapse,
        children: [
          /* @__PURE__ */ ye.jsx(ar.Header, { className: ur.collapseHeader, children: /* @__PURE__ */ ye.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ ye.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ ye.jsx(ys, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ ye.jsx(
                      "a",
                      {
                        className: ur.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (w) => {
                          w.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ ye.jsx(ue, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ ye.jsx("span", { className: ur.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ ye.jsx(Pn, { className: ur.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ ye.jsx("div", { className: ur.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ ye.jsx(ar.Content, { className: ur.collapseContent, children: /* @__PURE__ */ ye.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ ye.jsx("div", { className: ur.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ ye.jsx(Qn, { className: ur.collapseContentDescription, children: u ? Km(u, __) : "" }),
            /* @__PURE__ */ ye.jsx(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: ur.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ ye.jsx(
              St,
              {
                slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
                variant: "tertiary",
                className: ur.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ ye.jsx(ye.Fragment, {}) });
}, z1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, U1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, M1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, B1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, q1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, H1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, W1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, K1 = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': z1,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": U1,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": M1,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": B1,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': q1,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': H1,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": W1
};
function vi(e) {
  return K1[e] ?? {};
}
const S_ = vi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), G1 = vi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), Y1 = vi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), J1 = vi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Q1 = vi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), X1 = vi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), Z1 = vi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Gm = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), eF = new RegExp(`^${Gm.source}$`), nF = new RegExp(`/${Gm.source}$`), eh = new RegExp(
  `.+?[&?]selectedIssue=(${Gm.source})[&?]?.*`
);
function N_(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = se([]), [o, s] = se([]), [l, d] = se(), { track: m } = kn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: v } = mn(), {
    loading: N,
    data: w,
    error: C,
    store: F
  } = wm(e ?? null), [
    y,
    { loading: H, error: $, data: E }
  ] = h(S_, {
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    const le = E?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    le?.length && (s(le), a(le.map((pe) => pe?.key).filter(Boolean)));
  }, [E]), qe(
    () => d(C || $ || void 0),
    [C, $]
  ), qe(
    () => {
      N || M();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [w?.jira?.issues, N]
  );
  const D = async (le, pe) => {
    await F(le).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: pe.success.title,
        text: pe.success.text
      });
    }).catch((W) => {
      u({
        title: pe.error.title,
        text: `${pe.error.text} ${W.message && " (" + W.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [U] = v(G1, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Z = (le, pe) => {
    const W = window.location.href, ke = pe ? W.replace(
      e?.toString() ?? "",
      pe?.toString()
    ) : W, Ce = pe ? `# ${pe}` : `# ${e}`;
    U({
      variables: {
        issueKey: le,
        title: Ce,
        url: ke,
        globalId: `system=${ke}`
      }
    });
  }, [Q] = v(Y1, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ie = (le) => {
    const pe = window.location.href;
    Q({
      variables: {
        issueKey: le,
        globalId: `system=${pe}`
      }
    });
  }, Y = (le) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: le
  }), M = () => {
    w && w.jira?.issues?.length > 0 ? y({
      variables: {
        jql: `key in (${w?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, R = async (le, pe) => {
    m("jira:issue:link:clicked", Y(le));
    const W = w?.jira?.issues ? w : r;
    W.jira.issues = Array.from(
      new Set(W.jira.issues).add(le)
    ), await F(W, pe?.toString()).then(() => Z(le, pe)).catch((ke) => {
      u({
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again. ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, q = (le) => {
    m("jira:issue:link:clicked", Y(le));
    const pe = w?.jira?.issues ? w : r;
    pe.jira.issues = Array.from(
      new Set(pe.jira.issues).add(le)
    ), D(pe, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${le} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again.`
      }
    }).then(() => Z(le));
  }, ee = (le) => {
    m("jira:issue:unlink:clicked", Y(le)), f({
      headline: `Unlink issue ${le}?`,
      text: `You are about to unlink the issue ${le}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", Y(le));
        const pe = {
          ...w,
          jira: {
            ...w?.jira,
            issues: w?.jira?.issues.filter((W) => W !== le) || []
          }
        };
        D(pe, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${le}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${le} failed.`
          }
        }).then(() => ie(le));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", Y(le))
    });
  }, ge = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((le) => le?.key && ie(le.key)), D(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, de = w?.jira?.issues?.filter(
    (le) => !i?.includes(le)
  ) || [];
  return {
    linkIssue: q,
    linkIssueQuietly: R,
    unlinkIssue: ee,
    loadIssues: M,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const le = {
        ...w,
        jira: {
          ...w?.jira,
          issues: w?.jira?.issues.filter(
            (pe) => !de.includes(pe)
          ) || []
        }
      };
      F(le);
    },
    unlinkAllIssues: ge,
    maybeExtractIssueKey: (le) => {
      const pe = le.replace(/\s/g, "");
      if (eF.test(pe))
        return pe;
      if (eh.test(le))
        return le.match(eh)?.[1];
      if (le.startsWith(n) && nF.test(le))
        return le.substring(le.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: N,
    danglingIssueLinks: de,
    isLoadingIssues: H,
    issues: o,
    error: l
  };
}
function tF(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const rF = "_result_axxxc_48", iF = "_resultName_axxxc_68", aF = "_resultNameIcon_axxxc_76", oF = "_resultDescription_axxxc_81", sF = "_resultLinkIcon_axxxc_93", lF = "_tooltip_axxxc_102", cF = "_tooltipContent_axxxc_108", dF = "_tooltipName_axxxc_115", uF = "_tooltipNameIcon_axxxc_120", mF = "_tooltipDescription_axxxc_125", pF = "_tooltipSummary_axxxc_133", fF = "_tooltipTag_axxxc_137", tr = {
  result: rF,
  resultName: iF,
  resultNameIcon: aF,
  resultDescription: oF,
  resultLinkIcon: sF,
  tooltip: lF,
  tooltipContent: cF,
  tooltipName: dF,
  tooltipNameIcon: uF,
  tooltipDescription: mF,
  tooltipSummary: pF,
  tooltipTag: fF
}, hF = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = se(!1), h = x_({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ ye.jsx(
    Ke,
    {
      disabled: i,
      className: tr.tooltip,
      content: /* @__PURE__ */ ye.jsxs("div", { className: tr.tooltipContent, children: [
        /* @__PURE__ */ ye.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ ye.jsxs("span", { className: tr.tooltipName, children: [
                /* @__PURE__ */ ye.jsx(
                  ys,
                  {
                    width: 16,
                    iconUrl: h,
                    className: tr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ ye.jsx(Pn, { className: tr.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ ye.jsx("div", { className: tr.tooltipSummary, children: m }),
        d && /* @__PURE__ */ ye.jsx("div", { className: tr.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ ye.jsxs(
        "button",
        {
          ...a,
          className: tr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ ye.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ye.jsxs("span", { className: tr.resultName, children: [
                    /* @__PURE__ */ ye.jsx(
                      ys,
                      {
                        width: 16,
                        iconUrl: h,
                        className: tr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ ye.jsx("div", { className: tr.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ ye.jsx(
              ue,
              {
                className: tr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, yF = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ ye.jsx(
  St,
  {
    slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), gF = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(""), [m, { loading: u, error: f, data: h, networkStatus: v }] = a(S_, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: N } = N_(null, n);
  gi(
    () => {
      !u && l && v === Gt.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const $ = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      $.map((E) => ({
        id: E?.key ?? "",
        name: E?.key ?? "",
        description: E?.fields.summary,
        status: E?.fields.status,
        issuetype: E?.fields.issuetype,
        text: E?.fields.description ? Km(E?.fields.description, __) : /* @__PURE__ */ ye.jsx(ye.Fragment, {})
      }))
    );
  }, [h]);
  const w = ($) => {
    e($.id), d("");
  }, C = ($) => {
    const E = $.trim(), D = N(E);
    if (D) {
      const U = D.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${U}'`);
    } else E !== "" && d(
      `text ~ '${E}'${r ? " and project = " + r : ""}`
    );
  }, F = () => {
    d("");
  }, y = ($) => /* @__PURE__ */ ye.jsx(yF, { ...$, jiraInstanceUrl: n }), H = ($) => /* @__PURE__ */ ye.jsx(
    hF,
    {
      ...$,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ ye.jsx(In, { error: f }) : /* @__PURE__ */ ye.jsx(
    _r,
    {
      items: o,
      loading: u,
      onSearch: C,
      onSelect: w,
      onClear: F,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: y,
      itemComponent: H,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, vF = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = se(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return qe(() => {
    r(i);
  }, [i]), /* @__PURE__ */ ye.jsx(
    _r,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, kF = "_itemButton_1hl53_1", bF = "_result_1hl53_6", _F = "_resultIcon_1hl53_26", xF = "_resultName_1hl53_30", SF = "_resultCheckIcon_1hl53_38", da = {
  itemButton: kF,
  result: bF,
  resultIcon: _F,
  resultName: xF,
  resultCheckIcon: SF
}, em = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ ye.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ ye.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: da.itemButton,
          children: /* @__PURE__ */ ye.jsxs(b, { className: da.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ ye.jsx(
              ys,
              {
                width: 36,
                iconUrl: o || "",
                className: da.resultIcon
              }
            ),
            /* @__PURE__ */ ye.jsx(Qn, { className: da.resultName, children: e.name }),
            n && /* @__PURE__ */ ye.jsx(Qn, { className: da.resultCheckIcon, children: /* @__PURE__ */ ye.jsx(ue, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, NF = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(), m = 2, [u, { loading: f, error: h, data: v, networkStatus: N }] = a(Z1, {
    notifyOnNetworkStatusChange: !0
  });
  return gi(
    () => {
      !f && l && l.length >= m && N === Gt.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((w) => {
      if (w?.data?.Jira.findUsers?.length === 1) {
        const C = w?.data?.Jira?.findUsers[0];
        r(C.accountId), s([
          {
            id: C.accountId,
            name: C.displayName
          }
        ]);
      }
    });
  }, []), qe(() => {
    const w = v?.Jira?.findUsers || [];
    s(
      w.filter(({ active: C }) => C).map(({ accountId: C, displayName: F, avatarUrls: y, active: H }) => ({
        id: C,
        name: F,
        avatarUrls: y,
        active: H
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ ye.jsx(In, { error: h }) : /* @__PURE__ */ ye.jsx(
    _r,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (w) => d(w),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: w, onSelect: C, checked: F }) => /* @__PURE__ */ ye.jsx(
        em,
        {
          item: w,
          checked: F,
          onSelectItem: C,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, nh = ({
  field: e
}) => {
  const [n, r] = se(!1), [i, a] = t_();
  return qe(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ ye.jsx(b, { children: /* @__PURE__ */ ye.jsx(ue, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ ye.jsx(A.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ ye.jsx(Ke, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ ye.jsx(
      Yt,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, jF = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ ye.jsx(nh, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ ye.jsx(kr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ ye.jsx(Bu, { onChange: n, value: r }) : /* @__PURE__ */ ye.jsx(kr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ ye.jsx(Bu, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ ye.jsx(kr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ ye.jsx(
        NF,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ ye.jsx(
        _r,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ ye.jsx(vF, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ ye.jsx(nh, { field: e });
  }
}, wF = ["description", "reporter", "summary"], CF = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ ye.jsx(ye.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || wF.includes(o)
).map((o) => /* @__PURE__ */ ye.jsx(
  Lt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ ye.jsx(
      Ln,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: jF({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), FF = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ ye.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ ye.jsxs(A.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ ye.jsxs(
          A.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ ye.jsx(ue, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ ye.jsx(Ln, { label: "Jira issue link", children: /* @__PURE__ */ ye.jsx(
        kr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), IF = "_modalBody_1hk1o_1", EF = "_modalBodyFormFields_1hk1o_4", th = {
  modalBody: IF,
  modalBodyFormFields: EF
}, TF = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), $F = (e) => e?.custom?.split(":")?.[1] || null, DF = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, OF = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = DF(a, n), l = $F(s) ?? a;
        return r.includes(l) ? i[a] = TF(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, RF = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = se([]), [m, u] = se(), [f, h] = se(0), [v, N] = se([]), [w, C] = se([]), [F, y] = se(!1), [H, $] = se(!1), [E, D] = se({}), { track: U } = kn(), { isCopied: Z, copyToClipboard: Q } = tF(), ie = qn(() => i?.conversationId, [e]), { useMutation: Y, useLazyQuery: M, showNotification: R } = mn(), {
    control: q,
    handleSubmit: ee,
    formState: { errors: ge },
    reset: de,
    setValue: le,
    getValues: pe
  } = lr({
    defaultValues: s
  }), W = w.length > 0, ke = `${a}/browse`, Ce = Object.keys(E).length > 0, [K, { loading: Be, error: Me }] = M(J1, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (he) => {
      d(he.Jira.getAllProjects);
    },
    onError: (he) => {
      R({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", he), d([]);
    }
  }), [
    Pe,
    { loading: ze, error: je }
  ] = M(Q1, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (he) => {
      h(0);
      const Ie = he?.Jira?.getCreateIssueMeta?.projects[0];
      if (Ie) {
        const Le = Ie?.issuetypes.filter(
          ({ subtask: Oe }) => !Oe
        );
        N(Le || []), le(
          "issuetype",
          Le.length > 0 ? Le[0] : void 0
        );
      } else
        R({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), N([]), C([]);
    },
    onError: (he) => {
      R({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", he), N([]), C([]), h(0);
    }
  }), [Ae, { error: $e }] = Y(
    X1,
    {
      onError: () => {
        y(!1), R({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), U("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (he) => {
        if (y(!1), he?.Jira && "key" in he.Jira.createIssue)
          u(he?.Jira?.createIssue), R({
            title: "Success",
            text: `Jira issue '${he.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), U("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: he.Jira.createIssue.key
          }), ie && r(
            he.Jira.createIssue.key,
            ie
          );
        else if ("errorMessages" in he.Jira.createIssue || "errors" in he.Jira.createIssue) {
          const Ie = he?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", Ie), R({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), nn = (he) => {
    y(!0), D({}), Ae({
      variables: {
        input: OF(he, w)
      }
    });
  };
  qe(() => {
    if (e)
      try {
        K();
      } catch (he) {
        console.warn("Error when fetching initial projects", he);
      }
  }, [e]), qe(() => {
    const he = H ? window.setTimeout(() => $(!1), 2e3) : void 0;
    return () => window.clearTimeout(he);
  }, [H]), qe(() => {
    if (v?.length > 0) {
      le("issuetype", v[f]);
      const he = v[f]?.fields?.additionalProperties;
      if (he?.length > 0) {
        const Ie = he.map(
          ({ value: j }) => j
        ), Le = (o ? Ie.sort(({ name: j }, { name: _ }) => j.localeCompare(_)) : Ie).sort(
          ({ required: j }, { required: _ }) => Number(_) - Number(j)
        ), { project: Oe, issuetype: sn } = pe();
        de({ project: Oe, issuetype: sn }), C(Le);
      }
    } else
      C([]), le("issuetype", void 0);
  }, [v, le, f]), qe(() => {
    if ($e && xb($e)) {
      if ($e?.graphQLErrors?.length > 0) {
        const { graphQLErrors: he } = $e, Ie = he[0].extensions?.integration?.responseBody;
        try {
          const Le = JSON.parse(Ie);
          if (Le?.errors) {
            const Oe = Object.keys(Le.errors).reduce(
              (sn, j) => ({
                ...sn,
                [j]: {
                  type: "required",
                  message: Le.errors[j],
                  ref: {
                    name: j
                  }
                }
              }),
              {}
            );
            D(Oe);
          }
        } catch {
        }
      }
    } else
      D({});
  }, [$e]);
  const we = () => {
    d([]), C([]), N([]), u(void 0), h(0), y(!1), D({});
  }, He = () => {
    we(), de(s), n();
  }, Xe = (he) => {
    he && Pe({
      variables: {
        projectKey: he
      }
    });
  }, me = (he) => {
    const Ie = v.map((Le) => Le.id).indexOf(he);
    h(Ie ?? 0);
  };
  return /* @__PURE__ */ ye.jsxs(
    Nt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: He,
      children: [
        /* @__PURE__ */ ye.jsx(
          jt,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: He
          }
        ),
        /* @__PURE__ */ ye.jsxs(wt, { className: th.modalBody, children: [
          !Be && Me && /* @__PURE__ */ ye.jsx(In, { error: Me, retry: K }),
          !ze && je && /* @__PURE__ */ ye.jsx(
            In,
            {
              error: je,
              retry: Pe
            }
          ),
          !F && Ce && /* @__PURE__ */ ye.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ye.jsx(
            $s,
            {
              variant: "warning",
              description: /* @__PURE__ */ ye.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ ye.jsx(A.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ ye.jsx(
                      Kn,
                      {
                        icon: Z ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Q(JSON.stringify(w, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ ye.jsx(
            FF,
            {
              createdIssue: m,
              issueBaseLink: ke,
              issueLinkCopied: H,
              setIssueLinkCopied: $,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ ye.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ee(nn),
              children: /* @__PURE__ */ ye.jsxs(Ut, { children: [
                /* @__PURE__ */ ye.jsx(tn, { span: 3, children: /* @__PURE__ */ ye.jsx(Ln, { label: "Project", required: !0, children: /* @__PURE__ */ ye.jsx(
                  Lt,
                  {
                    control: q,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: he, value: Ie } }) => /* @__PURE__ */ ye.jsx(
                      _r,
                      {
                        searchable: !0,
                        loading: Be,
                        onSelect: (Le) => {
                          Xe(Le.key), he(Le);
                        },
                        selectedItems: [Ie],
                        placeholder: "Select Jira project",
                        emptyMessage: Me ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Le, onSelect: Oe, checked: sn }) => /* @__PURE__ */ ye.jsx(
                          em,
                          {
                            item: Le,
                            checked: sn,
                            onSelectItem: Oe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ ye.jsx(tn, { span: 3, children: /* @__PURE__ */ ye.jsx(Ln, { label: "Issue type", required: !0, children: /* @__PURE__ */ ye.jsx(
                  Lt,
                  {
                    control: q,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: he, value: Ie } }) => /* @__PURE__ */ ye.jsx(
                      _r,
                      {
                        disabled: v.length === 0,
                        loading: ze,
                        onSelect: (Le) => {
                          me(Le.id), he(Le);
                        },
                        selectedItems: [Ie],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: je ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Le, onSelect: Oe, checked: sn }) => /* @__PURE__ */ ye.jsx(
                          em,
                          {
                            item: Le,
                            checked: sn,
                            onSelectItem: Oe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                W && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ ye.jsx(tn, { className: th.modalBodyFormFields, children: /* @__PURE__ */ ye.jsx(
                  CF,
                  {
                    control: q,
                    errors: { ...ge, ...E },
                    getValues: pe,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: w
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ ye.jsx(
          It,
          {
            confirmOnClick: m ? He : ee(nn),
            confirmProps: {
              disabled: !W,
              isLoading: F,
              loadingIndicator: /* @__PURE__ */ ye.jsx(cn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : He
          }
        )
      ]
    }
  );
}, PF = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, AF = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, LF = "_wrapper_1bylq_1", VF = "_inputWrapper_1bylq_6", zF = "_inputSeparator_1bylq_18", UF = "_buttonLink_1bylq_23", MF = "_noIssuesFound_1bylq_27", ua = {
  wrapper: LF,
  inputWrapper: VF,
  inputSeparator: zF,
  buttonLink: UF,
  noIssuesFound: MF
}, BF = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = kn(), i = PF(n?.jiraSiteUrl), [a, o] = se(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: N,
    isLoadingIssues: w,
    issues: C,
    error: F
  } = N_(
    s ? e.conversationId : null,
    i
  ), y = !!n?.enableCreateIssue, H = !!n?.enableSortIssueTypeByLabel, $ = !!(C?.length || v?.length), E = !!n?.enableRemoveAllLinks && $, D = !N && !w && v?.length > 0 && !!n?.showDanglingLinks;
  return !w && F ? /* @__PURE__ */ ye.jsx(In, { error: F, retry: () => f() }) : /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
    /* @__PURE__ */ ye.jsxs(b, { className: ua.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ ye.jsxs(b, { className: ua.inputWrapper, flexDirection: "column", children: [
        y && /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
          /* @__PURE__ */ ye.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ ye.jsx("div", { className: ua.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ ye.jsx(
          gF,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      w ? /* @__PURE__ */ ye.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ye.jsx(cn, { "data-testid": "jira-widget-issue-spinner" }) }) : C?.length ? /* @__PURE__ */ ye.jsx(
        V1,
        {
          issues: C,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ ye.jsx(A.Paragraph, { align: "center", className: ua.noIssuesFound, children: "No linked issues found" }),
      E && C?.length > 0 && /* @__PURE__ */ ye.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: !C?.length && !v?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      D && /* @__PURE__ */ ye.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ ye.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((U) => /* @__PURE__ */ ye.jsx(Pn, { onDelete: () => m(U), children: U }, U)) }),
            /* @__PURE__ */ ye.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ ye.jsx(
        St,
        {
          slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
          variant: "tertiary",
          className: ua.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ ye.jsx(
      RF,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: H
      }
    )
  ] });
}, rh = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => AF(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Mi
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    secret: !1,
    type: "switch",
    defaultValue: !1
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var vl = { exports: {} }, ma = {}, ih;
function qF() {
  if (ih) return ma;
  ih = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ma.Fragment = r, ma.jsx = s, ma.jsxs = s, ma;
}
var xo = {}, ah;
function HF() {
  return ah || (ah = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    xo.Fragment = i, xo.jsx = On, xo.jsxs = Bn;
  })()), xo;
}
var oh;
function WF() {
  return oh || (oh = 1, process.env.NODE_ENV === "production" ? vl.exports = qF() : vl.exports = HF()), vl.exports;
}
var Te = WF();
function KF({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = mn(), [a, o] = se([]), [s] = i(e, n), [l, d] = se(
    []
  );
  return qe(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((N) => {
        const w = setTimeout(N, r);
        d([...l, w]);
      });
      const v = await s({
        variables: h
      });
      u.push(v);
    }
    o(u);
  }, a];
}
var j_ = /* @__PURE__ */ ((e) => (e.List = "list", e))(j_ || {}), nm = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(nm || {}), tm = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(tm || {});
const GF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, YF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, JF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, QF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, XF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, ZF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, eI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_EmailMessageContent" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, nI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, tI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, rI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "EnumValue", value: "subscriptions" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, iI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_lists" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, aI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, oI = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": GF,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": YF,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": QF,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": XF,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": JF,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": ZF,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              content {\n                ... on Klaviyo_EmailMessageContent {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": eI,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": nI,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": tI,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": rI,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_lists(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": iI,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_segments(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": aI
};
function Hr(e) {
  return oI[e] ?? {};
}
const sI = Hr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), lI = Hr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {
          data {
            id
            type
            attributes {
              content {
                ... on Klaviyo_EmailMessageContent {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), cI = Hr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), dI = Hr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), uI = Hr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), mI = Hr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_lists(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), pI = Hr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_segments(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), fI = Hr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), hI = Hr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function rm(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function sh(e) {
  return rm(e) && e?.attributes?.event_properties?.$message;
}
function yI(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function lh(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function gI(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollection" && e.Klaviyo.get_metrics.data || [];
}
function vI(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function kI(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function bI(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function _I(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function xI(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function ch(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function SI(e) {
  return e?.attributes?.content?.__typename === "Klaviyo_EmailMessageContent" && e.attributes.content.preview_text || void 0;
}
function NI(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const jI = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function wI(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function CI(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function FI({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = mn(), { track: a } = kn(), [o, s] = se(null), [l, d] = se(
    null
  ), [m, u] = se(null), [f, h] = se(null), [v, N] = se(
    null
  ), [w, C] = se([]), {
    data: F,
    error: y,
    loading: H,
    networkStatus: $
  } = i(cI, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    E,
    {
      data: D,
      error: U,
      loading: Z,
      networkStatus: Q
    }
  ] = r(sI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return qe(() => {
    if (F && !H && $ === Gt.ready) {
      const ie = gI(F);
      s(
        ie.find((Y) => Y?.attributes?.name === "Received Email")?.id || null
      ), d(
        ie.find((Y) => Y?.attributes?.name === "Opened Email")?.id || null
      ), u(
        ie.find((Y) => Y?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ie.find((Y) => Y?.attributes?.name === "Bounced Email")?.id || null
      ), N(
        ie.find((Y) => Y?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), N(null);
  }, [F]), qe(() => {
    o && l && m && f && v && !Z && Q === Gt.ready ? E({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : C([]);
  }, [
    o,
    l,
    m,
    f,
    v
  ]), qe(() => {
    if (!Z && D) {
      const ie = vI(D), Y = bI(
        D
      ).map(
        (de) => de?.attributes?.event_properties.$message
      ), M = _I(
        D
      ).map(
        (de) => de?.attributes?.event_properties.$message
      );
      ie.forEach((de) => {
        const le = de.attributes?.event_properties.$message;
        de.opened = Y.includes(le), de.clicked = M.includes(le);
      });
      const R = kI(D), q = xI(D), ee = [
        ...ie,
        ...q,
        ...R
      ].sort((de, le) => {
        const pe = lh(de), W = lh(le);
        return pe == null && W == null ? 0 : pe == null ? 1 : W == null ? -1 : W - pe;
      }).slice(0, n);
      C(ee);
      const ge = ee.map((de) => de.id);
      a("klaviyo:messages:received", {
        emailsReceived: ie.filter(
          (de) => ge.includes(de.id)
        ).length,
        emailsBounced: q.filter(
          (de) => ge.includes(de.id)
        ).length,
        smsReceived: R.filter(
          (de) => ge.includes(de.id)
        ).length,
        total: ge.length
      });
    } else
      C([]);
  }, [Z, D]), qn(
    () => ({
      receivedMessages: w,
      isLoading: H || Z,
      error: y || U
    }),
    [
      w,
      H,
      Z,
      y,
      U
    ]
  );
}
function II({ profileId: e }) {
  const { useQuery: n } = mn(), [r, i] = se(), [a, o] = se(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(uI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  qe(() => {
    l && o(l);
  }, [l]), qe(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return qn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function EI({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = kn(), { useLazyQuery: i } = mn(), [a, o] = se(), [s, l] = se(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(dI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    if (!f && m) {
      const v = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, N = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(v, N);
    }
  }, [f, m]);
  const h = (v, N) => {
    const w = v?.data?.length === 1 && v.data[0]?.id || void 0, C = N?.data?.length === 1 && N.data[0]?.id || void 0, F = w || C, y = !w || !C || w === C;
    if (F && y) {
      o(w || C), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), y || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${w}) and phone number ${n} (profile ID ${C}).`
      )
    );
  };
  return qn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const dh = 800, TI = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, $I = 3, DI = 1.5, OI = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = $I,
  useDelayRange: a = !1
}) => {
  const o = (U) => Math.floor(Math.random() * (U.max - U.min) + U.min), [s, l] = se(0), [d, m] = se(n || dh), [u, f] = se(r || TI), [h, v] = se(!1), [N, w] = se(!1), C = a || !!r, F = C ? o(u) : n || dh, [y, H] = se(F);
  yw(
    async () => {
      const U = s + 1, Z = DI ** U;
      l(U), H(
        (C ? o(u) : d) * Z
      ), await e().then(() => {
        w(!0), D();
      });
    },
    h ? y : null
  ), vw(() => D());
  const $ = tt(() => {
    l(0), H(F);
  }, [F]), E = tt(
    (U = {}) => {
      const { delay: Z, delayRange: Q } = U;
      w(!1), $(), Q && (f(Q), H(o(Q))), Z && (m(Z), H(Z)), v(!0);
    },
    [$]
  ), D = tt(() => {
    v(!1), $();
  }, [$]);
  return qe(() => {
    s >= i && D();
  }, [s, i, D]), qn(
    () => ({ isRunning: h, isSuccessful: N, start: E, stop: D }),
    [h, N, E, D]
  );
}, RI = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, PI = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function AI({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = mn(), [i, a] = se(), [o, s] = se(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? mI : pI,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: N
  } = OI({
    query: u,
    useDelayRange: !0
  }), w = m || h;
  return qe(() => {
    if (d)
      if (LS({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const C = RI(d);
          v({
            ...C && {
              delayRange: PI(C)
            }
          });
        }
      } else
        s(d);
  }, [d]), qe(() => {
    if (!m && l?.Klaviyo) {
      let C = {}, F = {};
      n === "lists" && (C = l?.Klaviyo?.get_profile_lists), n === "segments" && (F = l?.Klaviyo?.get_profile_segments), (C?.data || F?.data) && (N(), a(
        (n === "lists" ? C?.data : F?.data)?.map((y) => ({
          ...y,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), qn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: w,
      error: o,
      networkStatus: f
    }),
    [i, w, o, f, v]
  );
}
const LI = "_notificationText_1polx_1", Ym = {
  notificationText: LI
}, zs = ({ error: e }) => {
  const { track: n } = kn();
  let r = e;
  if (xb(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && hb({ error: i[0] }), o = i.length === 1 && AS({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ Te.jsx(In, { error: e });
  }
  return /* @__PURE__ */ Te.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ Te.jsx(
    We.Item,
    {
      contentLeft: /* @__PURE__ */ Te.jsx(ue, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, VI = "_message_1vrar_48", zI = "_messageIsOpen_1vrar_56", UI = "_messageHeader_1vrar_59", MI = "_messageLabel_1vrar_65", BI = "_messageText_1vrar_68", Ri = {
  message: VI,
  messageIsOpen: zI,
  messageHeader: UI,
  messageLabel: MI,
  messageText: BI
}, qI = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && SI(e.flowMessage);
  return /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
    /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", className: Ri.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ Te.jsx(A.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ Te.jsx(cn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ Te.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ Te.jsx(b, { children: /* @__PURE__ */ Te.jsx(
            A.Paragraph,
            {
              variant: "4",
              className: Ri.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", className: Ri.messageText, children: i })
        ]
      }
    )
  ] });
}, HI = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ Te.jsx(Te.Fragment, { children: /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ Te.jsx(b, { children: /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ Te.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, WI = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = se(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = qn(
    () => () => l ? An(l).format(m) : d ? An.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, N = f && e.clicked, w = f && o?.event_properties.Subject, C = h && o?.event_properties["Message Name"], F = f ? "mail" : "sms";
  return /* @__PURE__ */ Te.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: ut(Ri.message, {
        [Ri.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ Te.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: Ri.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ Te.jsx(ue, { size: 16, name: F }),
                  " ",
                  jI(s),
                  u && /* @__PURE__ */ Te.jsx(Un, { size: "small", variant: "info", children: u })
                ] }),
                w && w,
                C && C
              ] }),
              /* @__PURE__ */ Te.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ Te.jsx(Fm, {}),
          yI(e) && /* @__PURE__ */ Te.jsx(b, { children: /* @__PURE__ */ Te.jsx(Un, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
            /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ Te.jsx(Pn, { children: /* @__PURE__ */ Te.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Te.jsx(
                  ue,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ Te.jsx(Pn, { children: /* @__PURE__ */ Te.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Te.jsx(
                  ue,
                  {
                    size: 16,
                    color: N ? "green.400" : "red.400",
                    name: N ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ Te.jsx(qI, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ Te.jsx(HI, { event: e })
        ] })
      ]
    }
  );
}, KI = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, GI = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = se(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = FI({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = KF({
    query: lI,
    options: KI,
    delayMs: 1e3
  }), [m, u] = se([]);
  qe(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((v) => rm(v)).map((v) => sh(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), qe(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && rm(h) && !h.flowMessage) {
          const v = sh(h), N = d.find((C) => (C.data && ch(C.data))?.id === v), w = N?.data && ch(N.data);
          if (w)
            return {
              ...NI(h),
              flowMessage: w
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ Te.jsx(Te.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ Te.jsx(
    In,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ Te.jsx(
    zs,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
    /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Te.jsx(cn, {}) }) : /* @__PURE__ */ Te.jsx(Te.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ Te.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, v) => /* @__PURE__ */ Te.jsx(
      WI,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ Te.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: Ym.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, YI = "_list_ld0hf_1", JI = "_listItem_ld0hf_4", La = {
  list: YI,
  listItem: JI
}, uh = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = se(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = AI({ profileId: e, query: n });
  qe(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ Te.jsx(zs, { error: o }) : s ? /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: La.listItem, children: /* @__PURE__ */ Te.jsx(cn, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ Te.jsx(Te.Fragment, { children: u.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: La.listItem, children: /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ Te.jsx(Pn, { children: Es(h) })
    ] }) }, v)
  ) }) : r && !a ? /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: La.listItem, children: /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ Te.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Te.jsx(ue, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ Te.jsxs(A.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ Te.jsx(Ke, { content: "Refresh lists and segments", children: /* @__PURE__ */ Te.jsx(Kn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: La.listItem, children: /* @__PURE__ */ Te.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ Te.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, QI = "_tagHover_kzbzk_1", XI = "_channelUnsubscribed_kzbzk_6", mh = {
  tagHover: QI,
  channelUnsubscribed: XI
}, ph = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ Te.jsx(
    Ke,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ Te.jsx(
        Pn,
        {
          className: mh.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ Te.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: ut({
                [mh.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ Te.jsx(cn, { size: 16 }) : /* @__PURE__ */ Te.jsx(ue, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, ZI = "_subscriptionError_1qhhx_1", eE = {
  subscriptionError: ZI
}, nE = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(), { track: h } = kn(), [v, N] = gw({
    channel: null,
    request: null
  }), w = wI(n), C = CI(n), F = !!e, { useMutation: y } = mn(), [H] = y(
    fI
  ), [$] = y(
    hI
  ), E = (Z) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Z }), N.setAll({
      channel: Z,
      request: "subscribed"
    }), ((Q) => H({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: nm.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: tm.Subscribed
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: tm.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: j_.List,
              id: e
            }
          }
        }
      }
    }))(Z).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !0
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !0
      })
    );
  }, D = (Z) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Z }), N.setAll({
      channel: Z,
      request: "unsubscribed"
    }), $({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: nm.Profile,
                attributes: {
                  ...Z === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...Z === "SMS" ? { phone_number: i } : {}
                }
              }
            ]
          }
        }
      }
    }).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !1
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !1
      })
    );
  }, U = async ({
    channel: Z,
    mutationResponse: Q,
    mutationErrorResponse: ie,
    isSubscriptionRequest: Y
  }) => {
    const M = ie?.networkError, R = M ? M?.statusCode : NaN, q = Q?.errors, ee = !!q && yb({
      errors: q
    });
    R === 202 ? (h(
      Y ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Z }
    ), await o()) : ee ? (h(
      Y ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${Y ? "opt-in" : "opt-out"}.`
    )) : (h(
      Y ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: M?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${Y ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return qe(() => {
    if (v.request === "subscribed") {
      const Z = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Z), N.reset()), v.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Z), N.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ Te.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ Te.jsx(
            ph,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: w,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: F,
              handleAction: () => {
                l(!0), f(void 0), w ? D("EMAIL") : E("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ Te.jsx(
            ph,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: C,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: F,
              handleAction: () => {
                m(!0), f(void 0), C ? D("SMS") : E("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ Te.jsx(b, { className: eE.subscriptionError, children: u })
      ] })
    }
  );
}, tE = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  noOfMessagesToShow: s,
  subscriptionListId: l
}) => {
  const {
    profile: d,
    error: m,
    isLoading: u,
    refetchProfile: f
  } = II({ profileId: e });
  return m ? /* @__PURE__ */ Te.jsx(zs, { error: m }) : u ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Te.jsx(cn, {}) }) : !d && !u ? /* @__PURE__ */ Te.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: Ym.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ Te.jsxs(We, { className: La.list, children: [
        i && /* @__PURE__ */ Te.jsx(uh, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ Te.jsx(
          uh,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    d && e && o && /* @__PURE__ */ Te.jsx(
      nE,
      {
        profile: d,
        profileId: e,
        subscriptionListId: l,
        refetchProfile: f,
        email: n,
        phoneNumber: r
      }
    ),
    /* @__PURE__ */ Te.jsx(
      GI,
      {
        profileId: e,
        noOfMessagesToShow: s
      }
    )
  ] });
}, rE = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = Number(n?.noOfMessagesToShow), d = n?.subscriptionListId, {
    profileId: m,
    getProfileId: u,
    isLoading: f,
    error: h
  } = EI({ email: r, phoneNumber: i });
  return MS(() => {
    (r || i) && u({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : f ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Te.jsx(cn, {}) }) : h ? /* @__PURE__ */ Te.jsx(zs, { error: h }) : m ? /* @__PURE__ */ Te.jsx(
    tE,
    {
      profileId: m,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      noOfMessagesToShow: l,
      subscriptionListId: d
    }
  ) : /* @__PURE__ */ Te.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: Ym.notificationText,
      children: "No profile ID found"
    }
  );
}, iE = [
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: PS
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
], aE = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Mi
  }
], oE = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
];
function sE(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const lE = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, cE = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, dE = {};
function fh(e, n) {
  return (dE.jsx ? cE : lE).test(e);
}
const uE = /[ \t\n\f\r]/g;
function mE(e) {
  return typeof e == "object" ? e.type === "text" ? hh(e.value) : !1 : hh(e);
}
function hh(e) {
  return e.replace(uE, "") === "";
}
class so {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
so.prototype.property = {};
so.prototype.normal = {};
so.prototype.space = null;
function w_(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new so(r, i, n);
}
function im(e) {
  return e.toLowerCase();
}
class cr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
cr.prototype.space = null;
cr.prototype.boolean = !1;
cr.prototype.booleanish = !1;
cr.prototype.overloadedBoolean = !1;
cr.prototype.number = !1;
cr.prototype.commaSeparated = !1;
cr.prototype.spaceSeparated = !1;
cr.prototype.commaOrSpaceSeparated = !1;
cr.prototype.mustUseProperty = !1;
cr.prototype.defined = !1;
let pE = 0;
const Cn = ki(), pt = ki(), C_ = ki(), Ve = ki(), Zn = ki(), Pi = ki(), Jt = ki();
function ki() {
  return 2 ** ++pE;
}
const am = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Cn,
  booleanish: pt,
  commaOrSpaceSeparated: Jt,
  commaSeparated: Pi,
  number: Ve,
  overloadedBoolean: C_,
  spaceSeparated: Zn
}, Symbol.toStringTag, { value: "Module" })), kl = Object.keys(am);
class Jm extends cr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), yh(this, "space", a), typeof i == "number")
      for (; ++o < kl.length; ) {
        const s = kl[o];
        yh(this, kl[o], (i & am[s]) === am[s]);
      }
  }
}
Jm.prototype.defined = !0;
function yh(e, n, r) {
  r && (e[n] = r);
}
const fE = {}.hasOwnProperty;
function Ki(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (fE.call(e.properties, i)) {
      const a = e.properties[i], o = new Jm(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[im(i)] = i, r[im(o.attribute)] = i;
    }
  return new so(n, r, e.space);
}
const F_ = Ki({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), I_ = Ki({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function E_(e, n) {
  return n in e ? e[n] : n;
}
function T_(e, n) {
  return E_(e, n.toLowerCase());
}
const $_ = Ki({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: T_,
  properties: { xmlns: null, xmlnsXLink: null }
}), D_ = Ki({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: pt,
    ariaAutoComplete: null,
    ariaBusy: pt,
    ariaChecked: pt,
    ariaColCount: Ve,
    ariaColIndex: Ve,
    ariaColSpan: Ve,
    ariaControls: Zn,
    ariaCurrent: null,
    ariaDescribedBy: Zn,
    ariaDetails: null,
    ariaDisabled: pt,
    ariaDropEffect: Zn,
    ariaErrorMessage: null,
    ariaExpanded: pt,
    ariaFlowTo: Zn,
    ariaGrabbed: pt,
    ariaHasPopup: null,
    ariaHidden: pt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Zn,
    ariaLevel: Ve,
    ariaLive: null,
    ariaModal: pt,
    ariaMultiLine: pt,
    ariaMultiSelectable: pt,
    ariaOrientation: null,
    ariaOwns: Zn,
    ariaPlaceholder: null,
    ariaPosInSet: Ve,
    ariaPressed: pt,
    ariaReadOnly: pt,
    ariaRelevant: null,
    ariaRequired: pt,
    ariaRoleDescription: Zn,
    ariaRowCount: Ve,
    ariaRowIndex: Ve,
    ariaRowSpan: Ve,
    ariaSelected: pt,
    ariaSetSize: Ve,
    ariaSort: null,
    ariaValueMax: Ve,
    ariaValueMin: Ve,
    ariaValueNow: Ve,
    ariaValueText: null,
    role: null
  }
}), hE = Ki({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: T_,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Pi,
    acceptCharset: Zn,
    accessKey: Zn,
    action: null,
    allow: null,
    allowFullScreen: Cn,
    allowPaymentRequest: Cn,
    allowUserMedia: Cn,
    alt: null,
    as: null,
    async: Cn,
    autoCapitalize: null,
    autoComplete: Zn,
    autoFocus: Cn,
    autoPlay: Cn,
    blocking: Zn,
    capture: null,
    charSet: null,
    checked: Cn,
    cite: null,
    className: Zn,
    cols: Ve,
    colSpan: null,
    content: null,
    contentEditable: pt,
    controls: Cn,
    controlsList: Zn,
    coords: Ve | Pi,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Cn,
    defer: Cn,
    dir: null,
    dirName: null,
    disabled: Cn,
    download: C_,
    draggable: pt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Cn,
    formTarget: null,
    headers: Zn,
    height: Ve,
    hidden: Cn,
    high: Ve,
    href: null,
    hrefLang: null,
    htmlFor: Zn,
    httpEquiv: Zn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Cn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Cn,
    itemId: null,
    itemProp: Zn,
    itemRef: Zn,
    itemScope: Cn,
    itemType: Zn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Cn,
    low: Ve,
    manifest: null,
    max: null,
    maxLength: Ve,
    media: null,
    method: null,
    min: null,
    minLength: Ve,
    multiple: Cn,
    muted: Cn,
    name: null,
    nonce: null,
    noModule: Cn,
    noValidate: Cn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Cn,
    optimum: Ve,
    pattern: null,
    ping: Zn,
    placeholder: null,
    playsInline: Cn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Cn,
    referrerPolicy: null,
    rel: Zn,
    required: Cn,
    reversed: Cn,
    rows: Ve,
    rowSpan: Ve,
    sandbox: Zn,
    scope: null,
    scoped: Cn,
    seamless: Cn,
    selected: Cn,
    shadowRootClonable: Cn,
    shadowRootDelegatesFocus: Cn,
    shadowRootMode: null,
    shape: null,
    size: Ve,
    sizes: null,
    slot: null,
    span: Ve,
    spellCheck: pt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ve,
    step: null,
    style: null,
    tabIndex: Ve,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Cn,
    useMap: null,
    value: pt,
    width: Ve,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Zn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ve,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ve,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Cn,
    // Lists. Use CSS to reduce space between items instead
    declare: Cn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ve,
    // `<img>` and `<object>`
    leftMargin: Ve,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ve,
    // `<body>`
    marginWidth: Ve,
    // `<body>`
    noResize: Cn,
    // `<frame>`
    noHref: Cn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Cn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Cn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ve,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: pt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ve,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ve,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Cn,
    disableRemotePlayback: Cn,
    prefix: null,
    property: null,
    results: Ve,
    security: null,
    unselectable: null
  }
}), yE = Ki({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: E_,
  properties: {
    about: Jt,
    accentHeight: Ve,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ve,
    amplitude: Ve,
    arabicForm: null,
    ascent: Ve,
    attributeName: null,
    attributeType: null,
    azimuth: Ve,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ve,
    by: null,
    calcMode: null,
    capHeight: Ve,
    className: Zn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ve,
    diffuseConstant: Ve,
    direction: null,
    display: null,
    dur: null,
    divisor: Ve,
    dominantBaseline: null,
    download: Cn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ve,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ve,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ve,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Pi,
    g2: Pi,
    glyphName: Pi,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ve,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ve,
    horizOriginX: Ve,
    horizOriginY: Ve,
    id: null,
    ideographic: Ve,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ve,
    k: Ve,
    k1: Ve,
    k2: Ve,
    k3: Ve,
    k4: Ve,
    kernelMatrix: Jt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ve,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ve,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ve,
    overlineThickness: Ve,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ve,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Zn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ve,
    pointsAtY: Ve,
    pointsAtZ: Ve,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Jt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Jt,
    rev: Jt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Jt,
    requiredFeatures: Jt,
    requiredFonts: Jt,
    requiredFormats: Jt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ve,
    specularExponent: Ve,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ve,
    strikethroughThickness: Ve,
    string: null,
    stroke: null,
    strokeDashArray: Jt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ve,
    strokeOpacity: Ve,
    strokeWidth: null,
    style: null,
    surfaceScale: Ve,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Jt,
    tabIndex: Ve,
    tableValues: null,
    target: null,
    targetX: Ve,
    targetY: Ve,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Jt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ve,
    underlineThickness: Ve,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ve,
    values: null,
    vAlphabetic: Ve,
    vMathematical: Ve,
    vectorEffect: null,
    vHanging: Ve,
    vIdeographic: Ve,
    version: null,
    vertAdvY: Ve,
    vertOriginX: Ve,
    vertOriginY: Ve,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ve,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), gE = /^data[-\w.:]+$/i, gh = /-[a-z]/g, vE = /[A-Z]/g;
function kE(e, n) {
  const r = im(n);
  let i = n, a = cr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && gE.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(gh, _E);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!gh.test(o)) {
        let s = o.replace(vE, bE);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Jm;
  }
  return new a(i, n);
}
function bE(e) {
  return "-" + e.toLowerCase();
}
function _E(e) {
  return e.charAt(1).toUpperCase();
}
const xE = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, SE = w_([I_, F_, $_, D_, hE], "html"), Qm = w_([I_, F_, $_, D_, yE], "svg");
function NE(e) {
  return e.join(" ").trim();
}
var Ni = {}, bl, vh;
function jE() {
  if (vh) return bl;
  vh = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", v = "declaration";
  bl = function(w, C) {
    if (typeof w != "string")
      throw new TypeError("First argument must be a string");
    if (!w) return [];
    C = C || {};
    var F = 1, y = 1;
    function H(R) {
      var q = R.match(n);
      q && (F += q.length);
      var ee = R.lastIndexOf(d);
      y = ~ee ? R.length - ee : y + R.length;
    }
    function $() {
      var R = { line: F, column: y };
      return function(q) {
        return q.position = new E(R), Z(), q;
      };
    }
    function E(R) {
      this.start = R, this.end = { line: F, column: y }, this.source = C.source;
    }
    E.prototype.content = w;
    function D(R) {
      var q = new Error(
        C.source + ":" + F + ":" + y + ": " + R
      );
      if (q.reason = R, q.filename = C.source, q.line = F, q.column = y, q.source = w, !C.silent) throw q;
    }
    function U(R) {
      var q = R.exec(w);
      if (q) {
        var ee = q[0];
        return H(ee), w = w.slice(ee.length), q;
      }
    }
    function Z() {
      U(r);
    }
    function Q(R) {
      var q;
      for (R = R || []; q = ie(); )
        q !== !1 && R.push(q);
      return R;
    }
    function ie() {
      var R = $();
      if (!(m != w.charAt(0) || u != w.charAt(1))) {
        for (var q = 2; f != w.charAt(q) && (u != w.charAt(q) || m != w.charAt(q + 1)); )
          ++q;
        if (q += 2, f === w.charAt(q - 1))
          return D("End of comment missing");
        var ee = w.slice(2, q - 2);
        return y += 2, H(ee), w = w.slice(q), y += 2, R({
          type: h,
          comment: ee
        });
      }
    }
    function Y() {
      var R = $(), q = U(i);
      if (q) {
        if (ie(), !U(a)) return D("property missing ':'");
        var ee = U(o), ge = R({
          type: v,
          property: N(q[0].replace(e, f)),
          value: ee ? N(ee[0].replace(e, f)) : f
        });
        return U(s), ge;
      }
    }
    function M() {
      var R = [];
      Q(R);
      for (var q; q = Y(); )
        q !== !1 && (R.push(q), Q(R));
      return R;
    }
    return Z(), M();
  };
  function N(w) {
    return w ? w.replace(l, f) : f;
  }
  return bl;
}
var kh;
function wE() {
  if (kh) return Ni;
  kh = 1;
  var e = Ni && Ni.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Ni, "__esModule", { value: !0 }), Ni.default = r;
  var n = e(jE());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return Ni;
}
var CE = wE();
const bh = /* @__PURE__ */ Tm(CE), FE = bh.default || bh, O_ = R_("end"), Xm = R_("start");
function R_(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function IE(e) {
  const n = Xm(e), r = O_(e);
  if (n && r)
    return { start: n, end: r };
}
function Ba(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? _h(e.position) : "start" in e || "end" in e ? _h(e) : "line" in e || "column" in e ? om(e) : "";
}
function om(e) {
  return xh(e && e.line) + ":" + xh(e && e.column);
}
function _h(e) {
  return om(e && e.start) + "-" + om(e && e.end);
}
function xh(e) {
  return e && typeof e == "number" ? e : 1;
}
class Et extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = Ba(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Et.prototype.file = "";
Et.prototype.name = "";
Et.prototype.reason = "";
Et.prototype.message = "";
Et.prototype.stack = "";
Et.prototype.column = void 0;
Et.prototype.line = void 0;
Et.prototype.ancestors = void 0;
Et.prototype.cause = void 0;
Et.prototype.fatal = void 0;
Et.prototype.place = void 0;
Et.prototype.ruleId = void 0;
Et.prototype.source = void 0;
const Zm = {}.hasOwnProperty, EE = /* @__PURE__ */ new Map(), TE = /[A-Z]/g, $E = /-([a-z])/g, DE = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), OE = /* @__PURE__ */ new Set(["td", "th"]), P_ = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function RE(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = BE(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = ME(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Qm : SE,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = A_(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function A_(e, n, r) {
  if (n.type === "element")
    return PE(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return AE(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return VE(e, n, r);
  if (n.type === "mdxjsEsm")
    return LE(e, n);
  if (n.type === "root")
    return zE(e, n, r);
  if (n.type === "text")
    return UE(e, n);
}
function PE(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Qm, e.schema = a), e.ancestors.push(n);
  const o = V_(e, n.tagName, !1), s = qE(e, n);
  let l = np(e, n);
  return DE.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !mE(d) : !0;
  })), L_(e, s, o, n), ep(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function AE(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Za(e, n.position);
}
function LE(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Za(e, n.position);
}
function VE(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Qm, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : V_(e, n.name, !0), s = HE(e, n), l = np(e, n);
  return L_(e, s, o, n), ep(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function zE(e, n, r) {
  const i = {};
  return ep(i, np(e, n)), e.create(n, e.Fragment, i, r);
}
function UE(e, n) {
  return n.value;
}
function L_(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function ep(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function ME(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function BE(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = Xm(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function qE(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && Zm.call(n.properties, a)) {
      const o = WE(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && OE.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function HE(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Za(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Za(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function np(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : EE;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = A_(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function WE(e, n, r) {
  const i = kE(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? sE(r) : NE(r)), i.property === "style") {
      let a = typeof r == "object" ? r : KE(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = GE(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? xE[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function KE(e, n) {
  const r = {};
  try {
    FE(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Et("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = P_ + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace($E, JE)), r[s] = o;
  }
}
function V_(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = fh(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = fh(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return Zm.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Za(e);
}
function Za(e, n) {
  const r = new Et(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = P_ + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function GE(e) {
  const n = {};
  let r;
  for (r in e)
    Zm.call(e, r) && (n[YE(r)] = e[r]);
  return n;
}
function YE(e) {
  let n = e.replace(TE, QE);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function JE(e, n) {
  return n.toUpperCase();
}
function QE(e) {
  return "-" + e.toLowerCase();
}
const _l = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, XE = {};
function ZE(e, n) {
  const r = XE, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return z_(e, i, a);
}
function z_(e, n, r) {
  if (eT(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Sh(e.children, n, r);
  }
  return Array.isArray(e) ? Sh(e, n, r) : "";
}
function Sh(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = z_(e[a], n, r);
  return i.join("");
}
function eT(e) {
  return !!(e && typeof e == "object");
}
const Nh = document.createElement("i");
function tp(e) {
  const n = "&" + e + ";";
  Nh.innerHTML = n;
  const r = Nh.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Or(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function ir(e, n) {
  return e.length > 0 ? (Or(e, e.length, 0, n), e) : n;
}
const jh = {}.hasOwnProperty;
function nT(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    tT(n, e[r]);
  return n;
}
function tT(e, n) {
  let r;
  for (r in n) {
    const a = (jh.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        jh.call(a, s) || (a[s] = []);
        const l = o[s];
        rT(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function rT(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Or(e, 0, 0, i);
}
function U_(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function Ai(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Fr = ei(/[A-Za-z]/), nr = ei(/[\dA-Za-z]/), iT = ei(/[#-'*+\--9=?A-Z^-~]/);
function sm(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const lm = ei(/\d/), aT = ei(/[\dA-Fa-f]/), oT = ei(/[!-/:-@[-`{-~]/);
function gn(e) {
  return e !== null && e < -2;
}
function Kt(e) {
  return e !== null && (e < 0 || e === 32);
}
function zn(e) {
  return e === -2 || e === -1 || e === 32;
}
const sT = ei(new RegExp("\\p{P}|\\p{S}", "u")), lT = ei(/\s/);
function ei(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Gi(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && nr(e.charCodeAt(r + 1)) && nr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function et(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return zn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return zn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const cT = {
  tokenize: dT
};
function dT(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return gn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const uT = {
  tokenize: mT
}, wh = {
  tokenize: pT
};
function mT(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(H) {
    if (i < r.length) {
      const $ = r[i];
      return n.containerState = $[1], e.attempt($[0].continuation, d, m)(H);
    }
    return m(H);
  }
  function d(H) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && y();
      const $ = n.events.length;
      let E = $, D;
      for (; E--; )
        if (n.events[E][0] === "exit" && n.events[E][1].type === "chunkFlow") {
          D = n.events[E][1].end;
          break;
        }
      F(i);
      let U = $;
      for (; U < n.events.length; )
        n.events[U][1].end = {
          ...D
        }, U++;
      return Or(n.events, E + 1, 0, n.events.slice($)), n.events.length = U, m(H);
    }
    return l(H);
  }
  function m(H) {
    if (i === r.length) {
      if (!a)
        return h(H);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return N(H);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(wh, u, f)(H);
  }
  function u(H) {
    return a && y(), F(i), h(H);
  }
  function f(H) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, N(H);
  }
  function h(H) {
    return n.containerState = {}, e.attempt(wh, v, N)(H);
  }
  function v(H) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(H);
  }
  function N(H) {
    if (H === null) {
      a && y(), F(0), e.consume(H);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), w(H);
  }
  function w(H) {
    if (H === null) {
      C(e.exit("chunkFlow"), !0), F(0), e.consume(H);
      return;
    }
    return gn(H) ? (e.consume(H), C(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(H), w);
  }
  function C(H, $) {
    const E = n.sliceStream(H);
    if ($ && E.push(null), H.previous = o, o && (o.next = H), o = H, a.defineSkip(H.start), a.write(E), n.parser.lazy[H.start.line]) {
      let D = a.events.length;
      for (; D--; )
        if (
          // The token starts before the line ending…
          a.events[D][1].start.offset < s && // …and either is not ended yet…
          (!a.events[D][1].end || // …or ends after it.
          a.events[D][1].end.offset > s)
        )
          return;
      const U = n.events.length;
      let Z = U, Q, ie;
      for (; Z--; )
        if (n.events[Z][0] === "exit" && n.events[Z][1].type === "chunkFlow") {
          if (Q) {
            ie = n.events[Z][1].end;
            break;
          }
          Q = !0;
        }
      for (F(i), D = U; D < n.events.length; )
        n.events[D][1].end = {
          ...ie
        }, D++;
      Or(n.events, Z + 1, 0, n.events.slice(U)), n.events.length = D;
    }
  }
  function F(H) {
    let $ = r.length;
    for (; $-- > H; ) {
      const E = r[$];
      n.containerState = E[1], E[0].exit.call(n, e);
    }
    r.length = H;
  }
  function y() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function pT(e, n, r) {
  return et(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Ch(e) {
  if (e === null || Kt(e) || lT(e))
    return 1;
  if (sT(e))
    return 2;
}
function rp(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const cm = {
  name: "attention",
  resolveAll: fT,
  tokenize: hT
};
function fT(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          Fh(f, -d), Fh(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = ir(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = ir(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = ir(m, rp(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = ir(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = ir(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Or(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function hT(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = Ch(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = Ch(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function Fh(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const yT = {
  name: "autolink",
  tokenize: gT
};
function gT(e, n, r) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return Fr(v) ? (e.consume(v), s) : v === 64 ? r(v) : m(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || nr(v) ? (i = 1, l(v)) : m(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, d) : (v === 43 || v === 45 || v === 46 || nr(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, m(v));
  }
  function d(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || sm(v) ? r(v) : (e.consume(v), d);
  }
  function m(v) {
    return v === 64 ? (e.consume(v), u) : iT(v) ? (e.consume(v), m) : r(v);
  }
  function u(v) {
    return nr(v) ? f(v) : r(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, u) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || nr(v)) && i++ < 63) {
      const N = v === 45 ? h : f;
      return e.consume(v), N;
    }
    return r(v);
  }
}
const Us = {
  partial: !0,
  tokenize: vT
};
function vT(e, n, r) {
  return i;
  function i(o) {
    return zn(o) ? et(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || gn(o) ? n(o) : r(o);
  }
}
const M_ = {
  continuation: {
    tokenize: bT
  },
  exit: _T,
  name: "blockQuote",
  tokenize: kT
};
function kT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return zn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function bT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return zn(s) ? et(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(M_, n, r)(s);
  }
}
function _T(e) {
  e.exit("blockQuote");
}
const B_ = {
  name: "characterEscape",
  tokenize: xT
};
function xT(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return oT(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const q_ = {
  name: "characterReference",
  tokenize: ST
};
function ST(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = nr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = aT, u) : (e.enter("characterReferenceValue"), o = 7, s = lm, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === nr && !tp(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const Ih = {
  partial: !0,
  tokenize: jT
}, Eh = {
  concrete: !0,
  name: "codeFenced",
  tokenize: NT
};
function NT(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: E
  };
  let o = 0, s = 0, l;
  return d;
  function d(D) {
    return m(D);
  }
  function m(D) {
    const U = i.events[i.events.length - 1];
    return o = U && U[1].type === "linePrefix" ? U[2].sliceSerialize(U[1], !0).length : 0, l = D, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(D);
  }
  function u(D) {
    return D === l ? (s++, e.consume(D), u) : s < 3 ? r(D) : (e.exit("codeFencedFenceSequence"), zn(D) ? et(e, f, "whitespace")(D) : f(D));
  }
  function f(D) {
    return D === null || gn(D) ? (e.exit("codeFencedFence"), i.interrupt ? n(D) : e.check(Ih, w, $)(D)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(D));
  }
  function h(D) {
    return D === null || gn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(D)) : zn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), et(e, v, "whitespace")(D)) : D === 96 && D === l ? r(D) : (e.consume(D), h);
  }
  function v(D) {
    return D === null || gn(D) ? f(D) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), N(D));
  }
  function N(D) {
    return D === null || gn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(D)) : D === 96 && D === l ? r(D) : (e.consume(D), N);
  }
  function w(D) {
    return e.attempt(a, $, C)(D);
  }
  function C(D) {
    return e.enter("lineEnding"), e.consume(D), e.exit("lineEnding"), F;
  }
  function F(D) {
    return o > 0 && zn(D) ? et(e, y, "linePrefix", o + 1)(D) : y(D);
  }
  function y(D) {
    return D === null || gn(D) ? e.check(Ih, w, $)(D) : (e.enter("codeFlowValue"), H(D));
  }
  function H(D) {
    return D === null || gn(D) ? (e.exit("codeFlowValue"), y(D)) : (e.consume(D), H);
  }
  function $(D) {
    return e.exit("codeFenced"), n(D);
  }
  function E(D, U, Z) {
    let Q = 0;
    return ie;
    function ie(ee) {
      return D.enter("lineEnding"), D.consume(ee), D.exit("lineEnding"), Y;
    }
    function Y(ee) {
      return D.enter("codeFencedFence"), zn(ee) ? et(D, M, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ee) : M(ee);
    }
    function M(ee) {
      return ee === l ? (D.enter("codeFencedFenceSequence"), R(ee)) : Z(ee);
    }
    function R(ee) {
      return ee === l ? (Q++, D.consume(ee), R) : Q >= s ? (D.exit("codeFencedFenceSequence"), zn(ee) ? et(D, q, "whitespace")(ee) : q(ee)) : Z(ee);
    }
    function q(ee) {
      return ee === null || gn(ee) ? (D.exit("codeFencedFence"), U(ee)) : Z(ee);
    }
  }
}
function jT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const xl = {
  name: "codeIndented",
  tokenize: CT
}, wT = {
  partial: !0,
  tokenize: FT
};
function CT(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), et(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : gn(m) ? e.attempt(wT, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || gn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function FT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : gn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : et(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : gn(s) ? a(s) : r(s);
  }
}
const IT = {
  name: "codeText",
  previous: TT,
  resolve: ET,
  tokenize: $T
};
function ET(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function TT(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function $T(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : gn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || gn(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class DT {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && pa(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), pa(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), pa(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        pa(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        pa(this.left, r.reverse());
      }
  }
}
function pa(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function H_(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new DT(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, OT(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Or(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function OT(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, v = r, N = 0, w = 0;
  const C = [w];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (u = i.sliceStream(v), v.next || u.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (w = h + 1, C.push(w), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : C.pop(), h = C.length; h--; ) {
    const F = l.slice(C[h], C[h + 1]), y = o.pop();
    d.push([y, y + F.length - 1]), e.splice(y, 2, F);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[N + d[h][0]] = N + d[h][1], N += d[h][1] - d[h][0] - 1;
  return m;
}
const RT = {
  resolve: AT,
  tokenize: LT
}, PT = {
  partial: !0,
  tokenize: VT
};
function AT(e) {
  return H_(e), e;
}
function LT(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : gn(l) ? e.check(PT, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function VT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), et(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || gn(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function W_(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(F) {
    return F === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(F), e.exit(o), h) : F === null || F === 32 || F === 41 || sm(F) ? r(F) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), w(F));
  }
  function h(F) {
    return F === 62 ? (e.enter(o), e.consume(F), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(F));
  }
  function v(F) {
    return F === 62 ? (e.exit("chunkString"), e.exit(l), h(F)) : F === null || F === 60 || gn(F) ? r(F) : (e.consume(F), F === 92 ? N : v);
  }
  function N(F) {
    return F === 60 || F === 62 || F === 92 ? (e.consume(F), v) : v(F);
  }
  function w(F) {
    return !u && (F === null || F === 41 || Kt(F)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(F)) : u < m && F === 40 ? (e.consume(F), u++, w) : F === 41 ? (e.consume(F), u--, w) : F === null || F === 32 || F === 40 || sm(F) ? r(F) : (e.consume(F), F === 92 ? C : w);
  }
  function C(F) {
    return F === 40 || F === 41 || F === 92 ? (e.consume(F), w) : w(F);
  }
}
function K_(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), u;
  }
  function u(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : gn(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || gn(v) || l++ > 999 ? (e.exit("chunkString"), u(v)) : (e.consume(v), d || (d = !zn(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function G_(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : gn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), et(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || gn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function qa(e, n) {
  let r;
  return i;
  function i(a) {
    return gn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : zn(a) ? et(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const zT = {
  name: "definition",
  tokenize: MT
}, UT = {
  partial: !0,
  tokenize: BT
};
function MT(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return K_.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = Ai(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), d) : r(v);
  }
  function d(v) {
    return Kt(v) ? qa(e, m)(v) : m(v);
  }
  function m(v) {
    return W_(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function u(v) {
    return e.attempt(UT, f, f)(v);
  }
  function f(v) {
    return zn(v) ? et(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || gn(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : r(v);
  }
}
function BT(e, n, r) {
  return i;
  function i(l) {
    return Kt(l) ? qa(e, a)(l) : r(l);
  }
  function a(l) {
    return G_(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return zn(l) ? et(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || gn(l) ? n(l) : r(l);
  }
}
const qT = {
  name: "hardBreakEscape",
  tokenize: HT
};
function HT(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return gn(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const WT = {
  name: "headingAtx",
  resolve: KT,
  tokenize: GT
};
function KT(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Or(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function GT(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || Kt(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || gn(u) ? (e.exit("atxHeading"), n(u)) : zn(u) ? et(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || Kt(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const YT = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Th = ["pre", "script", "style", "textarea"], JT = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: ZT,
  tokenize: e$
}, QT = {
  partial: !0,
  tokenize: t$
}, XT = {
  partial: !0,
  tokenize: n$
};
function ZT(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function e$(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(K) {
    return u(K);
  }
  function u(K) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(K), f;
  }
  function f(K) {
    return K === 33 ? (e.consume(K), h) : K === 47 ? (e.consume(K), o = !0, w) : K === 63 ? (e.consume(K), a = 3, i.interrupt ? n : W) : Fr(K) ? (e.consume(K), s = String.fromCharCode(K), C) : r(K);
  }
  function h(K) {
    return K === 45 ? (e.consume(K), a = 2, v) : K === 91 ? (e.consume(K), a = 5, l = 0, N) : Fr(K) ? (e.consume(K), a = 4, i.interrupt ? n : W) : r(K);
  }
  function v(K) {
    return K === 45 ? (e.consume(K), i.interrupt ? n : W) : r(K);
  }
  function N(K) {
    const Be = "CDATA[";
    return K === Be.charCodeAt(l++) ? (e.consume(K), l === Be.length ? i.interrupt ? n : M : N) : r(K);
  }
  function w(K) {
    return Fr(K) ? (e.consume(K), s = String.fromCharCode(K), C) : r(K);
  }
  function C(K) {
    if (K === null || K === 47 || K === 62 || Kt(K)) {
      const Be = K === 47, Me = s.toLowerCase();
      return !Be && !o && Th.includes(Me) ? (a = 1, i.interrupt ? n(K) : M(K)) : YT.includes(s.toLowerCase()) ? (a = 6, Be ? (e.consume(K), F) : i.interrupt ? n(K) : M(K)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(K) : o ? y(K) : H(K));
    }
    return K === 45 || nr(K) ? (e.consume(K), s += String.fromCharCode(K), C) : r(K);
  }
  function F(K) {
    return K === 62 ? (e.consume(K), i.interrupt ? n : M) : r(K);
  }
  function y(K) {
    return zn(K) ? (e.consume(K), y) : ie(K);
  }
  function H(K) {
    return K === 47 ? (e.consume(K), ie) : K === 58 || K === 95 || Fr(K) ? (e.consume(K), $) : zn(K) ? (e.consume(K), H) : ie(K);
  }
  function $(K) {
    return K === 45 || K === 46 || K === 58 || K === 95 || nr(K) ? (e.consume(K), $) : E(K);
  }
  function E(K) {
    return K === 61 ? (e.consume(K), D) : zn(K) ? (e.consume(K), E) : H(K);
  }
  function D(K) {
    return K === null || K === 60 || K === 61 || K === 62 || K === 96 ? r(K) : K === 34 || K === 39 ? (e.consume(K), d = K, U) : zn(K) ? (e.consume(K), D) : Z(K);
  }
  function U(K) {
    return K === d ? (e.consume(K), d = null, Q) : K === null || gn(K) ? r(K) : (e.consume(K), U);
  }
  function Z(K) {
    return K === null || K === 34 || K === 39 || K === 47 || K === 60 || K === 61 || K === 62 || K === 96 || Kt(K) ? E(K) : (e.consume(K), Z);
  }
  function Q(K) {
    return K === 47 || K === 62 || zn(K) ? H(K) : r(K);
  }
  function ie(K) {
    return K === 62 ? (e.consume(K), Y) : r(K);
  }
  function Y(K) {
    return K === null || gn(K) ? M(K) : zn(K) ? (e.consume(K), Y) : r(K);
  }
  function M(K) {
    return K === 45 && a === 2 ? (e.consume(K), ge) : K === 60 && a === 1 ? (e.consume(K), de) : K === 62 && a === 4 ? (e.consume(K), ke) : K === 63 && a === 3 ? (e.consume(K), W) : K === 93 && a === 5 ? (e.consume(K), pe) : gn(K) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(QT, Ce, R)(K)) : K === null || gn(K) ? (e.exit("htmlFlowData"), R(K)) : (e.consume(K), M);
  }
  function R(K) {
    return e.check(XT, q, Ce)(K);
  }
  function q(K) {
    return e.enter("lineEnding"), e.consume(K), e.exit("lineEnding"), ee;
  }
  function ee(K) {
    return K === null || gn(K) ? R(K) : (e.enter("htmlFlowData"), M(K));
  }
  function ge(K) {
    return K === 45 ? (e.consume(K), W) : M(K);
  }
  function de(K) {
    return K === 47 ? (e.consume(K), s = "", le) : M(K);
  }
  function le(K) {
    if (K === 62) {
      const Be = s.toLowerCase();
      return Th.includes(Be) ? (e.consume(K), ke) : M(K);
    }
    return Fr(K) && s.length < 8 ? (e.consume(K), s += String.fromCharCode(K), le) : M(K);
  }
  function pe(K) {
    return K === 93 ? (e.consume(K), W) : M(K);
  }
  function W(K) {
    return K === 62 ? (e.consume(K), ke) : K === 45 && a === 2 ? (e.consume(K), W) : M(K);
  }
  function ke(K) {
    return K === null || gn(K) ? (e.exit("htmlFlowData"), Ce(K)) : (e.consume(K), ke);
  }
  function Ce(K) {
    return e.exit("htmlFlow"), n(K);
  }
}
function n$(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return gn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function t$(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(Us, n, r);
  }
}
const r$ = {
  name: "htmlText",
  tokenize: i$
};
function i$(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(W) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(W), d;
  }
  function d(W) {
    return W === 33 ? (e.consume(W), m) : W === 47 ? (e.consume(W), E) : W === 63 ? (e.consume(W), H) : Fr(W) ? (e.consume(W), Z) : r(W);
  }
  function m(W) {
    return W === 45 ? (e.consume(W), u) : W === 91 ? (e.consume(W), o = 0, N) : Fr(W) ? (e.consume(W), y) : r(W);
  }
  function u(W) {
    return W === 45 ? (e.consume(W), v) : r(W);
  }
  function f(W) {
    return W === null ? r(W) : W === 45 ? (e.consume(W), h) : gn(W) ? (s = f, de(W)) : (e.consume(W), f);
  }
  function h(W) {
    return W === 45 ? (e.consume(W), v) : f(W);
  }
  function v(W) {
    return W === 62 ? ge(W) : W === 45 ? h(W) : f(W);
  }
  function N(W) {
    const ke = "CDATA[";
    return W === ke.charCodeAt(o++) ? (e.consume(W), o === ke.length ? w : N) : r(W);
  }
  function w(W) {
    return W === null ? r(W) : W === 93 ? (e.consume(W), C) : gn(W) ? (s = w, de(W)) : (e.consume(W), w);
  }
  function C(W) {
    return W === 93 ? (e.consume(W), F) : w(W);
  }
  function F(W) {
    return W === 62 ? ge(W) : W === 93 ? (e.consume(W), F) : w(W);
  }
  function y(W) {
    return W === null || W === 62 ? ge(W) : gn(W) ? (s = y, de(W)) : (e.consume(W), y);
  }
  function H(W) {
    return W === null ? r(W) : W === 63 ? (e.consume(W), $) : gn(W) ? (s = H, de(W)) : (e.consume(W), H);
  }
  function $(W) {
    return W === 62 ? ge(W) : H(W);
  }
  function E(W) {
    return Fr(W) ? (e.consume(W), D) : r(W);
  }
  function D(W) {
    return W === 45 || nr(W) ? (e.consume(W), D) : U(W);
  }
  function U(W) {
    return gn(W) ? (s = U, de(W)) : zn(W) ? (e.consume(W), U) : ge(W);
  }
  function Z(W) {
    return W === 45 || nr(W) ? (e.consume(W), Z) : W === 47 || W === 62 || Kt(W) ? Q(W) : r(W);
  }
  function Q(W) {
    return W === 47 ? (e.consume(W), ge) : W === 58 || W === 95 || Fr(W) ? (e.consume(W), ie) : gn(W) ? (s = Q, de(W)) : zn(W) ? (e.consume(W), Q) : ge(W);
  }
  function ie(W) {
    return W === 45 || W === 46 || W === 58 || W === 95 || nr(W) ? (e.consume(W), ie) : Y(W);
  }
  function Y(W) {
    return W === 61 ? (e.consume(W), M) : gn(W) ? (s = Y, de(W)) : zn(W) ? (e.consume(W), Y) : Q(W);
  }
  function M(W) {
    return W === null || W === 60 || W === 61 || W === 62 || W === 96 ? r(W) : W === 34 || W === 39 ? (e.consume(W), a = W, R) : gn(W) ? (s = M, de(W)) : zn(W) ? (e.consume(W), M) : (e.consume(W), q);
  }
  function R(W) {
    return W === a ? (e.consume(W), a = void 0, ee) : W === null ? r(W) : gn(W) ? (s = R, de(W)) : (e.consume(W), R);
  }
  function q(W) {
    return W === null || W === 34 || W === 39 || W === 60 || W === 61 || W === 96 ? r(W) : W === 47 || W === 62 || Kt(W) ? Q(W) : (e.consume(W), q);
  }
  function ee(W) {
    return W === 47 || W === 62 || Kt(W) ? Q(W) : r(W);
  }
  function ge(W) {
    return W === 62 ? (e.consume(W), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(W);
  }
  function de(W) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(W), e.exit("lineEnding"), le;
  }
  function le(W) {
    return zn(W) ? et(e, pe, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(W) : pe(W);
  }
  function pe(W) {
    return e.enter("htmlTextData"), s(W);
  }
}
const ip = {
  name: "labelEnd",
  resolveAll: l$,
  resolveTo: c$,
  tokenize: d$
}, a$ = {
  tokenize: u$
}, o$ = {
  tokenize: m$
}, s$ = {
  tokenize: p$
};
function l$(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Or(e, 0, e.length, r), e;
}
function c$(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = ir(l, e.slice(o + 1, o + i + 3)), l = ir(l, [["enter", u, n]]), l = ir(l, rp(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = ir(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = ir(l, e.slice(s + 1)), l = ir(l, [["exit", d, n]]), Or(e, o, e.length, l), e;
}
function d$(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(Ai(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(a$, u, s ? u : f)(h) : h === 91 ? e.attempt(o$, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(s$, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function u$(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Kt(f) ? qa(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : W_(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Kt(f) ? qa(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? G_(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return Kt(f) ? qa(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function m$(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return K_.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(Ai(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function p$(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const f$ = {
  name: "labelStartImage",
  resolveAll: ip.resolveAll,
  tokenize: h$
};
function h$(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const y$ = {
  name: "labelStartLink",
  resolveAll: ip.resolveAll,
  tokenize: g$
};
function g$(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const Sl = {
  name: "lineEnding",
  tokenize: v$
};
function v$(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
}
const Xo = {
  name: "thematicBreak",
  tokenize: k$
};
function k$(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || gn(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), zn(m) ? et(e, l, "whitespace")(m) : l(m));
  }
}
const Bt = {
  continuation: {
    tokenize: S$
  },
  exit: j$,
  name: "list",
  tokenize: x$
}, b$ = {
  partial: !0,
  tokenize: w$
}, _$ = {
  partial: !0,
  tokenize: N$
};
function x$(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const N = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (N === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : lm(v)) {
      if (i.containerState.type || (i.containerState.type = N, e.enter(N, {
        _container: !0
      })), N === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check(Xo, r, m)(v) : m(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(v);
    }
    return r(v);
  }
  function d(v) {
    return lm(v) && ++s < 10 ? (e.consume(v), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), m(v)) : r(v);
  }
  function m(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      Us,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(b$, h, f)
    );
  }
  function u(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return zn(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : r(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function S$(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Us, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, et(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !zn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(_$, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, et(e, e.attempt(Bt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function N$(e, n, r) {
  const i = this;
  return et(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function j$(e) {
  e.exit(this.containerState.type);
}
function w$(e, n, r) {
  const i = this;
  return et(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !zn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const $h = {
  name: "setextUnderline",
  resolveTo: C$,
  tokenize: F$
};
function C$(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function F$(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), zn(m) ? et(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || gn(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const I$ = {
  tokenize: E$
};
function E$(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    Us,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, et(e, e.attempt(this.parser.constructs.flow, a, e.attempt(RT, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const T$ = {
  resolveAll: J_()
}, $$ = Y_("string"), D$ = Y_("text");
function Y_(e) {
  return {
    resolveAll: J_(e === "text" ? O$ : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function J_(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function O$(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const R$ = {
  42: Bt,
  43: Bt,
  45: Bt,
  48: Bt,
  49: Bt,
  50: Bt,
  51: Bt,
  52: Bt,
  53: Bt,
  54: Bt,
  55: Bt,
  56: Bt,
  57: Bt,
  62: M_
}, P$ = {
  91: zT
}, A$ = {
  [-2]: xl,
  [-1]: xl,
  32: xl
}, L$ = {
  35: WT,
  42: Xo,
  45: [$h, Xo],
  60: JT,
  61: $h,
  95: Xo,
  96: Eh,
  126: Eh
}, V$ = {
  38: q_,
  92: B_
}, z$ = {
  [-5]: Sl,
  [-4]: Sl,
  [-3]: Sl,
  33: f$,
  38: q_,
  42: cm,
  60: [yT, r$],
  91: y$,
  92: [qT, B_],
  93: ip,
  95: cm,
  96: IT
}, U$ = {
  null: [cm, T$]
}, M$ = {
  null: [42, 95]
}, B$ = {
  null: []
}, q$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: M$,
  contentInitial: P$,
  disable: B$,
  document: R$,
  flow: L$,
  flowInitial: A$,
  insideSpan: U$,
  string: V$,
  text: z$
}, Symbol.toStringTag, { value: "Module" }));
function H$(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: U(E),
    check: U(D),
    consume: y,
    enter: H,
    exit: $,
    interrupt: U(D, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: w,
    events: [],
    now: N,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(Y) {
    return s = ir(s, Y), C(), s[s.length - 1] !== null ? [] : (Z(n, 0), m.events = rp(o, m.events, m), m.events);
  }
  function h(Y, M) {
    return K$(v(Y), M);
  }
  function v(Y) {
    return W$(s, Y);
  }
  function N() {
    const {
      _bufferIndex: Y,
      _index: M,
      line: R,
      column: q,
      offset: ee
    } = i;
    return {
      _bufferIndex: Y,
      _index: M,
      line: R,
      column: q,
      offset: ee
    };
  }
  function w(Y) {
    a[Y.line] = Y.column, ie();
  }
  function C() {
    let Y;
    for (; i._index < s.length; ) {
      const M = s[i._index];
      if (typeof M == "string")
        for (Y = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === Y && i._bufferIndex < M.length; )
          F(M.charCodeAt(i._bufferIndex));
      else
        F(M);
    }
  }
  function F(Y) {
    u = u(Y);
  }
  function y(Y) {
    gn(Y) ? (i.line++, i.column = 1, i.offset += Y === -3 ? 2 : 1, ie()) : Y !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = Y;
  }
  function H(Y, M) {
    const R = M || {};
    return R.type = Y, R.start = N(), m.events.push(["enter", R, m]), l.push(R), R;
  }
  function $(Y) {
    const M = l.pop();
    return M.end = N(), m.events.push(["exit", M, m]), M;
  }
  function E(Y, M) {
    Z(Y, M.from);
  }
  function D(Y, M) {
    M.restore();
  }
  function U(Y, M) {
    return R;
    function R(q, ee, ge) {
      let de, le, pe, W;
      return Array.isArray(q) ? (
        /* c8 ignore next 1 */
        Ce(q)
      ) : "tokenize" in q ? (
        // Looks like a construct.
        Ce([
          /** @type {Construct} */
          q
        ])
      ) : ke(q);
      function ke(Pe) {
        return ze;
        function ze(je) {
          const Ae = je !== null && Pe[je], $e = je !== null && Pe.null, nn = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Ae) ? Ae : Ae ? [Ae] : [],
            ...Array.isArray($e) ? $e : $e ? [$e] : []
          ];
          return Ce(nn)(je);
        }
      }
      function Ce(Pe) {
        return de = Pe, le = 0, Pe.length === 0 ? ge : K(Pe[le]);
      }
      function K(Pe) {
        return ze;
        function ze(je) {
          return W = Q(), pe = Pe, Pe.partial || (m.currentConstruct = Pe), Pe.name && m.parser.constructs.disable.null.includes(Pe.name) ? Me() : Pe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            M ? Object.assign(Object.create(m), M) : m,
            d,
            Be,
            Me
          )(je);
        }
      }
      function Be(Pe) {
        return Y(pe, W), ee;
      }
      function Me(Pe) {
        return W.restore(), ++le < de.length ? K(de[le]) : ge;
      }
    }
  }
  function Z(Y, M) {
    Y.resolveAll && !o.includes(Y) && o.push(Y), Y.resolve && Or(m.events, M, m.events.length - M, Y.resolve(m.events.slice(M), m)), Y.resolveTo && (m.events = Y.resolveTo(m.events, m));
  }
  function Q() {
    const Y = N(), M = m.previous, R = m.currentConstruct, q = m.events.length, ee = Array.from(l);
    return {
      from: q,
      restore: ge
    };
    function ge() {
      i = Y, m.previous = M, m.currentConstruct = R, m.events.length = q, l = ee, ie();
    }
  }
  function ie() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function W$(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function K$(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function G$(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      nT([q$, ...(e || {}).extensions || []])
    ),
    content: a(cT),
    defined: [],
    document: a(uT),
    flow: a(I$),
    lazy: {},
    string: a($$),
    text: a(D$)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return H$(i, o, l);
    }
  }
}
function Y$(e) {
  for (; !H_(e); )
    ;
  return e;
}
const Dh = /[\0\t\n\r]/g;
function J$() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (Dh.lastIndex = f, m = Dh.exec(o), h = m && m.index !== void 0 ? m.index : o.length, v = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const Q$ = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function X$(e) {
  return e.replace(Q$, Z$);
}
function Z$(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return U_(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return tp(r) || e;
}
const Q_ = {}.hasOwnProperty;
function eD(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), nD(r)(Y$(G$(r).document().write(J$()(e, n, !0))));
}
function nD(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Oe),
      autolinkProtocol: Q,
      autolinkEmail: Q,
      atxHeading: o(me),
      blockQuote: o($e),
      characterEscape: Q,
      characterReference: Q,
      codeFenced: o(nn),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(nn, s),
      codeText: o(we, s),
      codeTextData: Q,
      data: Q,
      codeFlowValue: Q,
      definition: o(He),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Xe),
      hardBreakEscape: o(he),
      hardBreakTrailing: o(he),
      htmlFlow: o(Ie, s),
      htmlFlowData: Q,
      htmlText: o(Ie, s),
      htmlTextData: Q,
      image: o(Le),
      label: s,
      link: o(Oe),
      listItem: o(j),
      listItemValue: h,
      listOrdered: o(sn, f),
      listUnordered: o(sn),
      paragraph: o(_),
      reference: K,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(me),
      strong: o(T),
      thematicBreak: o(J)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: E,
      autolink: d(),
      autolinkEmail: Ae,
      autolinkProtocol: je,
      blockQuote: d(),
      characterEscapeValue: ie,
      characterReferenceMarkerHexadecimal: Me,
      characterReferenceMarkerNumeric: Me,
      characterReferenceValue: Pe,
      characterReference: ze,
      codeFenced: d(C),
      codeFencedFence: w,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: N,
      codeFlowValue: ie,
      codeIndented: d(F),
      codeText: d(ee),
      codeTextData: ie,
      data: ie,
      definition: d(),
      definitionDestinationString: $,
      definitionLabelString: y,
      definitionTitleString: H,
      emphasis: d(),
      hardBreakEscape: d(M),
      hardBreakTrailing: d(M),
      htmlFlow: d(R),
      htmlFlowData: ie,
      htmlText: d(q),
      htmlTextData: ie,
      image: d(de),
      label: pe,
      labelText: le,
      lineEnding: Y,
      link: d(ge),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: Be,
      resourceDestinationString: W,
      resourceTitleString: ke,
      resource: Ce,
      setextHeading: d(Z),
      setextHeadingLineSequence: U,
      setextHeadingText: D,
      strong: d(),
      thematicBreak: d()
    }
  };
  X_(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(O) {
    let z = {
      type: "root",
      children: []
    };
    const re = {
      stack: [z],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, fe = [];
    let be = -1;
    for (; ++be < O.length; )
      if (O[be][1].type === "listOrdered" || O[be][1].type === "listUnordered")
        if (O[be][0] === "enter")
          fe.push(be);
        else {
          const Ze = fe.pop();
          be = a(O, Ze, be);
        }
    for (be = -1; ++be < O.length; ) {
      const Ze = n[O[be][0]];
      Q_.call(Ze, O[be][1].type) && Ze[O[be][1].type].call(Object.assign({
        sliceSerialize: O[be][2].sliceSerialize
      }, re), O[be][1]);
    }
    if (re.tokenStack.length > 0) {
      const Ze = re.tokenStack[re.tokenStack.length - 1];
      (Ze[1] || Oh).call(re, void 0, Ze[0]);
    }
    for (z.position = {
      start: Kr(O.length > 0 ? O[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Kr(O.length > 0 ? O[O.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, be = -1; ++be < n.transforms.length; )
      z = n.transforms[be](z) || z;
    return z;
  }
  function a(O, z, re) {
    let fe = z - 1, be = -1, Ze = !1, un, rn, dn, pn;
    for (; ++fe <= re; ) {
      const ln = O[fe];
      switch (ln[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          ln[0] === "enter" ? be++ : be--, pn = void 0;
          break;
        }
        case "lineEndingBlank": {
          ln[0] === "enter" && (un && !pn && !be && !dn && (dn = fe), pn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          pn = void 0;
      }
      if (!be && ln[0] === "enter" && ln[1].type === "listItemPrefix" || be === -1 && ln[0] === "exit" && (ln[1].type === "listUnordered" || ln[1].type === "listOrdered")) {
        if (un) {
          let vn = fe;
          for (rn = void 0; vn--; ) {
            const Qe = O[vn];
            if (Qe[1].type === "lineEnding" || Qe[1].type === "lineEndingBlank") {
              if (Qe[0] === "exit") continue;
              rn && (O[rn][1].type = "lineEndingBlank", Ze = !0), Qe[1].type = "lineEnding", rn = vn;
            } else if (!(Qe[1].type === "linePrefix" || Qe[1].type === "blockQuotePrefix" || Qe[1].type === "blockQuotePrefixWhitespace" || Qe[1].type === "blockQuoteMarker" || Qe[1].type === "listItemIndent")) break;
          }
          dn && (!rn || dn < rn) && (un._spread = !0), un.end = Object.assign({}, rn ? O[rn][1].start : ln[1].end), O.splice(rn || fe, 0, ["exit", un, ln[2]]), fe++, re++;
        }
        if (ln[1].type === "listItemPrefix") {
          const vn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, ln[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          un = vn, O.splice(fe, 0, ["enter", vn, ln[2]]), fe++, re++, dn = void 0, pn = !0;
        }
      }
    }
    return O[z][1]._spread = Ze, re;
  }
  function o(O, z) {
    return re;
    function re(fe) {
      l.call(this, O(fe), fe), z && z.call(this, fe);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(O, z, re) {
    this.stack[this.stack.length - 1].children.push(O), this.stack.push(O), this.tokenStack.push([z, re || void 0]), O.position = {
      start: Kr(z.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(O) {
    return z;
    function z(re) {
      O && O.call(this, re), m.call(this, re);
    }
  }
  function m(O, z) {
    const re = this.stack.pop(), fe = this.tokenStack.pop();
    if (fe)
      fe[0].type !== O.type && (z ? z.call(this, O, fe[0]) : (fe[1] || Oh).call(this, O, fe[0]));
    else throw new Error("Cannot close `" + O.type + "` (" + Ba({
      start: O.start,
      end: O.end
    }) + "): it’s not open");
    re.position.end = Kr(O.end);
  }
  function u() {
    return ZE(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(O) {
    if (this.data.expectingFirstListItemValue) {
      const z = this.stack[this.stack.length - 2];
      z.start = Number.parseInt(this.sliceSerialize(O), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.lang = O;
  }
  function N() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.meta = O;
  }
  function w() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function C() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = O.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function F() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = O.replace(/(\r?\n|\r)$/g, "");
  }
  function y(O) {
    const z = this.resume(), re = this.stack[this.stack.length - 1];
    re.label = z, re.identifier = Ai(this.sliceSerialize(O)).toLowerCase();
  }
  function H() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.title = O;
  }
  function $() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.url = O;
  }
  function E(O) {
    const z = this.stack[this.stack.length - 1];
    if (!z.depth) {
      const re = this.sliceSerialize(O).length;
      z.depth = re;
    }
  }
  function D() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function U(O) {
    const z = this.stack[this.stack.length - 1];
    z.depth = this.sliceSerialize(O).codePointAt(0) === 61 ? 1 : 2;
  }
  function Z() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Q(O) {
    const re = this.stack[this.stack.length - 1].children;
    let fe = re[re.length - 1];
    (!fe || fe.type !== "text") && (fe = G(), fe.position = {
      start: Kr(O.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, re.push(fe)), this.stack.push(fe);
  }
  function ie(O) {
    const z = this.stack.pop();
    z.value += this.sliceSerialize(O), z.position.end = Kr(O.end);
  }
  function Y(O) {
    const z = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const re = z.children[z.children.length - 1];
      re.position.end = Kr(O.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(z.type) && (Q.call(this, O), ie.call(this, O));
  }
  function M() {
    this.data.atHardBreak = !0;
  }
  function R() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = O;
  }
  function q() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = O;
  }
  function ee() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = O;
  }
  function ge() {
    const O = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const z = this.data.referenceType || "shortcut";
      O.type += "Reference", O.referenceType = z, delete O.url, delete O.title;
    } else
      delete O.identifier, delete O.label;
    this.data.referenceType = void 0;
  }
  function de() {
    const O = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const z = this.data.referenceType || "shortcut";
      O.type += "Reference", O.referenceType = z, delete O.url, delete O.title;
    } else
      delete O.identifier, delete O.label;
    this.data.referenceType = void 0;
  }
  function le(O) {
    const z = this.sliceSerialize(O), re = this.stack[this.stack.length - 2];
    re.label = X$(z), re.identifier = Ai(z).toLowerCase();
  }
  function pe() {
    const O = this.stack[this.stack.length - 1], z = this.resume(), re = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, re.type === "link") {
      const fe = O.children;
      re.children = fe;
    } else
      re.alt = z;
  }
  function W() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.url = O;
  }
  function ke() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.title = O;
  }
  function Ce() {
    this.data.inReference = void 0;
  }
  function K() {
    this.data.referenceType = "collapsed";
  }
  function Be(O) {
    const z = this.resume(), re = this.stack[this.stack.length - 1];
    re.label = z, re.identifier = Ai(this.sliceSerialize(O)).toLowerCase(), this.data.referenceType = "full";
  }
  function Me(O) {
    this.data.characterReferenceType = O.type;
  }
  function Pe(O) {
    const z = this.sliceSerialize(O), re = this.data.characterReferenceType;
    let fe;
    re ? (fe = U_(z, re === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : fe = tp(z);
    const be = this.stack[this.stack.length - 1];
    be.value += fe;
  }
  function ze(O) {
    const z = this.stack.pop();
    z.position.end = Kr(O.end);
  }
  function je(O) {
    ie.call(this, O);
    const z = this.stack[this.stack.length - 1];
    z.url = this.sliceSerialize(O);
  }
  function Ae(O) {
    ie.call(this, O);
    const z = this.stack[this.stack.length - 1];
    z.url = "mailto:" + this.sliceSerialize(O);
  }
  function $e() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function nn() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function we() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function He() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Xe() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function me() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function he() {
    return {
      type: "break"
    };
  }
  function Ie() {
    return {
      type: "html",
      value: ""
    };
  }
  function Le() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Oe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function sn(O) {
    return {
      type: "list",
      ordered: O.type === "listOrdered",
      start: null,
      spread: O._spread,
      children: []
    };
  }
  function j(O) {
    return {
      type: "listItem",
      spread: O._spread,
      checked: null,
      children: []
    };
  }
  function _() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function T() {
    return {
      type: "strong",
      children: []
    };
  }
  function G() {
    return {
      type: "text",
      value: ""
    };
  }
  function J() {
    return {
      type: "thematicBreak"
    };
  }
}
function Kr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function X_(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? X_(e, i) : tD(e, i);
  }
}
function tD(e, n) {
  let r;
  for (r in n)
    if (Q_.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Oh(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ba({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Ba({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Ba({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function rD(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return eD(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function iD(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function aD(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function oD(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function sD(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function lD(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function cD(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Gi(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function dD(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function uD(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function Z_(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function mD(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return Z_(e, n);
  const a = { src: Gi(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function pD(e, n) {
  const r = { src: Gi(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function fD(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function hD(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return Z_(e, n);
  const a = { href: Gi(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function yD(e, n) {
  const r = { href: Gi(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function gD(e, n, r) {
  const i = e.all(n), a = r ? vD(r) : ex(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function vD(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = ex(r[i]);
  }
  return n;
}
function ex(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function kD(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function bD(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function _D(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function xD(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function SD(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = Xm(n.children[1]), d = O_(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function ND(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, v = s ? s[d] : void 0;
    v && (h.align = v);
    let N = { type: "element", tagName: o, properties: h, children: [] };
    f && (N.children = e.all(f), e.patch(f, N), N = e.applyData(f, N)), m.push(N);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function jD(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Rh = 9, Ph = 32;
function wD(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      Ah(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(Ah(n.slice(a), a > 0, !1)), o.join("");
}
function Ah(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Rh || o === Ph; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Rh || o === Ph; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function CD(e, n) {
  const r = { type: "text", value: wD(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function FD(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const ID = {
  blockquote: iD,
  break: aD,
  code: oD,
  delete: sD,
  emphasis: lD,
  footnoteReference: cD,
  heading: dD,
  html: uD,
  imageReference: mD,
  image: pD,
  inlineCode: fD,
  linkReference: hD,
  link: yD,
  listItem: gD,
  list: kD,
  paragraph: bD,
  // @ts-expect-error: root is different, but hard to type.
  root: _D,
  strong: xD,
  table: SD,
  tableCell: jD,
  tableRow: ND,
  text: CD,
  thematicBreak: FD,
  toml: So,
  yaml: So,
  definition: So,
  footnoteDefinition: So
};
function So() {
}
const nx = -1, Ms = 0, gs = 1, vs = 2, ap = 3, op = 4, sp = 5, lp = 6, tx = 7, rx = 8, Lh = typeof self == "object" ? self : globalThis, ED = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Ms:
      case nx:
        return r(s, a);
      case gs: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case vs: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case ap:
        return r(new Date(s), a);
      case op: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case sp: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case lp: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case tx: {
        const { name: l, message: d } = s;
        return r(new Lh[l](d), a);
      }
      case rx:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new Lh[o](s), a);
  };
  return i;
}, Vh = (e) => ED(/* @__PURE__ */ new Map(), e)(0), ji = "", { toString: TD } = {}, { keys: $D } = Object, fa = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Ms, n];
  const r = TD.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [gs, ji];
    case "Object":
      return [vs, ji];
    case "Date":
      return [ap, ji];
    case "RegExp":
      return [op, ji];
    case "Map":
      return [sp, ji];
    case "Set":
      return [lp, ji];
  }
  return r.includes("Array") ? [gs, r] : r.includes("Error") ? [tx, r] : [vs, r];
}, No = ([e, n]) => e === Ms && (n === "function" || n === "symbol"), DD = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = fa(s);
    switch (l) {
      case Ms: {
        let u = s;
        switch (d) {
          case "bigint":
            l = rx, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([nx], s);
        }
        return a([l, u], s);
      }
      case gs: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case vs: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of $D(s))
          (e || !No(fa(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case ap:
        return a([l, s.toISOString()], s);
      case op: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case sp: {
        const u = [], f = a([l, u], s);
        for (const [h, v] of s)
          (e || !(No(fa(h)) || No(fa(v)))) && u.push([o(h), o(v)]);
        return f;
      }
      case lp: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !No(fa(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, zh = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return DD(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, ks = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Vh(zh(e, n)) : structuredClone(e)
) : (e, n) => Vh(zh(e, n));
function OD(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function RD(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function PD(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || OD, i = e.options.footnoteBackLabel || RD, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = Gi(f.toLowerCase());
    let v = 0;
    const N = [], w = e.footnoteCounts.get(f);
    for (; w !== void 0 && ++v <= w; ) {
      N.length > 0 && N.push({ type: "text", value: " " });
      let y = typeof r == "string" ? r : r(d, v);
      typeof y == "string" && (y = { type: "text", value: y }), N.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(y) ? y : [y]
      });
    }
    const C = u[u.length - 1];
    if (C && C.type === "element" && C.tagName === "p") {
      const y = C.children[C.children.length - 1];
      y && y.type === "text" ? y.value += " " : C.children.push({ type: "text", value: " " }), C.children.push(...N);
    } else
      u.push(...N);
    const F = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, F), l.push(F);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...ks(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const ix = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return zD;
    if (typeof e == "function")
      return Bs(e);
    if (typeof e == "object")
      return Array.isArray(e) ? AD(e) : LD(e);
    if (typeof e == "string")
      return VD(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function AD(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = ix(e[r]);
  return Bs(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function LD(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Bs(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function VD(e) {
  return Bs(n);
  function n(r) {
    return r && r.type === e;
  }
}
function Bs(e) {
  return n;
  function n(r, i, a) {
    return !!(UD(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function zD() {
  return !0;
}
function UD(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const ax = [], MD = !0, Uh = !1, BD = "skip";
function qD(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = ix(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = ax, N, w, C;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (v = HD(r(d, u)), v[0] === Uh))
        return v;
      if ("children" in d && d.children) {
        const F = (
          /** @type {UnistParent} */
          d
        );
        if (F.children && v[0] !== BD)
          for (w = (i ? F.children.length : -1) + s, C = u.concat(F); w > -1 && w < F.children.length; ) {
            const y = F.children[w];
            if (N = l(y, w, C)(), N[0] === Uh)
              return N;
            w = typeof N[1] == "number" ? N[1] : w + s;
          }
      }
      return v;
    }
  }
}
function HD(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [MD, e] : e == null ? ax : [e];
}
function ox(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), qD(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const dm = {}.hasOwnProperty, WD = {};
function KD(e, n) {
  const r = n || WD, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...ID, ...r.handlers }, l = {
    all: m,
    applyData: YD,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: GD,
    wrap: QD
  };
  return ox(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, v = l.handlers[h];
    if (dm.call(l.handlers, h) && v)
      return v(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: w, ...C } = u, F = ks(C);
        return F.children = l.all(u), F;
      }
      return ks(u);
    }
    return (l.options.unknownHandler || JD)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const N = l.one(h[v], u);
        if (N) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(N) && N.type === "text" && (N.value = Mh(N.value)), !Array.isArray(N) && N.type === "element")) {
            const w = N.children[0];
            w && w.type === "text" && (w.value = Mh(w.value));
          }
          Array.isArray(N) ? f.push(...N) : f.push(N);
        }
      }
    }
    return f;
  }
}
function GD(e, n) {
  e.position && (n.position = IE(e));
}
function YD(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, ks(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function JD(e, n) {
  const r = n.data || {}, i = "value" in n && !(dm.call(r, "hProperties") || dm.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function QD(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Mh(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Bh(e, n) {
  const r = KD(e, n), i = r.one(e, void 0), a = PD(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function XD(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Bh(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Bh(r, { file: i, ...e || n })
    );
  };
}
function qh(e) {
  if (e)
    throw e;
}
var Nl, Hh;
function ZD() {
  if (Hh) return Nl;
  Hh = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return Nl = function d() {
    var m, u, f, h, v, N, w = arguments[0], C = 1, F = arguments.length, y = !1;
    for (typeof w == "boolean" && (y = w, w = arguments[1] || {}, C = 2), (w == null || typeof w != "object" && typeof w != "function") && (w = {}); C < F; ++C)
      if (m = arguments[C], m != null)
        for (u in m)
          f = l(w, u), h = l(m, u), w !== h && (y && h && (o(h) || (v = a(h))) ? (v ? (v = !1, N = f && a(f) ? f : []) : N = f && o(f) ? f : {}, s(w, { name: u, newValue: d(y, N, h) })) : typeof h < "u" && s(w, { name: u, newValue: h }));
    return w;
  }, Nl;
}
var eO = ZD();
const jl = /* @__PURE__ */ Tm(eO);
function um(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function nO() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? tO(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function tO(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const wr = { basename: rO, dirname: iO, extname: aO, join: oO, sep: "/" };
function rO(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  lo(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function iO(e) {
  if (lo(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function aO(e) {
  lo(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function oO(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    lo(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : sO(r);
}
function sO(e) {
  lo(e);
  const n = e.codePointAt(0) === 47;
  let r = lO(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function lO(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function lo(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const cO = { cwd: dO };
function dO() {
  return "/";
}
function mm(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function uO(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!mm(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return mO(e);
}
function mO(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const wl = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class sx {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? mm(n) ? r = { path: n } : typeof n == "string" || pO(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : cO.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < wl.length; ) {
      const o = wl[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      wl.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? wr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Fl(n, "basename"), Cl(n, "basename"), this.path = wr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? wr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Wh(this.basename, "dirname"), this.path = wr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? wr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (Cl(n, "extname"), Wh(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = wr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    mm(n) && (n = uO(n)), Fl(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? wr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Fl(n, "stem"), Cl(n, "stem"), this.path = wr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Et(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function Cl(e, n) {
  if (e && e.includes(wr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + wr.sep + "`"
    );
}
function Fl(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Wh(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function pO(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const fO = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), hO = {}.hasOwnProperty;
class cp extends fO {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = nO();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new cp()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(jl(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (Tl("data", this.frozen), this.namespace[n] = r, this) : hO.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (Tl("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = jo(n), i = this.parser || this.Parser;
    return Il("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), Il("process", this.parser || this.Parser), El("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = jo(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), N = i.stringify(v, h);
        vO(N) ? h.value = N : h.result = N, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), Il("processSync", this.parser || this.Parser), El("processSync", this.compiler || this.Compiler), this.process(n, a), Gh("processSync", "process", r), i;
    function a(o, s) {
      r = !0, qh(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    Kh(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = jo(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), Gh("runSync", "run", i), a;
    function o(s, l) {
      qh(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = jo(r), a = this.compiler || this.Compiler;
    return El("stringify", a), Kh(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (Tl("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = jl(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [v, ...N] = u;
        const w = i[h][1];
        um(w) && um(v) && (v = jl(!0, w, v)), i[h] = [m, v, ...N];
      }
    }
  }
}
const yO = new cp().freeze();
function Il(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function El(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Tl(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Kh(e) {
  if (!um(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Gh(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function jo(e) {
  return gO(e) ? e : new sx(e);
}
function gO(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function vO(e) {
  return typeof e == "string" || kO(e);
}
function kO(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const bO = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Yh = [], Jh = { allowDangerousHtml: !0 }, _O = /^(https?|ircs?|mailto|xmpp)$/i, xO = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function SO(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || Yh, d = e.remarkPlugins || Yh, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Jh } : Jh, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || NO, v = yO().use(rD).use(d).use(XD, m).use(l), N = new sx();
  typeof i == "string" && (N.value = i);
  for (const y of xO)
    Object.hasOwn(e, y.from) && ("" + y.from + (y.to ? "use `" + y.to + "` instead" : "remove it") + bO + y.id, void 0);
  const w = v.parse(N);
  let C = v.runSync(w, N);
  return a && (C = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      C.type === "root" ? C.children : [C]
    )
  }), ox(C, F), RE(C, {
    Fragment: Ue.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Ue.jsx,
    jsxs: Ue.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function F(y, H, $) {
    if (y.type === "raw" && $ && typeof H == "number")
      return u ? $.children.splice(H, 1) : $.children[H] = { type: "text", value: y.value }, H;
    if (y.type === "element") {
      let E;
      for (E in _l)
        if (Object.hasOwn(_l, E) && Object.hasOwn(y.properties, E)) {
          const D = y.properties[E], U = _l[E];
          (U === null || U.includes(y.tagName)) && (y.properties[E] = h(String(D || ""), E, y));
        }
    }
    if (y.type === "element") {
      let E = n ? !n.includes(y.tagName) : s ? s.includes(y.tagName) : !1;
      if (!E && r && typeof H == "number" && (E = !r(y, H, $)), E && $ && typeof H == "number")
        return f && y.children ? $.children.splice(H, 1, ...y.children) : $.children.splice(H, 1), H;
    }
  }
}
function NO(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    _O.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var $l = { exports: {} }, ha = {}, Qh;
function jO() {
  if (Qh) return ha;
  Qh = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ha.Fragment = r, ha.jsx = s, ha.jsxs = s, ha;
}
var wo = {}, Xh;
function wO() {
  return Xh || (Xh = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    wo.Fragment = i, wo.jsx = On, wo.jsxs = Bn;
  })()), wo;
}
var Zh;
function CO() {
  return Zh || (Zh = 1, process.env.NODE_ENV === "production" ? $l.exports = jO() : $l.exports = wO()), $l.exports;
}
var oe = CO();
const FO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, IO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, EO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, TO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, $O = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, DO = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": FO,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": IO,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": EO,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": TO,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": $O
};
function co(e) {
  return DO[e] ?? {};
}
const OO = co(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), RO = co(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), Co = ({
  title: e,
  children: n
}) => /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), PO = "_issueAvatar_kc0sw_1", AO = "_issueField_kc0sw_9", LO = "_issueDescription_kc0sw_12", Fo = {
  issueAvatar: PO,
  issueField: AO,
  issueDescription: LO
}, lx = ({ issue: e }) => /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
  /* @__PURE__ */ oe.jsx(Co, { title: "Assignee", children: /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: Fo.issueAvatar,
      children: [
        /* @__PURE__ */ oe.jsx(
          Im,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ oe.jsx(Co, { title: "Team", children: /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Fo.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ oe.jsx(Co, { title: "Project", children: /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Fo.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ oe.jsx(Co, { title: "Description", children: /* @__PURE__ */ oe.jsx(SO, { className: Fo.issueDescription, children: e.description }) })
] }), VO = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), zO = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), UO = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), MO = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), BO = /* @__PURE__ */ oe.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), cx = {
  0: VO,
  1: BO,
  2: MO,
  3: UO,
  4: zO
}, qO = (e) => e in cx, bs = ({ priority: e }) => qO(e) ? cx[e] : /* @__PURE__ */ oe.jsx(Pn, { "data-testid": "defaultPriorityTag", children: e }), HO = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), WO = (e, n) => /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ oe.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ oe.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), KO = (e, n) => /* @__PURE__ */ oe.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ oe.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ oe.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), GO = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), YO = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), JO = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), pm = {
  backlog: (e, n) => HO(e, n),
  unstarted: (e, n) => WO(e, n),
  started: (e, n) => KO(e, n),
  done: (e, n) => GO(e, n),
  canceled: (e, n) => YO(e, n),
  completed: (e, n) => JO(e, n)
}, QO = (e) => e in pm, _s = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => QO(e) ? pm[e](n, r) : pm.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), XO = "_wrapper_e0qj3_1", ZO = "_resultTitle_e0qj3_21", eR = "_resultTooltipTitle_e0qj3_28", nR = "_resultLinkIcon_e0qj3_31", ya = {
  wrapper: XO,
  resultTitle: ZO,
  resultTooltipTitle: eR,
  resultLinkIcon: nR
}, tR = ({
  issue: e
}) => {
  const [n, r] = se(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = Cm(GS()), o = tt(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ oe.jsx(
    Ke,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", className: ya.wrapper, children: [
        /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ oe.jsx(
              _s,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ oe.jsx(bs, { priority: e.priority })
          ] }),
          /* @__PURE__ */ oe.jsx(Pn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ oe.jsx(
            A.Heading,
            {
              variant: "heading-3",
              className: ya.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ oe.jsx(lx, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ oe.jsx(
        ot.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: ya.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ oe.jsx(
                    _s,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ oe.jsx(bs, { priority: e.priority })
                ] }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", className: ya.resultTitle, children: e.title }),
                n && /* @__PURE__ */ oe.jsx(
                  ue,
                  {
                    className: ya.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, rR = "_loader_13xpk_1", iR = "_dropdown_13xpk_8", aR = "_loadMore_13xpk_13", Dl = {
  loader: rR,
  dropdown: iR,
  loadMore: aR
}, oR = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = se(), [a, o] = se([]), [s, l] = se(""), [d, m] = se(!1), { useLazyQuery: u } = mn(), [f, { data: h, loading: v, networkStatus: N }] = u(
    OO,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  gi(
    () => {
      !v && s !== "" && N === Gt.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), qe(() => {
    v || o([]);
  }, [s]), qe(() => {
    if (h && Object.keys(h).length > 0) {
      const C = h.Linear.searchIssues.edges.map(
        ({ node: $ }) => $
      ), F = a.filter(
        ($) => !n.find((E) => E.id === $.id)
      ), y = F.filter(
        ($) => !C.find(
          (E) => E.id === $.id
        )
      ), H = C.filter(
        ($) => !n.find((E) => E.id === $.id)
      );
      n.length > 0 ? o(
        d ? [...y, ...H] : H
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...F, ...C] : C
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const w = () => {
    !v && s !== "" && N === Gt.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ oe.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ oe.jsxs(
    Yr,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (C) => C?.title,
      onChange: (C) => e(C.selectedValues[0]),
      dropdownProps: { className: Dl.dropdown },
      filter: {
        value: s,
        onChange: (C) => {
          const F = C.target.value;
          l(F);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((C) => /* @__PURE__ */ oe.jsx(tR, { issue: C }, C.id)),
        r?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ oe.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => w(),
            className: Dl.loadMore,
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", className: Dl.loader, children: /* @__PURE__ */ oe.jsx(cn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, sR = "_collapse_su0f9_1", lR = "_collapseHeader_su0f9_8", cR = "_collapseContent_su0f9_31", dR = "_url_su0f9_35", uR = "_externalLink_su0f9_51", mR = "_emptyState_su0f9_55", Gr = {
  collapse: sR,
  collapseHeader: lR,
  collapseContent: cR,
  url: dR,
  externalLink: uR,
  emptyState: mR
}, pR = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = se(s), { track: m } = kn();
  return n ? /* @__PURE__ */ oe.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ oe.jsx(cn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ oe.jsx(
          A.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: Gr.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          St,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
            variant: "tertiary",
            className: Gr.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ oe.jsxs(
            ar,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: Gr.collapse,
              children: [
                /* @__PURE__ */ oe.jsx(ar.Header, { className: Gr.collapseHeader, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ oe.jsx(Ke, { content: /* @__PURE__ */ oe.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(
                        _s,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ oe.jsxs(
                        A.ExternalLink,
                        {
                          className: Gr.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ oe.jsx(ue, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ oe.jsx(Ke, { content: /* @__PURE__ */ oe.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(bs, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ oe.jsx(Pn, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ oe.jsx(ar.Content, { className: Gr.collapseContent, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ oe.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ oe.jsx(Pn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(lx, { issue: u }),
                  /* @__PURE__ */ oe.jsx(
                    Kn,
                    {
                      slotStart: /* @__PURE__ */ oe.jsx(ue, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ oe.jsxs(
                    St,
                    {
                      slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
                      variant: "tertiary",
                      className: Gr.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ oe.jsx(
          Kn,
          {
            slotStart: /* @__PURE__ */ oe.jsx(ue, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          St,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
            variant: "tertiary",
            className: Gr.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, fR = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, dx = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => dx(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, hR = "_modalBody_iv3ua_1", yR = "_error_iv3ua_5", gR = "_dropdown_iv3ua_16", wi = {
  modalBody: hR,
  error: yR,
  dropdown: gR
}, vR = co(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), kR = co(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), bR = co(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), _R = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = mn(), { control: m, handleSubmit: u, reset: f } = lr(), [h, v] = se([]), [N, w] = se(), [C, F] = se([]), [y, H] = se(), [$, E] = se([]), [D, U] = se(), [Z, Q] = se([]), [ie, Y] = se(), [M, R] = se([]), [q, ee] = se(), [ge, de] = se(!1), { useMutation: le } = mn(), { track: pe } = kn(), [W, { loading: ke }] = le(
    vR,
    {
      onError: () => {
        de(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (we) => {
        const He = {
          identifier: we.Linear?.issueCreate?.issue?.identifier,
          url: we.Linear?.issueCreate?.issue?.url
        };
        we.Linear && we.Linear?.issueCreate?.issue?.id && (a(we.Linear?.issueCreate?.issue?.id), Ae(He), de(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${we.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), pe("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Ce,
    { data: K, loading: Be, error: Me }
  ] = l(kR, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (we) => {
      const He = we.Linear.teams.edges.map(
        ({ node: Xe }) => Xe
      );
      v(He), Q(we.Linear.issuePriorityValues), s(`${ER}${we.Linear.organization.urlKey}`);
    }
  }), [Pe, { data: ze, loading: je }] = l(bR, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (we) => {
      const He = we?.Linear?.team?.projects?.edges?.map(
        ({ node: he }) => he
      );
      F(He);
      const Xe = we?.Linear?.team?.states?.edges?.map(
        ({ node: he }) => he
      );
      E(Xe);
      const me = we?.Linear?.team?.templates?.edges?.map(
        ({ node: he }) => he
      );
      R(
        me.filter(
          (he) => he.type === "issue"
        )
      );
    }
  }), Ae = (we) => {
    r(!1), H(void 0), w(void 0), U(void 0), Y(void 0), ee(void 0), we && (e(we), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, $e = (we) => {
    K && !Be && (W({
      variables: {
        issueTitle: we.title,
        issueDescription: we?.description,
        teamId: we.team.id,
        projectId: we?.project?.id,
        statusId: we?.status?.id,
        priority: we?.priority?.priority
      }
    }), de(!0));
  };
  qe(() => {
    n && Ce();
  }, [n]);
  const nn = () => {
    pe("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ oe.jsxs(
    Nt,
    {
      isOpen: n,
      onClose: () => {
        nn(), Ae();
      },
      children: [
        /* @__PURE__ */ oe.jsx(
          jt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              nn(), Ae();
            }
          }
        ),
        /* @__PURE__ */ oe.jsx(
          wt,
          {
            className: wi.modalBody,
            "data-testid": "createIssueModalBody",
            children: Me ? /* @__PURE__ */ oe.jsx(In, { error: Me }) : /* @__PURE__ */ oe.jsx("form", { onSubmit: u($e), id: "issueCreationForm", children: /* @__PURE__ */ oe.jsxs(Ut, { children: [
              /* @__PURE__ */ oe.jsx(tn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: we, onChange: He },
                    fieldState: { error: Xe }
                  }) => /* @__PURE__ */ oe.jsx(
                    Ln,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Xe?.message ?? null
                      },
                      children: /* @__PURE__ */ oe.jsx(
                        Yr,
                        {
                          dropdownProps: { className: wi.dropdown },
                          placeholder: "Select Linear team",
                          className: ut({ [wi.error]: Xe }),
                          getItemTitleByValue: (me) => me?.name,
                          onChange: (me) => {
                            H(void 0), U(void 0), Y(void 0), ee(void 0), w(me.selectedValues[0]), Pe({
                              variables: { teamId: me.selectedValues[0].id }
                            }), He(me.selectedValues[0]);
                          },
                          value: N ? [we] : void 0,
                          children: h?.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.name })
                            },
                            me.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: we, onChange: He } }) => {
                    const Xe = je ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ oe.jsx(Ln, { label: "Project", children: /* @__PURE__ */ oe.jsx(
                      Yr,
                      {
                        dropdownProps: { className: wi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (me) => me?.name,
                        disabled: N === void 0,
                        placeholder: N ? "Select Linear project" : "Select a Team first",
                        onChange: (me) => {
                          H(me.selectedValues[0]), He(me.selectedValues[0]);
                        },
                        value: y ? [we] : Xe,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          je && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(cn, { size: 24 })
                            }
                          ),
                          ze && !je && C.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.name })
                            },
                            me.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 6, children: /* @__PURE__ */ oe.jsx(Ln, { label: "Template", children: /* @__PURE__ */ oe.jsx(
                Yr,
                {
                  clearable: !0,
                  dropdownProps: { className: wi.dropdown },
                  disabled: !N || je,
                  placeholder: N ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (we) => we?.name,
                  onChange: (we) => {
                    if (we.selectedValues.length > 0) {
                      ee(we.selectedValues[0]);
                      const He = JSON.parse(
                        we.selectedValues[0].templateData
                      ), Xe = Z.filter(
                        (Le) => Le.priority === He.priority
                      );
                      Y(
                        Xe ? Xe[0] : void 0
                      );
                      const me = $.filter(
                        (Le) => Le.id === He.stateId
                      );
                      U(
                        me ? me[0] : void 0
                      );
                      const he = C.filter(
                        (Le) => Le.id === He.projectId
                      );
                      H(
                        he ? he[0] : void 0
                      );
                      const Ie = He.description;
                      f({
                        title: He?.title,
                        priority: Xe[0],
                        status: me[0],
                        project: he[0],
                        description: Ie ? dx(Ie, fR) : "",
                        team: N
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: N
                      }), H(void 0), Y(void 0), U(void 0), ee(void 0);
                  },
                  value: q ? [q] : void 0,
                  children: M?.map((we) => /* @__PURE__ */ oe.jsx(
                    ot.Item,
                    {
                      value: we,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: we.name })
                    },
                    we.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 6, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: we, value: He },
                    fieldState: { error: Xe }
                  }) => /* @__PURE__ */ oe.jsx(
                    or,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: He || "",
                        onChange: we
                      },
                      meta: {
                        error: Xe?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: we, onChange: He } }) => {
                    const Xe = je ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(Ln, { label: "Status", children: /* @__PURE__ */ oe.jsx(
                      Yr,
                      {
                        dropdownProps: { className: wi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (me) => me?.name,
                        disabled: N === void 0,
                        placeholder: N ? "Select Issue status" : "Select a Team first",
                        onChange: (me) => {
                          U(me.selectedValues[0]), He(me.selectedValues[0]);
                        },
                        value: D ? [we] : Xe,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          je && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(cn, { size: 24 })
                            }
                          ),
                          ze && !je && $.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      _s,
                                      {
                                        type: me.type,
                                        color: me.color,
                                        name: me.name
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.name })
                                  ]
                                }
                              )
                            },
                            me.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: we, onChange: He } }) => {
                    const Xe = Be ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(Ln, { label: "Priority", children: /* @__PURE__ */ oe.jsx(
                      Yr,
                      {
                        clearable: !0,
                        getItemTitleByValue: (me) => me?.label,
                        disabled: N === void 0,
                        placeholder: N ? "Select Issue priority" : "Select a Team first",
                        onChange: (me) => {
                          Y(me.selectedValues[0]), He(me.selectedValues[0]);
                        },
                        value: ie ? [we] : Xe,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          je && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(cn, { size: 24 })
                            }
                          ),
                          K && !Be && Z.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      bs,
                                      {
                                        priority: me.priority
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.label })
                                  ]
                                }
                              )
                            },
                            me.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: we, value: He },
                    fieldState: { error: Xe }
                  }) => /* @__PURE__ */ oe.jsx(
                    WS,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: He || "",
                        onChange: we
                      },
                      meta: {
                        error: Xe?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ oe.jsx(
          It,
          {
            confirmOnClick: u($e),
            confirmProps: {
              disabled: ke || !K,
              isLoading: ge || Be || je,
              loadingIndicator: /* @__PURE__ */ oe.jsx(cn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              nn(), Ae();
            }
          }
        )
      ]
    }
  );
}, xR = "_modalWrapper_4kh9u_1", SR = "_copyButton_4kh9u_6", NR = "_copyWrapper_4kh9u_15", jR = "_copyField_4kh9u_24", wR = "_externalLink_4kh9u_47", CR = "_externalLinkIcon_4kh9u_52", FR = "_textWrapper_4kh9u_56", ti = {
  modalWrapper: xR,
  copyButton: SR,
  copyWrapper: NR,
  copyField: jR,
  externalLink: wR,
  externalLinkIcon: CR,
  textWrapper: FR
}, IR = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ oe.jsxs(
  Nt,
  {
    isOpen: !!n && e,
    className: ti.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ oe.jsx(
        jt,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ oe.jsx(wt, { children: /* @__PURE__ */ oe.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ oe.jsxs(A.Paragraph, { className: ti.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ oe.jsxs(
                A.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: ti.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ oe.jsx(ue, { name: "external-link", className: ti.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ oe.jsx(Ln, { label: "Linear issue link", children: /* @__PURE__ */ oe.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: ti.copyWrapper,
                children: [
                  /* @__PURE__ */ oe.jsx(
                    kr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: ti.copyField
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(
                    KS,
                    {
                      className: ti.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ oe.jsx(
        It,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), ER = "https://linear.app/", TR = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), [a, o] = se([]), [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(!1), [h, v] = se(), { useLazyQuery: N } = mn(), [w, C] = se(""), F = n?.enableCreateIssue, y = !!n?.enableUnlinkAll, { track: H } = kn(), {
    loading: $,
    data: E,
    error: D,
    store: U
  } = wm(e?.conversationId ?? null), [
    Z,
    {
      data: Q,
      loading: ie,
      networkStatus: Y,
      error: M
    }
  ] = N(RO, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    !$ && !D && E && E?.linear?.issues?.length > 0 ? (o(E.linear.issues), Z({
      variables: {
        linkedIssues: E.linear.issues
      }
    })) : !$ && !D && (i([]), o([]));
  }, [E, $, D]), qe(() => {
    Q && Q?.Linear && !ie && Y === Gt.ready && Object.keys(Q).length > 0 && i(Q.Linear.issues?.edges?.map(({ node: de }) => de));
  }, [Q, ie, Y]);
  const R = (de) => {
    de && de?.team?.organization?.urlKey && H("linear:link:issue:clicked", {
      linearInstanceUrl: w,
      linearIssueKey: de.id
    });
    const le = (pe) => pe.id === de?.id;
    r.some((pe) => pe && le(pe)) || (E && a.length === 0 && o([]), U({
      linear: {
        issues: [...a, de.id]
      }
    }));
  }, q = (de) => {
    const le = E?.linear.issues.filter((pe) => pe !== de) || [];
    H("linear:unlink:issue:clicked", {
      linearInstanceUrl: w,
      linearIssueKey: de
    }), i(r.filter(({ id: pe }) => pe !== de)), o(le), U({
      linear: {
        issues: le
      }
    });
  }, ee = () => {
    l(!1), i([]), o([]), U({
      linear: {
        issues: []
      }
    });
  }, ge = $ || ie || !E && !D || (E?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !$ && !ie && (M || D) ? /* @__PURE__ */ oe.jsx(In, { error: M || D }) : /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ oe.jsxs(
      Nt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ oe.jsx(
            jt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ oe.jsx(wt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ oe.jsx(
            It,
            {
              confirmOnClick: () => ee(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      _R,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (de) => m(de),
        setIsCreationSuccessfulModalOpen: (de) => f(de),
        addToLinkedIssueIds: (de) => {
          U({
            linear: {
              issues: [...a, de]
            }
          });
        },
        setCreatedIssue: (de) => v(de),
        organizationUrl: w,
        setOrganizationUrl: (de) => C(de)
      }
    ),
    /* @__PURE__ */ oe.jsx(
      IR,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (de) => f(de),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          F && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
            /* @__PURE__ */ oe.jsx(
              Kn,
              {
                variant: "primary",
                onClick: () => {
                  H("linear:create:new:issue:clicked", {
                    linearInstanceUrl: w
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ oe.jsx(oR, { handleSelect: R, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      pR,
      {
        linkedIssues: r,
        isLoading: ge,
        handleUnlinkIssue: q,
        showUnlinkAllModal: (de) => l(de),
        showUnlinkAllButton: y,
        organizationUrl: w
      }
    )
  ] });
}, $R = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Mi
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ol = { exports: {} }, ga = {}, ey;
function DR() {
  if (ey) return ga;
  ey = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ga.Fragment = r, ga.jsx = s, ga.jsxs = s, ga;
}
var Io = {}, ny;
function OR() {
  return ny || (ny = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    Io.Fragment = i, Io.jsx = On, Io.jsxs = Bn;
  })()), Io;
}
var ty;
function RR() {
  return ty || (ty = 1, process.env.NODE_ENV === "production" ? Ol.exports = DR() : Ol.exports = OR()), Ol.exports;
}
var De = RR();
const PR = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, AR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, LR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, VR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, zR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, UR = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": PR,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": AR,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": LR,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": VR,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": zR
};
function qs(e) {
  return UR[e] ?? {};
}
const MR = qs(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), BR = qs(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), qR = qs(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), HR = qs(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function Rl(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const WR = "_wrapper_27vny_1", KR = "_copyIcon_27vny_12", va = {
  wrapper: WR,
  copyIcon: KR
}, GR = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = Rl(), { isCopied: i, copy: a } = Rl(), { isCopied: o, copy: s } = Rl();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: N,
    referral_url: w
  } = e, C = f ? An(f).isSame(Date.now(), "day") : !1, { name: F, first_name: y, last_name: H } = m ?? {}, $ = F ?? (`${y} ${H}`.trim() || "A customer has no name"), E = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ De.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ De.jsxs(b, { className: va.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: va.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-2", children: $ }),
          C && /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "secondary", children: An(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ De.jsx(b, { gap: "200", children: /* @__PURE__ */ De.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      An(N).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ue, { size: l, name: "mail" }),
        /* @__PURE__ */ De.jsx(A.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ De.jsx(Ke, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: va.copyIcon
        }
      ) })
    ] }),
    E && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ue, { size: l, name: "link" }),
        /* @__PURE__ */ De.jsx(Ke, { content: "Shopify shop", children: /* @__PURE__ */ De.jsx(
          A.ExternalLink,
          {
            href: E,
            target: "_blank",
            rel: "noreferrer",
            children: E.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ De.jsx(Ke, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(E),
          className: va.copyIcon
        }
      ) })
    ] }),
    w && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ue, { size: l, name: "external-link" }),
        /* @__PURE__ */ De.jsx(Ke, { content: "Referral link", children: /* @__PURE__ */ De.jsx(
          A.ExternalLink,
          {
            href: w,
            target: "_blank",
            rel: "noreferrer",
            children: w.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ De.jsx(Ke, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(w),
          className: va.copyIcon
        }
      ) })
    ] })
  ] }) });
}, YR = "_list_1q5b5_5", JR = "_listItem_1q5b5_8", QR = "_listItemEdit_1q5b5_15", XR = "_notificationText_1q5b5_19", Ui = {
  list: YR,
  listItem: JR,
  listItemEdit: QR,
  notificationText: XR
}, ZR = "_modalBody_1clhs_1", eP = {
  modalBody: ZR
}, nP = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = kn(), [d, m] = se(n), [u, f] = se(""), [h, v] = se(), [N, { loading: w }] = o(
    qR,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), Y();
      }
    }
  ), [C, { loading: F }] = o(HR), y = w || F, H = !!h, $ = n === d ? "Change the value to update the points" : "", E = isNaN(d), D = E ? "Points can not be empty" : "", U = d > n && d - n > 1e6, Z = U ? "Points can not exceed 1,000,000" : "", Q = () => {
    if (!r) {
      v(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && N({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((M) => {
      const R = M?.networkError;
      (R ? R?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), Y()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), d < n && C({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((M) => {
      M.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), Y()) : "errors" in M && (l("loyaltylion:remove:points:failed"), v(
        M.errors?.map((R) => R.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, ie = () => {
    E && m(n), f(""), i();
  }, Y = () => {
    a(), ie();
  };
  return /* @__PURE__ */ De.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: ie,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ De.jsx(jt, { title: "Change points", onClose: ie }),
        /* @__PURE__ */ De.jsxs(wt, { className: eP.modalBody, children: [
          /* @__PURE__ */ De.jsxs(Ut, { children: [
            /* @__PURE__ */ De.jsx(tn, { span: 6, children: /* @__PURE__ */ De.jsx(
              or,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Z || D,
                  warning: $
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (M) => m(M?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ De.jsx(tn, { span: 6, children: /* @__PURE__ */ De.jsx(
              or,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (M) => f(M?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !y && H && /* @__PURE__ */ De.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ De.jsx(We, { children: h?.map((M, R) => /* @__PURE__ */ De.jsx(
            We.Item,
            {
              variant: "dense",
              title: M,
              contentLeft: /* @__PURE__ */ De.jsx(
                ue,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            R
          )) }) })
        ] }),
        /* @__PURE__ */ De.jsx(
          It,
          {
            confirmName: "Save",
            confirmOnClick: () => Q(),
            confirmProps: {
              isLoading: y,
              disabled: E || U || n === d,
              loadingIndicator: /* @__PURE__ */ De.jsx(cn, { size: 16 })
            },
            cancelOnClick: ie
          }
        )
      ]
    }
  );
}, tP = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ De.jsx(We.Text, { variant: "dense", className: Ui.listItem, children: /* @__PURE__ */ De.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ De.jsx(Ke, { content: "Edit points", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Ui.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ De.jsx(Un, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, rP = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = se(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ De.jsx(We, { className: Ui.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ De.jsx(
      tP,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      u
    )) }),
    /* @__PURE__ */ De.jsx(
      nP,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, iP = "_reward_1wxia_1", aP = {
  reward: iP
}, oP = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ De.jsx(b, { gap: "100", flexDirection: "column", className: aP.reward, children: /* @__PURE__ */ De.jsx(Ke, { content: a ?? "No description", children: /* @__PURE__ */ De.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ De.jsx(ue, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ De.jsxs(Un, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ De.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { size: 14, name: "external-link" }),
      /* @__PURE__ */ De.jsx(
        A.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, sP = ({ customer: e }) => {
  const { useQuery: n } = mn(), [r, i] = se(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(BR, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (qe(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return no({ errors: d }) ? /* @__PURE__ */ De.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Ui.notificationText,
        children: "No rewards found"
      }
    ) : yb({ errors: d }) ? /* @__PURE__ */ De.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Ui.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ De.jsx(In, { error: s });
  }
  return /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ De.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ De.jsx(cn, {}) }) : /* @__PURE__ */ De.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ De.jsx(oP, { reward: d }, d.id)) })
  ] });
}, lP = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(Pn, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(
        ue,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(Pn, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(Ke, { content: "Insights segment", children: /* @__PURE__ */ De.jsx(Pn, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, cP = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), { track: i } = kn(), [a, o] = se(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: v,
    data: N,
    refetch: w
  } = r(MR, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return qe(() => {
    if (N && !h) {
      const C = (N?.LoyaltyLion?.getCustomers).customers;
      C && C.length > 0 && (o(C[0]), i("loyaltylion:customer:received"));
    }
  }, [N, h]), s?.email ? v ? no({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ De.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Ui.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ De.jsx(In, { error: v }) : h ? /* @__PURE__ */ De.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ De.jsx(cn, {}) }) : f ? /* @__PURE__ */ De.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ De.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ De.jsxs(De.Fragment, { children: [
        l && /* @__PURE__ */ De.jsx(GR, { customer: a }),
        d && /* @__PURE__ */ De.jsx(lP, { customer: a }),
        m && /* @__PURE__ */ De.jsx(
          rP,
          {
            customer: a,
            refetchCustomerData: w
          }
        ),
        u && /* @__PURE__ */ De.jsx(sP, { customer: a })
      ] }) : /* @__PURE__ */ De.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ De.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, dP = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Pl = { exports: {} }, ka = {}, ry;
function uP() {
  if (ry) return ka;
  ry = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ka.Fragment = r, ka.jsx = s, ka.jsxs = s, ka;
}
var Eo = {}, iy;
function mP() {
  return iy || (iy = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    Eo.Fragment = i, Eo.jsx = On, Eo.jsxs = Bn;
  })()), Eo;
}
var ay;
function pP() {
  return ay || (ay = 1, process.env.NODE_ENV === "production" ? Pl.exports = uP() : Pl.exports = mP()), Pl.exports;
}
var wn = pP();
const fP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, hP = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": fP
};
function yP(e) {
  return hP[e] ?? {};
}
const {
  entries: ux,
  setPrototypeOf: oy,
  isFrozen: gP,
  getPrototypeOf: vP,
  getOwnPropertyDescriptor: kP
} = Object;
let {
  freeze: Vt,
  seal: sr,
  create: Va
} = Object, {
  apply: fm,
  construct: hm
} = typeof Reflect < "u" && Reflect;
Vt || (Vt = function(e) {
  return e;
});
sr || (sr = function(e) {
  return e;
});
fm || (fm = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
hm || (hm = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const ba = zt(Array.prototype.forEach), bP = zt(Array.prototype.lastIndexOf), sy = zt(Array.prototype.pop), _a = zt(Array.prototype.push), _P = zt(Array.prototype.splice), Zo = zt(String.prototype.toLowerCase), Al = zt(String.prototype.toString), Ll = zt(String.prototype.match), Ci = zt(String.prototype.replace), xP = zt(String.prototype.indexOf), SP = zt(String.prototype.trim), mr = zt(Object.prototype.hasOwnProperty), Tt = zt(RegExp.prototype.test), xa = NP(TypeError);
function zt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return fm(e, n, i);
  };
}
function NP(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return hm(e, r);
  };
}
function Tn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Zo;
  oy && oy(e, null);
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (gP(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function jP(e) {
  for (let n = 0; n < e.length; n++)
    mr(e, n) || (e[n] = null);
  return e;
}
function jr(e) {
  const n = Va(null);
  for (const [r, i] of ux(e))
    mr(e, r) && (Array.isArray(i) ? n[r] = jP(i) : i && typeof i == "object" && i.constructor === Object ? n[r] = jr(i) : n[r] = i);
  return n;
}
function Sa(e, n) {
  for (; e !== null; ) {
    const i = kP(e, n);
    if (i) {
      if (i.get)
        return zt(i.get);
      if (typeof i.value == "function")
        return zt(i.value);
    }
    e = vP(e);
  }
  function r() {
    return null;
  }
  return r;
}
const ly = Vt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Vl = Vt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), zl = Vt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), wP = Vt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Ul = Vt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), CP = Vt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), cy = Vt(["#text"]), dy = Vt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ml = Vt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), uy = Vt(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), To = Vt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), FP = sr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), IP = sr(/<%[\w\W]*|[\w\W]*%>/gm), EP = sr(/\$\{[\w\W]*/gm), TP = sr(/^data-[\-\w.\u00B7-\uFFFF]+$/), $P = sr(/^aria-[\-\w]+$/), mx = sr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), DP = sr(/^(?:\w+script|data):/i), OP = sr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), px = sr(/^html$/i), RP = sr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var my = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: $P,
  ATTR_WHITESPACE: OP,
  CUSTOM_ELEMENT: RP,
  DATA_ATTR: TP,
  DOCTYPE_NAME: px,
  ERB_EXPR: IP,
  IS_ALLOWED_URI: mx,
  IS_SCRIPT_OR_DATA: DP,
  MUSTACHE_EXPR: FP,
  TMPLIT_EXPR: EP
});
const Na = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, PP = function() {
  return typeof window > "u" ? null : window;
}, AP = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, py = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function fx() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : PP();
  const n = (x) => fx(x);
  if (n.version = "3.4.0", n.removed = [], !e || !e.document || e.document.nodeType !== Na.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: r
  } = e;
  const i = r, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: d,
    NodeFilter: m,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: v
  } = e, N = d.prototype, w = Sa(N, "cloneNode"), C = Sa(N, "remove"), F = Sa(N, "nextSibling"), y = Sa(N, "childNodes"), H = Sa(N, "parentNode");
  if (typeof s == "function") {
    const x = r.createElement("template");
    x.content && x.content.ownerDocument && (r = x.content.ownerDocument);
  }
  let $, E = "";
  const {
    implementation: D,
    createNodeIterator: U,
    createDocumentFragment: Z,
    getElementsByTagName: Q
  } = r, {
    importNode: ie
  } = i;
  let Y = py();
  n.isSupported = typeof ux == "function" && typeof H == "function" && D && D.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: M,
    ERB_EXPR: R,
    TMPLIT_EXPR: q,
    DATA_ATTR: ee,
    ARIA_ATTR: ge,
    IS_SCRIPT_OR_DATA: de,
    ATTR_WHITESPACE: le,
    CUSTOM_ELEMENT: pe
  } = my;
  let {
    IS_ALLOWED_URI: W
  } = my, ke = null;
  const Ce = Tn({}, [...ly, ...Vl, ...zl, ...Ul, ...cy]);
  let K = null;
  const Be = Tn({}, [...dy, ...Ml, ...uy, ...To]);
  let Me = Object.seal(Va(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Pe = null, ze = null;
  const je = Object.seal(Va(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Ae = !0, $e = !0, nn = !1, we = !0, He = !1, Xe = !0, me = !1, he = !1, Ie = !1, Le = !1, Oe = !1, sn = !1, j = !0, _ = !1;
  const T = "user-content-";
  let G = !0, J = !1, O = {}, z = null;
  const re = Tn({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let fe = null;
  const be = Tn({}, ["audio", "video", "img", "source", "image", "track"]);
  let Ze = null;
  const un = Tn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), rn = "http://www.w3.org/1998/Math/MathML", dn = "http://www.w3.org/2000/svg", pn = "http://www.w3.org/1999/xhtml";
  let ln = pn, vn = !1, Qe = null;
  const xn = Tn({}, [rn, dn, pn], Al);
  let Re = Tn({}, ["mi", "mo", "mn", "ms", "mtext"]), an = Tn({}, ["annotation-xml"]);
  const on = Tn({}, ["title", "style", "font", "a", "script"]);
  let hn = null;
  const Hn = ["application/xhtml+xml", "text/html"], Sn = "text/html";
  let yn = null, fn = null;
  const Nn = r.createElement("form"), Mn = function(x) {
    return x instanceof RegExp || x instanceof Function;
  }, Vn = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(fn && fn === x)) {
      if ((!x || typeof x != "object") && (x = {}), x = jr(x), hn = // eslint-disable-next-line unicorn/prefer-includes
      Hn.indexOf(x.PARSER_MEDIA_TYPE) === -1 ? Sn : x.PARSER_MEDIA_TYPE, yn = hn === "application/xhtml+xml" ? Al : Zo, ke = mr(x, "ALLOWED_TAGS") ? Tn({}, x.ALLOWED_TAGS, yn) : Ce, K = mr(x, "ALLOWED_ATTR") ? Tn({}, x.ALLOWED_ATTR, yn) : Be, Qe = mr(x, "ALLOWED_NAMESPACES") ? Tn({}, x.ALLOWED_NAMESPACES, Al) : xn, Ze = mr(x, "ADD_URI_SAFE_ATTR") ? Tn(jr(un), x.ADD_URI_SAFE_ATTR, yn) : un, fe = mr(x, "ADD_DATA_URI_TAGS") ? Tn(jr(be), x.ADD_DATA_URI_TAGS, yn) : be, z = mr(x, "FORBID_CONTENTS") ? Tn({}, x.FORBID_CONTENTS, yn) : re, Pe = mr(x, "FORBID_TAGS") ? Tn({}, x.FORBID_TAGS, yn) : jr({}), ze = mr(x, "FORBID_ATTR") ? Tn({}, x.FORBID_ATTR, yn) : jr({}), O = mr(x, "USE_PROFILES") ? x.USE_PROFILES : !1, Ae = x.ALLOW_ARIA_ATTR !== !1, $e = x.ALLOW_DATA_ATTR !== !1, nn = x.ALLOW_UNKNOWN_PROTOCOLS || !1, we = x.ALLOW_SELF_CLOSE_IN_ATTR !== !1, He = x.SAFE_FOR_TEMPLATES || !1, Xe = x.SAFE_FOR_XML !== !1, me = x.WHOLE_DOCUMENT || !1, Le = x.RETURN_DOM || !1, Oe = x.RETURN_DOM_FRAGMENT || !1, sn = x.RETURN_TRUSTED_TYPE || !1, Ie = x.FORCE_BODY || !1, j = x.SANITIZE_DOM !== !1, _ = x.SANITIZE_NAMED_PROPS || !1, G = x.KEEP_CONTENT !== !1, J = x.IN_PLACE || !1, W = x.ALLOWED_URI_REGEXP || mx, ln = x.NAMESPACE || pn, Re = x.MATHML_TEXT_INTEGRATION_POINTS || Re, an = x.HTML_INTEGRATION_POINTS || an, Me = x.CUSTOM_ELEMENT_HANDLING || Va(null), x.CUSTOM_ELEMENT_HANDLING && Mn(x.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Me.tagNameCheck = x.CUSTOM_ELEMENT_HANDLING.tagNameCheck), x.CUSTOM_ELEMENT_HANDLING && Mn(x.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Me.attributeNameCheck = x.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), x.CUSTOM_ELEMENT_HANDLING && typeof x.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Me.allowCustomizedBuiltInElements = x.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), He && ($e = !1), Oe && (Le = !0), O && (ke = Tn({}, cy), K = Va(null), O.html === !0 && (Tn(ke, ly), Tn(K, dy)), O.svg === !0 && (Tn(ke, Vl), Tn(K, Ml), Tn(K, To)), O.svgFilters === !0 && (Tn(ke, zl), Tn(K, Ml), Tn(K, To)), O.mathMl === !0 && (Tn(ke, Ul), Tn(K, uy), Tn(K, To))), je.tagCheck = null, je.attributeCheck = null, x.ADD_TAGS && (typeof x.ADD_TAGS == "function" ? je.tagCheck = x.ADD_TAGS : (ke === Ce && (ke = jr(ke)), Tn(ke, x.ADD_TAGS, yn))), x.ADD_ATTR && (typeof x.ADD_ATTR == "function" ? je.attributeCheck = x.ADD_ATTR : (K === Be && (K = jr(K)), Tn(K, x.ADD_ATTR, yn))), x.ADD_URI_SAFE_ATTR && Tn(Ze, x.ADD_URI_SAFE_ATTR, yn), x.FORBID_CONTENTS && (z === re && (z = jr(z)), Tn(z, x.FORBID_CONTENTS, yn)), x.ADD_FORBID_CONTENTS && (z === re && (z = jr(z)), Tn(z, x.ADD_FORBID_CONTENTS, yn)), G && (ke["#text"] = !0), me && Tn(ke, ["html", "head", "body"]), ke.table && (Tn(ke, ["tbody"]), delete Pe.tbody), x.TRUSTED_TYPES_POLICY) {
        if (typeof x.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw xa('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof x.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw xa('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        $ = x.TRUSTED_TYPES_POLICY, E = $.createHTML("");
      } else
        $ === void 0 && ($ = AP(v, a)), $ !== null && typeof E == "string" && (E = $.createHTML(""));
      Vt && Vt(x), fn = x;
    }
  }, bn = Tn({}, [...Vl, ...zl, ...wP]), _n = Tn({}, [...Ul, ...CP]), Wn = function(x) {
    let V = H(x);
    (!V || !V.tagName) && (V = {
      namespaceURI: ln,
      tagName: "template"
    });
    const X = Zo(x.tagName), Ne = Zo(V.tagName);
    return Qe[x.namespaceURI] ? x.namespaceURI === dn ? V.namespaceURI === pn ? X === "svg" : V.namespaceURI === rn ? X === "svg" && (Ne === "annotation-xml" || Re[Ne]) : !!bn[X] : x.namespaceURI === rn ? V.namespaceURI === pn ? X === "math" : V.namespaceURI === dn ? X === "math" && an[Ne] : !!_n[X] : x.namespaceURI === pn ? V.namespaceURI === dn && !an[Ne] || V.namespaceURI === rn && !Re[Ne] ? !1 : !_n[X] && (on[X] || !bn[X]) : !!(hn === "application/xhtml+xml" && Qe[x.namespaceURI]) : !1;
  }, Dn = function(x) {
    _a(n.removed, {
      element: x
    });
    try {
      H(x).removeChild(x);
    } catch {
      C(x);
    }
  }, On = function(x, V) {
    try {
      _a(n.removed, {
        attribute: V.getAttributeNode(x),
        from: V
      });
    } catch {
      _a(n.removed, {
        attribute: null,
        from: V
      });
    }
    if (V.removeAttribute(x), x === "is")
      if (Le || Oe)
        try {
          Dn(V);
        } catch {
        }
      else
        try {
          V.setAttribute(x, "");
        } catch {
        }
  }, Bn = function(x) {
    let V = null, X = null;
    if (Ie)
      x = "<remove></remove>" + x;
    else {
      const ne = Ll(x, /^[\r\n\t ]+/);
      X = ne && ne[0];
    }
    hn === "application/xhtml+xml" && ln === pn && (x = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + x + "</body></html>");
    const Ne = $ ? $.createHTML(x) : x;
    if (ln === pn)
      try {
        V = new h().parseFromString(Ne, hn);
      } catch {
      }
    if (!V || !V.documentElement) {
      V = D.createDocument(ln, "template", null);
      try {
        V.documentElement.innerHTML = vn ? E : Ne;
      } catch {
      }
    }
    const xe = V.body || V.documentElement;
    return x && X && xe.insertBefore(r.createTextNode(X), xe.childNodes[0] || null), ln === pn ? Q.call(V, me ? "html" : "body")[0] : me ? V.documentElement : xe;
  }, t = function(x) {
    return U.call(
      x.ownerDocument || x,
      x,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, c = function(x) {
    return x instanceof f && (typeof x.nodeName != "string" || typeof x.textContent != "string" || typeof x.removeChild != "function" || !(x.attributes instanceof u) || typeof x.removeAttribute != "function" || typeof x.setAttribute != "function" || typeof x.namespaceURI != "string" || typeof x.insertBefore != "function" || typeof x.hasChildNodes != "function");
  }, p = function(x) {
    return typeof l == "function" && x instanceof l;
  };
  function g(x, V, X) {
    ba(x, (Ne) => {
      Ne.call(n, V, X, fn);
    });
  }
  const P = function(x) {
    let V = null;
    if (g(Y.beforeSanitizeElements, x, null), c(x))
      return Dn(x), !0;
    const X = yn(x.nodeName);
    if (g(Y.uponSanitizeElement, x, {
      tagName: X,
      allowedTags: ke
    }), Xe && x.hasChildNodes() && !p(x.firstElementChild) && Tt(/<[/\w!]/g, x.innerHTML) && Tt(/<[/\w!]/g, x.textContent) || Xe && x.namespaceURI === pn && X === "style" && p(x.firstElementChild) || x.nodeType === Na.progressingInstruction || Xe && x.nodeType === Na.comment && Tt(/<[/\w]/g, x.data))
      return Dn(x), !0;
    if (Pe[X] || !(je.tagCheck instanceof Function && je.tagCheck(X)) && !ke[X]) {
      if (!Pe[X] && I(X) && (Me.tagNameCheck instanceof RegExp && Tt(Me.tagNameCheck, X) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(X)))
        return !1;
      if (G && !z[X]) {
        const Ne = H(x) || x.parentNode, xe = y(x) || x.childNodes;
        if (xe && Ne) {
          const ne = xe.length;
          for (let en = ne - 1; en >= 0; --en) {
            const En = w(xe[en], !0);
            En.__removalCount = (x.__removalCount || 0) + 1, Ne.insertBefore(En, F(x));
          }
        }
      }
      return Dn(x), !0;
    }
    return x instanceof d && !Wn(x) || (X === "noscript" || X === "noembed" || X === "noframes") && Tt(/<\/no(script|embed|frames)/i, x.innerHTML) ? (Dn(x), !0) : (He && x.nodeType === Na.text && (V = x.textContent, ba([M, R, q], (Ne) => {
      V = Ci(V, Ne, " ");
    }), x.textContent !== V && (_a(n.removed, {
      element: x.cloneNode()
    }), x.textContent = V)), g(Y.afterSanitizeElements, x, null), !1);
  }, L = function(x, V, X) {
    if (ze[V] || j && (V === "id" || V === "name") && (X in r || X in Nn))
      return !1;
    if (!($e && !ze[V] && Tt(ee, V)) && !(Ae && Tt(ge, V)) && !(je.attributeCheck instanceof Function && je.attributeCheck(V, x))) {
      if (!K[V] || ze[V]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(I(x) && (Me.tagNameCheck instanceof RegExp && Tt(Me.tagNameCheck, x) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(x)) && (Me.attributeNameCheck instanceof RegExp && Tt(Me.attributeNameCheck, V) || Me.attributeNameCheck instanceof Function && Me.attributeNameCheck(V, x)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          V === "is" && Me.allowCustomizedBuiltInElements && (Me.tagNameCheck instanceof RegExp && Tt(Me.tagNameCheck, X) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(X)))
        ) return !1;
      } else if (!Ze[V] && !Tt(W, Ci(X, le, "")) && !((V === "src" || V === "xlink:href" || V === "href") && x !== "script" && xP(X, "data:") === 0 && fe[x]) && !(nn && !Tt(de, Ci(X, le, ""))) && X)
        return !1;
    }
    return !0;
  }, I = function(x) {
    return x !== "annotation-xml" && Ll(x, pe);
  }, S = function(x) {
    g(Y.beforeSanitizeAttributes, x, null);
    const {
      attributes: V
    } = x;
    if (!V || c(x))
      return;
    const X = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: K,
      forceKeepAttr: void 0
    };
    let Ne = V.length;
    for (; Ne--; ) {
      const xe = V[Ne], {
        name: ne,
        namespaceURI: en,
        value: En
      } = xe, jn = yn(ne), Xi = En;
      let gt = ne === "value" ? Xi : SP(Xi);
      if (X.attrName = jn, X.attrValue = gt, X.keepAttr = !0, X.forceKeepAttr = void 0, g(Y.uponSanitizeAttribute, x, X), gt = X.attrValue, _ && (jn === "id" || jn === "name") && (On(ne, x), gt = T + gt), Xe && Tt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, gt)) {
        On(ne, x);
        continue;
      }
      if (jn === "attributename" && Ll(gt, "href")) {
        On(ne, x);
        continue;
      }
      if (X.forceKeepAttr)
        continue;
      if (!X.keepAttr) {
        On(ne, x);
        continue;
      }
      if (!we && Tt(/\/>/i, gt)) {
        On(ne, x);
        continue;
      }
      He && ba([M, R, q], (CS) => {
        gt = Ci(gt, CS, " ");
      });
      const Bp = yn(x.nodeName);
      if (!L(Bp, jn, gt)) {
        On(ne, x);
        continue;
      }
      if ($ && typeof v == "object" && typeof v.getAttributeType == "function" && !en)
        switch (v.getAttributeType(Bp, jn)) {
          case "TrustedHTML": {
            gt = $.createHTML(gt);
            break;
          }
          case "TrustedScriptURL": {
            gt = $.createScriptURL(gt);
            break;
          }
        }
      if (gt !== Xi)
        try {
          en ? x.setAttributeNS(en, ne, gt) : x.setAttribute(ne, gt), c(x) ? Dn(x) : sy(n.removed);
        } catch {
          On(ne, x);
        }
    }
    g(Y.afterSanitizeAttributes, x, null);
  }, te = function(x) {
    let V = null;
    const X = t(x);
    for (g(Y.beforeSanitizeShadowDOM, x, null); V = X.nextNode(); )
      g(Y.uponSanitizeShadowNode, V, null), P(V), S(V), V.content instanceof o && te(V.content);
    g(Y.afterSanitizeShadowDOM, x, null);
  };
  return n.sanitize = function(x) {
    let V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, X = null, Ne = null, xe = null, ne = null;
    if (vn = !x, vn && (x = "<!-->"), typeof x != "string" && !p(x))
      if (typeof x.toString == "function") {
        if (x = x.toString(), typeof x != "string")
          throw xa("dirty is not a string, aborting");
      } else
        throw xa("toString is not a function");
    if (!n.isSupported)
      return x;
    if (he || Vn(V), n.removed = [], typeof x == "string" && (J = !1), J) {
      if (x.nodeName) {
        const jn = yn(x.nodeName);
        if (!ke[jn] || Pe[jn])
          throw xa("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (x instanceof l)
      X = Bn("<!---->"), Ne = X.ownerDocument.importNode(x, !0), Ne.nodeType === Na.element && Ne.nodeName === "BODY" || Ne.nodeName === "HTML" ? X = Ne : X.appendChild(Ne);
    else {
      if (!Le && !He && !me && // eslint-disable-next-line unicorn/prefer-includes
      x.indexOf("<") === -1)
        return $ && sn ? $.createHTML(x) : x;
      if (X = Bn(x), !X)
        return Le ? null : sn ? E : "";
    }
    X && Ie && Dn(X.firstChild);
    const en = t(J ? x : X);
    for (; xe = en.nextNode(); )
      P(xe), S(xe), xe.content instanceof o && te(xe.content);
    if (J)
      return x;
    if (Le) {
      if (He) {
        X.normalize();
        let jn = X.innerHTML;
        ba([M, R, q], (Xi) => {
          jn = Ci(jn, Xi, " ");
        }), X.innerHTML = jn;
      }
      if (Oe)
        for (ne = Z.call(X.ownerDocument); X.firstChild; )
          ne.appendChild(X.firstChild);
      else
        ne = X;
      return (K.shadowroot || K.shadowrootmode) && (ne = ie.call(i, ne, !0)), ne;
    }
    let En = me ? X.outerHTML : X.innerHTML;
    return me && ke["!doctype"] && X.ownerDocument && X.ownerDocument.doctype && X.ownerDocument.doctype.name && Tt(px, X.ownerDocument.doctype.name) && (En = "<!DOCTYPE " + X.ownerDocument.doctype.name + `>
` + En), He && ba([M, R, q], (jn) => {
      En = Ci(En, jn, " ");
    }), $ && sn ? $.createHTML(En) : En;
  }, n.setConfig = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn(x), he = !0;
  }, n.clearConfig = function() {
    fn = null, he = !1;
  }, n.isValidAttribute = function(x, V, X) {
    fn || Vn({});
    const Ne = yn(x), xe = yn(V);
    return L(Ne, xe, X);
  }, n.addHook = function(x, V) {
    typeof V == "function" && _a(Y[x], V);
  }, n.removeHook = function(x, V) {
    if (V !== void 0) {
      const X = bP(Y[x], V);
      return X === -1 ? void 0 : _P(Y[x], X, 1)[0];
    }
    return sy(Y[x]);
  }, n.removeHooks = function(x) {
    Y[x] = [];
  }, n.removeAllHooks = function() {
    Y = py();
  }, n;
}
var LP = fx();
const VP = "_messageContainer_1rxr4_1", zP = "_chip_1rxr4_7", UP = "_chipLabel_1rxr4_10", MP = "_chipValue_1rxr4_13", $o = {
  messageContainer: VP,
  chip: zP,
  chipLabel: UP,
  chipValue: MP
}, fy = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, BP = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  qe(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ wn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ wn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ wn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ wn.jsx(Ke, { content: "Conversation Attributes", children: /* @__PURE__ */ wn.jsx(
        Im,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ wn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ wn.jsx(Pn, { className: $o.chip, children: /* @__PURE__ */ wn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ wn.jsxs(Qn, { className: $o.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ wn.jsx(Qn, { className: $o.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ wn.jsx(
      b,
      {
        className: $o.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? fy[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? fy[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ wn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ wn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ wn.jsx(A.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ wn.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ wn.jsx(YS, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ wn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: LP.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ wn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ wn.jsx(
      JS,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ wn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, qP = "_conversation_1draa_1", HP = "_conversationSubLine_1draa_9", WP = "_modal_1draa_14", Bl = {
  conversation: qP,
  conversationSubLine: HP,
  modal: WP
}, KP = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), GP = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), YP = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = se(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ wn.jsxs(b, { className: Bl.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ wn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ wn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ wn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ wn.jsx(A.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ wn.jsx(Un, { size: "small", variant: "info", children: An(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ wn.jsx(
          A.Heading,
          {
            variant: "heading-4",
            className: Bl.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ wn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ wn.jsx(Pn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ wn.jsx(Ke, { content: "Show conversation preview", children: /* @__PURE__ */ wn.jsx(
        Yt,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ wn.jsxs(
      Nt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Bl.modal,
        children: [
          /* @__PURE__ */ wn.jsx(
            jt,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ wn.jsx(wt, { children: /* @__PURE__ */ wn.jsx(
            BP,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: KP(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: GP(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, JP = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = se(!1), o = r > 0 ? r : 1, s = e?.length > o, l = qn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ wn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ wn.jsx(
      YP,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ wn.jsxs(
      Kn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, QP = yP(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), XP = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = mn(), { data: l, loading: d, error: m } = s(QP, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return qe(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ wn.jsx(In, { error: m }) : d ? /* @__PURE__ */ wn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ wn.jsx(cn, {}) }) : r?.length === 0 ? /* @__PURE__ */ wn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ wn.jsx(
    JP,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, ZP = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Mi
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ql = { exports: {} }, ja = {}, hy;
function eA() {
  if (hy) return ja;
  hy = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ja.Fragment = r, ja.jsx = s, ja.jsxs = s, ja;
}
var Do = {}, yy;
function nA() {
  return yy || (yy = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    Do.Fragment = i, Do.jsx = On, Do.jsxs = Bn;
  })()), Do;
}
var gy;
function tA() {
  return gy || (gy = 1, process.env.NODE_ENV === "production" ? ql.exports = eA() : ql.exports = nA()), ql.exports;
}
var Fe = tA();
const rA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, iA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, aA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, oA = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": rA,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": iA,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": aA
};
function dp(e) {
  return oA[e] ?? {};
}
const sA = dp(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), lA = dp(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), cA = dp(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function ym(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const dA = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, hx = "DD MMM YYYY @ HH:mm", uA = "_list_2c4dq_1", mA = "_listItem_2c4dq_4", pA = "_copyIcon_2c4dq_12", pi = {
  list: uA,
  listItem: mA,
  copyIcon: pA
}, gm = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = ym(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: v,
    country_code: N
  } = e ?? {}, w = `${d} ${m}`.trim() || void 0, C = `${h} ${v}`.trim() || void 0, F = [w, u, f, C, N].filter(
    Boolean
  );
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(ue, { size: l, name: n }),
      i ? /* @__PURE__ */ Fe.jsx(cn, { size: l }) : /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: F.map((y, H) => /* @__PURE__ */ Fe.jsx(Qn, { children: y }, H)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Fe.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Fe.jsx(Ke, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: l,
          name: "exclamation",
          className: pi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(Ke, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(F.join(", ")),
          className: pi.copyIcon
        }
      ) })
    ] })
  ] });
}, fA = "_wrapper_1nher_1", hA = {
  wrapper: fA
}, yA = ({
  customer: e,
  store: n
}) => {
  const { track: r } = kn(), { isCopied: i, copy: a } = ym(), { isCopied: o, copy: s } = ym(), { useQuery: l } = mn(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(lA, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, v = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, N = (h?.addresses?.length ?? 0) > 1;
  if (qe(() => {
    v && r("recharge:profile:received");
  }, [v, r]), u)
    return /* @__PURE__ */ Fe.jsx(In, { error: u });
  if (!e)
    return null;
  const {
    id: w,
    phone: C,
    email: F,
    first_name: y,
    last_name: H,
    created_at: $,
    has_valid_payment_method: E
  } = e, D = 14, U = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${w}` : null, Z = `${y || ""} ${H || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Fe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(b, { className: hA.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-2", children: Z }),
    $ && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: An($).format(hx) })
    ] }),
    F && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ue, { size: D, name: "mail" }),
        /* @__PURE__ */ Fe.jsx(A.ExternalLink, { href: `mailto:${F}`, children: F })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ke, { content: "Copy email", children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: D,
          name: i ? "done" : "copy",
          onClick: () => a(F),
          className: pi.copyIcon
        }
      ) })
    ] }),
    C && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ue, { size: D, name: "phone" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: C })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: D,
          name: o ? "done" : "copy",
          onClick: () => s(C),
          className: pi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Fe.jsx(
      gm,
      {
        address: v,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: N
      }
    ),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ue, { size: D, name: "credit-card" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: D,
          name: E ? "check-circle" : "close-circle-filled",
          color: E ? "green.500" : "red.500"
        }
      )
    ] }),
    U && /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(ue, { size: D, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        A.ExternalLink,
        {
          href: U,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, gA = "_order_1dlaa_1", vA = "_orderIsOpen_1dlaa_9", kA = "_orderHeader_1dlaa_12", bA = "_note_1dlaa_16", Oo = {
  order: gA,
  orderIsOpen: vA,
  orderHeader: kA,
  note: bA
}, _A = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = kn(), [a, o] = se(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: N,
    is_prepaid: w
  } = e, C = 14, F = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, y = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Fe.jsxs(
    b,
    {
      className: ut(Oo.order, {
        [Oo.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Fe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Oo.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Fe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: An(f).format(hx) }) }),
                /* @__PURE__ */ Fe.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Fe.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ Fe.jsx(Ke, { content: "Note", children: /* @__PURE__ */ Fe.jsx(
            A.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: Oo.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: C, name: "activity" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: dA(l) })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: C, name: "credit-card" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: w ? "Yes" : "No" })
            ] })
          ] }),
          y && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: C, name: "cog" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: y })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: C, name: "chart-bar" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Fe.jsxs(A.Paragraph, { variant: "4", children: [
                N,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsx(
            gm,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Fe.jsx(
            gm,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          F && /* @__PURE__ */ Fe.jsx(
            St,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(F, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Fe.jsx(ue, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, xA = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = kn(), { useQuery: i } = mn(), {
    loading: a,
    error: o,
    data: s
  } = i(cA, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Fe.jsx(In, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Fe.jsx(Un, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(cn, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ Fe.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Fe.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ Fe.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ Fe.jsx(
        _A,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ Fe.jsx(
        St,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Fe.jsx(ue, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, SA = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Fe.jsxs(We, { className: pi.list, children: [
      /* @__PURE__ */ Fe.jsx(We.Text, { variant: "dense", className: pi.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Fe.jsx(We.Text, { variant: "dense", className: pi.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, NA = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(sA, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const v = m.graphQLErrors;
    return Nm({ errors: v }) ? /* @__PURE__ */ Fe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : jm({ errors: v }) ? /* @__PURE__ */ Fe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Fe.jsx(In, { error: m });
  }
  return d ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(cn, {}) }) : f ? l ? /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Fe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Fe.jsx(yA, { customer: f, store: h }),
        o && /* @__PURE__ */ Fe.jsx(SA, { customer: f }),
        s && /* @__PURE__ */ Fe.jsx(xA, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, jA = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    placeholder: "Insert the Admin API token for Recharge",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
var Ro = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function yx(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Hl = { exports: {} }, wa = {}, vy;
function wA() {
  if (vy) return wa;
  vy = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return wa.Fragment = r, wa.jsx = s, wa.jsxs = s, wa;
}
var Po = {}, ky;
function CA() {
  return ky || (ky = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    Po.Fragment = i, Po.jsx = On, Po.jsxs = Bn;
  })()), Po;
}
var by;
function FA() {
  return by || (by = 1, process.env.NODE_ENV === "production" ? Hl.exports = wA() : Hl.exports = CA()), Hl.exports;
}
var fi = FA();
function IA(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Wl, _y;
function ni() {
  if (_y) return Wl;
  _y = 1;
  var e = Array.isArray;
  return Wl = e, Wl;
}
var Kl, xy;
function gx() {
  if (xy) return Kl;
  xy = 1;
  var e = typeof Ro == "object" && Ro && Ro.Object === Object && Ro;
  return Kl = e, Kl;
}
var Gl, Sy;
function Pr() {
  if (Sy) return Gl;
  Sy = 1;
  var e = gx(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Gl = r, Gl;
}
var Yl, Ny;
function uo() {
  if (Ny) return Yl;
  Ny = 1;
  var e = Pr(), n = e.Symbol;
  return Yl = n, Yl;
}
var Jl, jy;
function EA() {
  if (jy) return Jl;
  jy = 1;
  var e = uo(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return Jl = o, Jl;
}
var Ql, wy;
function TA() {
  if (wy) return Ql;
  wy = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Ql = r, Ql;
}
var Xl, Cy;
function Yi() {
  if (Cy) return Xl;
  Cy = 1;
  var e = uo(), n = EA(), r = TA(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Xl = s, Xl;
}
var Zl, Fy;
function bi() {
  if (Fy) return Zl;
  Fy = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Zl = e, Zl;
}
var ec, Iy;
function up() {
  if (Iy) return ec;
  Iy = 1;
  var e = Yi(), n = bi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return ec = i, ec;
}
var nc, Ey;
function $A() {
  if (Ey) return nc;
  Ey = 1;
  var e = ni(), n = up(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return nc = a, nc;
}
var tc, Ty;
function Ji() {
  if (Ty) return tc;
  Ty = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return tc = e, tc;
}
var rc, $y;
function vx() {
  if ($y) return rc;
  $y = 1;
  var e = Yi(), n = Ji(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return rc = s, rc;
}
var ic, Dy;
function DA() {
  if (Dy) return ic;
  Dy = 1;
  var e = Pr(), n = e["__core-js_shared__"];
  return ic = n, ic;
}
var ac, Oy;
function OA() {
  if (Oy) return ac;
  Oy = 1;
  var e = DA(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return ac = r, ac;
}
var oc, Ry;
function kx() {
  if (Ry) return oc;
  Ry = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return oc = r, oc;
}
var sc, Py;
function RA() {
  if (Py) return sc;
  Py = 1;
  var e = vx(), n = OA(), r = Ji(), i = kx(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? u : o;
    return v.test(i(h));
  }
  return sc = f, sc;
}
var lc, Ay;
function PA() {
  if (Ay) return lc;
  Ay = 1;
  function e(n, r) {
    return n?.[r];
  }
  return lc = e, lc;
}
var cc, Ly;
function _i() {
  if (Ly) return cc;
  Ly = 1;
  var e = RA(), n = PA();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return cc = r, cc;
}
var dc, Vy;
function Hs() {
  if (Vy) return dc;
  Vy = 1;
  var e = _i(), n = e(Object, "create");
  return dc = n, dc;
}
var uc, zy;
function AA() {
  if (zy) return uc;
  zy = 1;
  var e = Hs();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return uc = n, uc;
}
var mc, Uy;
function LA() {
  if (Uy) return mc;
  Uy = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return mc = e, mc;
}
var pc, My;
function VA() {
  if (My) return pc;
  My = 1;
  var e = Hs(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return pc = a, pc;
}
var fc, By;
function zA() {
  if (By) return fc;
  By = 1;
  var e = Hs(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return fc = i, fc;
}
var hc, qy;
function UA() {
  if (qy) return hc;
  qy = 1;
  var e = Hs(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return hc = r, hc;
}
var yc, Hy;
function MA() {
  if (Hy) return yc;
  Hy = 1;
  var e = AA(), n = LA(), r = VA(), i = zA(), a = UA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, yc = o, yc;
}
var gc, Wy;
function BA() {
  if (Wy) return gc;
  Wy = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return gc = e, gc;
}
var vc, Ky;
function bx() {
  if (Ky) return vc;
  Ky = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return vc = e, vc;
}
var kc, Gy;
function Ws() {
  if (Gy) return kc;
  Gy = 1;
  var e = bx();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return kc = n, kc;
}
var bc, Yy;
function qA() {
  if (Yy) return bc;
  Yy = 1;
  var e = Ws(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return bc = i, bc;
}
var _c, Jy;
function HA() {
  if (Jy) return _c;
  Jy = 1;
  var e = Ws();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return _c = n, _c;
}
var xc, Qy;
function WA() {
  if (Qy) return xc;
  Qy = 1;
  var e = Ws();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return xc = n, xc;
}
var Sc, Xy;
function KA() {
  if (Xy) return Sc;
  Xy = 1;
  var e = Ws();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Sc = n, Sc;
}
var Nc, Zy;
function Ks() {
  if (Zy) return Nc;
  Zy = 1;
  var e = BA(), n = qA(), r = HA(), i = WA(), a = KA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Nc = o, Nc;
}
var jc, eg;
function mp() {
  if (eg) return jc;
  eg = 1;
  var e = _i(), n = Pr(), r = e(n, "Map");
  return jc = r, jc;
}
var wc, ng;
function GA() {
  if (ng) return wc;
  ng = 1;
  var e = MA(), n = Ks(), r = mp();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return wc = i, wc;
}
var Cc, tg;
function YA() {
  if (tg) return Cc;
  tg = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return Cc = e, Cc;
}
var Fc, rg;
function Gs() {
  if (rg) return Fc;
  rg = 1;
  var e = YA();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return Fc = n, Fc;
}
var Ic, ig;
function JA() {
  if (ig) return Ic;
  ig = 1;
  var e = Gs();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Ic = n, Ic;
}
var Ec, ag;
function QA() {
  if (ag) return Ec;
  ag = 1;
  var e = Gs();
  function n(r) {
    return e(this, r).get(r);
  }
  return Ec = n, Ec;
}
var Tc, og;
function XA() {
  if (og) return Tc;
  og = 1;
  var e = Gs();
  function n(r) {
    return e(this, r).has(r);
  }
  return Tc = n, Tc;
}
var $c, sg;
function ZA() {
  if (sg) return $c;
  sg = 1;
  var e = Gs();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return $c = n, $c;
}
var Dc, lg;
function _x() {
  if (lg) return Dc;
  lg = 1;
  var e = GA(), n = JA(), r = QA(), i = XA(), a = ZA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Dc = o, Dc;
}
var Oc, cg;
function e2() {
  if (cg) return Oc;
  cg = 1;
  var e = _x(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Oc = r, Oc;
}
var Rc, dg;
function n2() {
  if (dg) return Rc;
  dg = 1;
  var e = e2(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return Rc = r, Rc;
}
var Pc, ug;
function t2() {
  if (ug) return Pc;
  ug = 1;
  var e = n2(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return Pc = i, Pc;
}
var Ac, mg;
function xx() {
  if (mg) return Ac;
  mg = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Ac = e, Ac;
}
var Lc, pg;
function r2() {
  if (pg) return Lc;
  pg = 1;
  var e = uo(), n = xx(), r = ni(), i = up(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return Lc = s, Lc;
}
var Vc, fg;
function i2() {
  if (fg) return Vc;
  fg = 1;
  var e = r2();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Vc = n, Vc;
}
var zc, hg;
function Qi() {
  if (hg) return zc;
  hg = 1;
  var e = ni(), n = $A(), r = t2(), i = i2();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return zc = a, zc;
}
var Uc, yg;
function Ys() {
  if (yg) return Uc;
  yg = 1;
  var e = up();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Uc = n, Uc;
}
var Mc, gg;
function Sx() {
  if (gg) return Mc;
  gg = 1;
  var e = Qi(), n = Ys();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Mc = r, Mc;
}
var Bc, vg;
function Nx() {
  if (vg) return Bc;
  vg = 1;
  var e = _i(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Bc = n, Bc;
}
var qc, kg;
function jx() {
  if (kg) return qc;
  kg = 1;
  var e = Nx();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return qc = n, qc;
}
var Hc, bg;
function pp() {
  if (bg) return Hc;
  bg = 1;
  var e = jx(), n = bx(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Hc = a, Hc;
}
var Wc, _g;
function fp() {
  if (_g) return Wc;
  _g = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Wc = r, Wc;
}
var Kc, xg;
function a2() {
  if (xg) return Kc;
  xg = 1;
  var e = pp(), n = Qi(), r = fp(), i = Ji(), a = Ys();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, v = s; v != null && ++u < f; ) {
      var N = a(l[u]), w = d;
      if (N === "__proto__" || N === "constructor" || N === "prototype")
        return s;
      if (u != h) {
        var C = v[N];
        w = m ? m(C, N, v) : void 0, w === void 0 && (w = i(C) ? C : r(l[u + 1]) ? [] : {});
      }
      e(v, N, w), v = v[N];
    }
    return s;
  }
  return Kc = o, Kc;
}
var Gc, Sg;
function o2() {
  if (Sg) return Gc;
  Sg = 1;
  var e = Sx(), n = a2(), r = Qi();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Gc = i, Gc;
}
var Yc, Ng;
function s2() {
  if (Ng) return Yc;
  Ng = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Yc = e, Yc;
}
var Jc, jg;
function l2() {
  if (jg) return Jc;
  jg = 1;
  var e = Yi(), n = bi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Jc = i, Jc;
}
var Qc, wg;
function hp() {
  if (wg) return Qc;
  wg = 1;
  var e = l2(), n = bi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Qc = o, Qc;
}
var Xc, Cg;
function yp() {
  if (Cg) return Xc;
  Cg = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Xc = n, Xc;
}
var Zc, Fg;
function c2() {
  if (Fg) return Zc;
  Fg = 1;
  var e = Qi(), n = hp(), r = ni(), i = fp(), a = yp(), o = Ys();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var v = o(d[u]);
      if (!(h = l != null && m(l, v)))
        break;
      l = l[v];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return Zc = s, Zc;
}
var ed, Ig;
function d2() {
  if (Ig) return ed;
  Ig = 1;
  var e = s2(), n = c2();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return ed = r, ed;
}
var nd, Eg;
function u2() {
  if (Eg) return nd;
  Eg = 1;
  var e = o2(), n = d2();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return nd = r, nd;
}
var td, Tg;
function gp() {
  if (Tg) return td;
  Tg = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return td = e, td;
}
var rd, $g;
function m2() {
  if ($g) return rd;
  $g = 1;
  var e = uo(), n = hp(), r = ni(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return rd = a, rd;
}
var id, Dg;
function p2() {
  if (Dg) return id;
  Dg = 1;
  var e = gp(), n = m2();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return id = r, id;
}
var ad, Og;
function f2() {
  if (Og) return ad;
  Og = 1;
  var e = p2();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return ad = n, ad;
}
var od, Rg;
function h2() {
  if (Rg) return od;
  Rg = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return od = e, od;
}
var sd, Pg;
function y2() {
  if (Pg) return sd;
  Pg = 1;
  var e = h2(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return sd = r, sd;
}
var ld, Ag;
function g2() {
  if (Ag) return ld;
  Ag = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return ld = e, ld;
}
var cd, Lg;
function wx() {
  if (Lg) return cd;
  Lg = 1;
  function e(n) {
    return n;
  }
  return cd = e, cd;
}
var dd, Vg;
function v2() {
  if (Vg) return dd;
  Vg = 1;
  var e = g2(), n = Nx(), r = wx(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return dd = i, dd;
}
var ud, zg;
function k2() {
  if (zg) return ud;
  zg = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return ud = i, ud;
}
var md, Ug;
function b2() {
  if (Ug) return md;
  Ug = 1;
  var e = v2(), n = k2(), r = n(e);
  return md = r, md;
}
var pd, Mg;
function Cx() {
  if (Mg) return pd;
  Mg = 1;
  var e = f2(), n = y2(), r = b2();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return pd = i, pd;
}
var fd, Bg;
function _2() {
  if (Bg) return fd;
  Bg = 1;
  var e = u2(), n = Cx(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return fd = r, fd;
}
var x2 = _2();
const Fx = /* @__PURE__ */ yx(x2), S2 = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function Ix(e) {
  const n = Fx(e, S2);
  return {
    controller: qm(n),
    controllerProps: n
  };
}
const N2 = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function Ex(e) {
  const { controller: n, controllerProps: r } = Ix(e), i = {
    ...Fx(e, N2),
    required: IA(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var hd, qg;
function j2() {
  if (qg) return hd;
  qg = 1;
  var e = Ks();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return hd = n, hd;
}
var yd, Hg;
function w2() {
  if (Hg) return yd;
  Hg = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return yd = e, yd;
}
var gd, Wg;
function C2() {
  if (Wg) return gd;
  Wg = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return gd = e, gd;
}
var vd, Kg;
function F2() {
  if (Kg) return vd;
  Kg = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return vd = e, vd;
}
var kd, Gg;
function I2() {
  if (Gg) return kd;
  Gg = 1;
  var e = Ks(), n = mp(), r = _x(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return kd = a, kd;
}
var bd, Yg;
function E2() {
  if (Yg) return bd;
  Yg = 1;
  var e = Ks(), n = j2(), r = w2(), i = C2(), a = F2(), o = I2();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, bd = s, bd;
}
var _d, Jg;
function T2() {
  if (Jg) return _d;
  Jg = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return _d = e, _d;
}
var xd, Qg;
function mo() {
  if (Qg) return xd;
  Qg = 1;
  var e = pp(), n = jx();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return xd = r, xd;
}
var Sd, Xg;
function $2() {
  if (Xg) return Sd;
  Xg = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Sd = e, Sd;
}
var es = { exports: {} }, Nd, Zg;
function D2() {
  if (Zg) return Nd;
  Zg = 1;
  function e() {
    return !1;
  }
  return Nd = e, Nd;
}
es.exports;
var ev;
function Tx() {
  return ev || (ev = 1, (function(e, n) {
    var r = Pr(), i = D2(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(es, es.exports)), es.exports;
}
var jd, nv;
function O2() {
  if (nv) return jd;
  nv = 1;
  var e = Yi(), n = yp(), r = bi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", N = "[object String]", w = "[object WeakMap]", C = "[object ArrayBuffer]", F = "[object DataView]", y = "[object Float32Array]", H = "[object Float64Array]", $ = "[object Int8Array]", E = "[object Int16Array]", D = "[object Int32Array]", U = "[object Uint8Array]", Z = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", ie = "[object Uint32Array]", Y = {};
  Y[y] = Y[H] = Y[$] = Y[E] = Y[D] = Y[U] = Y[Z] = Y[Q] = Y[ie] = !0, Y[i] = Y[a] = Y[C] = Y[o] = Y[F] = Y[s] = Y[l] = Y[d] = Y[m] = Y[u] = Y[f] = Y[h] = Y[v] = Y[N] = Y[w] = !1;
  function M(R) {
    return r(R) && n(R.length) && !!Y[e(R)];
  }
  return jd = M, jd;
}
var wd, tv;
function vp() {
  if (tv) return wd;
  tv = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return wd = e, wd;
}
var ns = { exports: {} };
ns.exports;
var rv;
function kp() {
  return rv || (rv = 1, (function(e, n) {
    var r = gx(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(ns, ns.exports)), ns.exports;
}
var Cd, iv;
function R2() {
  if (iv) return Cd;
  iv = 1;
  var e = O2(), n = vp(), r = kp(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return Cd = a, Cd;
}
var Fd, av;
function $x() {
  if (av) return Fd;
  av = 1;
  var e = $2(), n = hp(), r = ni(), i = Tx(), a = fp(), o = R2(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), v = !f && !h && i(m), N = !f && !h && !v && o(m), w = f || h || v || N, C = w ? e(m.length, String) : [], F = C.length;
    for (var y in m)
      (u || l.call(m, y)) && !(w && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      N && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, F))) && C.push(y);
    return C;
  }
  return Fd = d, Fd;
}
var Id, ov;
function bp() {
  if (ov) return Id;
  ov = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Id = n, Id;
}
var Ed, sv;
function Dx() {
  if (sv) return Ed;
  sv = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Ed = e, Ed;
}
var Td, lv;
function P2() {
  if (lv) return Td;
  lv = 1;
  var e = Dx(), n = e(Object.keys, Object);
  return Td = n, Td;
}
var $d, cv;
function A2() {
  if (cv) return $d;
  cv = 1;
  var e = bp(), n = P2(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return $d = a, $d;
}
var Dd, dv;
function Ox() {
  if (dv) return Dd;
  dv = 1;
  var e = vx(), n = yp();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Dd = r, Dd;
}
var Od, uv;
function _p() {
  if (uv) return Od;
  uv = 1;
  var e = $x(), n = A2(), r = Ox();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return Od = i, Od;
}
var Rd, mv;
function L2() {
  if (mv) return Rd;
  mv = 1;
  var e = mo(), n = _p();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Rd = r, Rd;
}
var Pd, pv;
function V2() {
  if (pv) return Pd;
  pv = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return Pd = e, Pd;
}
var Ad, fv;
function z2() {
  if (fv) return Ad;
  fv = 1;
  var e = Ji(), n = bp(), r = V2(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return Ad = o, Ad;
}
var Ld, hv;
function xp() {
  if (hv) return Ld;
  hv = 1;
  var e = $x(), n = z2(), r = Ox();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return Ld = i, Ld;
}
var Vd, yv;
function U2() {
  if (yv) return Vd;
  yv = 1;
  var e = mo(), n = xp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Vd = r, Vd;
}
var ts = { exports: {} };
ts.exports;
var gv;
function M2() {
  return gv || (gv = 1, (function(e, n) {
    var r = Pr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(ts, ts.exports)), ts.exports;
}
var zd, vv;
function B2() {
  if (vv) return zd;
  vv = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return zd = e, zd;
}
var Ud, kv;
function q2() {
  if (kv) return Ud;
  kv = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Ud = e, Ud;
}
var Md, bv;
function Rx() {
  if (bv) return Md;
  bv = 1;
  function e() {
    return [];
  }
  return Md = e, Md;
}
var Bd, _v;
function Sp() {
  if (_v) return Bd;
  _v = 1;
  var e = q2(), n = Rx(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Bd = o, Bd;
}
var qd, xv;
function H2() {
  if (xv) return qd;
  xv = 1;
  var e = mo(), n = Sp();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return qd = r, qd;
}
var Hd, Sv;
function Np() {
  if (Sv) return Hd;
  Sv = 1;
  var e = Dx(), n = e(Object.getPrototypeOf, Object);
  return Hd = n, Hd;
}
var Wd, Nv;
function Px() {
  if (Nv) return Wd;
  Nv = 1;
  var e = gp(), n = Np(), r = Sp(), i = Rx(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Wd = o, Wd;
}
var Kd, jv;
function W2() {
  if (jv) return Kd;
  jv = 1;
  var e = mo(), n = Px();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Kd = r, Kd;
}
var Gd, wv;
function Ax() {
  if (wv) return Gd;
  wv = 1;
  var e = gp(), n = ni();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Gd = r, Gd;
}
var Yd, Cv;
function K2() {
  if (Cv) return Yd;
  Cv = 1;
  var e = Ax(), n = Sp(), r = _p();
  function i(a) {
    return e(a, r, n);
  }
  return Yd = i, Yd;
}
var Jd, Fv;
function Lx() {
  if (Fv) return Jd;
  Fv = 1;
  var e = Ax(), n = Px(), r = xp();
  function i(a) {
    return e(a, r, n);
  }
  return Jd = i, Jd;
}
var Qd, Iv;
function G2() {
  if (Iv) return Qd;
  Iv = 1;
  var e = _i(), n = Pr(), r = e(n, "DataView");
  return Qd = r, Qd;
}
var Xd, Ev;
function Y2() {
  if (Ev) return Xd;
  Ev = 1;
  var e = _i(), n = Pr(), r = e(n, "Promise");
  return Xd = r, Xd;
}
var Zd, Tv;
function J2() {
  if (Tv) return Zd;
  Tv = 1;
  var e = _i(), n = Pr(), r = e(n, "Set");
  return Zd = r, Zd;
}
var eu, $v;
function Q2() {
  if ($v) return eu;
  $v = 1;
  var e = _i(), n = Pr(), r = e(n, "WeakMap");
  return eu = r, eu;
}
var nu, Dv;
function jp() {
  if (Dv) return nu;
  Dv = 1;
  var e = G2(), n = mp(), r = Y2(), i = J2(), a = Q2(), o = Yi(), s = kx(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), N = s(n), w = s(r), C = s(i), F = s(a), y = o;
  return (e && y(new e(new ArrayBuffer(1))) != h || n && y(new n()) != l || r && y(r.resolve()) != m || i && y(new i()) != u || a && y(new a()) != f) && (y = function(H) {
    var $ = o(H), E = $ == d ? H.constructor : void 0, D = E ? s(E) : "";
    if (D)
      switch (D) {
        case v:
          return h;
        case N:
          return l;
        case w:
          return m;
        case C:
          return u;
        case F:
          return f;
      }
    return $;
  }), nu = y, nu;
}
var tu, Ov;
function X2() {
  if (Ov) return tu;
  Ov = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return tu = r, tu;
}
var ru, Rv;
function Z2() {
  if (Rv) return ru;
  Rv = 1;
  var e = Pr(), n = e.Uint8Array;
  return ru = n, ru;
}
var iu, Pv;
function wp() {
  if (Pv) return iu;
  Pv = 1;
  var e = Z2();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return iu = n, iu;
}
var au, Av;
function eL() {
  if (Av) return au;
  Av = 1;
  var e = wp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return au = n, au;
}
var ou, Lv;
function nL() {
  if (Lv) return ou;
  Lv = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return ou = n, ou;
}
var su, Vv;
function tL() {
  if (Vv) return su;
  Vv = 1;
  var e = uo(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return su = i, su;
}
var lu, zv;
function rL() {
  if (zv) return lu;
  zv = 1;
  var e = wp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return lu = n, lu;
}
var cu, Uv;
function iL() {
  if (Uv) return cu;
  Uv = 1;
  var e = wp(), n = eL(), r = nL(), i = tL(), a = rL(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", N = "[object DataView]", w = "[object Float32Array]", C = "[object Float64Array]", F = "[object Int8Array]", y = "[object Int16Array]", H = "[object Int32Array]", $ = "[object Uint8Array]", E = "[object Uint8ClampedArray]", D = "[object Uint16Array]", U = "[object Uint32Array]";
  function Z(Q, ie, Y) {
    var M = Q.constructor;
    switch (ie) {
      case v:
        return e(Q);
      case o:
      case s:
        return new M(+Q);
      case N:
        return n(Q, Y);
      case w:
      case C:
      case F:
      case y:
      case H:
      case $:
      case E:
      case D:
      case U:
        return a(Q, Y);
      case l:
        return new M();
      case d:
      case f:
        return new M(Q);
      case m:
        return r(Q);
      case u:
        return new M();
      case h:
        return i(Q);
    }
  }
  return cu = Z, cu;
}
var du, Mv;
function aL() {
  if (Mv) return du;
  Mv = 1;
  var e = Ji(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return du = r, du;
}
var uu, Bv;
function oL() {
  if (Bv) return uu;
  Bv = 1;
  var e = aL(), n = Np(), r = bp();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return uu = i, uu;
}
var mu, qv;
function sL() {
  if (qv) return mu;
  qv = 1;
  var e = jp(), n = bi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return mu = i, mu;
}
var pu, Hv;
function lL() {
  if (Hv) return pu;
  Hv = 1;
  var e = sL(), n = vp(), r = kp(), i = r && r.isMap, a = i ? n(i) : e;
  return pu = a, pu;
}
var fu, Wv;
function cL() {
  if (Wv) return fu;
  Wv = 1;
  var e = jp(), n = bi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return fu = i, fu;
}
var hu, Kv;
function dL() {
  if (Kv) return hu;
  Kv = 1;
  var e = cL(), n = vp(), r = kp(), i = r && r.isSet, a = i ? n(i) : e;
  return hu = a, hu;
}
var yu, Gv;
function uL() {
  if (Gv) return yu;
  Gv = 1;
  var e = E2(), n = T2(), r = pp(), i = L2(), a = U2(), o = M2(), s = B2(), l = H2(), d = W2(), m = K2(), u = Lx(), f = jp(), h = X2(), v = iL(), N = oL(), w = ni(), C = Tx(), F = lL(), y = Ji(), H = dL(), $ = _p(), E = xp(), D = 1, U = 2, Z = 4, Q = "[object Arguments]", ie = "[object Array]", Y = "[object Boolean]", M = "[object Date]", R = "[object Error]", q = "[object Function]", ee = "[object GeneratorFunction]", ge = "[object Map]", de = "[object Number]", le = "[object Object]", pe = "[object RegExp]", W = "[object Set]", ke = "[object String]", Ce = "[object Symbol]", K = "[object WeakMap]", Be = "[object ArrayBuffer]", Me = "[object DataView]", Pe = "[object Float32Array]", ze = "[object Float64Array]", je = "[object Int8Array]", Ae = "[object Int16Array]", $e = "[object Int32Array]", nn = "[object Uint8Array]", we = "[object Uint8ClampedArray]", He = "[object Uint16Array]", Xe = "[object Uint32Array]", me = {};
  me[Q] = me[ie] = me[Be] = me[Me] = me[Y] = me[M] = me[Pe] = me[ze] = me[je] = me[Ae] = me[$e] = me[ge] = me[de] = me[le] = me[pe] = me[W] = me[ke] = me[Ce] = me[nn] = me[we] = me[He] = me[Xe] = !0, me[R] = me[q] = me[K] = !1;
  function he(Ie, Le, Oe, sn, j, _) {
    var T, G = Le & D, J = Le & U, O = Le & Z;
    if (Oe && (T = j ? Oe(Ie, sn, j, _) : Oe(Ie)), T !== void 0)
      return T;
    if (!y(Ie))
      return Ie;
    var z = w(Ie);
    if (z) {
      if (T = h(Ie), !G)
        return s(Ie, T);
    } else {
      var re = f(Ie), fe = re == q || re == ee;
      if (C(Ie))
        return o(Ie, G);
      if (re == le || re == Q || fe && !j) {
        if (T = J || fe ? {} : N(Ie), !G)
          return J ? d(Ie, a(T, Ie)) : l(Ie, i(T, Ie));
      } else {
        if (!me[re])
          return j ? Ie : {};
        T = v(Ie, re, G);
      }
    }
    _ || (_ = new e());
    var be = _.get(Ie);
    if (be)
      return be;
    _.set(Ie, T), H(Ie) ? Ie.forEach(function(rn) {
      T.add(he(rn, Le, Oe, rn, Ie, _));
    }) : F(Ie) && Ie.forEach(function(rn, dn) {
      T.set(dn, he(rn, Le, Oe, dn, Ie, _));
    });
    var Ze = O ? J ? u : m : J ? E : $, un = z ? void 0 : Ze(Ie);
    return n(un || Ie, function(rn, dn) {
      un && (dn = rn, rn = Ie[dn]), r(T, dn, he(rn, Le, Oe, dn, Ie, _));
    }), T;
  }
  return yu = he, yu;
}
var gu, Yv;
function mL() {
  if (Yv) return gu;
  Yv = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return gu = e, gu;
}
var vu, Jv;
function pL() {
  if (Jv) return vu;
  Jv = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return vu = e, vu;
}
var ku, Qv;
function fL() {
  if (Qv) return ku;
  Qv = 1;
  var e = Sx(), n = pL();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return ku = r, ku;
}
var bu, Xv;
function hL() {
  if (Xv) return bu;
  Xv = 1;
  var e = Qi(), n = mL(), r = fL(), i = Ys(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return bu = s, bu;
}
var _u, Zv;
function yL() {
  if (Zv) return _u;
  Zv = 1;
  var e = Yi(), n = Np(), r = bi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return _u = m, _u;
}
var xu, ek;
function gL() {
  if (ek) return xu;
  ek = 1;
  var e = yL();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return xu = n, xu;
}
var Su, nk;
function vL() {
  if (nk) return Su;
  nk = 1;
  var e = xx(), n = uL(), r = hL(), i = Qi(), a = mo(), o = gL(), s = Cx(), l = Lx(), d = 1, m = 2, u = 4, f = s(function(h, v) {
    var N = {};
    if (h == null)
      return N;
    var w = !1;
    v = e(v, function(F) {
      return F = i(F, h), w || (w = F.length > 1), F;
    }), a(h, l(h), N), w && (N = n(N, d | m | u, o));
    for (var C = v.length; C--; )
      r(N, v[C]);
    return N;
  });
  return Su = f, Su;
}
vL();
const br = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = Ex(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ fi.jsx(Ln, { ...a, children: /* @__PURE__ */ fi.jsx(
    Yr,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: Ln.getStatus(a.meta),
      children: e
    }
  ) });
};
var kL = wx();
const bL = /* @__PURE__ */ yx(kL), Nu = ({
  transformValue: e = bL,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = Ix(a);
  return /* @__PURE__ */ fi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ fi.jsx(
      qu,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ fi.jsx(QS, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, qt = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = Ex(e);
  return /* @__PURE__ */ fi.jsx(Ln, { ...i, children: /* @__PURE__ */ fi.jsx(
    kr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: Ln.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1dntr_1,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ju = { exports: {} }, Ca = {}, tk;
function _L() {
  if (tk) return Ca;
  tk = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ca.Fragment = r, Ca.jsx = s, Ca.jsxs = s, Ca;
}
var Ao = {}, rk;
function xL() {
  return rk || (rk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    Ao.Fragment = i, Ao.jsx = On, Ao.jsxs = Bn;
  })()), Ao;
}
var ik;
function SL() {
  return ik || (ik = 1, process.env.NODE_ENV === "production" ? ju.exports = _L() : ju.exports = xL()), ju.exports;
}
var k = SL();
const ak = "__PairingContext__", NL = () => globalThis[ak] ?? (() => {
  const e = vb({});
  return globalThis[ak] = e, e;
})(), jL = NL(), wL = () => Cm(jL), CL = "_banner_d9pot_1", FL = "_list_d9pot_8", ok = {
  banner: CL,
  list: FL
}, sk = "https://apps.shopify.com/dixa-dashboard", IL = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, Vx = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = wL(), [i, a] = se(!1), [o, s] = se(null), l = IL[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? sk,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(sk, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", className: ok.banner, children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(ue, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(m, { className: ok.list, children: l.listItems.map((u, f) => /* @__PURE__ */ k.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
      Kn,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(cn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, EL = (e) => /* @__PURE__ */ k.jsx(Vx, { ...e, bannerVariant: "install" }), TL = (e) => /* @__PURE__ */ k.jsx(Vx, { ...e, bannerVariant: "migration" }), $L = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], DL = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], OL = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: EL
  }
], RL = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], lk = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: TL,
    additionalProperties: { renderAboveForm: !0 }
  }
], zx = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], ck = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => pb(e)
  },
  ...zx
];
var Ti = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Ti || {}), hi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(hi || {}), Ir = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Ir || {}), Ux = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(Ux || {}), oi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(oi || {}), Br = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Br || {}), rs = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(rs || {}), Mx = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(Mx || {});
const PL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, AL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, LL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, VL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, zL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, UL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, ML = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, BL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, qL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, HL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, WL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, KL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, GL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, YL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, JL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, QL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, XL = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": PL,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": AL,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": LL,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": VL,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": zL,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": UL,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": ML,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": BL,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": qL,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": HL,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": WL,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": KL,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": GL,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": YL,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": JL,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": QL
};
function dr(e) {
  return XL[e] ?? {};
}
const ZL = dr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), eV = dr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), nV = dr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), tV = dr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Cp = dr(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), rV = dr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), iV = dr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), aV = dr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), oV = dr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), sV = dr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), lV = dr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), cV = dr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), Bx = Zr`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, dV = Zr`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, uV = ({
  conversationContext: e
}) => {
  const { useQuery: n } = mn(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: d,
    data: m,
    refetch: u,
    networkStatus: f
  } = n(ZL, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: d,
    customerData: m,
    refetchCustomer: u,
    customerNetworkStatus: f
  };
}, mV = () => {
  const { useLazyQuery: e } = mn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(eV);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function eo(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const pV = "_list_alvh6_1", fV = "_listItem_alvh6_4", hV = "_fullWidth_alvh6_15", yV = "_boxWrapper_alvh6_19", Ft = {
  list: pV,
  listItem: fV,
  fullWidth: hV,
  boxWrapper: yV
}, gV = "_modal_1vkwz_1", vV = "_disabled_1vkwz_5", wu = {
  modal: gV,
  disabled: vV
}, dk = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: hi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: hi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: hi.Unknown
  }
], uk = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Ir.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Ir.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Ir.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Ir.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Ir.Unsubscribed
  }
], kV = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = kn(), { useMutation: l, showNotification: d } = mn(), [m, u] = se(), [f, h] = se(), [v, N] = jf(!0), [w, C] = jf(!0), F = !!m, y = e.customer?.email, H = e.customer?.phone_number, $ = e.customer?.given_name, E = e.customer?.family_name, D = {
    email: y ?? "",
    phone: H ?? "",
    firstName: $ ?? "",
    lastName: E ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, U = lr({
    defaultValues: D
  });
  qe(() => {
    f?.forEach((R) => {
      const q = R?.field?.[0];
      q && (U.setError(q, {
        type: "server",
        message: R.message
      }), U.setFocus(q));
    });
  }, [f, U]);
  const [Z, { error: Q, reset: ie }] = l(lV, {
    onError: (R) => {
      u(R.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (R) => {
      const q = R?.Shopify?.customerCreate?.userErrors || [];
      q.length > 0 ? (h(q), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), Y = tt(
    (R) => {
      a(!0), u(void 0), Z({
        variables: {
          input: {
            firstName: R.firstName,
            lastName: R.lastName,
            ...v && { email: R.email },
            ...w && { phone: R.phone },
            ...R.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: R.smsMarketingState,
                marketingOptInLevel: R.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [Z, a, w, v]
  ), M = () => {
    r(!1), ie(), u(void 0), U.reset(D);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: n, onClose: M, className: wu.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: "Create new customer", onClose: M }),
    /* @__PURE__ */ k.jsx(wt, { children: /* @__PURE__ */ k.jsxs(Ut, { children: [
      /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
        qt,
        {
          label: "First name",
          name: "firstName",
          control: U.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
        qt,
        {
          label: "Last name",
          name: "lastName",
          control: U.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        qt,
        {
          label: "Email",
          name: "email",
          control: U.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: ut({
              [wu.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                qu,
                {
                  disabled: !w,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => N()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        qt,
        {
          label: "Phone",
          name: "phone",
          control: U.control,
          rules: {
            required: w ? "Phone is required" : void 0
          },
          componentProps: {
            className: ut({
              [wu.disabled]: !w
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                qu,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: w,
                  onChange: () => C()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        br,
        {
          control: U.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (R, q) => R === q,
            getItemTitleByValue: (R) => {
              const q = uk.find(
                (ee) => ee.value === R
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: uk.map((R) => /* @__PURE__ */ k.jsx(ot.Item, { value: R.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        br,
        {
          control: U.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (R, q) => R === q,
            getItemTitleByValue: (R) => {
              const q = dk.find(
                (ee) => ee.value === R
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: dk.map((R) => /* @__PURE__ */ k.jsx(ot.Item, { value: R.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      F && /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(ue, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      It,
      {
        confirmProps: {
          disabled: !(U.formState.isValid && U.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
        },
        confirmOnClick: U.handleSubmit(Y),
        cancelOnClick: M,
        confirmName: Q ? "Close" : "Save",
        cancelName: Q ? void 0 : "Cancel"
      }
    )
  ] });
}, bV = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = se(!1), [a, o] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(ue, { size: 14, name: "user-plus", color: "green.500" }),
        className: Ft.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      kV,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Fp = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, vm = "DD MMM YYYY @ HH:mm", _V = "_wrapper_10fld_1", xV = "_copyIcon_10fld_7", Lo = {
  wrapper: _V,
  copyIcon: xV
}, SV = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = eo(), { isCopied: l, copy: d } = eo(), { track: m } = kn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: N = [],
    verifiedEmail: w
  } = e, C = h?.emailAddress, F = v?.phoneNumber, y = Fp(u), H = `https://${n}/admin/customers/${y ?? ""}`, $ = i && a === Gt.refetch, E = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: Lo.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: f }),
        $ ? /* @__PURE__ */ k.jsx(cn, { size: E }) : /* @__PURE__ */ k.jsx(Ke, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: E,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: Lo.copyIcon
          }
        ) })
      ] }),
      C && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(ue, { size: E, name: "mail" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `mailto:${C}`, children: C }),
          /* @__PURE__ */ k.jsx(
            Ke,
            {
              content: w ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                ue,
                {
                  size: E,
                  color: w ? "green.500" : "red.500",
                  name: w ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: E,
            name: o ? "done" : "copy",
            onClick: () => s(C),
            className: Lo.copyIcon
          }
        ) })
      ] }),
      F && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(ue, { size: E, name: "phone" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `tel:${F}`, children: F })
        ] }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: E,
            name: l ? "done" : "copy",
            onClick: () => d(F),
            className: Lo.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(ue, { size: E, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          A.ExternalLink,
          {
            href: H,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    N.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: N.map((D) => /* @__PURE__ */ k.jsx(Pn, { children: D }, `${u}-${D}`)) })
    ] })
  ] });
}, NV = "_creationModal_pbe64_1", jV = "_detailsModal_pbe64_5", wV = "_percentageSuffix_pbe64_9", Cu = {
  creationModal: NV,
  detailsModal: jV,
  percentageSuffix: wV
}, CV = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, FV = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: Ux.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, mk = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], pk = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], fk = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], IV = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = er(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(We, { children: [
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            ue,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: An(e?.startsAt).format(dt) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(Ln, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      kr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, EV = "shopify-discount-code-form", hk = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, TV = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = kn(), { useMutation: i, showNotification: a } = mn(), [o, s] = se(
    []
  ), [l, d] = se(), m = lr({
    mode: "all",
    defaultValues: hk
  });
  qe(() => {
    o?.forEach((E) => {
      const D = E?.field?.[1];
      D && m.setError(D, {
        type: "server",
        message: E.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), v = qn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    N,
    {
      loading: w,
      error: C,
      reset: F
    }
  ] = i(cV, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (E) => {
      const D = E?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (D && D.length > 0)
        s(D);
      else {
        const U = E?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        U && "codes" in U && d(U), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), y = () => {
    m.setValue("code", CV(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, H = (E) => {
    N({
      variables: {
        input: FV(E)
      }
    });
  }, $ = () => {
    m.reset(hk), s([]), F(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: $,
      className: ut({
        [Cu.creationModal]: !u,
        [Cu.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          jt,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: $
          }
        ),
        /* @__PURE__ */ k.jsxs(wt, { children: [
          u && /* @__PURE__ */ k.jsx(IV, { codeDiscount: l }),
          !u && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: EV, onSubmit: m.handleSubmit(H), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              $s,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(Ut, { children: [
              /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
                qt,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
                br,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (E, D) => E === D,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (E) => {
                      const D = mk.find(
                        (U) => U.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: mk.map((E) => /* @__PURE__ */ k.jsx(ot.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
                qt,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (E) => {
                      if (E) {
                        if (h === "percentage" && (E < 0 || E > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && E < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: Cu.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
                qt,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: y
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
                br,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (E, D) => E === D,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (E) => {
                      const D = pk.find(
                        (U) => U.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: pk.map((E) => /* @__PURE__ */ k.jsx(ot.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
                qt,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (E) => {
                      if (E && f !== "none" && E < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
                br,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (E, D) => E === D,
                    getItemTitleByValue: (E) => {
                      const D = fk.find(
                        (U) => U.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: fk.map((E) => /* @__PURE__ */ k.jsx(ot.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) })
            ] })
          ] }),
          C && /* @__PURE__ */ k.jsx(In, { error: C })
        ] }),
        /* @__PURE__ */ k.jsx(
          It,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: w,
              loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? $ : m.handleSubmit(H),
            cancelOnClick: u ? void 0 : $
          }
        )
      ]
    }
  );
}, $V = ({ code: e }) => {
  const { isCopied: n, copy: r } = eo();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(ue, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          Yt,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, DV = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(We, { children: i.map((a) => /* @__PURE__ */ k.jsx(We.Item, { className: Ft.listItem, children: /* @__PURE__ */ k.jsx($V, { code: a.code }, a.id) }, a.id)) })
  ] });
}, OV = "_modal_11d6e_1", RV = "_modalBody_11d6e_4", PV = "_codeContainer_11d6e_9", Fu = {
  modal: OV,
  modalBody: RV,
  codeContainer: PV
}, AV = [50, 100, 250], qx = 50, LV = {
  maxNumberOfCodesToDisplay: qx
}, VV = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = mn(), [i, a] = se(
    qx
  ), [o, s] = se([]), l = o.length === 0, d = o.length > i, m = lr({
    mode: "all",
    defaultValues: LV
  }), { loading: u, error: f } = r(rV, {
    variables: {
      first: i
    },
    onCompleted: (v) => {
      const N = v?.Shopify?.codeDiscountNodes?.nodes ?? [];
      N && N.length > 0 && s(N);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: e, onClose: h, className: Fu.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(wt, { className: Fu.modalBody, children: [
      d && /* @__PURE__ */ k.jsx(Ut, { children: /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
        br,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (v) => {
              a(v.selectedValues[0]);
            },
            getItemTitleByValue: (v) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) })
          },
          children: AV.map((v) => /* @__PURE__ */ k.jsx(ot.Item, { value: v, children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) }, v))
        }
      ) }) }),
      u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(cn, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !u && l && /* @__PURE__ */ k.jsx(
        ss,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !u && !f && !l && o.map((v) => /* @__PURE__ */ k.jsx("div", { className: Fu.codeContainer, children: /* @__PURE__ */ k.jsx(DV, { discountCode: v }) }, v.id))
    ] }),
    /* @__PURE__ */ k.jsx(It, { confirmName: "Close", confirmOnClick: h })
  ] });
}, zV = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = se(!1), [i, a] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      VV,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      TV,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, UV = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? Es(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case Ti.Invalid:
      case Ti.NotSubscribed:
      case Ir.NotSubscribed:
        return "red.500";
      case Ti.Pending:
      case Ir.Pending:
      case Ti.Unsubscribed:
      case Ir.Unsubscribed:
        return "orange.500";
      case Ti.Subscribed:
      case Ir.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case hi.SingleOptIn:
      case hi.ConfirmedOptIn:
        return "green.500";
      case hi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(ue, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(Ke, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "info", children: An(l).format(vm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ke, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Pn, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Pn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(ue, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ k.jsx(Ke, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "info", children: An(u).format(vm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ke, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Pn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Pn, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, MV = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a ?? "",
          kind: Mx.Refund,
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    refunds: r.refunds
  }));
}, yk = [
  {
    value: Br.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Br.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Br.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Br.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Br.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Br.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Br.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], gk = [
  {
    value: rs.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: rs.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: rs.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], Hx = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), $i = (e) => BV(qV(e)), BV = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), qV = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, ri = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  Lt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      or,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), HV = "_modal_1wlra_1", WV = {
  modal: HV
};
function vk(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const kk = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], bk = "shopify-shiping-address-form", KV = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = mn(), { track: f } = kn(), [h, v] = se(!1), [N, w] = se({}), C = !l, [
    F,
    { error: y, reset: H }
  ] = m(iV, {
    onError: () => {
      v(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (Y) => {
      v(!1);
      const M = Y?.Shopify?.orderUpdate?.userErrors;
      if (M != null && M.length > 0) {
        const R = M.reduce(
          (q, ee) => {
            const ge = ee.field;
            if (ge == null || ge.length === 0)
              return q;
            const de = ge[ge.length - 1];
            return de != null && (q[de] = ee.message), q;
          },
          {}
        );
        w(R);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), ie();
    }
  }), $ = tt(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: kk.find(
        (Y) => Y === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: E, handleSubmit: D, formState: U, reset: Z } = lr({
    mode: "all",
    defaultValues: $()
  }), Q = D((Y) => {
    if (C) {
      if (v(!0), !o || !a) {
        v(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: M, ...R } = Y, q = {
        ...R,
        countryCode: M
      };
      F({
        variables: {
          input: {
            id: a,
            shippingAddress: q
          }
        }
      });
    } else
      l(Y), ie();
  });
  qe(() => {
    r && Z($());
  }, [r, n, Z, $]);
  const ie = () => {
    Z($()), w({}), H(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: r,
      onClose: ie,
      className: WV.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx(jt, { title: e, onClose: () => ie() }),
        /* @__PURE__ */ k.jsx(wt, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: bk, onSubmit: Q, children: [
          y && /* @__PURE__ */ k.jsx(In, { error: y }),
          /* @__PURE__ */ k.jsxs(Ut, { children: [
            /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 6, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                control: E,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 6, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 6, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                control: E,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 6, children: /* @__PURE__ */ k.jsx(
              br,
              {
                name: "countryCodeV2",
                control: E,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (Y) => Y ? vk(Y) : ""
                },
                children: kk.filter((Y) => s.includes(Y)).map((Y) => /* @__PURE__ */ k.jsx(ot.Item, { value: Y, children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: vk(Y) }) }, Y))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          It,
          {
            confirmProps: {
              disabled: !(U.isValid && U.isDirty),
              type: "submit",
              form: bk,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
            },
            confirmOnClick: () => {
              y && ie();
            },
            cancelOnClick: () => {
              o && a && !y && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ie();
            },
            confirmName: y ? "Close" : "Save",
            cancelName: y ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, GV = "_clickableIcon_33mqm_1", Iu = {
  clickableIcon: GV
}, _k = ({
  formFieldName: e,
  ...n
}) => {
  const r = Rr(), { field: i } = qm({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    km,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, km = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = se(!1), [h, v] = se(m), { isCopied: N, copy: w } = eo(), { track: C } = kn(), F = 14, y = o && (!!r || !!l), H = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), $ = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), E = n?.countryCodeV2 && VS(n.countryCodeV2), D = tt(() => [
    $,
    n?.company,
    n?.address1,
    n?.address2,
    H,
    n?.province,
    E
  ].filter(Boolean).join(`
`), [n, $, H, E]);
  if (!n)
    return null;
  const U = () => {
    i && r && C("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(ue, { size: F, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: Iu.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  ue,
                  {
                    size: F,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            $ && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: $ }),
            n?.company && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address2 }),
            H && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: H }),
            n?.province && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.province }),
            E && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: E })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        y && /* @__PURE__ */ k.jsx(Ke, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: F,
            name: "pen",
            onClick: () => U(),
            className: Iu.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(Ke, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: F,
            name: N ? "done" : "copy",
            onClick: () => w(D()),
            className: Iu.clickableIcon
          }
        ) })
      ] })
    ] }),
    y && /* @__PURE__ */ k.jsx(
      KV,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, Ip = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Rr(), i = Jo({ control: r.control, name: "lineItems" }), a = Jo({
    control: r.control,
    name: "billingAddress"
  }), o = Jo({
    control: r.control,
    name: "shippingAddress"
  }), s = qn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = qn(() => !s || s.length === 0 ? 0 : s.reduce((m, u) => {
    const f = u.priceRangeV2?.minVariantPrice?.amount || 0, h = u.quantity || 0;
    return m + f * h;
  }, 0), [s]), d = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        _k,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        _k,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${d}` })
    ] }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, YV = "_productTableHeader_6h6pl_1", JV = "_productImage_6h6pl_5", Ha = {
  productTableHeader: YV,
  productImage: JV
}, Ep = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, QV = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Rr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Ep(e);
  return /* @__PURE__ */ k.jsxs(Xn.Tr, { children: [
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ k.jsx(
        Bi,
        {
          src: d,
          alt: e.title,
          className: Ha.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
      qt,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(Yt, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, XV = 300, Fa = 2, ZV = 25, ez = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = mn(), [i, a] = se(""), [o, s] = se([]), l = Rr(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(Cp, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (w) => {
      const C = w?.Shopify?.products?.nodes || [];
      s(
        C.filter((F) => !!F).sort((F, y) => F.title.localeCompare(y.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  gi(
    () => {
      i.trim().length >= Fa && !u && f === Gt.ready ? m({
        variables: {
          query: i.trim(),
          productCount: ZV,
          mediaCount: 1
        }
      }) : i.trim().length < Fa && s([]);
    },
    XV,
    [i]
  ), qe(() => {
    if (!d) return;
    const w = o.find(
      (C) => C.id === d
    );
    w && e(w), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== Gt.ready, v = i.trim().length >= Fa, N = !o.length && !h && v;
  return /* @__PURE__ */ k.jsx(
    br,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${Fa} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (w) => {
          const C = o.find(
            (F) => F.id === w
          );
          return C ? /* @__PURE__ */ k.jsx(A.Paragraph, { children: C.title }) : null;
        },
        filter: {
          value: i,
          onChange: (w) => {
            a(w.target.value);
          }
        },
        onToggleDropdown: (w) => {
          !w && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(ot.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(cn, {}) }) }),
        !h && o.map((w) => {
          const C = w.totalInventory <= 0, F = Ep(w);
          return /* @__PURE__ */ k.jsx(
            ot.Item,
            {
              value: w.id,
              isDisabled: C,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  F && /* @__PURE__ */ k.jsx(
                    Bi,
                    {
                      src: F,
                      alt: w.title,
                      className: Ha.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ k.jsx(
                    XS,
                    {
                      text: w.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: w.title })
                ] }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: C ? "Out of stock" : `${w.totalInventory} in stock` })
              ] })
            },
            w.id
          );
        }),
        N && /* @__PURE__ */ k.jsx(ot.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          ss,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !v && !h && /* @__PURE__ */ k.jsx(ot.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          ss,
          {
            title: "Search for products",
            description: `Type at least ${Fa} characters to search.`
          }
        ) })
      ] })
    }
  );
}, Tp = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const m = Rr(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (C) => !o.includes(C?.id)
  ) : [], v = h.length > 0 && h.every(
    (C) => a.includes(C?.id)
  ), N = h.some(
    (C) => a.includes(C?.id)
  ) && !v, w = tt(
    (C) => {
      const F = m.getValues("lineItems"), y = F.findIndex(
        (H) => H?.id === C.id
      );
      if (y > -1) {
        const H = m.getValues(`lineItems.${y}.quantity`) || 0, $ = [...F];
        $[y] = {
          ...$[y],
          quantity: H + 1
        }, m.setValue("lineItems", $);
      } else
        m.setValue("lineItems", [
          ...F,
          { ...C, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ k.jsx(ez, { onProductSelected: w }),
    !f && e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Ft.boxWrapper,
        children: /* @__PURE__ */ k.jsx(cn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Ft.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          ss,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      Xn,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Ha.productTable,
        children: [
          /* @__PURE__ */ k.jsx(Xn.Thead, { className: Ha.productTableHeader, children: /* @__PURE__ */ k.jsxs(Xn.Tr, { children: [
            n && /* @__PURE__ */ k.jsx(Xn.Th, { children: /* @__PURE__ */ k.jsx(
              qp,
              {
                checked: v,
                indeterminate: N,
                onChange: () => d?.(!v)
              }
            ) }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Total" }),
            !r && /* @__PURE__ */ k.jsx(Xn.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(Xn.Tbody, { children: u?.map((C, F) => {
            if (!n)
              return /* @__PURE__ */ k.jsx(
                QV,
                {
                  product: C,
                  index: F,
                  onRemove: () => {
                    const M = u.filter(
                      (R, q) => q !== F
                    );
                    m.setValue("lineItems", M);
                  }
                },
                `${C?.id}-${F}`
              );
            const y = C, H = y.priceRangeV2.minVariantPrice.amount, $ = y.priceRangeV2.minVariantPrice.currencyCode, E = `lineItems.${F}.quantity`, D = m.watch(E) || 0, U = H * D, Z = Ep(y), Q = a.includes(y.id), ie = o.includes(y.id), Y = s?.[y.id] ?? y.totalInventory;
            return /* @__PURE__ */ k.jsxs(
              Xn.Tr,
              {
                style: ie ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
                    qp,
                    {
                      checked: Q,
                      disabled: ie,
                      onChange: () => l?.(y.id, !Q)
                    }
                  ) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                    Z && /* @__PURE__ */ k.jsx(
                      Bi,
                      {
                        src: Z,
                        alt: y.title,
                        className: Ha.productImage
                      }
                    ),
                    /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: y.title }),
                      ie && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: y.totalInventory }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${H} ${$}` }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
                    qt,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: ie || Y <= 1,
                      name: E,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: Y,
                        tabIndex: 0
                      }
                    },
                    `${E}-${m.watch(E)}`
                  ) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${U} ${$}` }) }),
                  !r && /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                    Yt,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const M = u.filter(
                          (R, q) => q !== F
                        );
                        m.setValue("lineItems", M), Q && l?.(y.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${y.id}-${F}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, Wx = ({
  previousOrderStatus: e
} = {}) => {
  const n = Rr();
  return /* @__PURE__ */ k.jsx(
    br,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = yk.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: yk.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ k.jsx(ot.Item, { value: r.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, Kx = () => {
  const e = Rr();
  return /* @__PURE__ */ k.jsx(
    br,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = gk.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: gk.map((n) => /* @__PURE__ */ k.jsx(ot.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, nz = "_modal_1mprq_1", tz = {
  modal: nz
}, Eu = "create-shopify-order-form", rz = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = kn(), [d, m] = se(!1), [
    u,
    f
  ] = se(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Br.Pending,
    fulfillmentStatus: void 0
  }, [N, w] = se([]), C = lr({
    mode: "all",
    defaultValues: v
  }), F = C.watch("lineItems").length > 0, y = () => {
    C.reset(v), w([]), i(!1);
  };
  qe(() => {
    N.length > 0 && C.setValue("tags", N, { shouldDirty: !0 });
  }, [N, C]);
  const [H, { error: $ }] = o(
    Bx,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), y();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), y();
      }
    }
  ), [E, { error: D }] = o(
    dV,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), y();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), y();
      }
    }
  ), U = (Q) => {
    const ie = Q.lineItems.map((R) => ({
      productId: R.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: R.priceRangeV2.maxVariantPrice.amount,
          currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: R.quantity
    }));
    m(!0);
    const Y = $i(Q?.billingAddress), M = $i(
      Q?.shippingAddress
    );
    H({
      variables: {
        order: {
          lineItems: ie,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: Q.customNote,
          tags: Q.tags,
          financialStatus: Q.financialStatus,
          fulfillmentStatus: Q.fulfillmentStatus,
          shippingAddress: M,
          billingAddress: Y
        }
      }
    });
  }, Z = (Q) => {
    const ie = Q.lineItems.map((R) => ({
      title: R.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: R.priceRangeV2.maxVariantPrice.amount,
        currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: R.quantity
    }));
    f(!0);
    const Y = $i(Q?.billingAddress), M = $i(
      Q?.shippingAddress
    );
    E({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: Q.customNote,
          tags: Q.tags,
          lineItems: ie,
          shippingAddress: M,
          billingAddress: Y
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: y,
      className: tz.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(jt, { title: "Create new order", onClose: y }),
        /* @__PURE__ */ k.jsxs(wt, { children: [
          /* @__PURE__ */ k.jsx(Bm, { ...C, children: /* @__PURE__ */ k.jsx("form", { id: Eu, children: /* @__PURE__ */ k.jsxs(Ut, { children: [
            /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(Tp, {}) }),
            /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
              Lt,
              {
                name: "tags",
                render: ({ fieldState: { error: Q } }) => /* @__PURE__ */ k.jsx(
                  Ln,
                  {
                    label: "Tags",
                    meta: {
                      error: Q?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ie) => {
                          ie.key === "Enter" && (ie.preventDefault(), ie.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ts,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: N,
                            onChange: (ie) => {
                              w(ie);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(Wx, {}),
              /* @__PURE__ */ k.jsx(Kx, {}),
              /* @__PURE__ */ k.jsx(
                qt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(tn, { span: 2, children: /* @__PURE__ */ k.jsx(Ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ft.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Ip, {})
              }
            ) }) })
          ] }) }) }),
          ($ || D) && /* @__PURE__ */ k.jsx(In, { error: $ || D })
        ] }),
        /* @__PURE__ */ k.jsx(
          It,
          {
            confirmProps: {
              type: "submit",
              form: Eu,
              disabled: !F || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: C.handleSubmit(U),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                C.handleSubmit(Z)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: Eu,
                disabled: !F || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, iz = "_modal_al73g_1", az = {
  modal: iz
}, xk = [
  {
    label: "Customer",
    value: oi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: oi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: oi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: oi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: oi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: oi.Staff,
    description: "Staff made an error."
  }
], oz = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = kn(), { useMutation: d, showNotification: m } = mn(), [u, f] = se([]), h = u.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, N = lr({
    defaultValues: v
  }), [w, { error: C, reset: F }] = d(oV, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async ($) => {
      const E = $.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (E.length > 0)
        o(!1), f(E), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const D = $.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, D ? 0 : 4e3), m({
          title: "Success",
          text: `${D ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), y = tt(
    ($) => {
      $.reason != null && (o(!0), w({
        variables: {
          orderId: $.orderId,
          reason: $.reason,
          refundMethod: $.refundMethod,
          restock: $.restock,
          notifyCustomer: $.notifyCustomer,
          staffNote: $.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), H = () => {
    i(!1), F(), f([]), N.reset(v);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: n, onClose: H, className: az.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: `Cancel order ${r}`, onClose: H }),
    /* @__PURE__ */ k.jsx(wt, { children: /* @__PURE__ */ k.jsxs(Ut, { children: [
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        br,
        {
          control: N.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: ($, E) => $ === E,
            getItemTitleByValue: ($) => {
              if (!$)
                return "";
              const E = xk.find(
                (D) => D.value === $
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
              ] });
            }
          },
          children: xk.map(($) => /* @__PURE__ */ k.jsx(ot.Item, { value: $.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: $.description })
          ] }) }, $.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(Ln, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        Nu,
        {
          control: N.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(Ln, { label: "Restock items", children: /* @__PURE__ */ k.jsx(Nu, { control: N.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(Ln, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(Nu, { control: N.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        qt,
        {
          name: "staffNote",
          label: "Staff note",
          control: N.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: u.map(($) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(ue, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $.code }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
              "(",
              $.field?.join(","),
              ") ",
              $.message
            ] })
          ]
        },
        $.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      It,
      {
        confirmProps: {
          disabled: !(N.formState.isValid && N.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
        },
        confirmOnClick: N.handleSubmit(y),
        cancelOnClick: H,
        confirmName: C ? "Close" : "Cancel order",
        cancelName: C ? void 0 : "Cancel"
      }
    )
  ] });
}, sz = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = se(!1), [s, l] = se(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Ft.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      oz,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, lz = "_modal_1mprq_1", cz = {
  modal: lz
}, dz = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = mn(), { track: m } = kn(), [u, f] = se(!1), [h, v] = se(e?.tags || []), N = "duplicate-shopify-order-form", w = (M) => ({
    firstName: M?.firstName,
    lastName: M?.lastName,
    company: M?.company,
    address1: M?.address1,
    address2: M?.address2,
    city: M?.city,
    provinceCode: M?.provinceCode,
    zip: M?.zip,
    countryCode: M?.countryCodeV2,
    phone: M?.phone
  }), C = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: w(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: w(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, F = lr({
    mode: "all",
    defaultValues: C
  }), y = F.watch("lineItems").length > 0, H = qn(
    () => (e?.lineItems || []).map((M) => M.product?.id).filter((M) => !!M),
    [e]
  ), $ = qn(
    () => Hx(H),
    [H]
  ), {
    data: E,
    loading: D,
    error: U
  } = d(Cp, {
    skip: !$,
    variables: {
      query: $,
      productCount: H.length,
      mediaCount: 1
    }
  });
  qe(() => {
    U && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [U, l]), qe(() => {
    if (!r || D || !E || F.getValues("lineItems")?.length)
      return;
    const M = E?.Shopify?.products?.nodes || [], R = [];
    e?.lineItems?.forEach((q) => {
      const ee = M.find(
        (ge) => ge.id === q.product?.id
      );
      ee && R.push({
        ...ee,
        quantity: q.quantity || 1,
        sku: q.sku,
        discountedUnitPrice: q.discountedUnitPriceSet?.shopMoney
      });
    }), R.length > 0 && F.setValue("lineItems", R, { shouldDirty: !0 });
  }, [r, E, D, e, F]), qe(() => {
    (h.length > 0 || (F.getValues("tags") || []).length > 0) && F.setValue("tags", h, { shouldDirty: !0 });
  }, [h, F]);
  const [Z, { error: Q }] = s(
    Bx,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), Y();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), Y();
      }
    }
  ), ie = (M) => {
    const R = M.lineItems.map((ee) => ({
      productId: ee.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ee.discountedUnitPrice?.amount ?? ee.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ee.discountedUnitPrice?.currencyCode ?? ee.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ee.quantity,
      sku: ee.sku
    })), q = (e?.shippingLines ?? []).map(
      (ee) => ({
        title: ee.title,
        code: ee.code,
        source: ee.source,
        priceSet: {
          shopMoney: {
            amount: ee.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: ee.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), Z({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: R,
          shippingLines: q,
          note: M.customNote,
          tags: M.tags,
          financialStatus: M.financialStatus,
          fulfillmentStatus: M.fulfillmentStatus,
          shippingAddress: $i(M?.shippingAddress),
          billingAddress: $i(M?.billingAddress)
        }
      }
    });
  }, Y = () => {
    F.reset(C), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: r,
      onClose: Y,
      className: cz.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(jt, { title: `Duplicate order ${n}`, onClose: Y }),
        /* @__PURE__ */ k.jsxs(wt, { children: [
          /* @__PURE__ */ k.jsx(Bm, { ...F, children: /* @__PURE__ */ k.jsx("form", { id: N, children: /* @__PURE__ */ k.jsxs(Ut, { children: [
            /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(Tp, { loading: D }) }),
            /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
              Lt,
              {
                name: "tags",
                render: ({ fieldState: { error: M } }) => /* @__PURE__ */ k.jsx(
                  Ln,
                  {
                    label: "Tags",
                    meta: {
                      error: M?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (R) => {
                          R.key === "Enter" && (R.preventDefault(), R.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ts,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (R) => {
                              v(R);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(
                Wx,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ k.jsx(Kx, {}),
              /* @__PURE__ */ k.jsx(
                qt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(tn, { span: 2, children: /* @__PURE__ */ k.jsx(Ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ft.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Ip, {})
              }
            ) }) })
          ] }) }) }),
          Q && /* @__PURE__ */ k.jsx(In, { error: Q })
        ] }),
        /* @__PURE__ */ k.jsx(
          It,
          {
            confirmProps: {
              type: "submit",
              form: N,
              disabled: !y || u || D,
              isLoading: u || D,
              loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: F.handleSubmit(ie)
          }
        )
      ]
    }
  );
}, uz = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  if (!n || n?.length === 0)
    return null;
  const i = Object.values(r).some(
    (a) => a > 0
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ k.jsx(ue, { size: 14, name: "shopify", color: "green.500" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    i && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(Pn, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(We, { children: n.map(({ id: a, title: o, quantity: s, variantTitle: l, image: d }) => {
      const m = r[a], u = m > 0, f = m > 1 ? `Refunded (${m} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        We.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: s }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "4", children: [
            o,
            " ",
            l && `(${l})`,
            u && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", color: "red.500", children: f })
          ] }),
          contentRight: d?.url && /* @__PURE__ */ k.jsx(Bi, { src: `${d?.url}&height=48`, alt: o })
        },
        `list-${e}-${a}`
      );
    }) })
  ] });
}, mz = Zr`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, pz = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, Gx = (e) => {
  const n = {}, r = pz(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, fz = "_modal_21e62_1", hz = {
  modal: fz
}, Sk = "partial-refund-shopify-order-form", yz = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = kn(), { useQuery: d } = mn(), [m, u] = se(!1), [f, h] = se([]), v = qn(
    () => e?.refunds ? Gx(e) : {},
    [e]
  ), N = qn(
    () => (e?.lineItems || []).filter((M) => (v[M.id] || 0) >= (M.quantity || 0)).map((M) => M.product?.id).filter((M) => !!M),
    [e, v]
  ), w = qn(() => {
    const M = {};
    return (e?.lineItems || []).forEach((R) => {
      if (R.product?.id) {
        const q = v[R.id] || 0, ee = Math.max(
          0,
          (R.quantity || 0) - q
        );
        M[R.product.id] = ee;
      }
    }), M;
  }, [e, v]), C = qn(
    () => (e?.lineItems || []).map((M) => M.product?.id).filter((M) => !!M),
    [e]
  ), F = qn(
    () => Hx(C),
    [C]
  ), {
    data: y,
    loading: H,
    error: $
  } = d(Cp, {
    skip: !F,
    variables: {
      query: F,
      productCount: C.length,
      mediaCount: 1
    }
  });
  qe(() => {
    $ && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [$, s]);
  const E = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, D = lr({
    mode: "all",
    defaultValues: E
  }), U = f.length > 0, [Z, { error: Q }] = o(
    mz,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), Y();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), Y();
      }
    }
  );
  qe(() => {
    if (!r || H || !y || D.getValues("lineItems")?.length)
      return;
    const M = y?.Shopify?.products?.nodes || [], R = [];
    e?.lineItems?.forEach((q) => {
      const ee = M.find(
        (ge) => ge.id === q.product?.id
      );
      if (ee) {
        const ge = v[q.id] || 0, de = (q.quantity || 1) - ge;
        R.push({
          ...ee,
          quantity: de > 0 ? de : q.quantity || 1
        });
      }
    }), R.length > 0 && (D.setValue("lineItems", R, { shouldDirty: !0 }), h([]));
  }, [
    r,
    y,
    H,
    e,
    D,
    v
  ]);
  const ie = (M) => {
    u(!0);
    const R = (M.lineItems || []).filter(
      (q) => f.includes(q.id)
    ).map((q) => {
      const ee = e?.lineItems?.find(
        (pe) => pe.product?.id === q.id
      ), ge = v[ee?.id || ""] || 0, de = (ee?.quantity || 0) - ge, le = Math.max(
        0,
        Math.min(de, q.quantity || 0)
      );
      return ee && le > 0 ? { lineItemId: ee.id, quantity: le } : void 0;
    }).filter((q) => !!q);
    Z({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: R,
          note: M.customNote || void 0,
          notify: !0
        }
      }
    });
  }, Y = () => {
    D.reset(E), u(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: r, onClose: Y, className: hz.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: `Refund order ${n}`, onClose: Y }),
    /* @__PURE__ */ k.jsxs(wt, { children: [
      /* @__PURE__ */ k.jsx(Bm, { ...D, children: /* @__PURE__ */ k.jsx("form", { id: Sk, children: /* @__PURE__ */ k.jsxs(Ut, { children: [
        /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
          Tp,
          {
            loading: H,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: N,
            maxQuantities: w,
            onToggleSelect: (M, R) => {
              h((q) => R ? Array.from(/* @__PURE__ */ new Set([...q, M])) : q.filter((ee) => ee !== M));
            },
            onToggleSelectAll: (M) => {
              const R = (D.getValues("lineItems") || []).map((q) => q.id).filter((q) => !N.includes(q));
              h(M ? R : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(tn, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          qt,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(tn, { span: 2, children: /* @__PURE__ */ k.jsx(Ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Ft.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              Ip,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      Q && /* @__PURE__ */ k.jsx(In, { error: Q })
    ] }),
    /* @__PURE__ */ k.jsx(
      It,
      {
        confirmProps: {
          type: "submit",
          form: Sk,
          disabled: !U || m || H,
          isLoading: m || H,
          loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: D.handleSubmit(ie)
      }
    )
  ] });
}, gz = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = mn(), { track: l } = kn(), { suggestedRefund: d, currencyCode: m, id: u, name: f } = e, h = parseFloat(String(d?.amount)), v = !isNaN(h) && h > 0, [N] = a(aV, {
    onError: (F) => {
      setTimeout(() => C(F), 500);
    },
    onCompleted: (F) => {
      const y = F.Shopify?.refundCreate?.userErrors;
      y && y.length > 0 ? C(
        new a0({
          graphQLErrors: y.map((H) => ({
            message: H.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), w = tt(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: u });
    const { amount: F, ...y } = d;
    s(v ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
        "You are about to refund ",
        F,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: u }), N({
          variables: {
            input: y
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: u })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    u,
    f,
    m,
    d,
    v,
    s,
    N,
    l
  ]), C = tt(
    (F) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(In, { error: F }),
          /* @__PURE__ */ k.jsx(
            St,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    Kn,
    {
      variant: "secondary",
      onClick: w,
      disabled: d?.refundLineItems?.length === 0 || !v,
      slotStart: /* @__PURE__ */ k.jsx(ue, { size: 14, name: "undo" }),
      className: Ft.fullWidth,
      children: "Full refund"
    }
  ) });
}, vz = "_modal_al73g_1", kz = {
  modal: vz
}, bz = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = kn(), { useMutation: s, showNotification: l } = mn(), [d, m] = se(n), [u, f] = se(!1), h = lr({
    defaultValues: {
      tags: n
    }
  });
  qe(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [v, { error: N, reset: w }] = s(sV, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), C = tt(
    (y) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: y.tags
          }
        }
      }).then((H) => {
        const $ = H.data?.Shopify?.orderUpdate?.order?.tags ?? y.tags;
        h.reset({ tags: $ });
      });
    },
    [e, h, v]
  ), F = () => {
    i(!1), w();
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: r, onClose: F, className: kz.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: "Manage tags for order", onClose: F }),
    /* @__PURE__ */ k.jsxs(wt, { children: [
      /* @__PURE__ */ k.jsx(Ut, { children: /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        Lt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: y } }) => /* @__PURE__ */ k.jsx(
            Ln,
            {
              label: "Tags",
              meta: {
                error: y?.message
              },
              children: /* @__PURE__ */ k.jsx(
                Ts,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (H) => m(H)
                }
              )
            }
          )
        }
      ) }) }),
      N && /* @__PURE__ */ k.jsx(In, { error: N })
    ] }),
    /* @__PURE__ */ k.jsx(
      It,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(C),
        cancelOnClick: F,
        confirmName: N ? "Close" : "Save",
        cancelName: N ? void 0 : "Cancel"
      }
    )
  ] });
}, _z = "_editIcon_1dntr_1", xz = {
  editIcon: _z
}, Sz = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = se(!1), o = 14, s = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(ue, { size: o, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !s && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            s && n.map((l, d) => /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "primary", children: l }, d))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsx(b, { gap: "250", flexDirection: "row", children: /* @__PURE__ */ k.jsx(Ke, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
        ue,
        {
          size: o,
          name: "pen",
          className: xz.editIcon,
          onClick: () => a(!0)
        }
      ) }) })
    ] }),
    /* @__PURE__ */ k.jsx(
      bz,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, Nz = "_icon_cddi1_1", jz = "_link_cddi1_6", Nk = {
  icon: Nz,
  link: jz
}, wz = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = eo(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    We.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        A.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: Nk.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(Ke, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        ue,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: Nk.icon
        }
      ) })
    }
  );
}, Cz = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(ue, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(We, { children: e.map((n) => /* @__PURE__ */ k.jsx(wz, { trackingInfo: n }, n.number)) })
] }), Fz = "_order_135ze_1", Iz = "_orderIsOpen_135ze_9", Ez = "_orderHeader_135ze_12", Tu = {
  order: Fz,
  orderIsOpen: Iz,
  orderHeader: Ez
}, Tz = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = kn(), [h, v] = se(!1), [N, w] = se(!1), [C, F] = se(r), {
    id: y,
    name: H,
    createdAt: $,
    status: E,
    currentTotalPriceSet: D,
    currencyCode: U,
    lineItems: Z,
    billingAddress: Q,
    shippingAddress: ie,
    trackingInfos: Y,
    tags: M
  } = e, R = !!ie, q = Fp(y), ee = `https://${l}/admin/orders/${q ?? ""}`, ge = D?.shopMoney?.amount ?? 0, de = E.includes("cancelled"), le = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: U
  }).format(ge), pe = e?.refunds ? Gx(e) : {}, W = !!Z?.length && Z.every((ke) => (pe[ke.id] || 0) >= (ke.quantity || 0));
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: ut(Tu.order, {
        [Tu.orderIsOpen]: C
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Tu.orderHeader,
            onClick: () => F(!C),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                $ && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: An($).format(vm) }) }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order ",
                  H
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: C ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        C && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(ue, { size: 14, name: "activity", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: E })
            ] })
          ] }),
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(ue, { size: 14, name: "chart-bar", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: le })
            ] })
          ] }),
          /* @__PURE__ */ k.jsx(
            Sz,
            {
              orderId: y,
              tags: M,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            km,
            {
              openByDefault: !R,
              labelText: "Billing address",
              address: Q,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            km,
            {
              openByDefault: R,
              shopifyId: n,
              orderId: y,
              icon: "map-pin",
              labelText: "Shipping address",
              address: ie,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            uz,
            {
              orderId: y,
              lineItems: Z,
              refundedQuantities: pe
            }
          ),
          /* @__PURE__ */ k.jsx(Cz, { trackingInfos: Y }),
          (o || m) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              gz,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: ee
              }
            ),
            m && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => w(!0),
                className: Ft.fullWidth,
                disabled: de || W,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => v(!0),
                className: Ft.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              sz,
              {
                orderId: y,
                orderName: H,
                disabled: de,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            St,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(ee, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: y
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        h && /* @__PURE__ */ k.jsx(
          dz,
          {
            order: e,
            shopifyId: n,
            orderName: H,
            isOpen: h,
            setIsOpen: v,
            refetchOrders: u
          }
        ),
        N && /* @__PURE__ */ k.jsx(
          yz,
          {
            order: e,
            orderName: H,
            isOpen: N,
            setIsOpen: w,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, $z = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = kn(), [f, h] = se([]), [v, N] = se(!1), w = Fp(m?.id), C = `https://${n}/admin/orders?customer_id=${w ?? ""}`, {
    getCustomerOrders: F,
    isCustomerOrdersLoading: y,
    customerOrdersError: H,
    customerOrders: $,
    refetchCustomerOrders: E
  } = mV();
  return qe(() => {
    !y && w && F({
      variables: {
        query: `customer_id:${w}`
      }
    });
  }, [w]), qe(() => {
    const D = $?.Shopify?.orders?.edges;
    D && h(MV({ ordersData: D }));
  }, [$]), m ? H ? /* @__PURE__ */ k.jsx(In, { error: H }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !y && /* @__PURE__ */ k.jsx(Un, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => N(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      y && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(cn, {}) }),
      !y && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !y && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map((D, U) => /* @__PURE__ */ k.jsx(
        Tz,
        {
          order: D,
          openByDefault: U === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: E,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${U}-${D.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        St,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(C, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      rz,
      {
        isOpen: v,
        setIsOpen: N,
        shopifyCustomer: m,
        refetchCustomerOrders: E,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, Dz = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(We, { className: Ft.list, children: [
      /* @__PURE__ */ k.jsx(We.Text, { variant: "dense", className: Ft.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { variant: "dense", className: Ft.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, Oz = "_segmentName_1dkhk_1", Rz = {
  segmentName: Oz
}, Pz = 100, Vo = 10, Az = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = mn(), [i, a] = se([]), [o, s] = se(Vo), [l, d] = se(!1), m = qn(
    () => i.filter((w) => w.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    nV,
    {
      skip: !e,
      variables: {
        first: Pz
      },
      onCompleted: (w) => {
        const C = w?.Shopify?.segments?.edges;
        if (C && C.length > 0) {
          const F = C.map(({ node: y }) => ({
            ...y,
            isMember: !1
          })).sort((y, H) => y.name.localeCompare(H.name));
          a(F), h({
            variables: {
              customerId: e,
              segmentIds: F.map((y) => y.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: N }
  ] = r(tV, {
    onCompleted: (w) => {
      const C = w?.Shopify?.customerSegmentMembership?.memberships;
      if (C && C.length > 0) {
        const F = i.map((y) => {
          const H = C.find(
            ($) => $.segmentId === y.id
          );
          return {
            ...y,
            ...H?.isMember && { isMember: H.isMember }
          };
        }).sort(
          (y, H) => y.isMember === H.isMember ? 0 : y.isMember ? -1 : 1
        );
        a(F);
      }
    }
  });
  return qe(() => {
    s(l ? i.length : Vo);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ k.jsx(Un, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(cn, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(In, { error: f }),
    N && /* @__PURE__ */ k.jsx(In, { error: N }),
    !u && i.length > 0 && /* @__PURE__ */ k.jsxs(We, { className: Ft.list, children: [
      i.slice(0, o).map(({ id: w, name: C, isMember: F }) => /* @__PURE__ */ k.jsx(We.Text, { className: Ft.listItem, children: /* @__PURE__ */ k.jsx(
        Ke,
        {
          content: `${F ? "Member of" : "Not a member of"} ${C}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", className: Rz.segmentName, children: C }),
            v && /* @__PURE__ */ k.jsx(cn, { size: 12 }),
            !v && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              ue,
              {
                color: F ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, w)),
      i.length > Vo && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        Kn,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Vo} more`
        }
      ) })
    ] })
  ] }) : null;
}, Lz = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: r,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = uV({ conversationContext: e }), [l, d] = se(), [m, u] = se(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, v = n.displayCancelOrder ?? !1, N = n.enableEditShippingAddress ?? !1, w = n.displayEmailMarketingConsent ?? !1, C = n.displayOrdersOverview ?? !1, F = n.displaySegmentMembership ?? !1, y = n.displayDiscountCodeCreation ?? !1, H = n.displayDiscountCodes ?? !1, $ = n.displayCreateOrder ?? !1, E = n.displayDuplicateOrder ?? !1, D = n.displayCreateDraftOrder ?? !1, U = n.displayPartialRefundOrder ?? !1;
  if (qe(() => {
    const Z = a?.Shopify?.customers?.edges[0]?.node;
    Z && !r ? (u(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(Z)) : d(void 0);
  }, [a]), !r && i)
    return /* @__PURE__ */ k.jsx(In, { error: i, retry: o });
  if (!r && !i && !l) {
    const Z = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              bV,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              St,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(Z, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return r && s !== Gt.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(cn, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          SV,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: r,
            networkStatus: s
          }
        ),
        C && /* @__PURE__ */ k.jsx(
          Dz,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        F && /* @__PURE__ */ k.jsx(Az, { shopifyId: l?.id }),
        w && /* @__PURE__ */ k.jsx(UV, { customer: l }),
        H && /* @__PURE__ */ k.jsx(
          zV,
          {
            displayDiscountCodeCreation: y
          }
        ),
        /* @__PURE__ */ k.jsx(
          $z,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: v,
            displayCreateOrder: $,
            displayCreateDraftOrder: D,
            enableEditShippingAddress: N,
            customerCountryCodes: m,
            displayDuplicateOrder: E,
            displayPartialRefundOrder: U
          }
        )
      ]
    }
  );
}, kt = [];
for (let e = 0; e < 256; ++e)
  kt.push((e + 256).toString(16).slice(1));
function Vz(e, n = 0) {
  return (kt[e[n + 0]] + kt[e[n + 1]] + kt[e[n + 2]] + kt[e[n + 3]] + "-" + kt[e[n + 4]] + kt[e[n + 5]] + "-" + kt[e[n + 6]] + kt[e[n + 7]] + "-" + kt[e[n + 8]] + kt[e[n + 9]] + "-" + kt[e[n + 10]] + kt[e[n + 11]] + kt[e[n + 12]] + kt[e[n + 13]] + kt[e[n + 14]] + kt[e[n + 15]]).toLowerCase();
}
let $u;
const zz = new Uint8Array(16);
function Uz() {
  if (!$u) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    $u = crypto.getRandomValues.bind(crypto);
  }
  return $u(zz);
}
const Mz = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), jk = { randomUUID: Mz };
function Bz(e, n, r) {
  if (jk.randomUUID && !e)
    return jk.randomUUID();
  e = e || {};
  const i = e.random ?? e.rng?.() ?? Uz();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, Vz(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Du = { exports: {} }, Ia = {}, wk;
function qz() {
  if (wk) return Ia;
  wk = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ia.Fragment = r, Ia.jsx = s, Ia.jsxs = s, Ia;
}
var zo = {}, Ck;
function Hz() {
  return Ck || (Ck = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    zo.Fragment = i, zo.jsx = On, zo.jsxs = Bn;
  })()), zo;
}
var Fk;
function Wz() {
  return Fk || (Fk = 1, process.env.NODE_ENV === "production" ? Du.exports = qz() : Du.exports = Hz()), Du.exports;
}
var B = Wz(), Yx = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(Yx || {}), bm = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(bm || {});
const Kz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, Gz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, Yz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, Jz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, Qz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, Xz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, Zz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, e3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, n3 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, t3 = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": Kz,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": Gz,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": Yz,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": Jz,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": Qz,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": Xz,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": Zz,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": e3,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": n3
};
function Wr(e) {
  return t3[e] ?? {};
}
const r3 = Wr(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), i3 = Wr(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), a3 = Wr(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), o3 = Wr(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), s3 = Wr(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), l3 = Wr(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), c3 = Wr(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), d3 = Wr(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), u3 = Wr(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), m3 = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = kn(), [i, a] = se(), [o, s] = se(), [l, d] = se(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(r3, {
    skip: !e,
    variables: { contactId: e }
  });
  return qe(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !m && v && typeof v == "object" && ("id" in v && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && d(
      v?.consents?.filter(
        (N) => N !== null
      ) || void 0
    )), !m && (!v || typeof v != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), qn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function is(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const p3 = {
  count: 0,
  items: []
}, f3 = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = kn(), [i, a] = se(p3), {
    loading: o,
    error: s,
    data: l
  } = n(o3, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, h3 = {
  count: 0,
  totalCount: 0,
  items: []
}, y3 = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = kn(), [i, a] = se(
    h3
  ), {
    loading: o,
    error: s,
    data: l
  } = n(s3, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, g3 = ({
  conversationContext: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se(void 0), [a, o] = se(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(a3, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return qe(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, v3 = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = mn(), [i, a] = se(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(i3, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return qe(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), qn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, k3 = "_pointer_ls8kj_48", b3 = "_list_ls8kj_53", _3 = "_listItem_ls8kj_63", nt = {
  pointer: k3,
  list: b3,
  listItem: _3
};
var po = (e) => e.type === "checkbox", ci = (e) => e instanceof Date, Pt = (e) => e == null;
const Jx = (e) => typeof e == "object";
var lt = (e) => !Pt(e) && !Array.isArray(e) && Jx(e) && !ci(e), Qx = (e) => lt(e) && e.target ? po(e.target) ? e.target.checked : e.target.value : e, x3 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Xx = (e, n) => e.has(x3(n)), S3 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return lt(n) && n.hasOwnProperty("isPrototypeOf");
}, $p = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function _t(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!($p && (e instanceof Blob || i)) && (r || lt(e)))
    if (n = r ? [] : {}, !r && !S3(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = _t(e[a]));
  else
    return e;
  return n;
}
var Js = (e) => Array.isArray(e) ? e.filter(Boolean) : [], it = (e) => e === void 0, Ye = (e, n, r) => {
  if (!n || !lt(e))
    return r;
  const i = Js(n.split(/[,[\].]+?/)).reduce((a, o) => Pt(a) ? a : a[o], e);
  return it(i) || i === e ? it(e[n]) ? r : e[n] : i;
}, Xt = (e) => typeof e == "boolean", Dp = (e) => /^\w*$/.test(e), Zx = (e) => Js(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Yn = (e, n, r) => {
  let i = -1;
  const a = Dp(n) ? [n] : Zx(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = lt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const xs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, hr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Ur = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, N3 = Se.createContext(null), Op = () => Se.useContext(N3);
var eS = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== hr.all && (n._proxyFormState[s] = !i || hr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function j3(e) {
  const n = Op(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => eS(s, r, d.current, !1), [s, r]);
}
var Tr = (e) => typeof e == "string", nS = (e, n, r, i, a) => Tr(e) ? (i && n.watch.add(e), Ye(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ye(r, o))) : (i && (n.watchAll = !0), r);
function tS(e) {
  const n = Op(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(nS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function w3(e) {
  const n = Op(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Xx(a._names.array, r), l = tS({
    control: a,
    name: r,
    defaultValue: Ye(a._formValues, r, Ye(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = j3({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Xt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ye(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ye(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ye(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ye(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Ye(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((C) => u.current.onChange({
    target: {
      value: Qx(C),
      name: r
    },
    type: xs.CHANGE
  }), [r]), v = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Ye(a._formValues, r),
      name: r
    },
    type: xs.BLUR
  }), [r, a._formValues]), N = Se.useCallback((C) => {
    const F = Ye(a._fields, r);
    F && C && (F._f.ref = {
      focus: () => C.focus(),
      select: () => C.select(),
      setCustomValidity: (y) => C.setCustomValidity(y),
      reportValidity: () => C.reportValidity()
    });
  }, [a._fields, r]), w = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Xt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: N
  }), [r, i, d.disabled, h, v, N, l]);
  return Se.useEffect(() => {
    const C = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Xt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const F = (y, H) => {
      const $ = Ye(a._fields, y);
      $ && $._f && ($._f.mount = H);
    };
    if (F(r, !0), C) {
      const y = _t(Ye(a._options.defaultValues, r));
      Yn(a._defaultValues, r, y), it(Ye(a._formValues, r)) && Yn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? C && !a._state.action : C) ? a.unregister(r) : F(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: w,
    formState: d,
    fieldState: f
  }), [w, d, f]);
}
const Ik = (e) => e.render(w3(e));
var C3 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Wa = (e) => Array.isArray(e) ? e : [e], Ek = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, _m = (e) => Pt(e) || !Jx(e);
function Qr(e, n) {
  if (_m(e) || _m(n))
    return e === n;
  if (ci(e) && ci(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (ci(o) && ci(s) || lt(o) && lt(s) || Array.isArray(o) && Array.isArray(s) ? !Qr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Dt = (e) => lt(e) && !Object.keys(e).length, Rp = (e) => e.type === "file", yr = (e) => typeof e == "function", Ss = (e) => {
  if (!$p)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, rS = (e) => e.type === "select-multiple", Pp = (e) => e.type === "radio", F3 = (e) => Pp(e) || po(e), Ou = (e) => Ss(e) && e.isConnected;
function I3(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = it(e) ? i++ : e[n[i++]];
  return e;
}
function E3(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !it(e[n]))
      return !1;
  return !0;
}
function ht(e, n) {
  const r = Array.isArray(n) ? n : Dp(n) ? [n] : Zx(n), i = r.length === 1 ? e : I3(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (lt(i) && Dt(i) || Array.isArray(i) && E3(i)) && ht(e, r.slice(0, -1)), e;
}
var iS = (e) => {
  for (const n in e)
    if (yr(e[n]))
      return !0;
  return !1;
};
function Ns(e, n = {}) {
  const r = Array.isArray(e);
  if (lt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || lt(e[i]) && !iS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Ns(e[i], n[i])) : Pt(e[i]) || (n[i] = !0);
  return n;
}
function aS(e, n, r) {
  const i = Array.isArray(e);
  if (lt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || lt(e[a]) && !iS(e[a]) ? it(n) || _m(r[a]) ? r[a] = Array.isArray(e[a]) ? Ns(e[a], []) : { ...Ns(e[a]) } : aS(e[a], Pt(n) ? {} : n[a], r[a]) : r[a] = !Qr(e[a], n[a]);
  return r;
}
var Ea = (e, n) => aS(e, n, Ns(n));
const Tk = {
  value: !1,
  isValid: !1
}, $k = { value: !0, isValid: !0 };
var oS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !it(e[0].attributes.value) ? it(e[0].value) || e[0].value === "" ? $k : { value: e[0].value, isValid: !0 } : $k
    ) : Tk;
  }
  return Tk;
}, sS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => it(e) ? e : n ? e === "" ? NaN : e && +e : r && Tr(e) ? new Date(e) : i ? i(e) : e;
const Dk = {
  isValid: !1,
  value: null
};
var lS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Dk) : Dk;
function Ok(e) {
  const n = e.ref;
  return Rp(n) ? n.files : Pp(n) ? lS(e.refs).value : rS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : po(n) ? oS(e.refs).value : sS(it(n.value) ? e.ref.value : n.value, e);
}
var T3 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Ye(n, o);
    s && Yn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, js = (e) => e instanceof RegExp, Ta = (e) => it(e) ? e : js(e) ? e.source : lt(e) ? js(e.value) ? e.value.source : e.value : e, Rk = (e) => ({
  isOnSubmit: !e || e === hr.onSubmit,
  isOnBlur: e === hr.onBlur,
  isOnChange: e === hr.onChange,
  isOnAll: e === hr.all,
  isOnTouch: e === hr.onTouched
});
const Pk = "AsyncFunction";
var $3 = (e) => !!e && !!e.validate && !!(yr(e.validate) && e.validate.constructor.name === Pk || lt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Pk)), D3 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Ak = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ka = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Ye(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ka(l, n))
          break;
      } else if (lt(l) && Ka(l, n))
        break;
    }
  }
};
function Lk(e, n, r) {
  const i = Ye(e, r);
  if (i || Dp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ye(n, o), l = Ye(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var O3 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Dt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || hr.all));
}, R3 = (e, n, r) => !e || !n || e === n || Wa(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), P3 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, A3 = (e, n) => !Js(Ye(e, n)).length && ht(e, n), L3 = (e, n, r) => {
  const i = Wa(Ye(e, r));
  return Yn(i, "root", n[r]), Yn(e, r, i), e;
}, as = (e) => Tr(e);
function Vk(e, n, r = "validate") {
  if (as(e) || Array.isArray(e) && e.every(as) || Xt(e) && !e)
    return {
      type: r,
      message: as(e) ? e : "",
      ref: n
    };
}
var Fi = (e) => lt(e) && !js(e) ? e : {
  value: e,
  message: ""
}, zk = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: N, name: w, valueAsNumber: C, mount: F } = e._f, y = Ye(r, w);
  if (!F || n.has(w))
    return {};
  const H = l ? l[0] : s, $ = (M) => {
    a && H.reportValidity && (H.setCustomValidity(Xt(M) ? "" : M || ""), H.reportValidity());
  }, E = {}, D = Pp(s), U = po(s), Z = D || U, Q = (C || Rp(s)) && it(s.value) && it(y) || Ss(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ie = C3.bind(null, w, i, E), Y = (M, R, q, ee = Ur.maxLength, ge = Ur.minLength) => {
    const de = M ? R : q;
    E[w] = {
      type: M ? ee : ge,
      message: de,
      ref: s,
      ...ie(M ? ee : ge, de)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Z && (Q || Pt(y)) || Xt(y) && !y || U && !oS(l).isValid || D && !lS(l).isValid)) {
    const { value: M, message: R } = as(d) ? { value: !!d, message: d } : Fi(d);
    if (M && (E[w] = {
      type: Ur.required,
      message: R,
      ref: H,
      ...ie(Ur.required, R)
    }, !i))
      return $(R), E;
  }
  if (!Q && (!Pt(f) || !Pt(h))) {
    let M, R;
    const q = Fi(h), ee = Fi(f);
    if (!Pt(y) && !isNaN(y)) {
      const ge = s.valueAsNumber || y && +y;
      Pt(q.value) || (M = ge > q.value), Pt(ee.value) || (R = ge < ee.value);
    } else {
      const ge = s.valueAsDate || new Date(y), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", pe = s.type == "week";
      Tr(q.value) && y && (M = le ? de(y) > de(q.value) : pe ? y > q.value : ge > new Date(q.value)), Tr(ee.value) && y && (R = le ? de(y) < de(ee.value) : pe ? y < ee.value : ge < new Date(ee.value));
    }
    if ((M || R) && (Y(!!M, q.message, ee.message, Ur.max, Ur.min), !i))
      return $(E[w].message), E;
  }
  if ((m || u) && !Q && (Tr(y) || o && Array.isArray(y))) {
    const M = Fi(m), R = Fi(u), q = !Pt(M.value) && y.length > +M.value, ee = !Pt(R.value) && y.length < +R.value;
    if ((q || ee) && (Y(q, M.message, R.message), !i))
      return $(E[w].message), E;
  }
  if (v && !Q && Tr(y)) {
    const { value: M, message: R } = Fi(v);
    if (js(M) && !y.match(M) && (E[w] = {
      type: Ur.pattern,
      message: R,
      ref: s,
      ...ie(Ur.pattern, R)
    }, !i))
      return $(R), E;
  }
  if (N) {
    if (yr(N)) {
      const M = await N(y, r), R = Vk(M, H);
      if (R && (E[w] = {
        ...R,
        ...ie(Ur.validate, R.message)
      }, !i))
        return $(R.message), E;
    } else if (lt(N)) {
      let M = {};
      for (const R in N) {
        if (!Dt(M) && !i)
          break;
        const q = Vk(await N[R](y, r), H, R);
        q && (M = {
          ...q,
          ...ie(R, q.message)
        }, $(q.message), i && (E[w] = M));
      }
      if (!Dt(M) && (E[w] = {
        ref: H,
        ...M
      }, !i))
        return E;
    }
  }
  return $(!0), E;
};
const V3 = {
  mode: hr.onSubmit,
  reValidateMode: hr.onChange,
  shouldFocusError: !0
};
function z3(e = {}) {
  let n = {
    ...V3,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: yr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = lt(n.defaultValues) || lt(n.values) ? _t(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : _t(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Ek(),
    state: Ek()
  }, v = Rk(n.mode), N = Rk(n.reValidateMode), w = n.criteriaMode === hr.all, C = (j) => (_) => {
    clearTimeout(m), m = setTimeout(j, _);
  }, F = async (j) => {
    if (!n.disabled && (u.isValid || f.isValid || j)) {
      const _ = n.resolver ? Dt((await Q()).errors) : await Y(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, y = (j, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((j || Array.from(l.mount)).forEach((T) => {
      T && (_ ? Yn(r.validatingFields, T, _) : ht(r.validatingFields, T));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Dt(r.validatingFields)
    }));
  }, H = (j, _ = [], T, G, J = !0, O = !0) => {
    if (G && T && !n.disabled) {
      if (s.action = !0, O && Array.isArray(Ye(i, j))) {
        const z = T(Ye(i, j), G.argA, G.argB);
        J && Yn(i, j, z);
      }
      if (O && Array.isArray(Ye(r.errors, j))) {
        const z = T(Ye(r.errors, j), G.argA, G.argB);
        J && Yn(r.errors, j, z), A3(r.errors, j);
      }
      if ((u.touchedFields || f.touchedFields) && O && Array.isArray(Ye(r.touchedFields, j))) {
        const z = T(Ye(r.touchedFields, j), G.argA, G.argB);
        J && Yn(r.touchedFields, j, z);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Ea(a, o)), h.state.next({
        name: j,
        isDirty: R(j, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Yn(o, j, _);
  }, $ = (j, _) => {
    Yn(r.errors, j, _), h.state.next({
      errors: r.errors
    });
  }, E = (j) => {
    r.errors = j, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (j, _, T, G) => {
    const J = Ye(i, j);
    if (J) {
      const O = Ye(o, j, it(T) ? Ye(a, j) : T);
      it(O) || G && G.defaultChecked || _ ? Yn(o, j, _ ? O : Ok(J._f)) : ge(j, O), s.mount && F();
    }
  }, U = (j, _, T, G, J) => {
    let O = !1, z = !1;
    const re = {
      name: j
    };
    if (!n.disabled) {
      if (!T || G) {
        (u.isDirty || f.isDirty) && (z = r.isDirty, r.isDirty = re.isDirty = R(), O = z !== re.isDirty);
        const fe = Qr(Ye(a, j), _);
        z = !!Ye(r.dirtyFields, j), fe ? ht(r.dirtyFields, j) : Yn(r.dirtyFields, j, !0), re.dirtyFields = r.dirtyFields, O = O || (u.dirtyFields || f.dirtyFields) && z !== !fe;
      }
      if (T) {
        const fe = Ye(r.touchedFields, j);
        fe || (Yn(r.touchedFields, j, T), re.touchedFields = r.touchedFields, O = O || (u.touchedFields || f.touchedFields) && fe !== T);
      }
      O && J && h.state.next(re);
    }
    return O ? re : {};
  }, Z = (j, _, T, G) => {
    const J = Ye(r.errors, j), O = (u.isValid || f.isValid) && Xt(_) && r.isValid !== _;
    if (n.delayError && T ? (d = C(() => $(j, T)), d(n.delayError)) : (clearTimeout(m), d = null, T ? Yn(r.errors, j, T) : ht(r.errors, j)), (T ? !Qr(J, T) : J) || !Dt(G) || O) {
      const z = {
        ...G,
        ...O && Xt(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: j
      };
      r = {
        ...r,
        ...z
      }, h.state.next(z);
    }
  }, Q = async (j) => {
    y(j, !0);
    const _ = await n.resolver(o, n.context, T3(j || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(j), _;
  }, ie = async (j) => {
    const { errors: _ } = await Q(j);
    if (j)
      for (const T of j) {
        const G = Ye(_, T);
        G ? Yn(r.errors, T, G) : ht(r.errors, T);
      }
    else
      r.errors = _;
    return _;
  }, Y = async (j, _, T = {
    valid: !0
  }) => {
    for (const G in j) {
      const J = j[G];
      if (J) {
        const { _f: O, ...z } = J;
        if (O) {
          const re = l.array.has(O.name), fe = J._f && $3(J._f);
          fe && u.validatingFields && y([G], !0);
          const be = await zk(J, l.disabled, o, w, n.shouldUseNativeValidation && !_, re);
          if (fe && u.validatingFields && y([G]), be[O.name] && (T.valid = !1, _))
            break;
          !_ && (Ye(be, O.name) ? re ? L3(r.errors, be, O.name) : Yn(r.errors, O.name, be[O.name]) : ht(r.errors, O.name));
        }
        !Dt(z) && await Y(z, _, T);
      }
    }
    return T.valid;
  }, M = () => {
    for (const j of l.unMount) {
      const _ = Ye(i, j);
      _ && (_._f.refs ? _._f.refs.every((T) => !Ou(T)) : !Ou(_._f.ref)) && Ae(j);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (j, _) => !n.disabled && (j && _ && Yn(o, j, _), !Qr(Ce(), a)), q = (j, _, T) => nS(j, l, {
    ...s.mount ? o : it(_) ? a : Tr(j) ? { [j]: _ } : _
  }, T, _), ee = (j) => Js(Ye(s.mount ? o : a, j, n.shouldUnregister ? Ye(a, j, []) : [])), ge = (j, _, T = {}) => {
    const G = Ye(i, j);
    let J = _;
    if (G) {
      const O = G._f;
      O && (!O.disabled && Yn(o, j, sS(_, O)), J = Ss(O.ref) && Pt(_) ? "" : _, rS(O.ref) ? [...O.ref.options].forEach((z) => z.selected = J.includes(z.value)) : O.refs ? po(O.ref) ? O.refs.length > 1 ? O.refs.forEach((z) => (!z.defaultChecked || !z.disabled) && (z.checked = Array.isArray(J) ? !!J.find((re) => re === z.value) : J === z.value)) : O.refs[0] && (O.refs[0].checked = !!J) : O.refs.forEach((z) => z.checked = z.value === J) : Rp(O.ref) ? O.ref.value = "" : (O.ref.value = J, O.ref.type || h.state.next({
        name: j,
        values: _t(o)
      })));
    }
    (T.shouldDirty || T.shouldTouch) && U(j, J, T.shouldTouch, T.shouldDirty, !0), T.shouldValidate && ke(j);
  }, de = (j, _, T) => {
    for (const G in _) {
      const J = _[G], O = `${j}.${G}`, z = Ye(i, O);
      (l.array.has(j) || lt(J) || z && !z._f) && !ci(J) ? de(O, J, T) : ge(O, J, T);
    }
  }, le = (j, _, T = {}) => {
    const G = Ye(i, j), J = l.array.has(j), O = _t(_);
    Yn(o, j, O), J ? (h.array.next({
      name: j,
      values: _t(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && T.shouldDirty && h.state.next({
      name: j,
      dirtyFields: Ea(a, o),
      isDirty: R(j, O)
    })) : G && !G._f && !Pt(O) ? de(j, O, T) : ge(j, O, T), Ak(j, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? j : void 0,
      values: _t(o)
    });
  }, pe = async (j) => {
    s.mount = !0;
    const _ = j.target;
    let T = _.name, G = !0;
    const J = Ye(i, T), O = (z) => {
      G = Number.isNaN(z) || ci(z) && isNaN(z.getTime()) || Qr(z, Ye(o, T, z));
    };
    if (J) {
      let z, re;
      const fe = _.type ? Ok(J._f) : Qx(j), be = j.type === xs.BLUR || j.type === xs.FOCUS_OUT, Ze = !D3(J._f) && !n.resolver && !Ye(r.errors, T) && !J._f.deps || P3(be, Ye(r.touchedFields, T), r.isSubmitted, N, v), un = Ak(T, l, be);
      Yn(o, T, fe), be ? (J._f.onBlur && J._f.onBlur(j), d && d(0)) : J._f.onChange && J._f.onChange(j);
      const rn = U(T, fe, be), dn = !Dt(rn) || un;
      if (!be && h.state.next({
        name: T,
        type: j.type,
        values: _t(o)
      }), Ze)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? be && F() : be || F()), dn && h.state.next({ name: T, ...un ? {} : rn });
      if (!be && un && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await Q([T]);
        if (O(fe), G) {
          const ln = Lk(r.errors, i, T), vn = Lk(pn, i, ln.name || T);
          z = vn.error, T = vn.name, re = Dt(pn);
        }
      } else
        y([T], !0), z = (await zk(J, l.disabled, o, w, n.shouldUseNativeValidation))[T], y([T]), O(fe), G && (z ? re = !1 : (u.isValid || f.isValid) && (re = await Y(i, !0)));
      G && (J._f.deps && ke(J._f.deps), Z(T, re, z, rn));
    }
  }, W = (j, _) => {
    if (Ye(r.errors, _) && j.focus)
      return j.focus(), 1;
  }, ke = async (j, _ = {}) => {
    let T, G;
    const J = Wa(j);
    if (n.resolver) {
      const O = await ie(it(j) ? j : J);
      T = Dt(O), G = j ? !J.some((z) => Ye(O, z)) : T;
    } else j ? (G = (await Promise.all(J.map(async (O) => {
      const z = Ye(i, O);
      return await Y(z && z._f ? { [O]: z } : z);
    }))).every(Boolean), !(!G && !r.isValid) && F()) : G = T = await Y(i);
    return h.state.next({
      ...!Tr(j) || (u.isValid || f.isValid) && T !== r.isValid ? {} : { name: j },
      ...n.resolver || !j ? { isValid: T } : {},
      errors: r.errors
    }), _.shouldFocus && !G && Ka(i, W, j ? J : l.mount), G;
  }, Ce = (j) => {
    const _ = {
      ...s.mount ? o : a
    };
    return it(j) ? _ : Tr(j) ? Ye(_, j) : j.map((T) => Ye(_, T));
  }, K = (j, _) => ({
    invalid: !!Ye((_ || r).errors, j),
    isDirty: !!Ye((_ || r).dirtyFields, j),
    error: Ye((_ || r).errors, j),
    isValidating: !!Ye(r.validatingFields, j),
    isTouched: !!Ye((_ || r).touchedFields, j)
  }), Be = (j) => {
    j && Wa(j).forEach((_) => ht(r.errors, _)), h.state.next({
      errors: j ? r.errors : {}
    });
  }, Me = (j, _, T) => {
    const G = (Ye(i, j, { _f: {} })._f || {}).ref, J = Ye(r.errors, j) || {}, { ref: O, message: z, type: re, ...fe } = J;
    Yn(r.errors, j, {
      ...fe,
      ..._,
      ref: G
    }), h.state.next({
      name: j,
      errors: r.errors,
      isValid: !1
    }), T && T.shouldFocus && G && G.focus && G.focus();
  }, Pe = (j, _) => yr(j) ? h.state.subscribe({
    next: (T) => j(q(void 0, _), T)
  }) : q(j, _, !0), ze = (j) => h.state.subscribe({
    next: (_) => {
      R3(j.name, _.name, j.exact) && O3(_, j.formState || u, Oe, j.reRenderRoot) && j.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, je = (j) => (s.mount = !0, f = {
    ...f,
    ...j.formState
  }, ze({
    ...j,
    formState: f
  })), Ae = (j, _ = {}) => {
    for (const T of j ? Wa(j) : l.mount)
      l.mount.delete(T), l.array.delete(T), _.keepValue || (ht(i, T), ht(o, T)), !_.keepError && ht(r.errors, T), !_.keepDirty && ht(r.dirtyFields, T), !_.keepTouched && ht(r.touchedFields, T), !_.keepIsValidating && ht(r.validatingFields, T), !n.shouldUnregister && !_.keepDefaultValue && ht(a, T);
    h.state.next({
      values: _t(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: R() } : {}
    }), !_.keepIsValid && F();
  }, $e = ({ disabled: j, name: _ }) => {
    (Xt(j) && s.mount || j || l.disabled.has(_)) && (j ? l.disabled.add(_) : l.disabled.delete(_));
  }, nn = (j, _ = {}) => {
    let T = Ye(i, j);
    const G = Xt(_.disabled) || Xt(n.disabled);
    return Yn(i, j, {
      ...T || {},
      _f: {
        ...T && T._f ? T._f : { ref: { name: j } },
        name: j,
        mount: !0,
        ..._
      }
    }), l.mount.add(j), T ? $e({
      disabled: Xt(_.disabled) ? _.disabled : n.disabled,
      name: j
    }) : D(j, !0, _.value), {
      ...G ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Ta(_.min),
        max: Ta(_.max),
        minLength: Ta(_.minLength),
        maxLength: Ta(_.maxLength),
        pattern: Ta(_.pattern)
      } : {},
      name: j,
      onChange: pe,
      onBlur: pe,
      ref: (J) => {
        if (J) {
          nn(j, _), T = Ye(i, j);
          const O = it(J.value) && J.querySelectorAll && J.querySelectorAll("input,select,textarea")[0] || J, z = F3(O), re = T._f.refs || [];
          if (z ? re.find((fe) => fe === O) : O === T._f.ref)
            return;
          Yn(i, j, {
            _f: {
              ...T._f,
              ...z ? {
                refs: [
                  ...re.filter(Ou),
                  O,
                  ...Array.isArray(Ye(a, j)) ? [{}] : []
                ],
                ref: { type: O.type, name: j }
              } : { ref: O }
            }
          }), D(j, !1, void 0, O);
        } else
          T = Ye(i, j, {}), T._f && (T._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(Xx(l.array, j) && s.action) && l.unMount.add(j);
      }
    };
  }, we = () => n.shouldFocusError && Ka(i, W, l.mount), He = (j) => {
    Xt(j) && (h.state.next({ disabled: j }), Ka(i, (_, T) => {
      const G = Ye(i, T);
      G && (_.disabled = G._f.disabled || j, Array.isArray(G._f.refs) && G._f.refs.forEach((J) => {
        J.disabled = G._f.disabled || j;
      }));
    }, 0, !1));
  }, Xe = (j, _) => async (T) => {
    let G;
    T && (T.preventDefault && T.preventDefault(), T.persist && T.persist());
    let J = _t(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: O, values: z } = await Q();
      r.errors = O, J = z;
    } else
      await Y(i);
    if (l.disabled.size)
      for (const O of l.disabled)
        Yn(J, O, void 0);
    if (ht(r.errors, "root"), Dt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await j(J, T);
      } catch (O) {
        G = O;
      }
    } else
      _ && await _({ ...r.errors }, T), we(), setTimeout(we);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Dt(r.errors) && !G,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), G)
      throw G;
  }, me = (j, _ = {}) => {
    Ye(i, j) && (it(_.defaultValue) ? le(j, _t(Ye(a, j))) : (le(j, _.defaultValue), Yn(a, j, _t(_.defaultValue))), _.keepTouched || ht(r.touchedFields, j), _.keepDirty || (ht(r.dirtyFields, j), r.isDirty = _.defaultValue ? R(j, _t(Ye(a, j))) : R()), _.keepError || (ht(r.errors, j), u.isValid && F()), h.state.next({ ...r }));
  }, he = (j, _ = {}) => {
    const T = j ? _t(j) : a, G = _t(T), J = Dt(j), O = J ? a : G;
    if (_.keepDefaultValues || (a = T), !_.keepValues) {
      if (_.keepDirtyValues) {
        const z = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Ea(a, o))
        ]);
        for (const re of Array.from(z))
          Ye(r.dirtyFields, re) ? Yn(O, re, Ye(o, re)) : le(re, Ye(O, re));
      } else {
        if ($p && it(j))
          for (const z of l.mount) {
            const re = Ye(i, z);
            if (re && re._f) {
              const fe = Array.isArray(re._f.refs) ? re._f.refs[0] : re._f.ref;
              if (Ss(fe)) {
                const be = fe.closest("form");
                if (be) {
                  be.reset();
                  break;
                }
              }
            }
          }
        for (const z of l.mount)
          le(z, Ye(O, z));
      }
      o = _t(O), h.array.next({
        values: { ...O }
      }), h.state.next({
        values: { ...O }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: J ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Qr(j, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: J ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? Ea(a, o) : r.dirtyFields : _.keepDefaultValues && j ? Ea(a, j) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ie = (j, _) => he(yr(j) ? j(o) : j, _), Le = (j, _ = {}) => {
    const T = Ye(i, j), G = T && T._f;
    if (G) {
      const J = G.refs ? G.refs[0] : G.ref;
      J.focus && (J.focus(), _.shouldSelect && yr(J.select) && J.select());
    }
  }, Oe = (j) => {
    r = {
      ...r,
      ...j
    };
  }, sn = {
    control: {
      register: nn,
      unregister: Ae,
      getFieldState: K,
      handleSubmit: Xe,
      setError: Me,
      _subscribe: ze,
      _runSchema: Q,
      _getWatch: q,
      _getDirty: R,
      _setValid: F,
      _setFieldArray: H,
      _setDisabledField: $e,
      _setErrors: E,
      _getFieldArray: ee,
      _reset: he,
      _resetDefaultValues: () => yr(n.defaultValues) && n.defaultValues().then((j) => {
        Ie(j, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: M,
      _disableForm: He,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(j) {
        s = j;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(j) {
        l = j;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(j) {
        n = {
          ...n,
          ...j
        };
      }
    },
    subscribe: je,
    trigger: ke,
    register: nn,
    handleSubmit: Xe,
    watch: Pe,
    setValue: le,
    getValues: Ce,
    reset: Ie,
    resetField: me,
    clearErrors: Be,
    unregister: Ae,
    setError: Me,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...sn,
    formControl: sn
  };
}
function U3(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: yr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: yr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : z3(e),
    formState: i
  }, e.formControl && e.defaultValues && !yr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Qr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !Dt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = eS(i, o), n.current;
}
const M3 = "_modalBody_1clhs_1", B3 = {
  modalBody: M3
}, q3 = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = kn(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = U3({
    defaultValues: u,
    mode: "onChange"
  }), N = tS({ control: f }), w = parseInt(N?.balance ?? "0", 10), C = m === w, F = C ? "Change the value to update the points" : "", y = w < 0, H = y ? "Points can not be negative" : "", $ = N.description === "", E = $ ? "Description can not be empty" : "";
  qe(() => {
    w > m ? h(
      "transactionType",
      bm.Addition
    ) : w < m && h(
      "transactionType",
      bm.Deduction
    );
  }, [m, w, h]);
  const [D, { loading: U, error: Z, reset: Q }] = o(u3, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ie = () => {
    if (d) {
      const M = Bz();
      D({
        variables: {
          input: {
            accountId: d,
            transactionId: M,
            amount: Math.abs(w - m),
            transactionType: N.transactionType,
            description: N.description,
            source: Yx.UpdateBalance
          }
        }
      }).then(async (R) => {
        R?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), Y());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, Y = () => {
    v(u), Q(), n();
  };
  return /* @__PURE__ */ B.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: Y,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ B.jsx(jt, { title: "Update points balance", onClose: Y }),
        /* @__PURE__ */ B.jsxs(wt, { className: B3.modalBody, children: [
          /* @__PURE__ */ B.jsxs(Ut, { children: [
            /* @__PURE__ */ B.jsx(tn, { span: 6, children: /* @__PURE__ */ B.jsx(
              Ik,
              {
                name: "balance",
                control: f,
                render: ({ field: M }) => /* @__PURE__ */ B.jsx(
                  or,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: F || H
                    },
                    input: {
                      ...M,
                      value: M.value.toString(),
                      onChange: (R) => M.onChange(R)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ B.jsx(tn, { span: 6, children: /* @__PURE__ */ B.jsx(
              Ik,
              {
                name: "description",
                control: f,
                render: ({ field: M }) => /* @__PURE__ */ B.jsx(
                  or,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: M,
                    meta: {
                      warning: E
                    }
                  }
                )
              }
            ) })
          ] }),
          Z && /* @__PURE__ */ B.jsx(In, { error: Z })
        ] }),
        /* @__PURE__ */ B.jsx(
          It,
          {
            confirmName: "Save",
            confirmOnClick: () => ie(),
            confirmProps: {
              isLoading: U,
              disabled: C || y || $,
              loadingIndicator: /* @__PURE__ */ B.jsx(cn, { size: 16 })
            },
            cancelOnClick: Y
          }
        )
      ]
    }
  );
}, H3 = "_wrapper_1ge6c_1", W3 = "_block_1ge6c_12", Uk = {
  wrapper: H3,
  block: W3
}, K3 = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = mn(), { isCopied: i, copy: a } = is(), { isCopied: o, copy: s } = is(), { isCopied: l, copy: d } = is(), [m, u] = se(!1), [f, h] = se(), [v, N] = se(!1), {
    loading: w,
    data: C,
    refetch: F
  } = r(c3, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  qe(() => {
    if (C) {
      const ee = C?.Voyado?.PointAccountV_GetPointAccounts;
      ee && ee?.length > 0 && h(ee[0]);
    }
  }, [C]);
  const y = !!f?.id, H = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: $,
    lastName: E,
    street: D,
    zipCode: U,
    city: Z,
    country: Q,
    isRegistrationCompleted: ie,
    email: Y,
    mobilePhone: M
  } = e, R = 14, q = `${$ || ""} ${E || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", className: Uk.wrapper, children: [
    /* @__PURE__ */ B.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Uk.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-2", children: q }),
          w && /* @__PURE__ */ B.jsx(cn, { size: 12 }),
          y && !w && /* @__PURE__ */ B.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ B.jsxs(Un, { size: "small", variant: "warning", children: [
              H,
              " points"
            ] }),
            /* @__PURE__ */ B.jsx(Ke, { content: "Update points balance", children: /* @__PURE__ */ B.jsx(
              ue,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: nt.pointer
              }
            ) }),
            v && /* @__PURE__ */ B.jsx(Ke, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ B.jsx(
              ue,
              {
                name: "info",
                size: 12,
                className: nt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (D || Z || U || Q || M || Y) && /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
      M && /* @__PURE__ */ B.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(ue, { size: R, name: "phone" }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: M })
        ] }),
        /* @__PURE__ */ B.jsx(
          ue,
          {
            size: R,
            name: o ? "done" : "copy",
            onClick: () => s(M),
            className: nt.pointer
          }
        )
      ] }),
      Y && /* @__PURE__ */ B.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(ue, { size: R, name: "mail" }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: Y })
        ] }),
        /* @__PURE__ */ B.jsx(
          ue,
          {
            size: R,
            name: i ? "done" : "copy",
            onClick: () => a(Y),
            className: nt.pointer
          }
        )
      ] }),
      (D || Z || U || Q) && /* @__PURE__ */ B.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ B.jsx(ue, { size: R, name: "home" }),
          /* @__PURE__ */ B.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ B.jsx(Qn, { children: D }),
            /* @__PURE__ */ B.jsxs(Qn, { children: [
              U,
              " ",
              Z
            ] }),
            /* @__PURE__ */ B.jsx(Qn, { children: Q })
          ] })
        ] }),
        /* @__PURE__ */ B.jsx(
          ue,
          {
            size: R,
            name: l ? "done" : "copy",
            onClick: () => d(`${D}, ${U} ${Z}, ${Q}`),
            className: nt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ B.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(ue, { size: R, name: "sign-in" }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ B.jsx(
          ue,
          {
            name: ie ? "check-circle-filled" : "close-circle-filled",
            color: ie ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    y && /* @__PURE__ */ B.jsx(
      q3,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: N,
        refetchPointsQuery: F
      }
    )
  ] });
}, G3 = "_list_yud4a_7", Y3 = "_listItem_yud4a_11", J3 = "_listItemTooltip_yud4a_15", Q3 = "_listItemTimestamp_yud4a_18", Uo = {
  list: G3,
  listItem: Y3,
  listItemTooltip: J3,
  listItemTimestamp: Q3
}, X3 = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ B.jsx(We, { className: Uo.list, children: e.map((n, r) => /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: Uo.listItem, children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ B.jsx(Ke, { content: n?.comment, children: /* @__PURE__ */ B.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: ut({
          [Uo.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { className: Uo.listItemTimestamp, children: An(n.date).format(dt) }),
          n?.comment && /* @__PURE__ */ B.jsx(ue, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ B.jsx(
      ue,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), Z3 = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? An(e.latestChange).format(dt) : null, o = e?.expires ? `${An(e.expires).fromNow()} (${An(e.expires).format(dt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ B.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ B.jsx(Ke, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ B.jsx(
        ue,
        {
          name: "question",
          size: 14,
          className: nt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ B.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ B.jsxs(We, { className: nt.list, children: [
      s && /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ke, { content: "", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ B.jsx(Un, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ke, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ B.jsx(Un, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ke, { content: "", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ B.jsx(Un, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ke, { content: "", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ke, { content: "", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, eU = "_tagHover_kzbzk_1", nU = "_channelUnsubscribed_kzbzk_6", Mk = {
  tagHover: eU,
  channelUnsubscribed: nU
}, Ru = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = kn(), { useMutation: l } = mn(), [d, m] = se(!1), [u, { loading: f }] = l(d3), h = async ({
    newPreference: N,
    isSubscribed: w,
    channelType: C
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...N
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? w ? s("voyado:channel:unsubscribe:succeeded", { channel: C }) : s("voyado:channel:subscribe:succeeded", { channel: C }) : w ? s("voyado:channel:unsubscribe:failed", { channel: C }) : s("voyado:channel:subscribe:failed", { channel: C }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, v = d || f;
  return /* @__PURE__ */ B.jsx(Ke, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ B.jsx(
    Pn,
    {
      className: Mk.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ B.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: ut({
            [Mk.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ B.jsx(cn, { size: 16 }) : /* @__PURE__ */ B.jsx(ue, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, tU = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ B.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(
        Ru,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ B.jsx(
        Ru,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ B.jsx(
        Ru,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, rU = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = m3({ contactId: e }), {
    isLoading: v,
    error: N,
    memberLevel: w
  } = v3({ contactId: e, skip: !s }), C = v || l, F = qn(
    () => h?.filter(
      (y) => y !== null
    ),
    [h]
  );
  return d || N ? no({
    errors: d?.graphQLErrors || N?.graphQLErrors || []
  }) ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ B.jsx(A.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ B.jsx(In, { error: d || N }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ B.jsx(A.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : C ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(cn, {}) }) : /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
    r && /* @__PURE__ */ B.jsx(
      K3,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ B.jsx(Z3, { memberLevel: w }),
    i && /* @__PURE__ */ B.jsx(
      tU,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ B.jsx(X3, { contactConsents: F })
  ] });
}, xm = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, iU = "_list_zu4s7_1", aU = "_listItem_zu4s7_4", oU = "_listSum_zu4s7_7", Mo = {
  list: iU,
  listItem: aU,
  listSum: oU
}, sU = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ B.jsxs(We, { className: Mo.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ B.jsx(We.Text, { variant: "dense", className: Mo.listItem, children: /* @__PURE__ */ B.jsx(Ke, { content: s, children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ B.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ B.jsx(b, { flex: "auto", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ B.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: xm(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ B.jsx(
    We.Text,
    {
      variant: "dense",
      className: ut(Mo.listItem, Mo.listSum),
      children: /* @__PURE__ */ B.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: xm(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), lU = "_transaction_1kr8d_1", cU = "_transactionIsOpen_1kr8d_9", dU = "_transactionHeader_1kr8d_12", uU = "_transactionHeaderSubLine_1kr8d_15", mU = "_transactionHeaderAlignItemRight_1kr8d_19", Ii = {
  transaction: lU,
  transactionIsOpen: cU,
  transactionHeader: dU,
  transactionHeaderSubLine: uU,
  transactionHeaderAlignItemRight: mU
}, pU = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", v = f ?? 0, N = m?.length ? m : [];
  return /* @__PURE__ */ B.jsxs(
    b,
    {
      className: ut(Ii.transaction, {
        [Ii.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ B.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ii.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ B.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: An(o).format(dt) }),
                  /* @__PURE__ */ B.jsxs(
                    A.Heading,
                    {
                      variant: "heading-4",
                      className: Ii.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ B.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: Ii.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-4", children: xm(v, h) }),
                      /* @__PURE__ */ B.jsxs(
                        A.Heading,
                        {
                          variant: "heading-4",
                          className: Ii.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ B.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ B.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ B.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ B.jsx(Fm, {}),
              /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ B.jsx(Pn, { children: /* @__PURE__ */ B.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ B.jsx(
                  sU,
                  {
                    lineItems: N,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, fU = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = y3({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ B.jsx(In, { error: r }) : /* @__PURE__ */ B.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(cn, {}) }) : /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
          s === 0 && /* @__PURE__ */ B.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ B.jsx(
            pU,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, hU = "_message_unsvt_48", yU = "_messageIsOpen_unsvt_56", gU = "_messageHeader_unsvt_60", vU = "_messageText_unsvt_64", kU = "_buttonLink_unsvt_86", $a = {
  message: hU,
  messageIsOpen: yU,
  messageHeader: gU,
  messageText: vU,
  buttonLink: kU
}, Pu = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Au = (e, n) => n && e in Pu && n in Pu[e] ? Pu[e][n] : null, bU = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { track: a } = kn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, v = l ? Au("type", l) : null, N = d ? Au("source", d) : null, w = u ? Au("status", u) : null, C = l?.replace("Message", "");
  return /* @__PURE__ */ B.jsxs(
    b,
    {
      className: ut($a.message, {
        [$a.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ B.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: $a.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ B.jsxs(b, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
                    /* @__PURE__ */ B.jsx(ue, { name: v, size: 16 }),
                    " ",
                    C
                  ] }),
                  s && /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: An(s).format(dt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ B.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ B.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ B.jsx(Fm, {}),
          /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            w && /* @__PURE__ */ B.jsx(Pn, { children: /* @__PURE__ */ B.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ B.jsx(ue, { name: w }),
              " ",
              u
            ] }) }),
            N && /* @__PURE__ */ B.jsx(Pn, { children: /* @__PURE__ */ B.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ B.jsx(ue, { name: N }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ B.jsx(Pn, { children: /* @__PURE__ */ B.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ B.jsx(ue, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", className: $a.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ B.jsx(
            St,
            {
              slotEnd: /* @__PURE__ */ B.jsx(ue, { name: "external-link" }),
              variant: "tertiary",
              className: $a.buttonLink,
              navigate: () => {
                C && a("voyado:message:external-link:opened", {
                  channel: C.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, _U = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = f3({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ B.jsx(In, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ B.jsx(Un, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ B.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(cn, {}) }) : /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ B.jsx(
        bU,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, Qs = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, Bk = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = is(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = tt(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(ue, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ B.jsx(Ke, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ B.jsx(
      ue,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: nt.pointer
      }
    ) })
  ] });
}, xU = "_order_19t4p_1", SU = "_orderIsOpen_19t4p_9", NU = "_orderHeader_19t4p_12", jU = "_orderIconColor_19t4p_15", Cr = {
  order: xU,
  orderIsOpen: SU,
  orderHeader: NU,
  orderIconColor: jU
}, wU = "_delivery_1m9nb_1", CU = "_deliveryCode_1m9nb_4", Lu = {
  delivery: wU,
  deliveryCode: CU
}, FU = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = er();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ B.jsx(
      ue,
      {
        size: l,
        name: "eye",
        className: Cr.orderIconColor
      }
    ),
    /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ B.jsx(
        Ke,
        {
          content: /* @__PURE__ */ B.jsxs(A.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            An(s).format(dt)
          ] }),
          children: /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ B.jsx(
              A.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ B.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Lu.delivery,
                    children: [
                      /* @__PURE__ */ B.jsx(ue, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ B.jsx(
              A.Paragraph,
              {
                variant: "4",
                className: ut(Lu.delivery, Lu.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ B.jsx(Ke, { content: "Copy tracking code", children: /* @__PURE__ */ B.jsx(
      ue,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: nt.pointer
      }
    ) })
  ] });
}, IU = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(
        ue,
        {
          size: 14,
          name: "file-text",
          className: Cr.orderIconColor
        }
      ),
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ B.jsx(We, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ B.jsx(We.Item, { className: nt.listItem, children: /* @__PURE__ */ B.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ B.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ B.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: nt.listItemAlignRight,
              children: [
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: Qs({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, EU = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(
        ue,
        {
          size: 14,
          name: "tag",
          className: Cr.orderIconColor
        }
      ),
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ B.jsx(We, { className: nt.list, children: r?.map((i) => /* @__PURE__ */ B.jsx(
      We.Item,
      {
        className: nt.listItem,
        contentLeft: /* @__PURE__ */ B.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ B.jsx(
          Ke,
          {
            content: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ B.jsx(b, { children: /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: Qs({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ B.jsx(
          Bi,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, TU = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(
        ue,
        {
          size: 14,
          name: "credit-card",
          className: Cr.orderIconColor
        }
      ),
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ B.jsx(We, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ B.jsx(
      We.Item,
      {
        className: nt.listItem,
        children: /* @__PURE__ */ B.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ B.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: nt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", children: An(i?.paidAt).format(dt) }),
                    /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: Qs({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, $U = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: N
  } = e, w = 14;
  return /* @__PURE__ */ B.jsxs(
    b,
    {
      className: ut(Cr.order, {
        [Cr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ B.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Cr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ B.jsx(b, { alignItems: "center", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: An(m).format(dt) }) }),
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ B.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ B.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ B.jsx(
              ue,
              {
                size: w,
                name: "activity",
                className: Cr.orderIconColor
              }
            ),
            /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ B.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ B.jsx(Ke, { content: "Internal status", children: /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ B.jsx(B.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ B.jsx(Ke, { content: "External status", children: /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ B.jsx(B.Fragment, { children: s }) }) }),
                /* @__PURE__ */ B.jsx(Ke, { content: "Last updated at", children: /* @__PURE__ */ B.jsx(A.Paragraph, { as: "span", variant: "5", children: An(u).format(dt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ B.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ B.jsx(
              ue,
              {
                size: w,
                name: "chart-bar",
                className: Cr.orderIconColor
              }
            ),
            /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: Qs({
                value: N,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ B.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ B.jsx(
              ue,
              {
                size: w,
                name: "channels",
                className: Cr.orderIconColor
              }
            ),
            /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ B.jsx(B.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ B.jsx(Bk, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ B.jsx(
            Bk,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ B.jsx(FU, { delivery: e.delivery }),
          /* @__PURE__ */ B.jsx(EU, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ B.jsx(IU, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ B.jsx(
            TU,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, DU = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || no({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ B.jsx(In, { error: e }) : /* @__PURE__ */ B.jsx(B.Fragment, { children: r }), OU = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se([]), { track: a } = kn(), {
    loading: o,
    error: s,
    data: l
  } = n(l3, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return qe(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ B.jsx(cn, {}) }) : /* @__PURE__ */ B.jsx(DU, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ B.jsx(
      $U,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, RU = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = g3({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: N
  } = n;
  return s ? /* @__PURE__ */ B.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ B.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? no({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ B.jsx(In, { error: o }) : !d && !m && !u && !f && !h && !v ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(cn, {}) }) : /* @__PURE__ */ B.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ B.jsx(rU, { contactId: i, settings: n }),
        h && /* @__PURE__ */ B.jsx(_U, { contactId: i }),
        v && /* @__PURE__ */ B.jsx(fU, { contactId: i }),
        N && /* @__PURE__ */ B.jsx(OU, { contactId: i }),
        !l && /* @__PURE__ */ B.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, PU = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_nr4rl_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_nr4rl_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_nr4rl_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_nr4rl_63:last-child{border-bottom:none}._channelHeadline_yeqqp_1{padding:var(--dixa-size-spacer-200);border-bottom:var(--dixa-size-border-200) solid var(--dixa-color-neutral-200)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Vu = { exports: {} }, Da = {}, qk;
function AU() {
  if (qk) return Da;
  qk = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Da.Fragment = r, Da.jsx = s, Da.jsxs = s, Da;
}
var Bo = {}, Hk;
function LU() {
  return Hk || (Hk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, w = "@@iterator";
    function C(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[w];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Be() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, ze;
    function je(t, c, p) {
      {
        if (ze === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            ze = g && g[1] || "";
          }
        return `
` + ze + t;
      }
    }
    var Ae = !1, $e;
    {
      var nn = typeof WeakMap == "function" ? WeakMap : Map;
      $e = new nn();
    }
    function we(t, c) {
      if (!t || Ae)
        return "";
      {
        var p = $e.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Ae = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, Pe.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && $e.set(t, xe), xe;
    }
    function He(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return He(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Le = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function sn(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Oe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Oe(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Oe(P), y("Failed %s type: %s", p, S.message), Oe(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function Ze(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function un(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), un(c) && (O(c.key), S = "" + c.key), Ze(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && pn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Qe = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function on(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Qe.current) {
          var t = R(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Qe.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Re(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Re(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            on(g) && fn(g, c);
          }
        else if (on(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = C(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              on(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          sn(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Re(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Re(null);
            break;
          }
        }
        t.ref !== null && (Re(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), en = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + en]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, xe, En, xe), bn[xe + en] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var On = Dn, Bn = Wn;
    Bo.Fragment = i, Bo.jsx = On, Bo.jsxs = Bn;
  })()), Bo;
}
var Wk;
function VU() {
  return Wk || (Wk = 1, process.env.NODE_ENV === "production" ? Vu.exports = AU() : Vu.exports = LU()), Vu.exports;
}
var ce = VU();
const zU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "account_status" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "accepts_sms_marketing" } }, { kind: "Field", name: { kind: "Name", value: "accepts_email_marketing" } }, { kind: "Field", name: { kind: "Name", value: "channels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "suppressions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "province_code" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }] } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "response_messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "keyword" } }, { kind: "Field", name: { kind: "Name", value: "flowId" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }, { kind: "Field", name: { kind: "Name", value: "converted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_promotional_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_delivered" } }, { kind: "Field", name: { kind: "Name", value: "last_opened" } }, { kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_spam" } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, UU = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              account_status\n              default_language\n              dafault_currency\n              accepts_sms_marketing\n              accepts_email_marketing\n              channels {\n                sms {\n                  marketing {\n                    consent\n                    timestamp\n                  }\n                }\n                email {\n                  marketing {\n                    consent\n                    timestamp\n                    suppressions {\n                      timestamp\n                      timestamp\n                    }\n                  }\n                }\n              }\n              tags\n              address {\n                address1\n                address2\n                city\n                company\n                state\n                zip\n                province_code\n                country_code\n                phone_number\n              }\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n              }\n              yotpo_sms {\n                last_engaged\n                last_converted\n                last_sent\n                response_messages {\n                  id\n                  keyword\n                  flowId\n                  timestamp\n                }\n                campaigns {\n                  converted\n                  id\n                  clicked\n                }\n                flows {\n                  id\n                  opened\n                  clicked\n                  converted\n                }\n              }\n              yotpo_email {\n                last_sent\n                last_promotional_sent\n                last_delivered\n                last_opened\n                last_engaged\n                last_converted\n                last_spam\n                campaigns {\n                  opened\n                  id\n                  clicked\n                }\n                flows {\n                  converted\n                  id\n                }\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": zU
};
function MU(e) {
  return UU[e] ?? {};
}
const BU = MU(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              account_status
              default_language
              dafault_currency
              accepts_sms_marketing
              accepts_email_marketing
              channels {
                sms {
                  marketing {
                    consent
                    timestamp
                  }
                }
                email {
                  marketing {
                    consent
                    timestamp
                    suppressions {
                      timestamp
                      timestamp
                    }
                  }
                }
              }
              tags
              address {
                address1
                address2
                city
                company
                state
                zip
                province_code
                country_code
                phone_number
              }
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
              }
              yotpo_sms {
                last_engaged
                last_converted
                last_sent
                response_messages {
                  id
                  keyword
                  flowId
                  timestamp
                }
                campaigns {
                  converted
                  id
                  clicked
                }
                flows {
                  id
                  opened
                  clicked
                  converted
                }
              }
              yotpo_email {
                last_sent
                last_promotional_sent
                last_delivered
                last_opened
                last_engaged
                last_converted
                last_spam
                campaigns {
                  opened
                  id
                  clicked
                }
                flows {
                  converted
                  id
                }
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), qU = "_copyIcon_nr4rl_48", HU = "_list_nr4rl_53", WU = "_listItem_nr4rl_63", Dr = {
  copyIcon: qU,
  list: HU,
  listItem: WU
}, $n = ({
  description: e,
  content: n,
  tooltip: r
}) => {
  if (n == null)
    return null;
  const i = BS(n);
  return /* @__PURE__ */ ce.jsx(We.Text, { variant: "dense", className: Dr.listItem, children: /* @__PURE__ */ ce.jsx(Ke, { content: r, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: e }),
    i ? n : fb(n)
  ] }) }) });
}, Kk = ({
  channel: e
}) => {
  const n = (a) => Es(a.replace("_", " "));
  if (!e?.marketing)
    return null;
  const { marketing: r } = e, i = "suppressions" in r && !!r.suppressions;
  return /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
    /* @__PURE__ */ ce.jsx(We.Text, { variant: "dense", className: Dr.listItem, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Consent" }),
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", alignItems: "center", children: [
        r?.timestamp && /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "5", color: "secondary", children: An(r?.timestamp).format(dt) }),
        r?.consent && /* @__PURE__ */ ce.jsx(Un, { variant: "primary", size: "small", children: n(r?.consent) })
      ] })
    ] }) }),
    i && /* @__PURE__ */ ce.jsx(We.Text, { variant: "dense", className: Dr.listItem, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Suppressions" }),
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", alignItems: "center", children: [
        r.suppressions?.timestamp && /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "5", color: "secondary", children: An(r.suppressions?.timestamp).format(
          dt
        ) }),
        r.suppressions?.suppression_reason && /* @__PURE__ */ ce.jsx(Un, { variant: "warning", size: "small", children: r.suppressions?.suppression_reason })
      ] })
    ] }) })
  ] });
}, KU = "_channelHeadline_yeqqp_1", Gk = {
  channelHeadline: KU
}, GU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { channels: n } = e, { yotpo_email: r, yotpo_sms: i } = e;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Channels" }),
    /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", className: Gk.channelHeadline, children: [
        /* @__PURE__ */ ce.jsx(ue, { name: "mail" }),
        /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-4", children: "EMAIL" })
      ] }),
      /* @__PURE__ */ ce.jsxs(We, { className: Dr.list, children: [
        /* @__PURE__ */ ce.jsx(Kk, { channel: n?.email }),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the customer's last email was sent.",
            content: r?.last_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last promotional sent",
            tooltip: "The timestamp for when the customer's last promotional email was sent.",
            content: r?.last_promotional_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last delivered",
            tooltip: "The timestamp for when the customer's last email was delivered.",
            content: r?.last_delivered
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last opened",
            tooltip: "The timestamp for when the customer's last email was opened.",
            content: r?.last_opened
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via email.",
            content: r?.last_engaged
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via email.",
            content: r?.last_converted
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last spam",
            tooltip: "The timestamp for when the customer's last email was marked as spam.",
            content: r?.last_spam
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", className: Gk.channelHeadline, children: [
        /* @__PURE__ */ ce.jsx(ue, { name: "sms" }),
        /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-4", children: "SMS" })
      ] }),
      /* @__PURE__ */ ce.jsxs(We, { className: Dr.list, children: [
        /* @__PURE__ */ ce.jsx(Kk, { channel: n?.sms }),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via SMS.",
            content: i?.last_engaged
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the last SMS was sent to the customer.",
            content: i?.last_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via SMS.",
            content: i?.last_converted
          }
        )
      ] })
    ] })
  ] });
}, YU = "_wrapper_1xucg_1", JU = "_externalLink_1xucg_7", zu = {
  wrapper: YU,
  externalLink: JU
}, QU = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = er(), { isCopied: i, copy: a } = er(), { isCopied: o, copy: s } = er();
  if (!e)
    return null;
  const {
    first_name: l,
    last_name: d,
    address: m,
    email: u,
    phone_number: f,
    account_created_at: h,
    account_status: v,
    accepts_sms_marketing: N,
    accepts_email_marketing: w
  } = e, C = 14, F = `${l || ""} ${d || ""}`.trim() || "A customer has no name", {
    address1: y,
    address2: H,
    city: $,
    company: E,
    state: D,
    zip: U,
    province_code: Z,
    country_code: Q
  } = m || {}, ie = [
    y,
    H,
    [U, $].filter(Boolean).join(", "),
    [Q, D, Z].filter(Boolean).join(", "),
    E
  ].filter(Boolean);
  return /* @__PURE__ */ ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ce.jsxs(b, { className: zu.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "space-between",
        className: zu.block,
        alignItems: "center",
        children: /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-2", children: F })
      }
    ),
    h && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: An(h).format(dt) })
    ] }),
    u && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: C, name: "mail" }),
        /* @__PURE__ */ ce.jsx("span", { className: zu.externalLink, children: u })
      ] }),
      /* @__PURE__ */ ce.jsx(Ke, { content: "Copy email", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: C,
          name: n ? "done" : "copy",
          onClick: () => r(u),
          className: Dr.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: C, name: "phone" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: f })
      ] }),
      /* @__PURE__ */ ce.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: C,
          name: i ? "done" : "copy",
          onClick: () => a(f),
          className: Dr.copyIcon
        }
      ) }) })
    ] }),
    (y || $ || E || D || U || Q) && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: C, name: "home" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: ie.map((Y) => /* @__PURE__ */ ce.jsx(Qn, { children: Y }, Y)) })
      ] }),
      /* @__PURE__ */ ce.jsx(Ke, { content: "Copy address", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: C,
          name: o ? "done" : "copy",
          onClick: () => s(ie.join(", ")),
          className: Dr.copyIcon
        }
      ) }) })
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: C, name: "sms" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Accepts sms marketing" })
      ] }),
      /* @__PURE__ */ ce.jsx(
        ue,
        {
          name: N ? "check-circle-filled" : "close-circle-filled",
          color: N ? "green.500" : "red.500"
        }
      )
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: C, name: "paper-plane" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Accepts email marketing" })
      ] }),
      /* @__PURE__ */ ce.jsx(
        ue,
        {
          name: w ? "check-circle-filled" : "close-circle-filled",
          color: w ? "green.500" : "red.500"
        }
      )
    ] }),
    v && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: C, name: "yotpo", color: "rgb(0, 66, 228)" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Account status" })
      ] }),
      /* @__PURE__ */ ce.jsx(Pn, { children: Es(v) })
    ] })
  ] }) });
}, XU = ({
  loyalty: e
}) => /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ ce.jsxs(We, { className: Dr.list, children: [
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points expire date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.points_expire_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), ZU = ({ tags: e }) => {
  const n = e?.split(","), r = n && n.length > 0;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
    !r && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No tags available" }) }),
    r && /* @__PURE__ */ ce.jsx(b, { gap: "200", flexWrap: "wrap", children: n.map((i, a) => /* @__PURE__ */ ce.jsx(Pn, { children: i }, a)) })
  ] });
}, eM = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ ce.jsxs(We, { className: Dr.list, children: [
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: e.sentiment_avg_site
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: An(e.last_review_date).format(
          dt
        )
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: e.last_sentiment
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ ce.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ ce.jsx(Un, { variant: "info", size: "small", children: /* @__PURE__ */ ce.jsx(ce.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), nM = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), { track: i } = kn(), [a, o] = se(), [s, l] = se(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showTags ?? !1, N = n?.showChannels ?? !1, w = n?.showUserGeneratedContent ?? !1, C = n?.displayLoyalty ?? !1, F = n?.displayEmailData ?? !1, y = n?.displaySmsData ?? !1, H = n?.displaySubscriptions ?? !1, $ = !h && !v && !N && !w && !C && !F && !y && !H, {
    loading: E,
    error: D,
    data: U
  } = r(BU, {
    skip: !d || !f,
    variables: {
      ...d && { email: d },
      // eslint-disable-next-line camelcase
      ...!d && m && { phone_number: m },
      storeId: f,
      expand: "all"
    }
  });
  if (qe(() => {
    const Z = U?.Yotpo?.getCustomers;
    Z?.customers && (Z?.customers?.length > 0 ? (o(Z?.customers[0]), l(!1), i("yotpo:customer:received")) : l(!0));
  }, [U?.Yotpo, E]), u)
    return /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (s)
    return /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if ($)
    return /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (D) {
    const Z = D.graphQLErrors;
    return Nm({ errors: Z }) ? /* @__PURE__ */ ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : jm({ errors: Z }) ? /* @__PURE__ */ ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ce.jsx(In, { error: D });
  }
  return E ? /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ce.jsx(cn, {}) }) : /* @__PURE__ */ ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ce.jsx(QU, { customerDetails: a }),
        v && /* @__PURE__ */ ce.jsx(ZU, { tags: a?.tags }),
        N && /* @__PURE__ */ ce.jsx(GU, { customerDetails: a }),
        w && /* @__PURE__ */ ce.jsx(
          eM,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        C && /* @__PURE__ */ ce.jsx(XU, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var fo = (e) => e.type === "checkbox", di = (e) => e instanceof Date, At = (e) => e == null;
const cS = (e) => typeof e == "object";
var ct = (e) => !At(e) && !Array.isArray(e) && cS(e) && !di(e), dS = (e) => ct(e) && e.target ? fo(e.target) ? e.target.checked : e.target.value : e, tM = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, uS = (e, n) => e.has(tM(n)), rM = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ct(n) && n.hasOwnProperty("isPrototypeOf");
}, Ap = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function xt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Ap && (e instanceof Blob || i)) && (r || ct(e)))
    if (n = r ? [] : {}, !r && !rM(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = xt(e[a]));
  else
    return e;
  return n;
}
var Xs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], at = (e) => e === void 0, Je = (e, n, r) => {
  if (!n || !ct(e))
    return r;
  const i = Xs(n.split(/[,[\].]+?/)).reduce((a, o) => At(a) ? a : a[o], e);
  return at(i) || i === e ? at(e[n]) ? r : e[n] : i;
}, Zt = (e) => typeof e == "boolean", Lp = (e) => /^\w*$/.test(e), mS = (e) => Xs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Jn = (e, n, r) => {
  let i = -1;
  const a = Lp(n) ? [n] : mS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = ct(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const ws = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, gr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Mr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, iM = Se.createContext(null), Vp = () => Se.useContext(iM);
var pS = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== gr.all && (n._proxyFormState[s] = !i || gr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function aM(e) {
  const n = Vp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => pS(s, r, d.current, !1), [s, r]);
}
var $r = (e) => typeof e == "string", fS = (e, n, r, i, a) => $r(e) ? (i && n.watch.add(e), Je(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Je(r, o))) : (i && (n.watchAll = !0), r);
function hS(e) {
  const n = Vp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(fS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function oM(e) {
  const n = Vp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = uS(a._names.array, r), l = hS({
    control: a,
    name: r,
    defaultValue: Je(a._formValues, r, Je(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = aM({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Zt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Je(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Je(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Je(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Je(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Je(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((C) => u.current.onChange({
    target: {
      value: dS(C),
      name: r
    },
    type: ws.CHANGE
  }), [r]), v = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Je(a._formValues, r),
      name: r
    },
    type: ws.BLUR
  }), [r, a._formValues]), N = Se.useCallback((C) => {
    const F = Je(a._fields, r);
    F && C && (F._f.ref = {
      focus: () => C.focus(),
      select: () => C.select(),
      setCustomValidity: (y) => C.setCustomValidity(y),
      reportValidity: () => C.reportValidity()
    });
  }, [a._fields, r]), w = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Zt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: N
  }), [r, i, d.disabled, h, v, N, l]);
  return Se.useEffect(() => {
    const C = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Zt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const F = (y, H) => {
      const $ = Je(a._fields, y);
      $ && $._f && ($._f.mount = H);
    };
    if (F(r, !0), C) {
      const y = xt(Je(a._options.defaultValues, r));
      Jn(a._defaultValues, r, y), at(Je(a._formValues, r)) && Jn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? C && !a._state.action : C) ? a.unregister(r) : F(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: w,
    formState: d,
    fieldState: f
  }), [w, d, f]);
}
const Yk = (e) => e.render(oM(e));
var sM = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ga = (e) => Array.isArray(e) ? e : [e], Jk = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Sm = (e) => At(e) || !cS(e);
function Xr(e, n) {
  if (Sm(e) || Sm(n))
    return e === n;
  if (di(e) && di(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (di(o) && di(s) || ct(o) && ct(s) || Array.isArray(o) && Array.isArray(s) ? !Xr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Ot = (e) => ct(e) && !Object.keys(e).length, zp = (e) => e.type === "file", vr = (e) => typeof e == "function", Cs = (e) => {
  if (!Ap)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, yS = (e) => e.type === "select-multiple", Up = (e) => e.type === "radio", lM = (e) => Up(e) || fo(e), Uu = (e) => Cs(e) && e.isConnected;
function cM(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = at(e) ? i++ : e[n[i++]];
  return e;
}
function dM(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !at(e[n]))
      return !1;
  return !0;
}
function yt(e, n) {
  const r = Array.isArray(n) ? n : Lp(n) ? [n] : mS(n), i = r.length === 1 ? e : cM(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (ct(i) && Ot(i) || Array.isArray(i) && dM(i)) && yt(e, r.slice(0, -1)), e;
}
var gS = (e) => {
  for (const n in e)
    if (vr(e[n]))
      return !0;
  return !1;
};
function Fs(e, n = {}) {
  const r = Array.isArray(e);
  if (ct(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || ct(e[i]) && !gS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Fs(e[i], n[i])) : At(e[i]) || (n[i] = !0);
  return n;
}
function vS(e, n, r) {
  const i = Array.isArray(e);
  if (ct(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ct(e[a]) && !gS(e[a]) ? at(n) || Sm(r[a]) ? r[a] = Array.isArray(e[a]) ? Fs(e[a], []) : { ...Fs(e[a]) } : vS(e[a], At(n) ? {} : n[a], r[a]) : r[a] = !Xr(e[a], n[a]);
  return r;
}
var Oa = (e, n) => vS(e, n, Fs(n));
const Qk = {
  value: !1,
  isValid: !1
}, Xk = { value: !0, isValid: !0 };
var kS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !at(e[0].attributes.value) ? at(e[0].value) || e[0].value === "" ? Xk : { value: e[0].value, isValid: !0 } : Xk
    ) : Qk;
  }
  return Qk;
}, bS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => at(e) ? e : n ? e === "" ? NaN : e && +e : r && $r(e) ? new Date(e) : i ? i(e) : e;
const Zk = {
  isValid: !1,
  value: null
};
var _S = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Zk) : Zk;
function eb(e) {
  const n = e.ref;
  return zp(n) ? n.files : Up(n) ? _S(e.refs).value : yS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : fo(n) ? kS(e.refs).value : bS(at(n.value) ? e.ref.value : n.value, e);
}
var uM = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Je(n, o);
    s && Jn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Is = (e) => e instanceof RegExp, Ra = (e) => at(e) ? e : Is(e) ? e.source : ct(e) ? Is(e.value) ? e.value.source : e.value : e, nb = (e) => ({
  isOnSubmit: !e || e === gr.onSubmit,
  isOnBlur: e === gr.onBlur,
  isOnChange: e === gr.onChange,
  isOnAll: e === gr.all,
  isOnTouch: e === gr.onTouched
});
const tb = "AsyncFunction";
var mM = (e) => !!e && !!e.validate && !!(vr(e.validate) && e.validate.constructor.name === tb || ct(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === tb)), pM = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), rb = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ya = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Je(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ya(l, n))
          break;
      } else if (ct(l) && Ya(l, n))
        break;
    }
  }
};
function ib(e, n, r) {
  const i = Je(e, r);
  if (i || Lp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Je(n, o), l = Je(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var fM = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Ot(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || gr.all));
}, hM = (e, n, r) => !e || !n || e === n || Ga(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), yM = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, gM = (e, n) => !Xs(Je(e, n)).length && yt(e, n), vM = (e, n, r) => {
  const i = Ga(Je(e, r));
  return Jn(i, "root", n[r]), Jn(e, r, i), e;
}, os = (e) => $r(e);
function ab(e, n, r = "validate") {
  if (os(e) || Array.isArray(e) && e.every(os) || Zt(e) && !e)
    return {
      type: r,
      message: os(e) ? e : "",
      ref: n
    };
}
var Ei = (e) => ct(e) && !Is(e) ? e : {
  value: e,
  message: ""
}, ob = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: N, name: w, valueAsNumber: C, mount: F } = e._f, y = Je(r, w);
  if (!F || n.has(w))
    return {};
  const H = l ? l[0] : s, $ = (M) => {
    a && H.reportValidity && (H.setCustomValidity(Zt(M) ? "" : M || ""), H.reportValidity());
  }, E = {}, D = Up(s), U = fo(s), Z = D || U, Q = (C || zp(s)) && at(s.value) && at(y) || Cs(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ie = sM.bind(null, w, i, E), Y = (M, R, q, ee = Mr.maxLength, ge = Mr.minLength) => {
    const de = M ? R : q;
    E[w] = {
      type: M ? ee : ge,
      message: de,
      ref: s,
      ...ie(M ? ee : ge, de)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Z && (Q || At(y)) || Zt(y) && !y || U && !kS(l).isValid || D && !_S(l).isValid)) {
    const { value: M, message: R } = os(d) ? { value: !!d, message: d } : Ei(d);
    if (M && (E[w] = {
      type: Mr.required,
      message: R,
      ref: H,
      ...ie(Mr.required, R)
    }, !i))
      return $(R), E;
  }
  if (!Q && (!At(f) || !At(h))) {
    let M, R;
    const q = Ei(h), ee = Ei(f);
    if (!At(y) && !isNaN(y)) {
      const ge = s.valueAsNumber || y && +y;
      At(q.value) || (M = ge > q.value), At(ee.value) || (R = ge < ee.value);
    } else {
      const ge = s.valueAsDate || new Date(y), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", pe = s.type == "week";
      $r(q.value) && y && (M = le ? de(y) > de(q.value) : pe ? y > q.value : ge > new Date(q.value)), $r(ee.value) && y && (R = le ? de(y) < de(ee.value) : pe ? y < ee.value : ge < new Date(ee.value));
    }
    if ((M || R) && (Y(!!M, q.message, ee.message, Mr.max, Mr.min), !i))
      return $(E[w].message), E;
  }
  if ((m || u) && !Q && ($r(y) || o && Array.isArray(y))) {
    const M = Ei(m), R = Ei(u), q = !At(M.value) && y.length > +M.value, ee = !At(R.value) && y.length < +R.value;
    if ((q || ee) && (Y(q, M.message, R.message), !i))
      return $(E[w].message), E;
  }
  if (v && !Q && $r(y)) {
    const { value: M, message: R } = Ei(v);
    if (Is(M) && !y.match(M) && (E[w] = {
      type: Mr.pattern,
      message: R,
      ref: s,
      ...ie(Mr.pattern, R)
    }, !i))
      return $(R), E;
  }
  if (N) {
    if (vr(N)) {
      const M = await N(y, r), R = ab(M, H);
      if (R && (E[w] = {
        ...R,
        ...ie(Mr.validate, R.message)
      }, !i))
        return $(R.message), E;
    } else if (ct(N)) {
      let M = {};
      for (const R in N) {
        if (!Ot(M) && !i)
          break;
        const q = ab(await N[R](y, r), H, R);
        q && (M = {
          ...q,
          ...ie(R, q.message)
        }, $(q.message), i && (E[w] = M));
      }
      if (!Ot(M) && (E[w] = {
        ref: H,
        ...M
      }, !i))
        return E;
    }
  }
  return $(!0), E;
};
const kM = {
  mode: gr.onSubmit,
  reValidateMode: gr.onChange,
  shouldFocusError: !0
};
function bM(e = {}) {
  let n = {
    ...kM,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: vr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ct(n.defaultValues) || ct(n.values) ? xt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : xt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Jk(),
    state: Jk()
  }, v = nb(n.mode), N = nb(n.reValidateMode), w = n.criteriaMode === gr.all, C = (j) => (_) => {
    clearTimeout(m), m = setTimeout(j, _);
  }, F = async (j) => {
    if (!n.disabled && (u.isValid || f.isValid || j)) {
      const _ = n.resolver ? Ot((await Q()).errors) : await Y(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, y = (j, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((j || Array.from(l.mount)).forEach((T) => {
      T && (_ ? Jn(r.validatingFields, T, _) : yt(r.validatingFields, T));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Ot(r.validatingFields)
    }));
  }, H = (j, _ = [], T, G, J = !0, O = !0) => {
    if (G && T && !n.disabled) {
      if (s.action = !0, O && Array.isArray(Je(i, j))) {
        const z = T(Je(i, j), G.argA, G.argB);
        J && Jn(i, j, z);
      }
      if (O && Array.isArray(Je(r.errors, j))) {
        const z = T(Je(r.errors, j), G.argA, G.argB);
        J && Jn(r.errors, j, z), gM(r.errors, j);
      }
      if ((u.touchedFields || f.touchedFields) && O && Array.isArray(Je(r.touchedFields, j))) {
        const z = T(Je(r.touchedFields, j), G.argA, G.argB);
        J && Jn(r.touchedFields, j, z);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Oa(a, o)), h.state.next({
        name: j,
        isDirty: R(j, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Jn(o, j, _);
  }, $ = (j, _) => {
    Jn(r.errors, j, _), h.state.next({
      errors: r.errors
    });
  }, E = (j) => {
    r.errors = j, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (j, _, T, G) => {
    const J = Je(i, j);
    if (J) {
      const O = Je(o, j, at(T) ? Je(a, j) : T);
      at(O) || G && G.defaultChecked || _ ? Jn(o, j, _ ? O : eb(J._f)) : ge(j, O), s.mount && F();
    }
  }, U = (j, _, T, G, J) => {
    let O = !1, z = !1;
    const re = {
      name: j
    };
    if (!n.disabled) {
      if (!T || G) {
        (u.isDirty || f.isDirty) && (z = r.isDirty, r.isDirty = re.isDirty = R(), O = z !== re.isDirty);
        const fe = Xr(Je(a, j), _);
        z = !!Je(r.dirtyFields, j), fe ? yt(r.dirtyFields, j) : Jn(r.dirtyFields, j, !0), re.dirtyFields = r.dirtyFields, O = O || (u.dirtyFields || f.dirtyFields) && z !== !fe;
      }
      if (T) {
        const fe = Je(r.touchedFields, j);
        fe || (Jn(r.touchedFields, j, T), re.touchedFields = r.touchedFields, O = O || (u.touchedFields || f.touchedFields) && fe !== T);
      }
      O && J && h.state.next(re);
    }
    return O ? re : {};
  }, Z = (j, _, T, G) => {
    const J = Je(r.errors, j), O = (u.isValid || f.isValid) && Zt(_) && r.isValid !== _;
    if (n.delayError && T ? (d = C(() => $(j, T)), d(n.delayError)) : (clearTimeout(m), d = null, T ? Jn(r.errors, j, T) : yt(r.errors, j)), (T ? !Xr(J, T) : J) || !Ot(G) || O) {
      const z = {
        ...G,
        ...O && Zt(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: j
      };
      r = {
        ...r,
        ...z
      }, h.state.next(z);
    }
  }, Q = async (j) => {
    y(j, !0);
    const _ = await n.resolver(o, n.context, uM(j || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(j), _;
  }, ie = async (j) => {
    const { errors: _ } = await Q(j);
    if (j)
      for (const T of j) {
        const G = Je(_, T);
        G ? Jn(r.errors, T, G) : yt(r.errors, T);
      }
    else
      r.errors = _;
    return _;
  }, Y = async (j, _, T = {
    valid: !0
  }) => {
    for (const G in j) {
      const J = j[G];
      if (J) {
        const { _f: O, ...z } = J;
        if (O) {
          const re = l.array.has(O.name), fe = J._f && mM(J._f);
          fe && u.validatingFields && y([G], !0);
          const be = await ob(J, l.disabled, o, w, n.shouldUseNativeValidation && !_, re);
          if (fe && u.validatingFields && y([G]), be[O.name] && (T.valid = !1, _))
            break;
          !_ && (Je(be, O.name) ? re ? vM(r.errors, be, O.name) : Jn(r.errors, O.name, be[O.name]) : yt(r.errors, O.name));
        }
        !Ot(z) && await Y(z, _, T);
      }
    }
    return T.valid;
  }, M = () => {
    for (const j of l.unMount) {
      const _ = Je(i, j);
      _ && (_._f.refs ? _._f.refs.every((T) => !Uu(T)) : !Uu(_._f.ref)) && Ae(j);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (j, _) => !n.disabled && (j && _ && Jn(o, j, _), !Xr(Ce(), a)), q = (j, _, T) => fS(j, l, {
    ...s.mount ? o : at(_) ? a : $r(j) ? { [j]: _ } : _
  }, T, _), ee = (j) => Xs(Je(s.mount ? o : a, j, n.shouldUnregister ? Je(a, j, []) : [])), ge = (j, _, T = {}) => {
    const G = Je(i, j);
    let J = _;
    if (G) {
      const O = G._f;
      O && (!O.disabled && Jn(o, j, bS(_, O)), J = Cs(O.ref) && At(_) ? "" : _, yS(O.ref) ? [...O.ref.options].forEach((z) => z.selected = J.includes(z.value)) : O.refs ? fo(O.ref) ? O.refs.length > 1 ? O.refs.forEach((z) => (!z.defaultChecked || !z.disabled) && (z.checked = Array.isArray(J) ? !!J.find((re) => re === z.value) : J === z.value)) : O.refs[0] && (O.refs[0].checked = !!J) : O.refs.forEach((z) => z.checked = z.value === J) : zp(O.ref) ? O.ref.value = "" : (O.ref.value = J, O.ref.type || h.state.next({
        name: j,
        values: xt(o)
      })));
    }
    (T.shouldDirty || T.shouldTouch) && U(j, J, T.shouldTouch, T.shouldDirty, !0), T.shouldValidate && ke(j);
  }, de = (j, _, T) => {
    for (const G in _) {
      const J = _[G], O = `${j}.${G}`, z = Je(i, O);
      (l.array.has(j) || ct(J) || z && !z._f) && !di(J) ? de(O, J, T) : ge(O, J, T);
    }
  }, le = (j, _, T = {}) => {
    const G = Je(i, j), J = l.array.has(j), O = xt(_);
    Jn(o, j, O), J ? (h.array.next({
      name: j,
      values: xt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && T.shouldDirty && h.state.next({
      name: j,
      dirtyFields: Oa(a, o),
      isDirty: R(j, O)
    })) : G && !G._f && !At(O) ? de(j, O, T) : ge(j, O, T), rb(j, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? j : void 0,
      values: xt(o)
    });
  }, pe = async (j) => {
    s.mount = !0;
    const _ = j.target;
    let T = _.name, G = !0;
    const J = Je(i, T), O = (z) => {
      G = Number.isNaN(z) || di(z) && isNaN(z.getTime()) || Xr(z, Je(o, T, z));
    };
    if (J) {
      let z, re;
      const fe = _.type ? eb(J._f) : dS(j), be = j.type === ws.BLUR || j.type === ws.FOCUS_OUT, Ze = !pM(J._f) && !n.resolver && !Je(r.errors, T) && !J._f.deps || yM(be, Je(r.touchedFields, T), r.isSubmitted, N, v), un = rb(T, l, be);
      Jn(o, T, fe), be ? (J._f.onBlur && J._f.onBlur(j), d && d(0)) : J._f.onChange && J._f.onChange(j);
      const rn = U(T, fe, be), dn = !Ot(rn) || un;
      if (!be && h.state.next({
        name: T,
        type: j.type,
        values: xt(o)
      }), Ze)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? be && F() : be || F()), dn && h.state.next({ name: T, ...un ? {} : rn });
      if (!be && un && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await Q([T]);
        if (O(fe), G) {
          const ln = ib(r.errors, i, T), vn = ib(pn, i, ln.name || T);
          z = vn.error, T = vn.name, re = Ot(pn);
        }
      } else
        y([T], !0), z = (await ob(J, l.disabled, o, w, n.shouldUseNativeValidation))[T], y([T]), O(fe), G && (z ? re = !1 : (u.isValid || f.isValid) && (re = await Y(i, !0)));
      G && (J._f.deps && ke(J._f.deps), Z(T, re, z, rn));
    }
  }, W = (j, _) => {
    if (Je(r.errors, _) && j.focus)
      return j.focus(), 1;
  }, ke = async (j, _ = {}) => {
    let T, G;
    const J = Ga(j);
    if (n.resolver) {
      const O = await ie(at(j) ? j : J);
      T = Ot(O), G = j ? !J.some((z) => Je(O, z)) : T;
    } else j ? (G = (await Promise.all(J.map(async (O) => {
      const z = Je(i, O);
      return await Y(z && z._f ? { [O]: z } : z);
    }))).every(Boolean), !(!G && !r.isValid) && F()) : G = T = await Y(i);
    return h.state.next({
      ...!$r(j) || (u.isValid || f.isValid) && T !== r.isValid ? {} : { name: j },
      ...n.resolver || !j ? { isValid: T } : {},
      errors: r.errors
    }), _.shouldFocus && !G && Ya(i, W, j ? J : l.mount), G;
  }, Ce = (j) => {
    const _ = {
      ...s.mount ? o : a
    };
    return at(j) ? _ : $r(j) ? Je(_, j) : j.map((T) => Je(_, T));
  }, K = (j, _) => ({
    invalid: !!Je((_ || r).errors, j),
    isDirty: !!Je((_ || r).dirtyFields, j),
    error: Je((_ || r).errors, j),
    isValidating: !!Je(r.validatingFields, j),
    isTouched: !!Je((_ || r).touchedFields, j)
  }), Be = (j) => {
    j && Ga(j).forEach((_) => yt(r.errors, _)), h.state.next({
      errors: j ? r.errors : {}
    });
  }, Me = (j, _, T) => {
    const G = (Je(i, j, { _f: {} })._f || {}).ref, J = Je(r.errors, j) || {}, { ref: O, message: z, type: re, ...fe } = J;
    Jn(r.errors, j, {
      ...fe,
      ..._,
      ref: G
    }), h.state.next({
      name: j,
      errors: r.errors,
      isValid: !1
    }), T && T.shouldFocus && G && G.focus && G.focus();
  }, Pe = (j, _) => vr(j) ? h.state.subscribe({
    next: (T) => j(q(void 0, _), T)
  }) : q(j, _, !0), ze = (j) => h.state.subscribe({
    next: (_) => {
      hM(j.name, _.name, j.exact) && fM(_, j.formState || u, Oe, j.reRenderRoot) && j.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, je = (j) => (s.mount = !0, f = {
    ...f,
    ...j.formState
  }, ze({
    ...j,
    formState: f
  })), Ae = (j, _ = {}) => {
    for (const T of j ? Ga(j) : l.mount)
      l.mount.delete(T), l.array.delete(T), _.keepValue || (yt(i, T), yt(o, T)), !_.keepError && yt(r.errors, T), !_.keepDirty && yt(r.dirtyFields, T), !_.keepTouched && yt(r.touchedFields, T), !_.keepIsValidating && yt(r.validatingFields, T), !n.shouldUnregister && !_.keepDefaultValue && yt(a, T);
    h.state.next({
      values: xt(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: R() } : {}
    }), !_.keepIsValid && F();
  }, $e = ({ disabled: j, name: _ }) => {
    (Zt(j) && s.mount || j || l.disabled.has(_)) && (j ? l.disabled.add(_) : l.disabled.delete(_));
  }, nn = (j, _ = {}) => {
    let T = Je(i, j);
    const G = Zt(_.disabled) || Zt(n.disabled);
    return Jn(i, j, {
      ...T || {},
      _f: {
        ...T && T._f ? T._f : { ref: { name: j } },
        name: j,
        mount: !0,
        ..._
      }
    }), l.mount.add(j), T ? $e({
      disabled: Zt(_.disabled) ? _.disabled : n.disabled,
      name: j
    }) : D(j, !0, _.value), {
      ...G ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Ra(_.min),
        max: Ra(_.max),
        minLength: Ra(_.minLength),
        maxLength: Ra(_.maxLength),
        pattern: Ra(_.pattern)
      } : {},
      name: j,
      onChange: pe,
      onBlur: pe,
      ref: (J) => {
        if (J) {
          nn(j, _), T = Je(i, j);
          const O = at(J.value) && J.querySelectorAll && J.querySelectorAll("input,select,textarea")[0] || J, z = lM(O), re = T._f.refs || [];
          if (z ? re.find((fe) => fe === O) : O === T._f.ref)
            return;
          Jn(i, j, {
            _f: {
              ...T._f,
              ...z ? {
                refs: [
                  ...re.filter(Uu),
                  O,
                  ...Array.isArray(Je(a, j)) ? [{}] : []
                ],
                ref: { type: O.type, name: j }
              } : { ref: O }
            }
          }), D(j, !1, void 0, O);
        } else
          T = Je(i, j, {}), T._f && (T._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(uS(l.array, j) && s.action) && l.unMount.add(j);
      }
    };
  }, we = () => n.shouldFocusError && Ya(i, W, l.mount), He = (j) => {
    Zt(j) && (h.state.next({ disabled: j }), Ya(i, (_, T) => {
      const G = Je(i, T);
      G && (_.disabled = G._f.disabled || j, Array.isArray(G._f.refs) && G._f.refs.forEach((J) => {
        J.disabled = G._f.disabled || j;
      }));
    }, 0, !1));
  }, Xe = (j, _) => async (T) => {
    let G;
    T && (T.preventDefault && T.preventDefault(), T.persist && T.persist());
    let J = xt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: O, values: z } = await Q();
      r.errors = O, J = z;
    } else
      await Y(i);
    if (l.disabled.size)
      for (const O of l.disabled)
        Jn(J, O, void 0);
    if (yt(r.errors, "root"), Ot(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await j(J, T);
      } catch (O) {
        G = O;
      }
    } else
      _ && await _({ ...r.errors }, T), we(), setTimeout(we);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Ot(r.errors) && !G,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), G)
      throw G;
  }, me = (j, _ = {}) => {
    Je(i, j) && (at(_.defaultValue) ? le(j, xt(Je(a, j))) : (le(j, _.defaultValue), Jn(a, j, xt(_.defaultValue))), _.keepTouched || yt(r.touchedFields, j), _.keepDirty || (yt(r.dirtyFields, j), r.isDirty = _.defaultValue ? R(j, xt(Je(a, j))) : R()), _.keepError || (yt(r.errors, j), u.isValid && F()), h.state.next({ ...r }));
  }, he = (j, _ = {}) => {
    const T = j ? xt(j) : a, G = xt(T), J = Ot(j), O = J ? a : G;
    if (_.keepDefaultValues || (a = T), !_.keepValues) {
      if (_.keepDirtyValues) {
        const z = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Oa(a, o))
        ]);
        for (const re of Array.from(z))
          Je(r.dirtyFields, re) ? Jn(O, re, Je(o, re)) : le(re, Je(O, re));
      } else {
        if (Ap && at(j))
          for (const z of l.mount) {
            const re = Je(i, z);
            if (re && re._f) {
              const fe = Array.isArray(re._f.refs) ? re._f.refs[0] : re._f.ref;
              if (Cs(fe)) {
                const be = fe.closest("form");
                if (be) {
                  be.reset();
                  break;
                }
              }
            }
          }
        for (const z of l.mount)
          le(z, Je(O, z));
      }
      o = xt(O), h.array.next({
        values: { ...O }
      }), h.state.next({
        values: { ...O }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: J ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Xr(j, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: J ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? Oa(a, o) : r.dirtyFields : _.keepDefaultValues && j ? Oa(a, j) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ie = (j, _) => he(vr(j) ? j(o) : j, _), Le = (j, _ = {}) => {
    const T = Je(i, j), G = T && T._f;
    if (G) {
      const J = G.refs ? G.refs[0] : G.ref;
      J.focus && (J.focus(), _.shouldSelect && vr(J.select) && J.select());
    }
  }, Oe = (j) => {
    r = {
      ...r,
      ...j
    };
  }, sn = {
    control: {
      register: nn,
      unregister: Ae,
      getFieldState: K,
      handleSubmit: Xe,
      setError: Me,
      _subscribe: ze,
      _runSchema: Q,
      _getWatch: q,
      _getDirty: R,
      _setValid: F,
      _setFieldArray: H,
      _setDisabledField: $e,
      _setErrors: E,
      _getFieldArray: ee,
      _reset: he,
      _resetDefaultValues: () => vr(n.defaultValues) && n.defaultValues().then((j) => {
        Ie(j, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: M,
      _disableForm: He,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(j) {
        s = j;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(j) {
        l = j;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(j) {
        n = {
          ...n,
          ...j
        };
      }
    },
    subscribe: je,
    trigger: ke,
    register: nn,
    handleSubmit: Xe,
    watch: Pe,
    setValue: le,
    getValues: Ce,
    reset: Ie,
    resetField: me,
    clearErrors: Be,
    unregister: Ae,
    setError: Me,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...sn,
    formControl: sn
  };
}
function _M(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: vr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: vr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : bM(e),
    formState: i
  }, e.formControl && e.defaultValues && !vr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Xr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !Ot(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = pS(i, o), n.current;
}
const xM = "_settingsWrapper_1ycvy_1", SM = "_settingsWrapperHeader_1ycvy_6", NM = "_settingsWrapperContent_1ycvy_10", jM = "_settingsWrapperContentCode_1ycvy_18", wM = "_settingsWrapperContentCURL_1ycvy_26", Pa = {
  settingsWrapper: xM,
  settingsWrapperHeader: SM,
  settingsWrapperContent: NM,
  settingsWrapperContentCode: jM,
  settingsWrapperContentCURL: wM
}, CM = ({
  handleChangeText: e
}) => {
  const [n, r] = se(!1), { isCopied: i, copy: a } = er(), { control: o } = _M({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = hS({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = tt(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ ce.jsx(ce.Fragment, { children: /* @__PURE__ */ ce.jsx(tn, { span: 6, children: /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", className: Pa.settingsWrapper, children: [
    /* @__PURE__ */ ce.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: Pa.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ ce.jsx(ue, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ ce.jsxs(
      b,
      {
        flexDirection: "column",
        className: Pa.settingsWrapperContent,
        children: [
          /* @__PURE__ */ ce.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ce.jsx(
            $s,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ ce.jsxs("ol", { children: [
                /* @__PURE__ */ ce.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ ce.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ ce.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ ce.jsx("span", { className: Pa.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ ce.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ ce.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ ce.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ ce.jsx(
            Yk,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ ce.jsx(
                or,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ ce.jsx(
            Yk,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ ce.jsx(
                or,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
            /* @__PURE__ */ ce.jsx(Ln, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ ce.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: Pa.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ ce.jsx(b, { alignContent: "start", children: /* @__PURE__ */ ce.jsx(
              Ke,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ ce.jsx(
                  Kn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, FM = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showChannels",
    label: "Show email and sms channels",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], IM = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Mi
  }
], EM = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: CM
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], TM = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, $M = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, DM = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: OL,
  featureSettings: []
} : n ? {
  authSettings: RL,
  featureSettings: [...zx]
} : e ? {
  authSettings: [
    ...lk,
    ...$L
  ],
  featureSettings: [...ck]
} : {
  authSettings: [
    ...lk,
    ...DL
  ],
  featureSettings: [...ck]
}, xS = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, OM = xS(
  IM,
  EM
), RM = xS(
  aE,
  oE
), SS = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = $M(a?.value, r), s = i !== void 0 ? i : TM(
    r
  );
  return o !== void 0 ? o : s;
}, NS = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = DM(n), s = OM(r), l = RM(i);
  return {
    SHOPIFY: {
      widget: Lz,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: BF,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      settingsConfiguration: [
        ...rh ? [...rh] : []
      ]
    },
    GITHUB: {
      widget: GC,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      settingsConfiguration: [...YC]
    },
    MIUROS: {
      widget: XP,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      settingsConfiguration: [...ZP]
    },
    KLAVIYO: {
      widget: rE,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...l, ...iE]
    },
    LINEAR: {
      widget: TR,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      settingsConfiguration: [...$R]
    },
    VOYADO: {
      widget: RU,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...PU]
    },
    LOYALTYLION: {
      widget: cP,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      settingsConfiguration: [...dP]
    },
    RECHARGE: {
      widget: NA,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      settingsConfiguration: [...jA]
    },
    BRAZE: {
      widget: aw,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...ow]
    },
    YOTPO: {
      widget: nM,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...s, ...FM]
    },
    INGRID: {
      widget: _1,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...x1]
    }
  };
}, PM = (e) => {
  const n = NS();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      integrationKey: l
    }) => {
      const m = n[i], { settingsConfiguration: u } = m, f = u?.filter(({ secret: h }) => !h)?.map(
        ({
          key: h,
          type: v,
          defaultValue: N
        }) => ({
          key: h,
          value: SS({
            key: h,
            configuration: o,
            settingType: v,
            settingDefault: N
          })
        })
      );
      return {
        id: r,
        type: i,
        name: a,
        settings: f,
        misconfigured: s,
        icon: m.icon,
        iconColors: m.iconColors,
        widget: m.widget,
        integrationKey: l
      };
    }
  );
}, D4 = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d
}) => {
  const m = ui(
    {}
  ), u = ($) => (m.current[$] || (m.current[$] = { current: null }), m.current[$]), { track: f } = kn(), h = qn(
    () => PM(e),
    [e]
  ), v = {
    headline: "",
    text: "",
    onConfirm: () => H(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [N, w] = se(v), [C, F] = se(!1), y = ($) => {
    F(!0), w($);
  }, H = () => {
    F(!1), w(v);
  };
  return /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
    h.map(
      ({
        id: $,
        name: E,
        type: D,
        widget: U,
        settings: Z,
        misconfigured: Q,
        icon: ie,
        iconColors: Y,
        integrationKey: M
      }, R) => {
        const q = `partner-integration-${D}`, ee = /* @__PURE__ */ Ue.jsx(Im, { icon: ie, color: Y }), ge = Z?.reduce(
          (de, le) => (de[le.key] = le.value, de),
          {}
        );
        return s ? /* @__PURE__ */ Ue.jsx("div", { className: "icon-holder", children: ee }, `partner-icon-${$}`) : /* @__PURE__ */ Ue.jsxs(
          ar,
          {
            onToggle: () => {
              f(
                o(M) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: $,
                  widgetType: D.toLowerCase()
                }
              ), a(M);
            },
            isOpen: o(M),
            className: q,
            containerRef: (de) => {
              u(M).current = de;
            },
            children: [
              /* @__PURE__ */ Ue.jsx(
                ar.Header,
                {
                  wrap: "normal",
                  avatar: ee,
                  slotBeforeTitle: d?.(
                    M,
                    R,
                    u(M)
                  ),
                  slotAfterTitle: l?.(M),
                  children: E
                }
              ),
              /* @__PURE__ */ Ue.jsx(ar.Content, { children: Q ? /* @__PURE__ */ Ue.jsx(In, { isMisconfigured: !0 }) : /* @__PURE__ */ Ue.jsx(
                kb.Provider,
                {
                  value: {
                    onError: (de, le) => console.warn(
                      `Something went wrong with a partner widget of type '${D}' and id '${$}'`,
                      de,
                      le
                    )
                  },
                  children: /* @__PURE__ */ Ue.jsx(
                    e_,
                    {
                      integrationId: $,
                      type: D,
                      configuration: n,
                      showNotification: i,
                      showModal: y,
                      children: qS(U, {
                        conversationContext: r,
                        settings: ge
                      })
                    }
                  )
                }
              ) })
            ]
          },
          M
        );
      }
    ),
    /* @__PURE__ */ Ue.jsx(
      gb,
      {
        isOpen: C,
        setIsOpen: F,
        headline: N.headline,
        text: N.text,
        confirmLabel: N.confirmLabel,
        confirmVariant: N.confirmVariant,
        cancelLabel: N.cancelLabel,
        cancelVariant: N.cancelVariant,
        onConfirm: N.onConfirm ? () => {
          try {
            N.onConfirm && N.onConfirm();
          } finally {
            F(!1), w(v);
          }
        } : void 0,
        onCancel: N.onCancel ? () => {
          try {
            N.onCancel && N.onCancel();
          } finally {
            F(!1), w(v);
          }
        } : void 0,
        children: N.children
      }
    )
  ] });
}, AM = Zr`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        settings {
          key
          value
        }
      }
    }
  }
`;
function O4(e, { skip: n = !1 } = {}) {
  const [r, i] = se([]), [a, o] = se(!1);
  return qe(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), Zb(e).query({
      query: AM
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const LM = ({
  widgetConfiguration: e
}) => {
  const n = qn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = qn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, VM = "FULL_ACCESS", zM = "2", UM = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [VM],
        version: zM
      })
    }).then((l) => l.json())
  };
}, MM = "dixaApiToken", Mp = "dixaApiTokenId", jS = "dixaApiTokenName", sb = (e) => [Mp, jS].every(
  (r) => e.find((i) => i?.key === r)
);
function BM({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = qM(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const qM = (e) => [
  {
    key: MM,
    value: e.value,
    secret: !0
  },
  {
    key: Mp,
    value: e.id,
    secret: !1
  },
  {
    key: jS,
    value: e.name,
    secret: !1
  }
], HM = Zr`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, WM = Zr`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, KM = Zr`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, GM = Zr`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, YM = "_wrapper_1lmim_1", JM = "_wrapperBox_1lmim_4", QM = "_wrapperBoxErrorBorder_1lmim_9", Mu = {
  wrapper: YM,
  wrapperBox: JM,
  wrapperBoxErrorBorder: QM
}, XM = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (H) => H.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: v } = f, N = `Insert your ${h.label.toLowerCase()}`, w = `Insert your ${v.label.toLowerCase()}`, [C, F] = se({
    username: "",
    password: ""
  }), y = tt(
    (H) => {
      m({
        target: {
          name: s,
          value: H
        }
      });
    },
    [s, m]
  );
  return qe(() => {
    y(
      C.username !== "" && C.password !== "" ? window.btoa(`${C.username}:${C.password}`) : ""
    );
  }, [C]), /* @__PURE__ */ Ue.jsx(
    Ln,
    {
      required: e,
      label: a,
      meta: l,
      className: Mu.wrapper,
      children: /* @__PURE__ */ Ue.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: ut(Mu.wrapperBox, {
            [Mu.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ Ue.jsx(
              or,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: N,
                input: {
                  name: s,
                  value: C.username,
                  onChange: (H) => F({
                    username: H?.target.value ?? "",
                    password: C.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ Ue.jsx(
              or,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: w,
                input: {
                  name: s,
                  value: C.password,
                  onChange: (H) => F({
                    username: C.username,
                    password: H?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function lb({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: v,
  isCreationMode: N,
  prefix: w,
  integrationId: C,
  integrationType: F,
  configuration: y,
  settings: H,
  otherProps: $
}) {
  const E = v === "custom" && $?.component, D = u(n)?.value;
  return E ? /* @__PURE__ */ Ue.jsx(
    E,
    {
      configuration: y,
      integrationId: C,
      integrationType: F,
      label: r,
      settings: H,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
    /* @__PURE__ */ Ue.jsx(tn, { span: 3, children: /* @__PURE__ */ Ue.jsx(
      ZM,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: N,
        children: v === "input" ? /* @__PURE__ */ Ue.jsx(
          or,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: D,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: w,
            ...e && !N && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : v === "basicAuthInput" ? /* @__PURE__ */ Ue.jsx(
          XM,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: N,
            label: r,
            widgetSettingsKey: n,
            settings: H,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : v === "switch" ? /* @__PURE__ */ Ue.jsx(Ln, { label: r, children: /* @__PURE__ */ Ue.jsx(
          bb,
          {
            input: {
              name: n,
              value: "",
              checked: D,
              onChange: l
            }
          }
        ) }) : v === "select" ? /* @__PURE__ */ Ue.jsx(Ln, { label: r, children: /* @__PURE__ */ Ue.jsx(
          Yr,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (U) => d(n, U),
            getItemTitleByValue: (U) => U ? /* @__PURE__ */ Ue.jsx(A.Paragraph, { children: U.label }) : /* @__PURE__ */ Ue.jsx(Ue.Fragment, {}),
            value: D ? [
              {
                label: ($?.selectItems || []).find(
                  (U) => U.value === D
                )?.label,
                value: D
              }
            ] : [],
            equalityFn: (U, Z) => U.value === Z.value,
            children: ($?.selectItems || []).map((U) => /* @__PURE__ */ Ue.jsx(ot.Item, { value: U, children: U.label }, U.value))
          }
        ) }) : /* @__PURE__ */ Ue.jsx(Ue.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ Ue.jsx(tn, { span: 3 })
  ] });
}
function ZM({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ Ue.jsx(Ln, { label: n, children: /* @__PURE__ */ Ue.jsxs(
    Kn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Ja = "partner-integrations-widget-name-form-field", cb = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: SS({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), e4 = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = se(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = se({}), s = ($) => i($), l = ($) => !$ || $ === "", d = ($) => {
    const { [$]: E, ...D } = a;
    o(D);
  }, m = ($) => ({
    ...$,
    settings: $.settings.filter(({ isEditing: E }) => E).map(({ key: E, value: D, secret: U }) => ({
      key: E,
      value: D,
      secret: U
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = ($) => {
    if (!$)
      return;
    const {
      target: { name: E, value: D }
    } = $;
    a[E] && !l(D) && d(E), i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === E ? { ...U, value: D } : U
      )
    });
  }, h = ($) => {
    if (!$)
      return;
    const {
      target: { name: E, checked: D }
    } = $;
    i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === E ? { ...U, value: D } : U
      )
    });
  }, v = ($, E) => {
    if (!E)
      return;
    const { selectedValues: D } = E, U = D?.[0];
    if (U) {
      const Z = r.settings.map(
        (Q) => Q.key === $ ? { ...Q, value: U?.value } : Q
      );
      i({
        ...r,
        settings: Z
      });
    } else {
      const Z = r.settings.filter(
        (Q) => Q.key !== $
      );
      i({
        ...r,
        settings: Z
      });
    }
  }, N = ($) => {
    i({
      ...r,
      enabled: $
    });
  }, w = ($) => {
    if (!$)
      return;
    const {
      target: { value: E }
    } = $;
    a[Ja] && !l(E) && d(Ja), i({
      ...r,
      name: E
    });
  }, C = ($, E) => {
    const { settings: D } = r, U = D.map((Z) => Z.key === E ? {
      ...Z,
      isEditing: $,
      ...!$ && { value: "" }
    } : Z);
    a[E] && !$ && d(E), i({
      ...r,
      settings: U
    });
  }, F = ($) => r.settings.find(
    (E) => E.key === $
  ), y = async ($) => {
    $.preventDefault(), H() && n(m(r));
  }, H = () => {
    const $ = {}, { name: E, settings: D } = r;
    return l(E) && ($[Ja] = u.input), D.forEach(
      ({ key: U, value: Z, required: Q, isEditing: ie, type: Y, customValidation: M }) => {
        if (Q && ie)
          if (M) {
            const R = M(Z);
            typeof R == "string" && ($[U] = R);
          } else
            typeof Z == "string" && l(Z) && ($[U] = u[Y]);
      }
    ), o($), !Object.keys($)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: N,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: v,
    handleEditSecret: C,
    handleChangeName: w,
    handleSubmit: y,
    getSettingValueByKey: F,
    initializeFormData: s,
    validate: H
  };
}, n4 = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], db = "The configuration of the integration is not correct. Please check the settings.", t4 = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o
}) => {
  const { track: s } = kn(), { deleteDixaApiToken: l, createDixaApiToken: d } = UM({
    type: n,
    baseUrl: a.baseUrl
  }), u = c0().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), f = !e && !!n && !!u, h = n4.includes(n), [v, N] = se(), [w, C] = se(!1), [F, y] = se(!1), [H, $] = se(!1), [E, D] = se(null), [U, Z] = se(), { isInboundOAuth: Q } = zS(), ie = Q && f ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: Y,
    isShopifyMarketplaceApp: M,
    initialValuesForShopify: R
  } = LM({
    featureFlags: a.featureFlags,
    widgetConfiguration: U
  }), q = n === "YOTPO" && !!U?.additionalProperties?.isUsingOAuth, ee = n === "KLAVIYO" && !!U?.additionalProperties?.isUsingOAuth, ge = f && n === "SHOPIFY", pe = NS({
    SHOPIFY: {
      hasShopifyOAuth: Y,
      isShopifyMarketplaceApp: M,
      isCreationMode: f
    },
    YOTPO: {
      hasOAuth: q,
      isCreationMode: f
    },
    KLAVIYO: {
      hasOAuth: ee,
      isCreationMode: f
    }
  })[n].settingsConfiguration, W = pe.filter(({ type: j }) => j !== "hidden").filter(({ hideOnCreate: j }) => f ? !j : !0), ke = W.filter(
    ({ additionalProperties: j }) => j?.renderAboveForm === !0
  ), Ce = W.filter(
    ({ additionalProperties: j }) => j?.renderAboveForm !== !0
  ), {
    error: K,
    loading: Be,
    refetch: Me
  } = o0(HM, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (j) => {
      if (Object.keys(j).length === 0)
        $(!0);
      else {
        $(!1);
        const _ = j?.Management?.widgetConfigurations?.[0];
        _ && Z({
          ..._,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${_.id}`,
          additionalProperties: _.additionalProperties ?? void 0
        });
      }
    }
  }), [Pe, { error: ze }] = Hp(
    f ? KM : WM,
    {
      onError: (j) => {
        N(j), C(!1), i({
          title: "Something went wrong",
          text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (j) => {
        if (C(!1), Object.keys(j).length !== 0) {
          if (f && r(
            j.Management?.createWidgetConfiguration?.id
          ), !f) {
            const T = j.Management?.updateWidgetConfiguration;
            T?.misconfigured ? D(
              T.misconfigurationCause ?? db
            ) : D(null);
          }
          i({
            title: `${f ? "Creating" : "Updating"} was successful`,
            text: `${f ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [je] = Hp(GM, {
    onError: (j) => {
      N(j), C(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      C(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Ae,
    handleIsEnabled: $e,
    errors: nn,
    handleChangeText: we,
    handleChangeBoolean: He,
    handleChangeSelect: Xe,
    handleEditSecret: me,
    handleChangeName: he,
    handleSubmit: Ie,
    getSettingValueByKey: Le,
    initializeFormData: Oe
  } = e4({
    onSubmit: async (j) => {
      f ? s("settings:create:submitted", { widgetType: n }) : e && s("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), C(!0);
      const _ = j.settings.map(
        (O) => typeof O.value == "boolean" ? { ...O, value: O.value.toString() } : O
      ), T = sb(_) && f;
      let G = [];
      if (T) {
        const O = await d().catch(
          (z) => {
            C(!1), console.warn("API-Token (creation) error resonse", z), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        O?.data && (G = BM({
          token: O.data,
          settings: _
        }));
      }
      const J = {
        ...j,
        settings: [
          ...G.length > 0 ? G : _
        ]
      };
      (T && G.length > 1 || !T && G.length === 0) && (Pe({
        variables: {
          ...!f && { id: e },
          ...f && { type: n },
          ...J
        }
      }), _.forEach(
        (O) => O.secret && me(!1, O.key)
      ));
    },
    ...f && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: cb({
          settingsFromBackend: R,
          settingsConfiguration: pe,
          creating: !0
        })
      }
    }
  });
  qe(() => {
    if (U) {
      const j = cb({
        settingsFromBackend: U.settings,
        settingsConfiguration: pe
      });
      Oe({
        enabled: !!U.enabled,
        name: U.name,
        settings: j
      }), U.misconfigured ? D(
        U?.misconfigurationCause ?? db
      ) : D(null);
    }
  }, [U]);
  const sn = qn(() => o ? !o.isCoupled : !0, [o]);
  return K || ze || v ? /* @__PURE__ */ Ue.jsx(
    In,
    {
      error: K || v,
      retry: K ? Me : void 0
    }
  ) : w || Be ? /* @__PURE__ */ Ue.jsx(cn, { "data-testid": "widget-settings-loading" }) : H ? /* @__PURE__ */ Ue.jsxs(A.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ Ue.jsx(Pn, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ Ue.jsxs("form", { children: [
    E && /* @__PURE__ */ Ue.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ue.jsx(
      $s,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ Ue.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ Ue.jsx(A.Paragraph, { children: E }),
          /* @__PURE__ */ Ue.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ Ue.jsx(A.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ Ue.jsx(A.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ Ue.jsxs(
      Ut,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          ke.map(
            ({ key: j, label: _, ...T }) => /* @__PURE__ */ Ue.jsx(
              lb,
              {
                widgetSettingsKey: j,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: Le,
                isSecret: !1,
                label: _,
                placeholder: "",
                required: !1,
                errors: nn,
                type: "custom",
                isCreationMode: f,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: pe,
                otherProps: T
              },
              j
            )
          ),
          !ge && /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
            /* @__PURE__ */ Ue.jsx(tn, { children: /* @__PURE__ */ Ue.jsx(Ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ue.jsx(
              bb,
              {
                input: {
                  name: "enabled",
                  checked: Ae.enabled,
                  value: "dummy",
                  onChange: (j) => $e(j.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ Ue.jsx(tn, { span: 3, children: /* @__PURE__ */ Ue.jsx(
              or,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: Ja,
                  value: Ae.name,
                  onChange: he
                },
                meta: {
                  error: nn[Ja]
                }
              }
            ) }),
            /* @__PURE__ */ Ue.jsx(tn, { span: 3 })
          ] }),
          Ce?.map(
            ({
              key: j,
              secret: _,
              label: T,
              placeholder: G = "",
              required: J = !1,
              type: O,
              prefix: z,
              readOnly: re,
              ...fe
            }) => {
              const { settings: be } = Ae, Ze = be.find(
                (un) => un.key === j
              );
              return /* @__PURE__ */ Ue.jsx(HS, { children: /* @__PURE__ */ Ue.jsx(
                lb,
                {
                  widgetSettingsKey: j,
                  isEditingField: !!Ze?.isEditing,
                  handleEditSecret: me,
                  handleChangeText: we,
                  handleChangeBoolean: He,
                  handleChangeSelect: Xe,
                  getValueByKey: Le,
                  isSecret: _,
                  label: T,
                  placeholder: G,
                  required: J,
                  errors: nn,
                  type: O,
                  isCreationMode: f,
                  prefix: z,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: re,
                  settings: pe,
                  otherProps: fe
                }
              ) }, j);
            }
          )
        ]
      }
    ),
    !ge && /* @__PURE__ */ Ue.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ Ue.jsx(Kn, { onClick: Ie, children: ie }),
      !f && /* @__PURE__ */ Ue.jsx(
        Ke,
        {
          content: "The widget is used in automations",
          disabled: sn,
          children: /* @__PURE__ */ Ue.jsx(
            Kn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && s("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), y(!0);
              },
              disabled: !sn,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Ue.jsx(
      gb,
      {
        isOpen: F,
        setIsOpen: y,
        confirmVariant: h ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && s("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && s("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), sb(Ae.settings)) {
            const j = Ae.settings.find(
              ({ key: _ }) => _ === Mp
            )?.value;
            j && l(j).catch((_) => {
              console.warn("API-Token (deletion) error response", _), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          je({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ Ue.jsx(b, { children: h ? /* @__PURE__ */ Ue.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ Ue.jsx(
            ue,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ Ue.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ Ue.jsxs(A.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ Ue.jsxs(A.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ Ue.jsxs(A.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Ae.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Ae.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, R4 = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o
}) => /* @__PURE__ */ Ue.jsx(
  kb.Provider,
  {
    value: {
      onError: (s, l) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        s,
        l
      )
    },
    children: /* @__PURE__ */ Ue.jsx(
      e_,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ Ue.jsx(
          t4,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o
          }
        )
      }
    )
  }
), ub = "__PairingContext__", wS = globalThis[ub] ?? (() => {
  const e = vb({});
  return globalThis[ub] = e, e;
})(), P4 = () => Cm(wS), A4 = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Ue.jsx(wS.Provider, { value: e, children: n });
var qo = { exports: {} }, mb;
function r4() {
  if (mb) return qo.exports;
  mb = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(E, D, U) {
    return Function.prototype.apply.call(E, D, U);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(E) {
    return Object.getOwnPropertyNames(E).concat(Object.getOwnPropertySymbols(E));
  } : r = function(E) {
    return Object.getOwnPropertyNames(E);
  };
  function i($) {
    console && console.warn && console.warn($);
  }
  var a = Number.isNaN || function(E) {
    return E !== E;
  };
  function o() {
    o.init.call(this);
  }
  qo.exports = o, qo.exports.once = F, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l($) {
    if (typeof $ != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof $);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function($) {
      if (typeof $ != "number" || $ < 0 || a($))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + $ + ".");
      s = $;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(E) {
    if (typeof E != "number" || E < 0 || a(E))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + E + ".");
    return this._maxListeners = E, this;
  };
  function d($) {
    return $._maxListeners === void 0 ? o.defaultMaxListeners : $._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(E) {
    for (var D = [], U = 1; U < arguments.length; U++) D.push(arguments[U]);
    var Z = E === "error", Q = this._events;
    if (Q !== void 0)
      Z = Z && Q.error === void 0;
    else if (!Z)
      return !1;
    if (Z) {
      var ie;
      if (D.length > 0 && (ie = D[0]), ie instanceof Error)
        throw ie;
      var Y = new Error("Unhandled error." + (ie ? " (" + ie.message + ")" : ""));
      throw Y.context = ie, Y;
    }
    var M = Q[E];
    if (M === void 0)
      return !1;
    if (typeof M == "function")
      n(M, this, D);
    else
      for (var R = M.length, q = N(M, R), U = 0; U < R; ++U)
        n(q[U], this, D);
    return !0;
  };
  function m($, E, D, U) {
    var Z, Q, ie;
    if (l(D), Q = $._events, Q === void 0 ? (Q = $._events = /* @__PURE__ */ Object.create(null), $._eventsCount = 0) : (Q.newListener !== void 0 && ($.emit(
      "newListener",
      E,
      D.listener ? D.listener : D
    ), Q = $._events), ie = Q[E]), ie === void 0)
      ie = Q[E] = D, ++$._eventsCount;
    else if (typeof ie == "function" ? ie = Q[E] = U ? [D, ie] : [ie, D] : U ? ie.unshift(D) : ie.push(D), Z = d($), Z > 0 && ie.length > Z && !ie.warned) {
      ie.warned = !0;
      var Y = new Error("Possible EventEmitter memory leak detected. " + ie.length + " " + String(E) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      Y.name = "MaxListenersExceededWarning", Y.emitter = $, Y.type = E, Y.count = ie.length, i(Y);
    }
    return $;
  }
  o.prototype.addListener = function(E, D) {
    return m(this, E, D, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(E, D) {
    return m(this, E, D, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f($, E, D) {
    var U = { fired: !1, wrapFn: void 0, target: $, type: E, listener: D }, Z = u.bind(U);
    return Z.listener = D, U.wrapFn = Z, Z;
  }
  o.prototype.once = function(E, D) {
    return l(D), this.on(E, f(this, E, D)), this;
  }, o.prototype.prependOnceListener = function(E, D) {
    return l(D), this.prependListener(E, f(this, E, D)), this;
  }, o.prototype.removeListener = function(E, D) {
    var U, Z, Q, ie, Y;
    if (l(D), Z = this._events, Z === void 0)
      return this;
    if (U = Z[E], U === void 0)
      return this;
    if (U === D || U.listener === D)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Z[E], Z.removeListener && this.emit("removeListener", E, U.listener || D));
    else if (typeof U != "function") {
      for (Q = -1, ie = U.length - 1; ie >= 0; ie--)
        if (U[ie] === D || U[ie].listener === D) {
          Y = U[ie].listener, Q = ie;
          break;
        }
      if (Q < 0)
        return this;
      Q === 0 ? U.shift() : w(U, Q), U.length === 1 && (Z[E] = U[0]), Z.removeListener !== void 0 && this.emit("removeListener", E, Y || D);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(E) {
    var D, U, Z;
    if (U = this._events, U === void 0)
      return this;
    if (U.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[E] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[E]), this;
    if (arguments.length === 0) {
      var Q = Object.keys(U), ie;
      for (Z = 0; Z < Q.length; ++Z)
        ie = Q[Z], ie !== "removeListener" && this.removeAllListeners(ie);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (D = U[E], typeof D == "function")
      this.removeListener(E, D);
    else if (D !== void 0)
      for (Z = D.length - 1; Z >= 0; Z--)
        this.removeListener(E, D[Z]);
    return this;
  };
  function h($, E, D) {
    var U = $._events;
    if (U === void 0)
      return [];
    var Z = U[E];
    return Z === void 0 ? [] : typeof Z == "function" ? D ? [Z.listener || Z] : [Z] : D ? C(Z) : N(Z, Z.length);
  }
  o.prototype.listeners = function(E) {
    return h(this, E, !0);
  }, o.prototype.rawListeners = function(E) {
    return h(this, E, !1);
  }, o.listenerCount = function($, E) {
    return typeof $.listenerCount == "function" ? $.listenerCount(E) : v.call($, E);
  }, o.prototype.listenerCount = v;
  function v($) {
    var E = this._events;
    if (E !== void 0) {
      var D = E[$];
      if (typeof D == "function")
        return 1;
      if (D !== void 0)
        return D.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function N($, E) {
    for (var D = new Array(E), U = 0; U < E; ++U)
      D[U] = $[U];
    return D;
  }
  function w($, E) {
    for (; E + 1 < $.length; E++)
      $[E] = $[E + 1];
    $.pop();
  }
  function C($) {
    for (var E = new Array($.length), D = 0; D < E.length; ++D)
      E[D] = $[D].listener || $[D];
    return E;
  }
  function F($, E) {
    return new Promise(function(D, U) {
      function Z(ie) {
        $.removeListener(E, Q), U(ie);
      }
      function Q() {
        typeof $.removeListener == "function" && $.removeListener("error", Z), D([].slice.call(arguments));
      }
      H($, E, Q, { once: !0 }), E !== "error" && y($, Z, { once: !0 });
    });
  }
  function y($, E, D) {
    typeof $.on == "function" && H($, "error", E, D);
  }
  function H($, E, D, U) {
    if (typeof $.on == "function")
      U.once ? $.once(E, D) : $.on(E, D);
    else if (typeof $.addEventListener == "function")
      $.addEventListener(E, function Z(Q) {
        U.once && $.removeEventListener(E, Z), D(Q);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof $);
  }
  return qo.exports;
}
var i4 = r4();
function L4() {
  const e = new i4.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  Fj as GraphQLClientProvider,
  wS as PairingContext,
  A4 as PairingProvider,
  D4 as PartnerIntegrations,
  R4 as PartnerIntegrationsSettings,
  KM as createWidgetConfigurationMutation,
  GM as deleteWidgetConfigurationMutation,
  HM as getWidgetConfigurationByIdQuery,
  NS as getWidgetDefinitions,
  L4 as initializePartnerEventEmitter,
  WM as updateWidgetConfigurationMutation,
  P4 as usePairing,
  O4 as usePartnerIntegrationWidgetConfigurations,
  LM as useShopifyConfiguration
};
